/**
 * Created by ljf on 2017/2/8.
 */
var SIDEBAR_ORDER = {
  'BM_USER': 1,
  'MEMBER': 5,
  'DEVICE': 10,
  'FIRMWARE': 15,
  'APP': 20,
  'DISTRIBUTOR': 25,
  'CLIENT': 30,
  'CLIENT_VERSION': 35,
  'CLIENT_LOG': 40,
  'PRICING': 44,
  'TRANSACTION': 45,
  "PRODUCTION_MANAGE": 49,
  "SERVER_MANAGE": 50,
  'STATISTICS': 55,
  "MARKETING": 60
};

var SIDEBAR_SUB_ORDER = {
  'ROLES': 101,
  'PERMISSIONS': 105,
  'SERVER_CONFIGS': 110,
  'STATISTICS_CHART': 201,
  'STATISTICS_LOG_LIST': 205,
  'STATISTICS_TASK': 210,
  'ACTIVITIES': 219,
  'NOTIFICATIONS': 220,
  'PROMOTIONS': 222,
  'ADVERTISEMENTS': 225,
  'FEEDBACK': 230,
  'FACTORY': 241,
  'PRODUCT': 242,
  'PLAN': 243,
  'TASK': 244,
};

var ACL = {
  /**
   * permissionObjects {'id','urlRegex','identification','group'}
   * @returns {Array}
   */
  getAllPermissionTreeData: function ($filter, permissionObjects) {
    var result = [];
    var newSet = new Set();
    permissionObjects.forEach(function (element) {
      newSet.add(element.group);
    });
    newSet.forEach(function (value) {
      result.push({
        id: value,
        parent: '#',
        type: "folder",
        text: value,
        state: {opened: false}
      });
    });
    permissionObjects.forEach(function (element) {
      result.push({
        id: element.id,
        parent: element.group,
        text: $filter('translate')(element.identification),
        state: {opened: false}
      });
    });
    return result;
  },

  getPermissionTreeDataWithSelect: function ($filter, permissionObjects, selectedIds) {
    var result = [];
    var newSet = new Set();

    permissionObjects.forEach(function (element) {
      newSet.add(element.group);
    });

    newSet.forEach(function (value) {
      result.push({
        id: value,
        parent: '#',
        type: "folder",
        text: $filter('translate')(value),
        state: {opened: false}
      });
    });
    permissionObjects.forEach(function (element) {
      var state = {opened: false};
      if (selectedIds.indexOf(element.id) != -1) {
        state.selected = true;
      }
      result.push({
        id: element.id,
        parent: element.group,
        text: $filter('translate')(element.identification),
        state: state
      });
    });
    return result;
  },

  //permission: identification from server
  hasPermission: function (dataStore, permission) {
    var result = false;
    var permissionStr = dataStore.get('permissions');
    if (permissionStr) {
      var permissionArray = permissionStr.split(';');
      for (var i = 0; i < permissionArray.length; i++) {
        if (permissionArray[i] === permission || permissionArray[i] === 'root') {
          return true;
        }
      }
    }
    return false;
  },

  getMyPermissionList: function (dataStore) {
    var permissionStr = dataStore.get('permissions');
    var result = [];
    if (permissionStr) {
      var permissionArray = permissionStr.split(';');
      $.each(permissionArray, function (i, v) {
        if (v.length > 0) {
          result.push({
            name: i,
            value: v,
            checked: true
          });
        }
      });
    }
    return result;
  },

  clear: function (dataStore) {
    dataStore.remove('acl');
  }
};

/*
 angular-file-upload v2.4.0
 https://github.com/nervgh/angular-file-upload
*/

!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["angular-file-upload"]=t():e["angular-file-upload"]=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={exports:{},id:o,loaded:!1};return e[o].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}var r=n(1),i=o(r),s=n(2),a=o(s),u=n(3),l=o(u),p=n(4),c=o(p),f=n(5),d=o(f),h=n(6),y=o(h),v=n(7),m=o(v),_=n(8),g=o(_),b=n(9),F=o(b),O=n(10),C=o(O),w=n(11),A=o(w),I=n(12),T=o(I),U=n(13),x=o(U);angular.module(i["default"].name,[]).value("fileUploaderOptions",a["default"]).factory("FileUploader",l["default"]).factory("FileLikeObject",c["default"]).factory("FileItem",d["default"]).factory("FileDirective",y["default"]).factory("FileSelect",m["default"]).factory("FileDrop",F["default"]).factory("FileOver",C["default"]).factory("Pipeline",g["default"]).directive("nvFileSelect",A["default"]).directive("nvFileDrop",T["default"]).directive("nvFileOver",x["default"]).run(["FileUploader","FileLikeObject","FileItem","FileDirective","FileSelect","FileDrop","FileOver","Pipeline",function(e,t,n,o,r,i,s,a){e.FileLikeObject=t,e.FileItem=n,e.FileDirective=o,e.FileSelect=r,e.FileDrop=i,e.FileOver=s,e.Pipeline=a}])},function(e,t){e.exports={name:"angularFileUpload"}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]={url:"/",alias:"file",headers:{},queue:[],progress:0,autoUpload:!1,removeAfterUpload:!1,method:"POST",filters:[],formData:[],queueLimit:Number.MAX_VALUE,withCredentials:!1,disableMultipart:!1}},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t,n,o,i,a,u,g){var b=o.File,F=o.FormData,O=function(){function o(t){r(this,o);var n=p(e);c(this,n,t,{isUploading:!1,_nextIndex:0,_directives:{select:[],drop:[],over:[]}}),this.filters.unshift({name:"queueLimit",fn:this._queueLimitFilter}),this.filters.unshift({name:"folder",fn:this._folderFilter})}return o.prototype.addToQueue=function(e,t,n){var o=this,r=this.isArrayLikeObject(e)?Array.prototype.slice.call(e):[e],i=this._getFilters(n),l=this.queue.length,p=[],c=function d(){var e=r.shift();if(m(e))return f();var n=o.isFile(e)?e:new a(e),l=o._convertFiltersToPipes(i),c=new g(l),h=function(e){var t=e.pipe.originalFilter,n=s(e.args,2),r=n[0],i=n[1];o._onWhenAddingFileFailed(r,t,i),d()},y=function(e,t){var n=new u(o,e,t);p.push(n),o.queue.push(n),o._onAfterAddingFile(n),d()};c.onThrown=h,c.onSuccessful=y,c.exec(n,t)},f=function(){o.queue.length!==l&&(o._onAfterAddingAll(p),o.progress=o._getTotalProgress()),o._render(),o.autoUpload&&o.uploadAll()};c()},o.prototype.removeFromQueue=function(e){var t=this.getIndexOfItem(e),n=this.queue[t];n.isUploading&&n.cancel(),this.queue.splice(t,1),n._destroy(),this.progress=this._getTotalProgress()},o.prototype.clearQueue=function(){for(;this.queue.length;)this.queue[0].remove();this.progress=0},o.prototype.uploadItem=function(e){var t=this.getIndexOfItem(e),n=this.queue[t],o=this.isHTML5?"_xhrTransport":"_iframeTransport";n._prepareToUploading(),this.isUploading||(this._onBeforeUploadItem(n),n.isCancel||(n.isUploading=!0,this.isUploading=!0,this[o](n),this._render()))},o.prototype.cancelItem=function(e){var t=this,n=this.getIndexOfItem(e),o=this.queue[n],r=this.isHTML5?"_xhr":"_form";o&&(o.isCancel=!0,o.isUploading?o[r].abort():!function(){var e=[void 0,0,{}],n=function(){t._onCancelItem.apply(t,[o].concat(e)),t._onCompleteItem.apply(t,[o].concat(e))};i(n)}())},o.prototype.uploadAll=function(){var e=this.getNotUploadedItems().filter(function(e){return!e.isUploading});e.length&&(f(e,function(e){return e._prepareToUploading()}),e[0].upload())},o.prototype.cancelAll=function(){var e=this.getNotUploadedItems();f(e,function(e){return e.cancel()})},o.prototype.isFile=function(e){return this.constructor.isFile(e)},o.prototype.isFileLikeObject=function(e){return this.constructor.isFileLikeObject(e)},o.prototype.isArrayLikeObject=function(e){return this.constructor.isArrayLikeObject(e)},o.prototype.getIndexOfItem=function(e){return h(e)?e:this.queue.indexOf(e)},o.prototype.getNotUploadedItems=function(){return this.queue.filter(function(e){return!e.isUploaded})},o.prototype.getReadyItems=function(){return this.queue.filter(function(e){return e.isReady&&!e.isUploading}).sort(function(e,t){return e.index-t.index})},o.prototype.destroy=function(){var e=this;f(this._directives,function(t){f(e._directives[t],function(e){e.destroy()})})},o.prototype.onAfterAddingAll=function(e){},o.prototype.onAfterAddingFile=function(e){},o.prototype.onWhenAddingFileFailed=function(e,t,n){},o.prototype.onBeforeUploadItem=function(e){},o.prototype.onProgressItem=function(e,t){},o.prototype.onProgressAll=function(e){},o.prototype.onSuccessItem=function(e,t,n,o){},o.prototype.onErrorItem=function(e,t,n,o){},o.prototype.onCancelItem=function(e,t,n,o){},o.prototype.onCompleteItem=function(e,t,n,o){},o.prototype.onCompleteAll=function(){},o.prototype._getTotalProgress=function(e){if(this.removeAfterUpload)return e||0;var t=this.getNotUploadedItems().length,n=t?this.queue.length-t:this.queue.length,o=100/this.queue.length,r=(e||0)*o/100;return Math.round(n*o+r)},o.prototype._getFilters=function(e){if(!e)return this.filters;if(v(e))return e;var t=e.match(/[^\s,]+/g);return this.filters.filter(function(e){return-1!==t.indexOf(e.name)})},o.prototype._convertFiltersToPipes=function(e){var t=this;return e.map(function(e){var n=l(t,e.fn);return n.isAsync=3===e.fn.length,n.originalFilter=e,n})},o.prototype._render=function(){t.$$phase||t.$apply()},o.prototype._folderFilter=function(e){return!(!e.size&&!e.type)},o.prototype._queueLimitFilter=function(){return this.queue.length<this.queueLimit},o.prototype._isSuccessCode=function(e){return e>=200&&300>e||304===e},o.prototype._transformResponse=function(e,t){var o=this._headersGetter(t);return f(n.defaults.transformResponse,function(t){e=t(e,o)}),e},o.prototype._parseHeaders=function(e){var t,n,o,r={};return e?(f(e.split("\n"),function(e){o=e.indexOf(":"),t=e.slice(0,o).trim().toLowerCase(),n=e.slice(o+1).trim(),t&&(r[t]=r[t]?r[t]+", "+n:n)}),r):r},o.prototype._headersGetter=function(e){return function(t){return t?e[t.toLowerCase()]||null:e}},o.prototype._xhrTransport=function(e){var t,n=this,o=e._xhr=new XMLHttpRequest;if(e.disableMultipart?t=e._file:(t=new F,f(e.formData,function(e){f(e,function(e,n){t.append(n,e)})}),t.append(e.alias,e._file,e.file.name)),"number"!=typeof e._file.size)throw new TypeError("The file specified is no longer valid");o.upload.onprogress=function(t){var o=Math.round(t.lengthComputable?100*t.loaded/t.total:0);n._onProgressItem(e,o)},o.onload=function(){var t=n._parseHeaders(o.getAllResponseHeaders()),r=n._transformResponse(o.response,t),i=n._isSuccessCode(o.status)?"Success":"Error",s="_on"+i+"Item";n[s](e,r,o.status,t),n._onCompleteItem(e,r,o.status,t)},o.onerror=function(){var t=n._parseHeaders(o.getAllResponseHeaders()),r=n._transformResponse(o.response,t);n._onErrorItem(e,r,o.status,t),n._onCompleteItem(e,r,o.status,t)},o.onabort=function(){var t=n._parseHeaders(o.getAllResponseHeaders()),r=n._transformResponse(o.response,t);n._onCancelItem(e,r,o.status,t),n._onCompleteItem(e,r,o.status,t)},o.open(e.method,e.url,!0),o.withCredentials=e.withCredentials,f(e.headers,function(e,t){o.setRequestHeader(t,e)}),o.send(t)},o.prototype._iframeTransport=function(e){var t=this,n=_('<form style="display: none;" />'),o=_('<iframe name="iframeTransport'+Date.now()+'">'),r=e._input;e._form&&e._form.replaceWith(r),e._form=n,r.prop("name",e.alias),f(e.formData,function(e){f(e,function(e,t){var o=_('<input type="hidden" name="'+t+'" />');o.val(e),n.append(o)})}),n.prop({action:e.url,method:"POST",target:o.prop("name"),enctype:"multipart/form-data",encoding:"multipart/form-data"}),o.bind("load",function(){var n="",r=200;try{n=o[0].contentDocument.body.innerHTML}catch(i){r=500}var s={response:n,status:r,dummy:!0},a={},u=t._transformResponse(s.response,a);t._onSuccessItem(e,u,s.status,a),t._onCompleteItem(e,u,s.status,a)}),n.abort=function(){var i,s={status:0,dummy:!0},a={};o.unbind("load").prop("src","javascript:false;"),n.replaceWith(r),t._onCancelItem(e,i,s.status,a),t._onCompleteItem(e,i,s.status,a)},r.after(n),n.append(r).append(o),n[0].submit()},o.prototype._onWhenAddingFileFailed=function(e,t,n){this.onWhenAddingFileFailed(e,t,n)},o.prototype._onAfterAddingFile=function(e){this.onAfterAddingFile(e)},o.prototype._onAfterAddingAll=function(e){this.onAfterAddingAll(e)},o.prototype._onBeforeUploadItem=function(e){e._onBeforeUpload(),this.onBeforeUploadItem(e)},o.prototype._onProgressItem=function(e,t){var n=this._getTotalProgress(t);this.progress=n,e._onProgress(t),this.onProgressItem(e,t),this.onProgressAll(n),this._render()},o.prototype._onSuccessItem=function(e,t,n,o){e._onSuccess(t,n,o),this.onSuccessItem(e,t,n,o)},o.prototype._onErrorItem=function(e,t,n,o){e._onError(t,n,o),this.onErrorItem(e,t,n,o)},o.prototype._onCancelItem=function(e,t,n,o){e._onCancel(t,n,o),this.onCancelItem(e,t,n,o)},o.prototype._onCompleteItem=function(e,t,n,o){e._onComplete(t,n,o),this.onCompleteItem(e,t,n,o);var r=this.getReadyItems()[0];return this.isUploading=!1,y(r)?void r.upload():(this.onCompleteAll(),this.progress=this._getTotalProgress(),void this._render())},o.isFile=function(e){return b&&e instanceof b},o.isFileLikeObject=function(e){return e instanceof a},o.isArrayLikeObject=function(e){return d(e)&&"length"in e},o.inherit=function(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.super_=t},o}();return O.prototype.isHTML5=!(!b||!F),O.isHTML5=O.prototype.isHTML5,O}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){var n=[],o=!0,r=!1,i=void 0;try{for(var s,a=e[Symbol.iterator]();!(o=(s=a.next()).done)&&(n.push(s.value),!t||n.length!==t);o=!0);}catch(u){r=!0,i=u}finally{try{!o&&a["return"]&&a["return"]()}finally{if(r)throw i}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();t["default"]=i;var a=n(1),u=(o(a),angular),l=u.bind,p=u.copy,c=u.extend,f=u.forEach,d=u.isObject,h=u.isNumber,y=u.isDefined,v=u.isArray,m=u.isUndefined,_=u.element;i.$inject=["fileUploaderOptions","$rootScope","$http","$window","$timeout","FileLikeObject","FileItem","Pipeline"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){return function(){function e(t){r(this,e);var n=l(t),o=n?t.value:t,i=p(o)?"FakePath":"Object",s="_createFrom"+i;this[s](o)}return e.prototype._createFromFakePath=function(e){this.lastModifiedDate=null,this.size=null,this.type="like/"+e.slice(e.lastIndexOf(".")+1).toLowerCase(),this.name=e.slice(e.lastIndexOf("/")+e.lastIndexOf("\\")+2)},e.prototype._createFromObject=function(e){this.lastModifiedDate=u(e.lastModifiedDate),this.size=e.size,this.type=e.type,this.name=e.name},e}()}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=i;var s=n(1),a=(o(s),angular),u=a.copy,l=a.isElement,p=a.isString},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){return function(){function n(e,o,i){r(this,n);var s=c(o),a=s?p(o):null,f=s?null:o;l(this,{url:e.url,alias:e.alias,headers:u(e.headers),formData:u(e.formData),removeAfterUpload:e.removeAfterUpload,withCredentials:e.withCredentials,disableMultipart:e.disableMultipart,method:e.method},i,{uploader:e,file:new t(o),isReady:!1,isUploading:!1,isUploaded:!1,isSuccess:!1,isCancel:!1,isError:!1,progress:0,index:null,_file:f,_input:a}),a&&this._replaceNode(a)}return n.prototype.upload=function(){try{this.uploader.uploadItem(this)}catch(e){this.uploader._onCompleteItem(this,"",0,[]),this.uploader._onErrorItem(this,"",0,[])}},n.prototype.cancel=function(){this.uploader.cancelItem(this)},n.prototype.remove=function(){this.uploader.removeFromQueue(this)},n.prototype.onBeforeUpload=function(){},n.prototype.onProgress=function(e){},n.prototype.onSuccess=function(e,t,n){},n.prototype.onError=function(e,t,n){},n.prototype.onCancel=function(e,t,n){},n.prototype.onComplete=function(e,t,n){},n.prototype._onBeforeUpload=function(){this.isReady=!0,this.isUploading=!1,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!1,this.isError=!1,this.progress=0,this.onBeforeUpload()},n.prototype._onProgress=function(e){this.progress=e,this.onProgress(e)},n.prototype._onSuccess=function(e,t,n){this.isReady=!1,this.isUploading=!1,this.isUploaded=!0,this.isSuccess=!0,this.isCancel=!1,this.isError=!1,this.progress=100,this.index=null,this.onSuccess(e,t,n)},n.prototype._onError=function(e,t,n){this.isReady=!1,this.isUploading=!1,this.isUploaded=!0,this.isSuccess=!1,this.isCancel=!1,this.isError=!0,this.progress=0,this.index=null,this.onError(e,t,n)},n.prototype._onCancel=function(e,t,n){this.isReady=!1,this.isUploading=!1,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!0,this.isError=!1,this.progress=0,this.index=null,this.onCancel(e,t,n)},n.prototype._onComplete=function(e,t,n){this.onComplete(e,t,n),this.removeAfterUpload&&this.remove()},n.prototype._destroy=function(){this._input&&this._input.remove(),this._form&&this._form.remove(),delete this._form,delete this._input},n.prototype._prepareToUploading=function(){this.index=this.index||++this.uploader._nextIndex,this.isReady=!0},n.prototype._replaceNode=function(t){var n=e(t.clone())(t.scope());n.prop("value",null),t.css("display","none"),t.after(n)},n}()}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=i;var s=n(1),a=(o(s),angular),u=a.copy,l=a.extend,p=a.element,c=a.isElement;i.$inject=["$compile","FileLikeObject"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){var e=function(){function e(t){r(this,e),u(this,t),this.uploader._directives[this.prop].push(this),this._saveLinks(),this.bind()}return e.prototype.bind=function(){for(var e in this.events){var t=this.events[e];this.element.bind(e,this[t])}},e.prototype.unbind=function(){for(var e in this.events)this.element.unbind(e,this.events[e])},e.prototype.destroy=function(){var e=this.uploader._directives[this.prop].indexOf(this);this.uploader._directives[this.prop].splice(e,1),this.unbind()},e.prototype._saveLinks=function(){for(var e in this.events){var t=this.events[e];this[t]=this[t].bind(this)}},e}();return e.prototype.events={},e}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=i;var s=n(1),a=(o(s),angular),u=a.extend},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e,t){return function(t){function n(e){r(this,n);var o=p(e,{events:{$destroy:"destroy",change:"onChange"},prop:"select"}),s=i(this,t.call(this,o));return s.uploader.isHTML5||s.element.removeAttr("multiple"),s.element.prop("value",null),s}return s(n,t),n.prototype.getOptions=function(){},n.prototype.getFilters=function(){},n.prototype.isEmptyAfterSelection=function(){return!!this.element.attr("multiple")},n.prototype.onChange=function(){var t=this.uploader.isHTML5?this.element[0].files:this.element[0],n=this.getOptions(),o=this.getFilters();this.uploader.isHTML5||this.destroy(),this.uploader.addToQueue(t,n,o),this.isEmptyAfterSelection()&&(this.element.prop("value",null),this.element.replaceWith(e(this.element.clone())(this.scope)))},n}(t)}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=a;var u=n(1),l=(o(u),angular),p=l.extend;a.$inject=["$compile","FileDirective"]},function(e,t){"use strict";function n(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e){return function(){function t(){var e=arguments.length<=0||void 0===arguments[0]?[]:arguments[0];o(this,t),this.pipes=e}return t.prototype.next=function(t){var o=this.pipes.shift();if(a(o))return void this.onSuccessful.apply(this,n(t));var r=new Error("The filter has not passed");if(r.pipe=o,r.args=t,o.isAsync){var i=e.defer(),u=s(this,this.next,t),l=s(this,this.onThrown,r);i.promise.then(u,l),o.apply(void 0,n(t).concat([i]))}else{var p=Boolean(o.apply(void 0,n(t)));p?this.next(t):this.onThrown(r)}},t.prototype.exec=function(){for(var e=arguments.length,t=Array(e),n=0;e>n;n++)t[n]=arguments[n];this.next(t)},t.prototype.onThrown=function(e){},t.prototype.onSuccessful=function(){},t}()}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=angular,s=i.bind,a=i.isUndefined;r.$inject=["$q"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return function(e){function t(n){r(this,t);var o=p(n,{events:{$destroy:"destroy",drop:"onDrop",dragover:"onDragOver",dragleave:"onDragLeave"},prop:"drop"});return i(this,e.call(this,o))}return s(t,e),t.prototype.getOptions=function(){},t.prototype.getFilters=function(){},t.prototype.onDrop=function(e){var t=this._getTransfer(e);if(t){var n=this.getOptions(),o=this.getFilters();this._preventAndStop(e),c(this.uploader._directives.over,this._removeOverClass,this),this.uploader.addToQueue(t.files,n,o)}},t.prototype.onDragOver=function(e){var t=this._getTransfer(e);this._haveFiles(t.types)&&(t.dropEffect="copy",this._preventAndStop(e),c(this.uploader._directives.over,this._addOverClass,this))},t.prototype.onDragLeave=function(e){e.currentTarget!==this.element[0]&&(this._preventAndStop(e),c(this.uploader._directives.over,this._removeOverClass,this))},t.prototype._getTransfer=function(e){return e.dataTransfer?e.dataTransfer:e.originalEvent.dataTransfer},t.prototype._preventAndStop=function(e){e.preventDefault(),e.stopPropagation()},t.prototype._haveFiles=function(e){return e?e.indexOf?-1!==e.indexOf("Files"):e.contains?e.contains("Files"):!1:!1},t.prototype._addOverClass=function(e){e.addOverClass()},t.prototype._removeOverClass=function(e){e.removeOverClass()},t}(e)}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=a;var u=n(1),l=(o(u),angular),p=l.extend,c=l.forEach;a.$inject=["FileDirective"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return function(e){function t(n){r(this,t);var o=p(n,{events:{$destroy:"destroy"},prop:"over",overClass:"nv-file-over"});return i(this,e.call(this,o))}return s(t,e),t.prototype.addOverClass=function(){this.element.addClass(this.getOverClass())},t.prototype.removeOverClass=function(){this.element.removeClass(this.getOverClass())},t.prototype.getOverClass=function(){return this.overClass},t}(e)}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=a;var u=n(1),l=(o(u),angular),p=l.extend;a.$inject=["FileDirective"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t,n){return{link:function(o,r,i){var s=o.$eval(i.uploader);if(!(s instanceof t))throw new TypeError('"Uploader" must be an instance of FileUploader');var a=new n({uploader:s,element:r,scope:o});a.getOptions=e(i.options).bind(a,o),a.getFilters=function(){return i.filters}}}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=n(1);o(i);r.$inject=["$parse","FileUploader","FileSelect"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t,n){return{link:function(o,r,i){var s=o.$eval(i.uploader);if(!(s instanceof t))throw new TypeError('"Uploader" must be an instance of FileUploader');if(s.isHTML5){var a=new n({uploader:s,element:r});a.getOptions=e(i.options).bind(a,o),a.getFilters=function(){return i.filters}}}}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=n(1);o(i);r.$inject=["$parse","FileUploader","FileDrop"]},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){return{link:function(n,o,r){var i=n.$eval(r.uploader);if(!(i instanceof e))throw new TypeError('"Uploader" must be an instance of FileUploader');var s=new t({uploader:i,element:o});s.getOverClass=function(){return r.overClass||s.overClass}}}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=n(1);o(i);r.$inject=["FileUploader","FileOver"]}])});

/**
 * Created by ljf on 2017/2/8.
 */
WEB_ENDPOINT = 'https://centralweb.nvts.co/v1/bm/';
// WEB_ENDPOINT = 'https://localweb.onelinkbell-firstalert.com/v1/bm/';
// WEB_ENDPOINT = 'http://localhost:8080/v1/bm/';
// WEB_ENDPOINT = 'http://test-localweb.nvts.co/v1/bm/';
// WEB_ENDPOINT = 'https://cn-north-1-localweb.nvts.co/v1/bm/';

/**
 * Created by ljf on 2017/2/10.
 */

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) { //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};
/* globals define, jQuery, module, require, angular, moment */
/* jslint vars:true */

/**
 * @license angular-bootstrap-datetimepicker
 * Copyright 2016 Knight Rider Consulting, Inc. http://www.knightrider.com
 * License: MIT
 *
 * @author        Dale "Ducky" Lotts
 * @since        2013-Jul-8
 */

;(function (root, factory) {
  'use strict'
  /* istanbul ignore if */
  if (typeof module !== 'undefined' && module.exports) {
    var ng = typeof angular === 'undefined' ? require('angular') : angular
    var mt = typeof moment === 'undefined' ? require('moment') : moment
    factory(ng, mt)
    module.exports = 'ui.bootstrap.datetimepicker'
    /* istanbul ignore next */
  } else if (typeof define === 'function' && /* istanbul ignore next */ define.amd) {
    define(['angular', 'moment'], factory)
  } else {
    factory(root.angular, root.moment)
  }
}(this, function (angular, moment) {
  'use strict'
  angular.module('ui.bootstrap.datetimepicker', [])
    .service('dateTimePickerConfig', DateTimePickerConfigProvider)
    .service('dateTimePickerValidator', DateTimePickerValidatorService)
    .directive('datetimepicker', DatetimepickerDirective)

  DatetimepickerDirective.$inject = ['dateTimePickerConfig', 'dateTimePickerValidator']

  function DatetimepickerDirective (defaultConfig, configurationValidator) {
    var directiveDefinition = {
      bindToController: false,
      controller: DirectiveController,
      controllerAs: 'dateTimePickerController',
      replace: true,
      require: 'ngModel',
      restrict: 'E',
      scope: {
        beforeRender: '&',
        onSetTime: '&'
      },
      templateUrl: 'templates/datetimepicker.html'
    }

    DirectiveController.$inject = ['$scope', '$element', '$attrs']

    function DirectiveController ($scope, $element, $attrs) {
      // Configuration
      var ngModelController = $element.controller('ngModel')

      var configuration = createConfiguration()
      $scope.screenReader = configuration.screenReader

      // Behavior
      $scope.changeView = changeView
      ngModelController.$render = $render

      if (configuration.configureOn) {
        $scope.$on(configuration.configureOn, function () {
          configuration = createConfiguration()
          $scope.screenReader = configuration.screenReader
          ngModelController.$render()
        })
      }

      if (configuration.renderOn) {
        $scope.$on(configuration.renderOn, ngModelController.$render)
      }

      // Implementation

      var viewToModelFactory = {
        year: yearModelFactory,

        month: monthModelFactory,

        day: dayModelFactory,

        hour: hourModelFactory,

        minute: minuteModelFactory,

        setTime: setTime
      }

      function changeView (viewName, dateObject, event) {
        if (event) {
          event.stopPropagation()
          event.preventDefault()
        }

        if (viewName && (dateObject.utcDateValue > -Infinity) && dateObject.selectable && viewToModelFactory[viewName]) {
          var result = viewToModelFactory[viewName](dateObject.utcDateValue)

          var weekDates = []
          if (result.weeks) {
            for (var i = 0; i < result.weeks.length; i += 1) {
              var week = result.weeks[i]
              for (var j = 0; j < week.dates.length; j += 1) {
                var weekDate = week.dates[j]
                weekDates.push(weekDate)
              }
            }
          }

          $scope.beforeRender({
            $view: result.currentView,
            $dates: result.dates || weekDates,
            $leftDate: result.leftDate,
            $upDate: result.previousViewDate,
            $rightDate: result.rightDate
          })

          $scope.data = result
        }
      }

      function yearModelFactory (milliseconds) {
        var selectedDate = moment.utc(milliseconds).startOf('year')
        // View starts one year before the decade starts and ends one year after the decade ends
        // i.e. passing in a date of 1/1/2013 will give a range of 2009 to 2020
        // Truncate the last digit from the current year and subtract 1 to get the start of the decade
        var startDecade = (parseInt(selectedDate.year() / 10, 10) * 10)
        var startDate = moment.utc(startOfDecade(milliseconds)).subtract(1, 'year').startOf('year')

        var yearFormat = 'YYYY'
        var activeFormat = formatValue(ngModelController.$modelValue, yearFormat)
        var currentFormat = moment().format(yearFormat)

        var result = {
          'currentView': 'year',
          'nextView': configuration.minView === 'year' ? 'setTime' : 'month',
          'previousViewDate': new DateObject({
            utcDateValue: null,
            display: startDecade + '-' + (startDecade + 9)
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(startDate).subtract(9, 'year').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(startDate).add(11, 'year').valueOf()}),
          'dates': []
        }

        for (var i = 0; i < 12; i += 1) {
          var yearMoment = moment.utc(startDate).add(i, 'years')
          var dateValue = {
            'active': yearMoment.format(yearFormat) === activeFormat,
            'current': yearMoment.format(yearFormat) === currentFormat,
            'display': yearMoment.format(yearFormat),
            'future': yearMoment.year() > startDecade + 9,
            'past': yearMoment.year() < startDecade,
            'utcDateValue': yearMoment.valueOf()
          }

          result.dates.push(new DateObject(dateValue))
        }

        return result
      }

      function monthModelFactory (milliseconds) {
        var startDate = moment.utc(milliseconds).startOf('year')
        var previousViewDate = startOfDecade(milliseconds)

        var monthFormat = 'YYYY-MMM'
        var activeFormat = formatValue(ngModelController.$modelValue, monthFormat)
        var currentFormat = moment().format(monthFormat)

        var result = {
          'previousView': 'year',
          'currentView': 'month',
          'nextView': configuration.minView === 'month' ? 'setTime' : 'day',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: startDate.format('YYYY')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(startDate).subtract(1, 'year').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(startDate).add(1, 'year').valueOf()}),
          'dates': []
        }

        for (var i = 0; i < 12; i += 1) {
          var monthMoment = moment.utc(startDate).add(i, 'months')
          var dateValue = {
            'active': monthMoment.format(monthFormat) === activeFormat,
            'current': monthMoment.format(monthFormat) === currentFormat,
            'display': monthMoment.format('MMM'),
            'utcDateValue': monthMoment.valueOf()
          }

          result.dates.push(new DateObject(dateValue))
        }

        return result
      }

      function dayModelFactory (milliseconds) {
        var selectedDate = moment.utc(milliseconds)
        var startOfMonth = moment.utc(selectedDate).startOf('month')
        var previousViewDate = moment.utc(selectedDate).startOf('year')
        var endOfMonth = moment.utc(selectedDate).endOf('month')

        var startDate = moment.utc(startOfMonth).subtract(Math.abs(startOfMonth.weekday()), 'days')

        var dayFormat = 'YYYY-MMM-DD'
        var activeFormat = formatValue(ngModelController.$modelValue, dayFormat)
        var currentFormat = moment().format(dayFormat)

        var result = {
          'previousView': 'month',
          'currentView': 'day',
          'nextView': configuration.minView === 'day' ? 'setTime' : 'hour',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: startOfMonth.format('YYYY-MMM')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(startOfMonth).subtract(1, 'months').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(startOfMonth).add(1, 'months').valueOf()}),
          'dayNames': [],
          'weeks': []
        }

        for (var dayNumber = 0; dayNumber < 7; dayNumber += 1) {
          result.dayNames.push(moment.utc().weekday(dayNumber).format('dd'))
        }

        for (var i = 0; i < 6; i += 1) {
          var week = {dates: []}
          for (var j = 0; j < 7; j += 1) {
            var dayMoment = moment.utc(startDate).add((i * 7) + j, 'days')
            var dateValue = {
              'active': dayMoment.format(dayFormat) === activeFormat,
              'current': dayMoment.format(dayFormat) === currentFormat,
              'display': dayMoment.format('D'),
              'future': dayMoment.isAfter(endOfMonth),
              'past': dayMoment.isBefore(startOfMonth),
              'utcDateValue': dayMoment.valueOf()
            }
            week.dates.push(new DateObject(dateValue))
          }
          result.weeks.push(week)
        }

        return result
      }

      function hourModelFactory (milliseconds) {
        var selectedDate = moment.utc(milliseconds).startOf('day')
        var previousViewDate = moment.utc(selectedDate).startOf('month')

        var hourFormat = 'YYYY-MM-DD H'
        var activeFormat = formatValue(ngModelController.$modelValue, hourFormat)
        var currentFormat = moment().format(hourFormat)

        var result = {
          'previousView': 'day',
          'currentView': 'hour',
          'nextView': configuration.minView === 'hour' ? 'setTime' : 'minute',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: selectedDate.format('ll')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(selectedDate).subtract(1, 'days').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(selectedDate).add(1, 'days').valueOf()}),
          'dates': []
        }

        for (var i = 0; i < 24; i += 1) {
          var hourMoment = moment.utc(selectedDate).add(i, 'hours')
          var dateValue = {
            'active': hourMoment.format(hourFormat) === activeFormat,
            'current': hourMoment.format(hourFormat) === currentFormat,
            'display': hourMoment.format('LT'),
            'utcDateValue': hourMoment.valueOf()
          }

          result.dates.push(new DateObject(dateValue))
        }

        return result
      }

      function minuteModelFactory (milliseconds) {
        var selectedDate = moment.utc(milliseconds).startOf('hour')
        var previousViewDate = moment.utc(selectedDate).startOf('day')

        var minuteFormat = 'YYYY-MM-DD H:mm'
        var activeFormat = formatValue(ngModelController.$modelValue, minuteFormat)
        var currentFormat = moment().format(minuteFormat)

        var result = {
          'previousView': 'hour',
          'currentView': 'minute',
          'nextView': 'setTime',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: selectedDate.format('lll')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(selectedDate).subtract(1, 'hours').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(selectedDate).add(1, 'hours').valueOf()}),
          'dates': []
        }

        var limit = 60 / configuration.minuteStep

        for (var i = 0; i < limit; i += 1) {
          var hourMoment = moment.utc(selectedDate).add(i * configuration.minuteStep, 'minute')
          var dateValue = {
            'active': hourMoment.format(minuteFormat) === activeFormat,
            'current': hourMoment.format(minuteFormat) === currentFormat,
            'display': hourMoment.format('LT'),
            'utcDateValue': hourMoment.valueOf()
          }

          result.dates.push(new DateObject(dateValue))
        }

        return result
      }

      function setTime (milliseconds) {
        var tempDate = new Date(milliseconds)
        var newDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds(), tempDate.getUTCMilliseconds())

        switch (configuration.modelType) {
          case 'Date':
            // No additional work needed
            break
          case 'moment':
            newDate = moment([tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds(), tempDate.getUTCMilliseconds()])
            break
          case 'milliseconds':
            newDate = milliseconds
            break
          default: // It is assumed that the modelType is a formatting string.
            newDate = moment([tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds(), tempDate.getUTCMilliseconds()]).format(configuration.modelType)
        }

        var oldDate = ngModelController.$modelValue
        ngModelController.$setViewValue(newDate)

        if (configuration.dropdownSelector) {
          jQuery(configuration.dropdownSelector).dropdown('toggle')
        }

        $scope.onSetTime({newDate: newDate, oldDate: oldDate})

        return viewToModelFactory[configuration.startView](milliseconds)
      }

      function $render () {
        $scope.changeView(configuration.startView, new DateObject({utcDateValue: getUTCTime(ngModelController.$viewValue)}))
      }

      function startOfDecade (milliseconds) {
        var startYear = (parseInt(moment.utc(milliseconds).year() / 10, 10) * 10)
        return moment.utc(milliseconds).year(startYear).startOf('year')
      }

      function formatValue (timeValue, formatString) {
        if (timeValue) {
          return getMoment(timeValue).format(formatString)
        } else {
          return ''
        }
      }

      /**
       * Converts a time value into a moment.
       *
       * This function is now necessary because moment logs a warning when parsing a string without a format.
       * @param modelValue
       *  a time value in any of the supported formats (Date, moment, milliseconds, and string)
       * @returns {moment}
       *  representing the specified time value.
       */

      function getMoment (modelValue) {
        return moment(modelValue, angular.isString(modelValue) ? configuration.parseFormat : undefined)
      }

      /**
       * Converts a time value to UCT/GMT time.
       * @param modelValue
       *  a time value in any of the supported formats (Date, moment, milliseconds, and string)
       * @returns {number}
       *  number of milliseconds since 1/1/1970
       */

      function getUTCTime (modelValue) {
        var tempDate = new Date()
        if (modelValue) {
          var tempMoment = getMoment(modelValue)
          if (tempMoment.isValid()) {
            tempDate = tempMoment.toDate()
          } else {
            throw new Error('Invalid date: ' + modelValue)
          }
        }
        return tempDate.getTime() - (tempDate.getTimezoneOffset() * 60000)
      }

      function createConfiguration () {
        var directiveConfig = {}

        if ($attrs.datetimepickerConfig) {
          directiveConfig = $scope.$parent.$eval($attrs.datetimepickerConfig)
        }

        var configuration = angular.extend({}, defaultConfig, directiveConfig)

        configurationValidator.validate(configuration)

        return configuration
      }
    }

    function DateObject () {
      var tempDate = new Date(arguments[0].utcDateValue)
      var localOffset = tempDate.getTimezoneOffset() * 60000

      this.utcDateValue = tempDate.getTime()
      this.selectable = true

      this.localDateValue = function localDateValue () {
        return this.utcDateValue + localOffset
      }

      var validProperties = ['active', 'current', 'display', 'future', 'past', 'selectable', 'utcDateValue']

      var constructorObject = arguments[0]

      Object.keys(constructorObject).filter(function (key) {
        return validProperties.indexOf(key) >= 0
      }).forEach(function (key) {
        this[key] = constructorObject[key]
      }, this)
    }

    return directiveDefinition
  }

  function DateTimePickerConfigProvider () {
    var defaultConfiguration = {
      configureOn: null,
      dropdownSelector: null,
      minuteStep: 5,
      minView: 'minute',
      modelType: 'Date',
      parseFormat: 'YYYY-MM-DDTHH:mm:ss.SSSZZ',
      renderOn: null,
      startView: 'day'
    }

    var defaultLocalization = {
      'bg': {previous: 'предишна', next: 'следваща'},
      'ca': {previous: 'anterior', next: 'següent'},
      'da': {previous: 'forrige', next: 'næste'},
      'de': {previous: 'vorige', next: 'weiter'},
      'en-au': {previous: 'previous', next: 'next'},
      'en-gb': {previous: 'previous', next: 'next'},
      'en': {previous: 'previous', next: 'next'},
      'es-us': {previous: 'atrás', next: 'siguiente'},
      'es': {previous: 'atrás', next: 'siguiente'},
      'fi': {previous: 'edellinen', next: 'seuraava'},
      'fr': {previous: 'précédent', next: 'suivant'},
      'hu': {previous: 'előző', next: 'következő'},
      'it': {previous: 'precedente', next: 'successivo'},
      'ja': {previous: '前へ', next: '次へ'},
      'ml': {previous: 'മുൻപുള്ളത്', next: 'അടുത്തത്'},
      'nl': {previous: 'vorige', next: 'volgende'},
      'pl': {previous: 'poprzednia', next: 'następna'},
      'pt-br': {previous: 'anteriores', next: 'próximos'},
      'pt': {previous: 'anterior', next: 'próximo'},
      'ro': {previous: 'anterior', next: 'următor'},
      'ru': {previous: 'предыдущая', next: 'следующая'},
      'sk': {previous: 'predošlá', next: 'ďalšia'},
      'sv': {previous: 'föregående', next: 'nästa'},
      'tr': {previous: 'önceki', next: 'sonraki'},
      'uk': {previous: 'назад', next: 'далі'},
      'zh-cn': {previous: '上一页', next: '下一页'},
      'zh-tw': {previous: '上一頁', next: '下一頁'}
    }

    var screenReader = defaultLocalization[moment.locale().toLowerCase()]

    return angular.extend({}, defaultConfiguration, {screenReader: screenReader})
  }

  DateTimePickerValidatorService.$inject = ['$log']

  function DateTimePickerValidatorService ($log) {
    return {
      validate: validator
    }

    function validator (configuration) {
      var validOptions = [
        'configureOn',
        'dropdownSelector',
        'minuteStep',
        'minView',
        'modelType',
        'parseFormat',
        'renderOn',
        'startView',
        'screenReader'
      ]

      var invalidOptions = Object.keys(configuration).filter(function (key) {
        return (validOptions.indexOf(key) < 0)
      })

      if (invalidOptions.length) {
        throw new Error('Invalid options: ' + invalidOptions.join(', '))
      }

      // Order of the elements in the validViews array is significant.
      var validViews = ['minute', 'hour', 'day', 'month', 'year']

      if (validViews.indexOf(configuration.startView) < 0) {
        throw new Error('invalid startView value: ' + configuration.startView)
      }

      if (validViews.indexOf(configuration.minView) < 0) {
        throw new Error('invalid minView value: ' + configuration.minView)
      }

      if (validViews.indexOf(configuration.minView) > validViews.indexOf(configuration.startView)) {
        throw new Error('startView must be greater than minView')
      }

      if (!angular.isNumber(configuration.minuteStep)) {
        throw new Error('minuteStep must be numeric')
      }
      if (configuration.minuteStep <= 0 || configuration.minuteStep >= 60) {
        throw new Error('minuteStep must be greater than zero and less than 60')
      }
      if (configuration.configureOn !== null && !angular.isString(configuration.configureOn)) {
        throw new Error('configureOn must be a string')
      }
      if (configuration.configureOn !== null && configuration.configureOn.length < 1) {
        throw new Error('configureOn must not be an empty string')
      }
      if (configuration.renderOn !== null && !angular.isString(configuration.renderOn)) {
        throw new Error('renderOn must be a string')
      }
      if (configuration.renderOn !== null && configuration.renderOn.length < 1) {
        throw new Error('renderOn must not be an empty string')
      }
      if (configuration.modelType !== null && !angular.isString(configuration.modelType)) {
        throw new Error('modelType must be a string')
      }
      if (configuration.modelType !== null && configuration.modelType.length < 1) {
        throw new Error('modelType must not be an empty string')
      }
      if (configuration.modelType !== 'Date' && configuration.modelType !== 'moment' && configuration.modelType !== 'milliseconds') {
        // modelType contains string format, overriding parseFormat with modelType
        configuration.parseFormat = configuration.modelType
      }
      if (configuration.dropdownSelector !== null && !angular.isString(configuration.dropdownSelector)) {
        throw new Error('dropdownSelector must be a string')
      }

      /* istanbul ignore next */
      if (configuration.dropdownSelector !== null && ((typeof jQuery === 'undefined') || (typeof jQuery().dropdown !== 'function'))) {
        $log.error('Please DO NOT specify the dropdownSelector option unless you are using jQuery AND Bootstrap.js. ' +
          'Please include jQuery AND Bootstrap.js, or write code to close the dropdown in the on-set-time callback. \n\n' +
          'The dropdownSelector configuration option is being removed because it will not function properly.')
        delete configuration.dropdownSelector
      }
    }
  }
}))

/* globals define, module, require, angular */

/**
 * @license angular-bootstrap-datetimepicker
 * Copyright 2016 Knight Rider Consulting, Inc. http://www.knightrider.com
 * License: MIT
 *
 * @author       Dale "Ducky" Lotts
 * @since        2016-Jan-31
 */

;(function (root, factory) {
  'use strict'
  /* istanbul ignore if */
  if (typeof module !== 'undefined' && module.exports) {
    var ng = typeof angular === 'undefined' ? require('angular') : angular
    factory(ng)
    module.exports = 'ui.bootstrap.datetimepicker.templates'
    /* istanbul ignore next */
  } else if (typeof define === 'function' && /* istanbul ignore next */ define.amd) {
    define(['angular'], factory)
  } else {
    factory(root.angular, root.moment)
  }
}(this, function (angular) {
  'use strict'
  angular.module('ui.bootstrap.datetimepicker').run(['$templateCache', function ($templateCache) {
    $templateCache.put('templates/datetimepicker.html', '<div class="datetimepicker table-responsive">\n    <table class="table table-condensed {{ data.currentView }}-view">\n        <thead>\n        <tr>\n            <th class="left" data-ng-click="changeView(data.currentView, data.leftDate, $event)" data-ng-show="data.leftDate.selectable"><i class="glyphicon glyphicon-arrow-left"><span class="sr-only">{{ screenReader.previous }}</span></i>\n            </th>\n            <th class="switch" colspan="5" data-ng-show="data.previousViewDate.selectable" data-ng-click="changeView(data.previousView, data.previousViewDate, $event)">{{ data.previousViewDate.display }}</th>\n            <th class="right" data-ng-click="changeView(data.currentView, data.rightDate, $event)" data-ng-show="data.rightDate.selectable"><i class="glyphicon glyphicon-arrow-right"><span class="sr-only">{{ screenReader.next }}</span></i>\n            </th>\n        </tr>\n        <tr>\n            <th class="dow" data-ng-repeat="day in data.dayNames">{{ day }}</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr data-ng-if="data.currentView !== \'day\'">\n            <td colspan="7">\n                          <span class="{{ data.currentView }}" data-ng-repeat="dateObject in data.dates" data-ng-class="{current: dateObject.current, active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}" data-ng-click="changeView(data.nextView, dateObject, $event)">{{ dateObject.display }}</span></td>\n        </tr>\n        <tr data-ng-if="data.currentView === \'day\'" data-ng-repeat="week in data.weeks">\n            <td data-ng-repeat="dateObject in week.dates" data-ng-click="changeView(data.nextView, dateObject, $event)" class="day" data-ng-class="{current: dateObject.current, active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}">{{ dateObject.display }}</td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n')
  }])
}))

/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */
var hexcase = 0;   /* hex output format. 0 - lowercase; 1 - uppercase        */
var b64pad  = "";  /* base-64 pad character. "=" for strict RFC compliance   */

/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
function hex_md5(s)    { return rstr2hex(rstr_md5(str2rstr_utf8(s))); }
function b64_md5(s)    { return rstr2b64(rstr_md5(str2rstr_utf8(s))); }
function any_md5(s, e) { return rstr2any(rstr_md5(str2rstr_utf8(s)), e); }
function hex_hmac_md5(k, d)
{ return rstr2hex(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d))); }
function b64_hmac_md5(k, d)
{ return rstr2b64(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d))); }
function any_hmac_md5(k, d, e)
{ return rstr2any(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)), e); }

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test()
{
  return hex_md5("abc").toLowerCase() == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of a raw string
 */
function rstr_md5(s)
{
  return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
}

/*
 * Calculate the HMAC-MD5, of a key and some data (raw strings)
 */
function rstr_hmac_md5(key, data)
{
  var bkey = rstr2binl(key);
  if(bkey.length > 16) bkey = binl_md5(bkey, key.length * 8);

  var ipad = Array(16), opad = Array(16);
  for(var i = 0; i < 16; i++)
  {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
  }

  var hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
}

/*
 * Convert a raw string to a hex string
 */
function rstr2hex(input)
{
  try { hexcase } catch(e) { hexcase=0; }
  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var output = "";
  var x;
  for(var i = 0; i < input.length; i++)
  {
    x = input.charCodeAt(i);
    output += hex_tab.charAt((x >>> 4) & 0x0F)
        +  hex_tab.charAt( x        & 0x0F);
  }
  return output;
}

/*
 * Convert a raw string to a base-64 string
 */
function rstr2b64(input)
{
  try { b64pad } catch(e) { b64pad=''; }
  var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var output = "";
  var len = input.length;
  for(var i = 0; i < len; i += 3)
  {
    var triplet = (input.charCodeAt(i) << 16)
        | (i + 1 < len ? input.charCodeAt(i+1) << 8 : 0)
        | (i + 2 < len ? input.charCodeAt(i+2)      : 0);
    for(var j = 0; j < 4; j++)
    {
      if(i * 8 + j * 6 > input.length * 8) output += b64pad;
      else output += tab.charAt((triplet >>> 6*(3-j)) & 0x3F);
    }
  }
  return output;
}

/*
 * Convert a raw string to an arbitrary string encoding
 */
function rstr2any(input, encoding)
{
  var divisor = encoding.length;
  var i, j, q, x, quotient;

  /* Convert to an array of 16-bit big-endian values, forming the dividend */
  var dividend = Array(Math.ceil(input.length / 2));
  for(i = 0; i < dividend.length; i++)
  {
    dividend[i] = (input.charCodeAt(i * 2) << 8) | input.charCodeAt(i * 2 + 1);
  }

  /*
   * Repeatedly perform a long division. The binary array forms the dividend,
   * the length of the encoding is the divisor. Once computed, the quotient
   * forms the dividend for the next step. All remainders are stored for later
   * use.
   */
  var full_length = Math.ceil(input.length * 8 /
      (Math.log(encoding.length) / Math.log(2)));
  var remainders = Array(full_length);
  for(j = 0; j < full_length; j++)
  {
    quotient = Array();
    x = 0;
    for(i = 0; i < dividend.length; i++)
    {
      x = (x << 16) + dividend[i];
      q = Math.floor(x / divisor);
      x -= q * divisor;
      if(quotient.length > 0 || q > 0)
        quotient[quotient.length] = q;
    }
    remainders[j] = x;
    dividend = quotient;
  }

  /* Convert the remainders to the output string */
  var output = "";
  for(i = remainders.length - 1; i >= 0; i--)
    output += encoding.charAt(remainders[i]);

  return output;
}

/*
 * Encode a string as utf-8.
 * For efficiency, this assumes the input is valid utf-16.
 */
function str2rstr_utf8(input)
{
  var output = "";
  var i = -1;
  var x, y;

  while(++i < input.length)
  {
    /* Decode utf-16 surrogate pairs */
    x = input.charCodeAt(i);
    y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
    if(0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF)
    {
      x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
      i++;
    }

    /* Encode output as utf-8 */
    if(x <= 0x7F)
      output += String.fromCharCode(x);
    else if(x <= 0x7FF)
      output += String.fromCharCode(0xC0 | ((x >>> 6 ) & 0x1F),
          0x80 | ( x         & 0x3F));
    else if(x <= 0xFFFF)
      output += String.fromCharCode(0xE0 | ((x >>> 12) & 0x0F),
          0x80 | ((x >>> 6 ) & 0x3F),
          0x80 | ( x         & 0x3F));
    else if(x <= 0x1FFFFF)
      output += String.fromCharCode(0xF0 | ((x >>> 18) & 0x07),
          0x80 | ((x >>> 12) & 0x3F),
          0x80 | ((x >>> 6 ) & 0x3F),
          0x80 | ( x         & 0x3F));
  }
  return output;
}

/*
 * Encode a string as utf-16
 */
function str2rstr_utf16le(input)
{
  var output = "";
  for(var i = 0; i < input.length; i++)
    output += String.fromCharCode( input.charCodeAt(i)        & 0xFF,
        (input.charCodeAt(i) >>> 8) & 0xFF);
  return output;
}

function str2rstr_utf16be(input)
{
  var output = "";
  for(var i = 0; i < input.length; i++)
    output += String.fromCharCode((input.charCodeAt(i) >>> 8) & 0xFF,
        input.charCodeAt(i)        & 0xFF);
  return output;
}

/*
 * Convert a raw string to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */
function rstr2binl(input)
{
  var output = Array(input.length >> 2);
  for(var i = 0; i < output.length; i++)
    output[i] = 0;
  for(var i = 0; i < input.length * 8; i += 8)
    output[i>>5] |= (input.charCodeAt(i / 8) & 0xFF) << (i%32);
  return output;
}

/*
 * Convert an array of little-endian words to a string
 */
function binl2rstr(input)
{
  var output = "";
  for(var i = 0; i < input.length * 32; i += 8)
    output += String.fromCharCode((input[i>>5] >>> (i % 32)) & 0xFF);
  return output;
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */
function binl_md5(x, len)
{
  /* append padding */
  x[len >> 5] |= 0x80 << ((len) % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var a =  1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d =  271733878;

  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);

    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);
}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t)
{
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
}
function md5_ff(a, b, c, d, x, s, t)
{
  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t)
{
  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t)
{
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t)
{
  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y)
{
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt)
{
  return (num << cnt) | (num >>> (32 - cnt));
}
/*!
 Papa Parse
 v4.1.2
 https://github.com/mholt/PapaParse
 */
!function(a,b){"function"==typeof define&&define.amd?define([],b):"object"==typeof module&&module.exports?module.exports=b():a.Papa=b()}(this,function(){"use strict";function a(a,b){if(b=b||{},b.worker&&y.WORKERS_SUPPORTED){var c=j();return c.userStep=b.step,c.userChunk=b.chunk,c.userComplete=b.complete,c.userError=b.error,b.step=q(b.step),b.chunk=q(b.chunk),b.complete=q(b.complete),b.error=q(b.error),delete b.worker,void c.postMessage({input:a,config:b,workerId:c.id})}var g=null;return"string"==typeof a?g=b.download?new d(b):new f(b):(s.File&&a instanceof File||a instanceof Object)&&(g=new e(b)),g.stream(a)}function b(a,b){function c(){"object"==typeof b&&("string"==typeof b.delimiter&&1===b.delimiter.length&&-1===y.BAD_DELIMITERS.indexOf(b.delimiter)&&(i=b.delimiter),("boolean"==typeof b.quotes||b.quotes instanceof Array)&&(h=b.quotes),"string"==typeof b.newline&&(j=b.newline))}function d(a){if("object"!=typeof a)return[];var b=[];for(var c in a)b.push(c);return b}function e(a,b){var c="";"string"==typeof a&&(a=JSON.parse(a)),"string"==typeof b&&(b=JSON.parse(b));var d=a instanceof Array&&a.length>0,e=!(b[0]instanceof Array);if(d){for(var g=0;g<a.length;g++)g>0&&(c+=i),c+=f(a[g],g);b.length>0&&(c+=j)}for(var h=0;h<b.length;h++){for(var k=d?a.length:b[h].length,l=0;k>l;l++){l>0&&(c+=i);var m=d&&e?a[l]:l;c+=f(b[h][m],l)}h<b.length-1&&(c+=j)}return c}function f(a,b){if("undefined"==typeof a||null===a)return"";a=a.toString().replace(/"/g,'""');var c="boolean"==typeof h&&h||h instanceof Array&&h[b]||g(a,y.BAD_DELIMITERS)||a.indexOf(i)>-1||" "===a.charAt(0)||" "===a.charAt(a.length-1);return c?'"'+a+'"':a}function g(a,b){for(var c=0;c<b.length;c++)if(a.indexOf(b[c])>-1)return!0;return!1}var h=!1,i=",",j="\r\n";if(c(),"string"==typeof a&&(a=JSON.parse(a)),a instanceof Array){if(!a.length||a[0]instanceof Array)return e(null,a);if("object"==typeof a[0])return e(d(a[0]),a)}else if("object"==typeof a)return"string"==typeof a.data&&(a.data=JSON.parse(a.data)),a.data instanceof Array&&(a.fields||(a.fields=a.meta&&a.meta.fields),a.fields||(a.fields=a.data[0]instanceof Array?a.fields:d(a.data[0])),a.data[0]instanceof Array||"object"==typeof a.data[0]||(a.data=[a.data])),e(a.fields||[],a.data||[]);throw"exception: Unable to serialize unrecognized input"}function c(a){function b(a){var b=o(a);b.chunkSize=parseInt(b.chunkSize),a.step||a.chunk||(b.chunkSize=null),this._handle=new g(b),this._handle.streamer=this,this._config=b}this._handle=null,this._paused=!1,this._finished=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},b.call(this,a),this.parseChunk=function(a){if(this.isFirstChunk&&q(this._config.beforeFirstChunk)){var b=this._config.beforeFirstChunk(a);void 0!==b&&(a=b)}this.isFirstChunk=!1;var c=this._partialLine+a;this._partialLine="";var d=this._handle.parse(c,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var e=d.meta.cursor;this._finished||(this._partialLine=c.substring(e-this._baseIndex),this._baseIndex=e),d&&d.data&&(this._rowCount+=d.data.length);var f=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(u)s.postMessage({results:d,workerId:y.WORKER_ID,finished:f});else if(q(this._config.chunk)){if(this._config.chunk(d,this._handle),this._paused)return;d=void 0,this._completeResults=void 0}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(d.data),this._completeResults.errors=this._completeResults.errors.concat(d.errors),this._completeResults.meta=d.meta),!f||!q(this._config.complete)||d&&d.meta.aborted||this._config.complete(this._completeResults,this._input),f||d&&d.meta.paused||this._nextChunk(),d}},this._sendError=function(a){q(this._config.error)?this._config.error(a):u&&this._config.error&&s.postMessage({workerId:y.WORKER_ID,error:a,finished:!1})}}function d(a){function b(a){var b=a.getResponseHeader("Content-Range");return parseInt(b.substr(b.lastIndexOf("/")+1))}a=a||{},a.chunkSize||(a.chunkSize=y.RemoteChunkSize),c.call(this,a);var d;t?this._nextChunk=function(){this._readChunk(),this._chunkLoaded()}:this._nextChunk=function(){this._readChunk()},this.stream=function(a){this._input=a,this._nextChunk()},this._readChunk=function(){if(this._finished)return void this._chunkLoaded();if(d=new XMLHttpRequest,this._config.withCredentials&&(d.withCredentials=this._config.withCredentials),t||(d.onload=p(this._chunkLoaded,this),d.onerror=p(this._chunkError,this)),d.open("GET",this._input,!t),this._config.chunkSize){var a=this._start+this._config.chunkSize-1;d.setRequestHeader("Range","bytes="+this._start+"-"+a),d.setRequestHeader("If-None-Match","webkit-no-cache")}try{d.send()}catch(b){this._chunkError(b.message)}t&&0===d.status?this._chunkError():this._start+=this._config.chunkSize},this._chunkLoaded=function(){if(4==d.readyState){if(d.status<200||d.status>=400)return void this._chunkError();this._finished=!this._config.chunkSize||this._start>b(d),this.parseChunk(d.responseText)}},this._chunkError=function(a){var b=d.statusText||a;this._sendError(b)}}function e(a){a=a||{},a.chunkSize||(a.chunkSize=y.LocalChunkSize),c.call(this,a);var b,d,e="undefined"!=typeof FileReader;this.stream=function(a){this._input=a,d=a.slice||a.webkitSlice||a.mozSlice,e?(b=new FileReader,b.onload=p(this._chunkLoaded,this),b.onerror=p(this._chunkError,this)):b=new FileReaderSync,this._nextChunk()},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk()},this._readChunk=function(){var a=this._input;if(this._config.chunkSize){var c=Math.min(this._start+this._config.chunkSize,this._input.size);a=d.call(a,this._start,c)}var f=b.readAsText(a,this._config.encoding);e||this._chunkLoaded({target:{result:f}})},this._chunkLoaded=function(a){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(a.target.result)},this._chunkError=function(){this._sendError(b.error)}}function f(a){a=a||{},c.call(this,a);var b,d;this.stream=function(a){return b=a,d=a,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var a=this._config.chunkSize,b=a?d.substr(0,a):d;return d=a?d.substr(a):"",this._finished=!d,this.parseChunk(b)}}}function g(a){function b(){if(v&&m&&(j("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+y.DefaultDelimiter+"'"),m=!1),a.skipEmptyLines)for(var b=0;b<v.data.length;b++)1===v.data[b].length&&""===v.data[b][0]&&v.data.splice(b--,1);return c()&&d(),e()}function c(){return a.header&&0===u.length}function d(){if(v){for(var a=0;c()&&a<v.data.length;a++)for(var b=0;b<v.data[a].length;b++)u.push(v.data[a][b]);v.data.splice(0,1)}}function e(){if(!v||!a.header&&!a.dynamicTyping)return v;for(var b=0;b<v.data.length;b++){for(var c={},d=0;d<v.data[b].length;d++){if(a.dynamicTyping){var e=v.data[b][d];"true"===e||"TRUE"===e?v.data[b][d]=!0:"false"===e||"FALSE"===e?v.data[b][d]=!1:v.data[b][d]=i(e)}a.header&&(d>=u.length?(c.__parsed_extra||(c.__parsed_extra=[]),c.__parsed_extra.push(v.data[b][d])):c[u[d]]=v.data[b][d])}a.header&&(v.data[b]=c,d>u.length?j("FieldMismatch","TooManyFields","Too many fields: expected "+u.length+" fields but parsed "+d,b):d<u.length&&j("FieldMismatch","TooFewFields","Too few fields: expected "+u.length+" fields but parsed "+d,b))}return a.header&&v.meta&&(v.meta.fields=u),v}function f(b,c){for(var d,e,f,g=[",","	","|",";",y.RECORD_SEP,y.UNIT_SEP],i=0;i<g.length;i++){var j=g[i],k=0,l=0;f=void 0;for(var m=new h({delimiter:j,newline:c,preview:10}).parse(b),n=0;n<m.data.length;n++){var o=m.data[n].length;l+=o,"undefined"!=typeof f?o>1&&(k+=Math.abs(o-f),f=o):f=o}m.data.length>0&&(l/=m.data.length),("undefined"==typeof e||e>k)&&l>1.99&&(e=k,d=j)}return a.delimiter=d,{successful:!!d,bestDelimiter:d}}function g(a){a=a.substr(0,1048576);var b=a.split("\r"),c=a.split("\n"),d=c.length>1&&c[0].length<b[0].length;if(1===b.length||d)return"\n";for(var e=0,f=0;f<b.length;f++)"\n"===b[f][0]&&e++;return e>=b.length/2?"\r\n":"\r"}function i(a){var b=n.test(a);return b?parseFloat(a):a}function j(a,b,c,d){v.errors.push({type:a,code:b,message:c,row:d})}var k,l,m,n=/^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i,p=this,r=0,s=!1,t=!1,u=[],v={data:[],errors:[],meta:{}};if(q(a.step)){var w=a.step;a.step=function(d){if(v=d,c())b();else{if(b(),0===v.data.length)return;r+=d.data.length,a.preview&&r>a.preview?l.abort():w(v,p)}}}this.parse=function(c,d,e){if(a.newline||(a.newline=g(c)),m=!1,!a.delimiter){var i=f(c,a.newline);i.successful?a.delimiter=i.bestDelimiter:(m=!0,a.delimiter=y.DefaultDelimiter),v.meta.delimiter=a.delimiter}var j=o(a);return a.preview&&a.header&&j.preview++,k=c,l=new h(j),v=l.parse(k,d,e),b(),s?{meta:{paused:!0}}:v||{meta:{paused:!1}}},this.paused=function(){return s},this.pause=function(){s=!0,l.abort(),k=k.substr(l.getCharIndex())},this.resume=function(){s=!1,p.streamer.parseChunk(k)},this.aborted=function(){return t},this.abort=function(){t=!0,l.abort(),v.meta.aborted=!0,q(a.complete)&&a.complete(v),k=""}}function h(a){a=a||{};var b=a.delimiter,c=a.newline,d=a.comments,e=a.step,f=a.preview,g=a.fastMode;if(("string"!=typeof b||y.BAD_DELIMITERS.indexOf(b)>-1)&&(b=","),d===b)throw"Comment character same as delimiter";d===!0?d="#":("string"!=typeof d||y.BAD_DELIMITERS.indexOf(d)>-1)&&(d=!1),"\n"!=c&&"\r"!=c&&"\r\n"!=c&&(c="\n");var h=0,i=!1;this.parse=function(a,j,k){function l(a){v.push(a),y=h}function m(b){return k?o():("undefined"==typeof b&&(b=a.substr(h)),x.push(b),h=q,l(x),u&&p(),o())}function n(b){h=b,l(x),x=[],C=a.indexOf(c,h)}function o(a){return{data:v,errors:w,meta:{delimiter:b,linebreak:c,aborted:i,truncated:!!a,cursor:y+(j||0)}}}function p(){e(o()),v=[],w=[]}if("string"!=typeof a)throw"Input must be a string";var q=a.length,r=b.length,s=c.length,t=d.length,u="function"==typeof e;h=0;var v=[],w=[],x=[],y=0;if(!a)return o();if(g||g!==!1&&-1===a.indexOf('"')){for(var z=a.split(c),A=0;A<z.length;A++){var x=z[A];if(h+=x.length,A!==z.length-1)h+=c.length;else if(k)return o();if(!d||x.substr(0,t)!==d){if(u){if(v=[],l(x.split(b)),p(),i)return o()}else l(x.split(b));if(f&&A>=f)return v=v.slice(0,f),o(!0)}}return o()}for(var B=a.indexOf(b,h),C=a.indexOf(c,h);;)if('"'!==a[h])if(d&&0===x.length&&a.substr(h,t)===d){if(-1===C)return o();h=C+s,C=a.indexOf(c,h),B=a.indexOf(b,h)}else if(-1!==B&&(C>B||-1===C))x.push(a.substring(h,B)),h=B+r,B=a.indexOf(b,h);else{if(-1===C)break;if(x.push(a.substring(h,C)),n(C+s),u&&(p(),i))return o();if(f&&v.length>=f)return o(!0)}else{var D=h;for(h++;;){var D=a.indexOf('"',D+1);if(-1===D)return k||w.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:v.length,index:h}),m();if(D===q-1){var E=a.substring(h,D).replace(/""/g,'"');return m(E)}if('"'!==a[D+1]){if(a[D+1]===b){x.push(a.substring(h,D).replace(/""/g,'"')),h=D+1+r,B=a.indexOf(b,h),C=a.indexOf(c,h);break}if(a.substr(D+1,s)===c){if(x.push(a.substring(h,D).replace(/""/g,'"')),n(D+1+s),B=a.indexOf(b,h),u&&(p(),i))return o();if(f&&v.length>=f)return o(!0);break}}else D++}}return m()},this.abort=function(){i=!0},this.getCharIndex=function(){return h}}function i(){var a=document.getElementsByTagName("script");return a.length?a[a.length-1].src:""}function j(){if(!y.WORKERS_SUPPORTED)return!1;if(!v&&null===y.SCRIPT_PATH)throw new Error("Script path cannot be determined automatically when Papa Parse is loaded asynchronously. You need to set Papa.SCRIPT_PATH manually.");var a=y.SCRIPT_PATH||r;a+=(-1!==a.indexOf("?")?"&":"?")+"papaworker";var b=new s.Worker(a);return b.onmessage=k,b.id=x++,w[b.id]=b,b}function k(a){var b=a.data,c=w[b.workerId],d=!1;if(b.error)c.userError(b.error,b.file);else if(b.results&&b.results.data){var e=function(){d=!0,l(b.workerId,{data:[],errors:[],meta:{aborted:!0}})},f={abort:e,pause:m,resume:m};if(q(c.userStep)){for(var g=0;g<b.results.data.length&&(c.userStep({data:[b.results.data[g]],errors:b.results.errors,meta:b.results.meta},f),!d);g++);delete b.results}else q(c.userChunk)&&(c.userChunk(b.results,f,b.file),delete b.results)}b.finished&&!d&&l(b.workerId,b.results)}function l(a,b){var c=w[a];q(c.userComplete)&&c.userComplete(b),c.terminate(),delete w[a]}function m(){throw"Not implemented."}function n(a){var b=a.data;if("undefined"==typeof y.WORKER_ID&&b&&(y.WORKER_ID=b.workerId),"string"==typeof b.input)s.postMessage({workerId:y.WORKER_ID,results:y.parse(b.input,b.config),finished:!0});else if(s.File&&b.input instanceof File||b.input instanceof Object){var c=y.parse(b.input,b.config);c&&s.postMessage({workerId:y.WORKER_ID,results:c,finished:!0})}}function o(a){if("object"!=typeof a)return a;var b=a instanceof Array?[]:{};for(var c in a)b[c]=o(a[c]);return b}function p(a,b){return function(){a.apply(b,arguments)}}function q(a){return"function"==typeof a}var r,s=Function("return this")(),t=!s.document&&!!s.postMessage,u=t&&/(\?|&)papaworker(=|&|$)/.test(s.location.search),v=!1,w={},x=0,y={};if(y.parse=a,y.unparse=b,y.RECORD_SEP=String.fromCharCode(30),y.UNIT_SEP=String.fromCharCode(31),y.BYTE_ORDER_MARK="\ufeff",y.BAD_DELIMITERS=["\r","\n",'"',y.BYTE_ORDER_MARK],y.WORKERS_SUPPORTED=!t&&!!s.Worker,y.SCRIPT_PATH=null,y.LocalChunkSize=10485760,y.RemoteChunkSize=5242880,y.DefaultDelimiter=",",y.Parser=h,y.ParserHandle=g,y.NetworkStreamer=d,y.FileStreamer=e,y.StringStreamer=f,s.jQuery){var z=s.jQuery;z.fn.parse=function(a){function b(){if(0===f.length)return void(q(a.complete)&&a.complete());var b=f[0];if(q(a.before)){var e=a.before(b.file,b.inputElem);if("object"==typeof e){if("abort"===e.action)return void c("AbortError",b.file,b.inputElem,e.reason);if("skip"===e.action)return void d();"object"==typeof e.config&&(b.instanceConfig=z.extend(b.instanceConfig,e.config))}else if("skip"===e)return void d()}var g=b.instanceConfig.complete;b.instanceConfig.complete=function(a){q(g)&&g(a,b.file,b.inputElem),d()},y.parse(b.file,b.instanceConfig)}function c(b,c,d,e){q(a.error)&&a.error({name:b},c,d,e)}function d(){f.splice(0,1),b()}var e=a.config||{},f=[];return this.each(function(a){var b="INPUT"===z(this).prop("tagName").toUpperCase()&&"file"===z(this).attr("type").toLowerCase()&&s.FileReader;if(!b||!this.files||0===this.files.length)return!0;for(var c=0;c<this.files.length;c++)f.push({file:this.files[c],inputElem:this,instanceConfig:z.extend({},e)})}),b(),this}}return u?s.onmessage=n:y.WORKERS_SUPPORTED&&(r=i(),document.body?document.addEventListener("DOMContentLoaded",function(){v=!0},!0):v=!0),d.prototype=Object.create(c.prototype),d.prototype.constructor=d,e.prototype=Object.create(c.prototype),e.prototype.constructor=e,f.prototype=Object.create(f.prototype),f.prototype.constructor=f,y});
/**
 * Created by ljf on 2017/2/7.
 */
var Validator = {

  /*Check Name, Password, Email*/
  isNotValidUsername: function (uname) {
    if (uname == null || uname.length == 0 || uname.replace(/(^\s*)|(\s*$)/g, "").length == 0) {
      return 'username_is_empty';
    }

    if (uname.match("^(\w)[\w._-]*@[\w_-]+(\.[\w_-]+)+$") != null) {
      return 'use_digit_char';
    }

    if (uname.length < 3) {
      return 'too_short3';
    }
    //
    // if (uname.length > 20) {
    //   return 'too_long20';
    // }

    return false;
  },

  isNotValidVersion: function (version) {
    if (version == null || version.length == 0) {
      return 'version_is_empty';
    }

    if (isNaN(version)) {
      return 'version_is_not_number';
    }

    return false;
  },

  isValidCameraname: function (uname) {
    if (uname == null || uname.length == 0) {
      return 'camera_name_is_empty';
    }
    //var reg = "[^a-zA-Z0-9\_]";
    //
    ////var reg = "/^(\w|[\u4E00-\u9FA5])*$/";
    //if (uname.match(reg) != null) {
    //    return 'use_digit_char';
    //}

    if (uname.length < 3) {
      return 'too_short3';
    }

    if (uname.length > 20) {
      return 'too_long20';
    }

    return null;
  },

  isNotValidPassword: function (password) {
    if (password == null || password.length == 0 || password.replace(/(^\s*)|(\s*$)/g, "").length == 0) {
      return 'password_is_empty';
    }

    if (password.length < 6) {
      return 'too_short6';
    }

    if (password.length > 20) {
      return 'too_long20';
    }

    return false;
  },

  isNotPasswordEqual: function (password1, password2) {

    if (password1 != password2) {
      return 'passwords_not_equal';
    }

    return false;
  },

  isNotValidEmail: function (email) {
    if (email == null || email.length == 0) {
      return 'email_is_empty';
    }

    //var reg = /^[^@]+@[^@]+$/;
    var reg = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    if (email.match(reg) == null) {
      return 'email_is_invalid';
    }

    if (email.length < 5)
      return 'email_too_short5';
    if (email.length > 64) {
      return 'email_too_long64';
    }

    return false;
  },

  isNotValidID: function (id) {

    if (isNaN(id)) {
      return 'id_is_not_a_number';
    }

    if (id <= 0) {
      return 'id_is_negative_or_zero';
    }

    return false;
  },

  isNotValidAppDistributorName: function (name) {
    if (name == null || name.length == 0) {
      return 'name_is_empty';
    }

    if (name.match("[^a-zA-Z0-9\_-]") != null) {
      return 'use_digit_char';
    }

    if (name.length < 3) {
      return 'too_short3';
    }

    if (name.length > 20) {
      return 'too_long20';
    }

    return false;
  },

  isNotStringValid: function (value) {
    if (value == null || value.length == 0) {
      return 'value_is_empty';
    }

    return false;
  },

  isNotValidSerialNumber: function (value) {
    if (value == null || value.length == 0) {
      return 'value_is_empty';
    }

    if (isNaN(value)) {
      return 'serial_number_is_not_digit';
    }

    if (value.length != 16) {
      return 'use_digit16';
    }

    return false;
  },

  isNotValidMD5: function (value) {
    if (value == null || value.length == 0) {
      return 'value_is_empty';
    }

    if (value.length != 32) {
      return 'md5_is_invalid';
    }

    return false;
  },

  isNotValidURL: function (value) {
    if (value == null || value.length == 0) {
      return 'value_is_empty';
    }

    var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
    if (!reg.test(value)) {
      return 'url_is_invaid';
    }

    return false;
  },

  isNotValidRoles: function (roles) {
    if (roles.length == 0) {
      return 'role_is_empty';
    }

    return false;
  },

  isValidMD5: function (md5) {
    if (md5 == null || md5.length == 0) {
      return 'md5_is_empty';
    }

    return null;
  },

  isValidURL: function (url) {
    if (url == null || url.length == 0) {
      return "url_is_empty";
    }

    return null;
  },
  isNotValidPrice: function (price) {
    if (isNaN(price)) {
      return "price_is_invalid";
    }

    if (price < 0) {
      return "price_is_invalid";
    }
  },

  isNotValidNumber: function (number, message) {
    if (isNaN(number) || number === "") {
      return message ? message : "number_is_invalid";
    }

    if (number < 0) {
      return message ? message : "number_is_invalid";
    }
  }
};
/**
 * created on 2016
 */
(function () {
  'use strict';

  var pages = angular.module('NetviewAdmin.pages', [
    'ui.router',
    'NetviewAdmin.pages.auth',
    'NetviewAdmin.pages.mine',
    'NetviewAdmin.pages.bmUsers',
    'NetviewAdmin.pages.devices',
    'NetviewAdmin.pages.clients',
    'NetviewAdmin.pages.clientVersions',
    'NetviewAdmin.pages.members',
    'NetviewAdmin.pages.apps',
    'NetviewAdmin.pages.distributors',
    'NetviewAdmin.pages.firmware',
    'NetviewAdmin.pages.transactions',
    'NetviewAdmin.pages.clientLogs',
    'NetviewAdmin.pages.devices',
    'NetviewAdmin.pages.modals',
    'NetviewAdmin.pages.notifications',
    'NetviewAdmin.pages.productionManage',
    'NetviewAdmin.pages.serverManage',
    'NetviewAdmin.pages.statistics',
    'NetviewAdmin.pages.pricing',
    'NetviewAdmin.pages.marketing'
  ])
      .config(routeConfig)
      .factory('AjaxRequest', AjaxRequest);

  /** @ngInject */
  function routeConfig($urlRouterProvider) {
    $urlRouterProvider.otherwise("/auth");
  }

  function AjaxRequest($resource, $cookies) {
    function dynamicToken() {
      return $cookies.get('central_token');
    }

    function dynamicEndPoint() {
      return WEB_ENDPOINT;
    }

    function localToken() {
      return $cookies.get('local_token');
    }

    var headers = {
      'x-nvs-ucid': '41f33045b1',
      'x-nvs-token': dynamicToken,
      'Content-Type': 'application/json;charset=utf-8'
    };
    var local_headers = {
      'x-nvs-ucid': '41f33045b1',
      'x-nvs-token': localToken,
      'Content-Type': 'application/json;charset=utf-8'
    };

    var decorator = {};
    decorator.path = function (lastUrl, localEndpoint) {
      if (typeof localEndpoint != 'undefined' && localEndpoint) {
        if (lastUrl == 'token') {
          return $resource(localEndpoint + '/' + lastUrl, null, {
            post: {
              method: 'POST',
              headers: {
                'x-nvs-ucid': '41f33045b1',
                'Content-Type': 'application/json;charset=utf-8'
              }
            }
          });
        } else {
          return $resource(localEndpoint + '/' + lastUrl, null, {
            get: {
              method: 'GET',
              headers: local_headers
            },
            put: {
              method: 'PUT',
              headers: local_headers
            },
            post: {
              method: 'POST',
              headers: local_headers
            },
            delete: {
              method: 'DELETE',
              headers: local_headers
            }
          });
        }
      } else {
        return $resource(dynamicEndPoint() + lastUrl, null, {
          get: {
            method: 'GET',
            headers: headers
          },
          put: {
            method: 'PUT',
            headers: headers
          },
          post: {
            method: 'POST',
            headers: headers
          },
          delete: {
            method: 'DELETE',
            headers: headers
          }
        });
      }
    };
    return decorator;
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme', [
      'toastr',
      'NetviewAdmin.theme.components',
      'NetviewAdmin.theme.translate',
      'NetviewAdmin.theme.inputs'
  ]);

})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.apps', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'smart-table', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('apps', {
          url: '/apps',
          templateUrl: 'app/pages/apps/apps.html',
          title: 'Apps',
          controller: 'AppsPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-grid',
            order: SIDEBAR_ORDER.APP,
          },
        });
  }

})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.auth', ['ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('auth', {
          url: '/auth',
          views: {
            'auth': {
              templateUrl: 'app/pages/auth/auth.html',
              controller: 'AuthPageCtrl',
            },
          }
        });
  }

})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.bmUsers', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(function () {
        $.jstree.defaults.core.themes.url = true;
        $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
      })
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('bmUsers', {
          url: '/bmUsers',
          templateUrl: 'app/pages/bmUsers/bmUsers.html',
          title: 'Bm Users',
          controller: 'BmUsersPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-person',
            order: SIDEBAR_ORDER.BM_USER,
          },
        });
  }

})();

(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.clientLogs', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('clientLogs', {
          url: '/clientLogs',
          templateUrl: 'app/pages/clientLogs/clientLogs.html',
          title: 'Client Logs',
          controller: 'ClientLogsPageCtrl',
          sidebarMeta: {
            icon: 'ion-ios-paper',
            order: SIDEBAR_ORDER.CLIENT_LOG,
          },
        });
  }
})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.clientVersions', ['angularFileUpload', 'pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('clientVersions', {
          url: '/clientVersions',
          templateUrl: 'app/pages/clientVersions/clientVersions.html',
          title: 'Client Versions',
          controller: 'ClientVersionsPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-cube',
            order: SIDEBAR_ORDER.CLIENT_VERSION,
          },
        });
  }

})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.clients', ['ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('clients', {
          url: '/clients',
          templateUrl: 'app/pages/clients/clients.html',
          title: 'Clients',
          controller: 'ClientsPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-android-phone-portrait',
            order: SIDEBAR_ORDER.CLIENT,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.devices', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('devices', {
          url: '/devices',
          templateUrl: 'app/pages/devices/devices.html',
          controller: 'DevicesPageCtrl',
          params: {
            reloadParams: null
          },
          title: 'Devices',
          sidebarMeta: {
            icon: 'ion-ios-videocam',
            order: SIDEBAR_ORDER.DEVICE,
          },
        });
  }

})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.distributors', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('distributors', {
          url: '/distributors',
          templateUrl: 'app/pages/distributors/distributors.html',
          title: 'Distributors',
          controller: 'DistributorsPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-ios-color-filter',
            order: SIDEBAR_ORDER.DISTRIBUTOR,
          },
        });
  }

})();

/**
 * @author shenfeng
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.firmware', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('firmware', {
          url: '/firmware',
          templateUrl: 'app/pages/firmware/patches.html',
          title: 'Firmware',
          controller: 'PatchesPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-ios-cog',
            order: SIDEBAR_ORDER.FIRMWARE,
          },
        });
  }
})();

/**
 * Created by John on 2017/4/1.
 */
(function () {
  'use strict';
  var pages = angular.module('NetviewAdmin.pages.marketing', [
    'NetviewAdmin.pages.marketing.promotions',
    'NetviewAdmin.pages.marketing.coupons',
    'NetviewAdmin.pages.marketing.advertisements',
    'NetviewAdmin.pages.marketing.notifications',
    'NetviewAdmin.pages.marketing.activities',
    'NetviewAdmin.pages.marketing.childActivities'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('marketing', {
        url: '/marketing',
        abstract: true,
        template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: SIDEBAR_ORDER.MARKETING,
        },
        title: 'Marketing'
      });
  }
})();
/**
 * created on 2016
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.members', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('members', {
          url: '/members',
          templateUrl: 'app/pages/members/members.html',
          title: 'Members',
          controller: 'MembersPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-android-contact',
            order: SIDEBAR_ORDER.MEMBER,
          },
        });
  }

})();

/**
 * Created by ptx.
 */
(function(){
  'use strict';

  angular.module('NetviewAdmin.pages.pricing', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'smart-table', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('pricing', {
          url: '/pricing',
          templateUrl: 'app/pages/pricing/pricing.html',
          title: 'Pricing',
          controller: 'PricingPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-social-yen',
            order: SIDEBAR_ORDER.PRICING,
          }
        });
  }

})();
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.productionManage', [
    'NetviewAdmin.pages.productionManage.factory',
    'NetviewAdmin.pages.productionManage.product',
    'NetviewAdmin.pages.productionManage.plan',
    'NetviewAdmin.pages.productionManage.task',
  ])
      .config(function () {
        $.jstree.defaults.core.themes.url = true;
        $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
      })
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('productionManage', {
          url: '/productionManage',
          template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'ProductionManage',
          sidebarMeta: {
            icon: 'ion-hammer',
            order: SIDEBAR_ORDER.PRODUCTION_MANAGE,
          },
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.serverManage', [
    'NetviewAdmin.pages.serverManage.roles',
    'NetviewAdmin.pages.serverManage.permissions'
  ])
      .config(function () {
        $.jstree.defaults.core.themes.url = true;
        $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
      })
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('serverManage', {
          url: '/serverManage',
          template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'ServerManage',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: SIDEBAR_ORDER.SERVER_MANAGE,
          },
        });
  }

})();

/**
 * Created by John on 2017/4/1.
 */
var pages = angular.module('NetviewAdmin.pages.statistics', [
  'NetviewAdmin.pages.statistics.charts',
  'NetviewAdmin.pages.statistics.logs'
])
    .config(routeConfig);

/** @ngInject */
function routeConfig($stateProvider) {
  $stateProvider
      .state('statistics', {
        url: '/statistics',
        abstract: true,
        template: '<div ui-view   autoscroll-body-top></div>',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: SIDEBAR_ORDER.STATISTICS
        },
        title: 'Statistics'
      });
}

(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.transactions', ['ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('transactions', {
          url: '/transactions',
          templateUrl: 'app/pages/transactions/transactions.html',
          title: 'Transactions',
          controller: 'TransactionsPageCtrl',
          sidebarMeta: {
            icon: 'ion-social-usd',
            order: SIDEBAR_ORDER.TRANSACTION,
          },
        });
  }
})();

/**
 * Created by ljf on 2017/3/14.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.modals', []);
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.mine',['ngResource','ngCookies','ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('mine', {
          url: '/mine',
          title: 'My Info',
          templateUrl: 'app/pages/bmUsers/mine/mine.html',
          controller: 'MinePageCtrl',
        });
  }

})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.marketing.activities',
      ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('marketing.activities', {
          url: '/activities',
          templateUrl: 'app/pages/marketing/activities/activities.html',
          title: 'New Activities',
          controller: 'ActivitiesPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-cube',
            order: SIDEBAR_SUB_ORDER.ACTIVITIES
          }
        });
  }
})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.marketing.advertisements', ['ui.carousel', 'angularFileUpload','pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('marketing.advertisements', {
          url: '/advertisements',
          templateUrl: 'app/pages/marketing/advertisements/advertisements.html',
          title: 'Advertisements',
          controller: 'AdvertisementsPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-cube',
            order: SIDEBAR_SUB_ORDER.ADVERTISEMENTS
          }
        });
  }
})();

(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.marketing.notifications',
      ['ui.carousel', 'angularFileUpload','pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('marketing.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/marketing/notifications/notifications.html',
          title: 'Notifications',
          controller: 'NotificationsPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-notifications',
            order: SIDEBAR_SUB_ORDER.NOTIFICATIONS
          }
        });
  }
})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.marketing.promotions',
    ['pascalprecht.translate','angularFileUpload', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('marketing.promotions', {
          url: '/promotions',
          templateUrl: 'app/pages/marketing/promotions/promotions.html',
          title: 'Activities',
          controller: 'PromotionPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-cube',
            order: SIDEBAR_SUB_ORDER.PROMOTIONS
          }
        });
  }
})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.productionManage.factory', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('productionManage.factory', {
          url: '/factory',
          templateUrl: 'app/pages/productionManage/factory/factory.html',
          title: 'Factory',
          controller: 'FactoryPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-jet',
            order: SIDEBAR_SUB_ORDER.FACTORY,
          },
        });
  }

})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.productionManage.plan', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router', 'ngFileSaver'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('productionManage.plan', {
          url: '/plan',
          templateUrl: 'app/pages/productionManage/plan/plan.html',
          title: 'Plan',
          controller: 'PlanPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-wrench',
            order: SIDEBAR_SUB_ORDER.PLAN,
          },
        });
  }

})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.productionManage.product', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('productionManage.product', {
          url: '/product',
          templateUrl: 'app/pages/productionManage/product/product.html',
          title: 'Product',
          controller: 'ProductPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-wrench',
            order: SIDEBAR_SUB_ORDER.PRODUCT,
          },
        });
  }

})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.productionManage.task', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('productionManage.task', {
          url: '/task',
          templateUrl: 'app/pages/productionManage/task/task.html',
          title: 'Task',
          controller: 'TaskPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-wrench',
            order: SIDEBAR_SUB_ORDER.TASK,
          },
        });
  }

})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.serverManage.permissions', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('serverManage.permissions', {
          url: '/permissions',
          templateUrl: 'app/pages/serverManage/permissions/permissions.html',
          title: 'Permissions',
          controller: 'PermissionsPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-person',
            order: SIDEBAR_SUB_ORDER.PERMISSIONS,
          },
        });
  }

})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.serverManage.roles', ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('serverManage.roles', {
          url: '/roles',
          templateUrl: 'app/pages/serverManage/roles/roles.html',
          title: 'Roles',
          controller: 'RolesPageCtrl',
          params: {
            reloadParams: null
          },
          sidebarMeta: {
            icon: 'ion-person',
            order: SIDEBAR_SUB_ORDER.ROLES,
          },
        });
  }

})();

/**
 * Created by John on 2017/4/5.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.statistics.charts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('statistics.charts', {
          url: '/charts',
          templateUrl: 'app/pages/statistics/charts/main.html',
          title: 'Charts',
          sidebarMeta: {
            order: SIDEBAR_SUB_ORDER.STATISTICS_CHART,
          },
        });
  }

})();
/**
 * Created by John on 2017/4/5.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.statistics.logs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('statistics.logs', {
          url: '/logs',
          templateUrl: 'app/pages/statistics/logs/main.html',
          title: 'LogList',
          sidebarMeta: {
            order: SIDEBAR_SUB_ORDER.STATISTICS_LOG_LIST,
          },
        });
  }

})();
/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.marketing.childActivities',
    ['pascalprecht.translate', 'ngResource', 'ngCookies', 'ui.router'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('marketing.childActivities', {
          url: '/childActivities',
          templateUrl: 'app/pages/marketing/activities/child/childActivities.html',
          controller: 'ChildActivitiesPageCtrl',
          title: 'Activities/Child Activities',
          params: {
            reloadParams: null
          },
        });
  }
})();

'use strict';

angular.module('NetviewAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'ngResource',
  'ngCookies',
  'smart-table',
  'ui.bootstrap.datetimepicker',

  'NetviewAdmin.pages',
  'NetviewAdmin.theme',
]).config(['$locationProvider', function ($locationProvider) {
  // $locationProvider.html5Mode(true);
}]);
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('NetviewAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('NetviewAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap/dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })

    .constant('patchLevelKeys', ['patch_level_now','patch_level_idle','patch_level_cmd'])

    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @ljf last modified on 20170207
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .run(themeRun);

  /** @ngInject */
  function themeRun($rootScope, baSidebarService, $cookies, $state) {
    if ($cookies.get('central_token') || $cookies.get('old_token')) {
      $rootScope.$authed = true;
    } else {
      $rootScope.$authed = false;
    }

    if (!$cookies.get('currentServer')) {
      $cookies.put('currentServer', 'central')
    }

    $rootScope.$pageFinishedLoading = true;
    $rootScope.$baSidebarService = baSidebarService;

    $rootScope.$on('$stateChangeStart', function (event, toState) {
      if (toState.name === "auth") {
        $rootScope.$authed = false;
      } else {
        if ($rootScope.$authed == false) {
          event.preventDefault();
          $state.go('auth');
        }
      }

    })
  }
})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
  'use strict';

  var app = angular.module('NetviewAdmin.theme.translate', ['pascalprecht.translate']);
  app.config(function ($translateProvider) {
    $translateProvider.preferredLanguage('en');

    $translateProvider.useSanitizeValueStrategy('escape');

    $translateProvider.useStaticFilesLoader({
      prefix: '/assets/i18n/',
      suffix: '.json'
    });
    $translateProvider.useCookieStorage();
  })

})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.apps')
      .controller('AppsPageCtrl', AppsPageCtrl);

  /** @ngInject */
  function AppsPageCtrl($scope, $uibModal, $cookies, $state, ModalsService, AjaxRequest, $stateParams) {
    if (!ACL.hasPermission($cookies, 'get_apps')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_apps');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_app_%s');

    $scope.data = {'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.appsEmpty = false;
      var pagination = tableState.pagination;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if($stateParams.reloadParams != null){
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      AjaxRequest.path('apps').get(
          $scope.data,
          function (data) {
            $scope.apps = data.apps;
            if($scope.apps.length == 0){
              $scope.appsEmpty = true;
            }else {
              $scope.appsEmpty = false;
            }
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if($stateParams.reloadParams != null){
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.apps = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.appsEmpty = false;
            if($stateParams.reloadParams != null){
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.refresh = function(){
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (app) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/apps/editApp.html',
        controller: 'EditAppCtrl',
        size: 'lg',
        resolve: {
          app: function () {
            return app;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    }
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.apps')
      .controller('EditAppCtrl', EditAppCtrl);

  /** @ngInject */
  function EditAppCtrl($scope, $cookies, $state, $filter, app, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    $scope.isRootItems = [
      {label: $filter('translate')('false'), value: 'false'},
      {label: $filter('translate')('true'), value: 'true'},
    ];
    $scope.isRootSelected = $scope.isRootItems[0];

    if (typeof app == 'undefined') {
      $scope.isNewApp = true;
      $scope.data = {
        'appName': '', 'displayName': '', 'emailAddress': '', 'appInfo': '', 'isRoot': false, 'appPG': ''
      };
    } else {
      $scope.isNewApp = false;
      $scope.data = {
        'appName': app.appName, 'displayName': app.displayName, 'emailAddress': app.emailAddress,
        'appInfo': app.appInfo, 'isRoot': app.isRoot, 'appPG': app.appPG
      };
      $scope.isRootSelected = app.isRoot ? $scope.isRootItems[1] : $scope.isRootItems[0];
    }

    $scope.isRootChange = function (isRootSelected) {
      $scope.data.isRoot = isRootSelected.value;
    };

    $scope.submit = function () {

      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;

      if (!$scope.isNewApp) {
        AjaxRequest.path('app/' + app.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_app_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('apps', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('apps').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              NotificationsService.openToast('success', 'op_info', 'create_app_success', 'toast-top-center');
              $state.go('apps', {reloadParams: null}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.errors = false;
    $scope.errAppName = false;
    $scope.errDisplayName = false;
    $scope.errEmail = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errAppName = false;
      $scope.errDisplayName = false;
      $scope.errEmail = false;
    };

    $scope.isNotValidate = function () {
      var appName = $scope.data.appName;
      var displayName = $scope.data.displayName;
      var emailAddress = $scope.data.emailAddress;

      if (Validator.isNotValidAppDistributorName(appName)) {
        $scope.errAppName = true;
        $scope.errorMessage = Validator.isNotValidAppDistributorName(appName);
        return true;
      }

      if (Validator.isNotStringValid(displayName)) {
        $scope.errDisplayName = true;
        $scope.errorMessage = Validator.isNotStringValid(displayName);
        return true;
      }

      if (Validator.isNotValidEmail(emailAddress)) {
        $scope.errEmail = true;
        $scope.errorMessage = Validator.isNotValidEmail(emailAddress);
        return true;
      }

      return false;
    }

  }
})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.auth')
      .controller('AuthPageCtrl', AuthPageCtrl);

  /** @ngInject */
  function AuthPageCtrl($scope, $rootScope, $cookies, $state, $filter, $translate, $uibModal, AjaxRequest) {
    $scope.authData = {'udid': 'web0000000', 'user': ''};
    $scope.errors = false;
    $scope.errorUser = false;
    $scope.errorPassword = false;

    $scope.clearError = function () {
      $scope.errorUser = false;
      $scope.errorPassword = false;
      $scope.errors = false;
    };

    $scope.submit = function () {
      $cookies.remove('central_token');

      if (Validator.isNotValidUsername($scope.authData.user)) {
        $scope.errorUser = true;
        $scope.errorMessage = Validator.isNotValidUsername($scope.authData.user);
        return;
      }

      if (Validator.isNotValidPassword($scope.plainPassword)) {
        $scope.errorPassword = true;
        $scope.errorMessage = Validator.isNotValidPassword($scope.plainPassword);
        return;
      }

      $scope.authData.pass = hex_md5($scope.plainPassword);
      $scope.holdSubmit = true;

      AjaxRequest.path('token').post(
          $scope.authData,
          function (data) {
            $rootScope.$authed = true;
            $scope.holdSubmit = false;
            var expires = new Date(data.expires);
            $cookies.put('userName', $scope.authData.user);
            $cookies.put('upd', $scope.authData.pass);
            $cookies.put('email', data.email, {'expires': expires.toUTCString()});
            $cookies.put('central_token', data.token, {'expires': expires.toUTCString()});
            $cookies.put('currentServer', 'central', {'expires': expires.toUTCString()});
            $cookies.put('appId', data.appid, {'expires': expires.toUTCString()});
            $cookies.put('distributorId', data.distributorid, {'expires': expires.toUTCString()});
            $cookies.put('isRootApp', data.isRootApp, {'expires': expires.toUTCString()});
            $cookies.put('isRootDistributor', data.isRootDistributor, {'expires': expires.toUTCString()});
            var permissions = "";
            data.permissions.forEach(function (element) {
              permissions += element.identification;
              permissions += ";";
            });
            $cookies.put('permissions', permissions, {'expires': expires.toUTCString()});
            $cookies.put('userId', data.userid, {'expires': expires.toUTCString()});
            $state.go('mine');
          },
          function (error) {
            $scope.holdSubmit = false;
            if (error.status == -1) {
              $scope.errors = true;
              $scope.errorMessage = "timeout";
            }
            if (error.status == 500) {
              $scope.errors = true;
              $scope.errorMessage = "error_code_9";
            }
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                if (data.ret == 48) {
                  $scope.plainPassword = '';
                  open('app/pages/auth/modals/updatePassword.html', 'md');
                } else {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
          }
      );
    };

    function open(page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        controller: 'UpdatePasswordCtrl',
        size: size,
        resolve: {
          userInfo: function () {
            return {
              'user': $scope.authData.user,
              'pass': $scope.authData.pass,
            };
          }
        }
      });
    }

    $scope.LocaleList = [{'name': '中文', 'value': 'cn'}, {'name': 'English', 'value': 'en'}];
    $scope.ServerList = [{'name': 'netvue', 'value': 'netvue'}, {'name': 'fa', 'value': 'fa'}];
    $scope.language = 'en';
    var cookieLanguage = $cookies.get('NG_TRANSLATE_LANG_KEY');
    if (cookieLanguage) {
      $scope.language = cookieLanguage.substr(1, cookieLanguage.length - 2)
    }
    $scope.changeLanguage = function () {
      $translate.use($scope.language);
    };

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.bmUsers')
      .controller('BmUsersPageCtrl', BmUsersPageCtrl);

  /** @ngInject */
  function BmUsersPageCtrl($scope, $uibModal, $cookies, $filter, $state, $stateParams, ModalsService, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_bmusers')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_bmusers');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_bmuser_%s');
    $scope.GET_ACTIVITY_P = ACL.hasPermission($cookies, 'get_bmuser_%s_activity');
    $scope.RESET_PASS_P = ACL.hasPermission($cookies, 'put_bmuser_%s_password');
    $scope.GET_ACTIVITIES_P = ACL.hasPermission($cookies, 'get_activities_bmusers');

    $scope.data = {'enable': 'enable', 'userName': undefined, 'email': undefined, 'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.statusItems = [
      {label: $filter('translate')('enable'), value: 'enable'},
      {label: $filter('translate')('disable'), value: 'disable'},
    ];
    $scope.statusSelected = $scope.statusItems[0];

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.bmUsersEmpty = false;
      var pagination = tableState.pagination;
      var params = tableState.search.predicateObject;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;

      if (typeof params != 'undefined') {
        $scope.data.email = params.hasOwnProperty('email') ? params.email : undefined;
        $scope.data.userName = params.hasOwnProperty('userName') ? params.userName : undefined;
        $scope.data.enable = params.hasOwnProperty('enable') ? params.enable : 'enable';
      }

      if ($stateParams.reloadParams != null) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      AjaxRequest.path('bmusers').get(
          $scope.data,
          function (data) {
            $scope.bmUsers = data.bmUsers;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($scope.bmUsers.length == 0) {
              $scope.bmUsersEmpty = true;
            } else {
              $scope.bmUsersEmpty = false;
            }
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.bmUsers = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.bmUsersEmpty = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.resetQuery = function () {
      tempTableState.pagination.start = 0;
      if (typeof tempTableState.search.predicateObject != 'undefined') {
        tempTableState.search.predicateObject = {'enable': 'enable'};
      }
      $scope.callServer(tempTableState);
    };

    $scope.refresh = function () {
      $scope.callServer(tempTableState);
    };

    $scope.resetPassword = function (bmUserId) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/bmUsers/resetPassword.html',
        controller: 'ResetPasswordCtrl',
        size: 'sm',
        resolve: {
          bmUserId: function () {
            return bmUserId;
          }
        }
      });
    };

    $scope.openEditPage = function (bmUser) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/bmUsers/editBmUser.html',
        controller: 'EditBmUserCtrl',
        size: 'lg',
        resolve: {
          bmUser: function () {
            return bmUser;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    }
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.bmUsers')
      .controller('EditBmUserCtrl', EditBmUserCtrl);

  /** @ngInject */
  function EditBmUserCtrl($scope, $cookies, $filter, $state, bmUser, reloadParams, AjaxRequest, NotificationsService, ModalsService) {
    var number = 1;

    AjaxRequest.path('roles').get('',
        function (data) {
          $scope.roleList = data.roles;
          if (typeof bmUser == 'undefined') {
            $scope.isNewBmUser = true;
            $scope.data = {'user': '', 'email': '', 'appId': '', 'distributorId': '', 'note': '', 'roles': []};
          } else {
            $scope.isNewBmUser = false;
            $scope.data = {
              'email': bmUser.email, 'enable': bmUser.enable, 'appId': bmUser.appId,
              'distributorId': bmUser.distributorId, 'note': bmUser.note, 'roles': [],
            };
            $.each($scope.roleList, function (i, role) {
              role.checked = false;
              for (var j = 0; j < bmUser.roles.length; j++) {
                if (bmUser.roles[j] == role.id) {
                  role.checked = true;
                }
              }
            });
            $scope.statusItems = [
              {label: $filter('translate')('enable'), value: true},
              {label: $filter('translate')('disable'), value: false},
            ];
            $scope.statusSelected = $scope.data.enable ? $scope.statusItems[0] : $scope.statusItems[1];
          }
        },
        function (error) {
          ModalsService.handleError(error);
        }
    );

    $scope.submit = function () {

      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;
      if (!$scope.isNewBmUser) {
        AjaxRequest.path('bmuser/' + bmUser.userId).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'bmUser_edit_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('bmUsers', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('bmusers').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              var translateMessage = $filter('translate')('bmUser_edit_success') + "," + $filter('translate')('new_pw_is') + data.pass;
              ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', translateMessage);
              $state.go('bmUsers', '', {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.openInfoPage = function (role) {
      var permissionData = role.permissions;
      $scope.basicConfig = {
        core: {
          multiple: false,
          check_callback: true,
          worker: true
        },
        'types': {
          'folder': {
            'icon': 'ion-ios-list'
          },
          'default': {
            'icon': 'ion-android-lock'
          }
        },
        'plugins': ['types'],
        'version': number++
      };
      var newSet = new Set();
      permissionData.forEach(function (element) {
        newSet.add(element.group);
      });

      var rootData = [];
      newSet.forEach(function (value) {
        rootData.push({
          id: value,
          parent: '#',
          type: "folder",
          text: $filter('translate')(value),
          state: {opened: true}
        });
      });

      permissionData.forEach(function (element) {
        rootData.push({
          id: element.id,
          parent: element.group,
          text: $filter('translate')(element.identification),
          state: {opened: false}
        });
      });
      $scope.treeData = rootData;
    };

    $scope.errors = false;
    $scope.errUser = false;
    $scope.errEmail = false;
    $scope.errAppId = false;
    $scope.errDistributorId = false;
    $scope.errRole = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errUser = false;
      $scope.errEmail = false;
      $scope.errAppId = false;
      $scope.errDistributorId = false;
      $scope.errRole = false;
    };

    $scope.setRoles = function () {
      $scope.data.roles = [];
      $.each($scope.roleList, function (i, v) {
        if (v.checked) {
          $scope.data.roles.push(v.id);
          console.log($scope.data.roles);
        }
      });
    };

    $scope.statusChange = function (statusSelected) {
      $scope.data.enable = statusSelected.value;
    };

    $scope.isNotValidate = function () {
      var email = $scope.data.email;
      var appId = $scope.data.appId;
      var distributorId = $scope.data.distributorId;

      if ($scope.isNewBmUser) {
        var userName = $scope.data.user;
        if (Validator.isNotValidUsername(userName)) {
          $scope.errUser = true;
          $scope.errorMessage = Validator.isNotValidUsername(userName);
          return true;
        }
      }

      if (Validator.isNotValidEmail(email)) {
        $scope.errEmail = true;
        $scope.errorMessage = Validator.isNotValidEmail(email);
        return true;
      }

      if (Validator.isNotValidID(appId)) {
        $scope.errAppId = true;
        $scope.errorMessage = Validator.isNotValidID(appId);
        return true;
      }

      if (Validator.isNotValidID(distributorId)) {
        $scope.errDistributorId = true;
        $scope.errorMessage = Validator.isNotValidID(distributorId);
        return true;
      }

      $scope.setRoles();
      if (Validator.isNotValidRoles($scope.data.roles)) {
        $scope.errRole = true;
        $scope.errorMessage = Validator.isNotValidRoles($scope.data.roles);
        return true;
      }
      return false;
    }

  }
})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.bmUsers')
      .controller('ResetPasswordCtrl', ResetPasswordCtrl);

  /** @ngInject */
  function ResetPasswordCtrl($scope, $filter, bmUserId, ModalsService, AjaxRequest) {
    $scope.message = 'confirm_to_reset_password';
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('bmuser/' + bmUserId + '/password').put('',
          function (data) {
            var translateMessage = $filter('translate')('new_pw_is') + data.pass;
            ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', translateMessage);
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by John on 2017/2/9.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.clientLogs')
      .controller('ClientLogsPageCtrl', ClientLogsPageCtrl);

  /** @ngInject */
  function ClientLogsPageCtrl($scope, $state, $cookies, $filter, AjaxRequest, ModalsService) {
    if (!ACL.hasPermission($cookies, 'get_clientlogs')) {
      $state.go('auth');
      return;
    }

    $scope.lastPages = [];
    $scope.lastPageLength = 0;
    $scope.data = {
      'userName': undefined, 'clientLogType': undefined, 'startKey': undefined,
      'startTime': undefined, 'endTime': undefined, 'limit': 10,
    };

    $scope.clientLogTypeItems = [
      {label: $filter('translate')('all'), value: undefined},
      {label: 'android-daily', value: 'android;DAILY'},
      {label: 'android-crash', value: 'android;CRASH'},
      {label: 'ios-daily', value: 'ios;DAILY'},
      {label: 'ios-crash', value: 'ios;CRASH'},
    ];
    $scope.clientLogTypeSelected = $scope.clientLogTypeItems[0];

    $scope.clientLogTypeChange = function (clientLogTypeSelected) {
      $scope.data.userName = undefined;
      $scope.data.clientLogType = clientLogTypeSelected.value;
    };

    $scope.dateRangeStart = undefined;
    $scope.dateRangeEnd = undefined;

    $scope.callServer = function () {
      $scope.isLoading = true;
      $scope.getDataError = false;

      AjaxRequest.path('clientlogs/v2').get(
          $scope.data,
          function (data) {
            $scope.newlogs = data.logs;

            $scope.nextPageKey = data.startKey;
            $scope.isLoading = false;
            $scope.getDataError = false;
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.newlogs = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
          });
    };

    $scope.search = function () {
      $scope.lastPages = [];
      $scope.lastPageLength = 0;
      $scope.nextPageKey = undefined;
      $scope.data.startKey = undefined;
      $scope.callServer();
    };

    $scope.resetSearch = function () {
      $scope.clientLogTypeSelected = $scope.clientLogTypeItems[0];
      $scope.dateRangeStart = undefined;
      $scope.dateRangeEnd = undefined;
      $scope.lastPages = [];
      $scope.lastPageLength = 0;
      $scope.nextPageKey = undefined;
      $scope.newlogs = null;
      $scope.data = {
        'userName': undefined, 'clientLogType': undefined, 'startKey': undefined,
        'startTime': undefined, 'endTime': undefined, 'limit': 10,
      };
    };

    $scope.selectPage = function (page) {
      if (page == 'last') {
        $scope.lastPageLength = $scope.lastPages.length;
        if ($scope.lastPageLength > 0) {
          $scope.data.startKey = $scope.lastPages.pop();
          $scope.lastPageLength = $scope.lastPages.length;
          $scope.callServer();
        }
      } else if (page == 'next') {
        if ($scope.nextPageKey != null) {
          $scope.lastPages.push($scope.data.startKey);
          $scope.lastPageLength = $scope.lastPages.length;
          $scope.data.startKey = $scope.nextPageKey;
          $scope.callServer();
        }
      }
    };

    $scope.startDateOnSetTime = function () {
      $scope.data.startTime = new Date($scope.dateRangeStart).getTime();
      $scope.dateRangeStart = new Date($scope.dateRangeStart).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('start-date-changed');
    };

    $scope.endDateOnSetTime = function () {
      $scope.data.endTime = new Date($scope.dateRangeEnd).getTime();
      $scope.dateRangeEnd = new Date($scope.dateRangeEnd).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('end-date-changed');
    };

    $scope.startDateBeforeRender = function ($dates) {
      if ($scope.dateRangeEnd) {
        var activeDate = moment($scope.dateRangeEnd);
        $dates.filter(function (date) {
          return date.localDateValue() >= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };

    $scope.endDateBeforeRender = function ($view, $dates) {
      if ($scope.dateRangeStart) {
        var activeDate = moment($scope.dateRangeStart).subtract(1, $view).add(1, 'minute');
        $dates.filter(function (date) {
          return date.localDateValue() <= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };

    $scope.download = function (logUrl) {
      AjaxRequest.path(logUrl).get(
          function (data) {
            goToUrl(data.presignedUrl);
          },
          function (error) {
            ModalsService.handleError(error);
          });
    };

    function goToUrl(url) {
      var a = $('<a href="' + url + '" target="_blank"></a>');
      var d = a.get(0);
      var e = document.createEvent('MouseEvents');
      e.initEvent('click', true, true);
      d.dispatchEvent(e);
      a.remove();
    }
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.clientVersions')
      .controller('ClientVersionsPageCtrl', ClientVersionsPageCtrl);

  /** @ngInject */
  function ClientVersionsPageCtrl($scope, $uibModal, $cookies, $state, $filter, $stateParams, ModalsService, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_clientversions')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_clientversions');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_clientversion_%s');
    $scope.WRITE_FILE = ACL.hasPermission($cookies, 'get_s3_signature') && ACL.hasPermission($cookies, 'post_clientfiles');
    $scope.RADE_FILE = ACL.hasPermission($cookies, 'get_clientfiles');

    $scope.data = {
      'ucid': undefined, 'version': undefined, 'level': undefined,
      'code': undefined, 'locale': undefined, 'url': undefined , 'pgs': 10, 'pgn': 0
    };
    var tempTableState = null;

    $scope.ucidItems = [
      {label: $filter('translate')('all'), value: 'all'},
      {label: 'Mynetvue-ios', value: '82db69b981'},
      {label: 'Mynetvue-android', value: 'f57ad0e472'},
      {label: 'Vuebell-ios', value: 'cabeffca09'},
      {label: 'Vuebell-android', value: '5821141b64'},
      {label: 'PPvue-android', value: '7ca25325bc'},
      {label: 'PPvue-ios', value: '24c7d4b73f'},
      {label: 'PPbell-ios', value: '3758b7239e'},
      {label: 'PPbell-android', value: 'cd87f930ab'},
      {label: 'QKeeper-ios', value: '228e7fac80'},
      {label: 'QKeeper-android', value: '702ea60d8e'},
      {label: 'Nightwatcher-ios', value: 'd651e93441'},
      {label: 'Nightwatcher-android', value: '7fc00e262d'},
      {label: 'Comdiy-ios', value: 'af8a8da62e'},
      {label: 'Comdiy-android', value: '5b762817c0'},
      {label: 'IISbell-ios', value: 'a2bedf63e5'},
      {label: 'IISBell-android', value: '3021f1ba13'},
      {label: 'Dorbell-ios', value: '96349756f3'},
      {label: 'Dorbell-android', value: '097e666c06'},
      {label: 'Marsboy-ios', value: 'cc51ebdce7'},
      {label: 'Marsboy-android', value: 'ea1ad72a34'},
      {label: 'Rintercom-ios', value: '7ed3282a6f'},
      {label: 'Rintercom-android', value: '9e70111eaf'},
    ];
    $scope.ucidSelected = $scope.ucidItems[0];

    $scope.levelItems = [
      {label: $filter('translate')('all'), value: 'all'},
      {label: $filter('translate')('low'), value: 0},
      {label: $filter('translate')('medium'), value: 1},
      {label: $filter('translate')('high'), value: 2},
    ];
    $scope.levelSelected = $scope.levelItems[0];

    $scope.localeItems = [
      {label: $filter('translate')('all'), value: 'all'},
      {label: $filter('translate')('cn'), value: 'cn'},
      {label: $filter('translate')('en'), value: 'en'},
    ];
    $scope.localeSelected = $scope.localeItems[0];

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.clientVersionsEmpty = false;
      var pagination = tableState.pagination;
      var params = tableState.search.predicateObject;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if (typeof params != 'undefined') {
        if (!params.hasOwnProperty('ucid')) {
          params.ucid = 'all';
        } else {
          $scope.data.ucid = params.ucid != 'all' ? params.ucid : undefined;
        }

        if (!params.hasOwnProperty('level')) {
          params.level = 'all';
        } else {
          $scope.data.level = params.level != 'all' ? params.level : undefined;

        }

        if (!params.hasOwnProperty('locale')) {
          params.locale = 'all';
        } else {
          $scope.data.locale = params.locale != 'all' ? params.locale : undefined;
        }

        $scope.data.code = params.hasOwnProperty('code') ? params.code : undefined;
        $scope.data.version = params.hasOwnProperty('version') ? params.version : undefined;
      }

      if ($stateParams.reloadParams != null) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      AjaxRequest.path('clientversions').get(
          $scope.data,
          function (data) {
            $scope.clientVersions = data.versions;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if($scope.clientVersions.length == 0){
              $scope.clientVersionsEmpty = true;
            }else{
              $scope.clientVersionsEmpty = false;
            }
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.clientVersions = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.clientVersionsEmpty = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.resetQuery = function () {
      tempTableState.pagination.start = 0;
      if (typeof tempTableState.search.predicateObject != 'undefined') {
        tempTableState.search.predicateObject = {};
      }
      $scope.data = {
        'ucid': undefined, 'version': undefined, 'level': undefined,
        'code': undefined, 'locale': undefined, 'pgs': 10, 'pgn': 0
      };
      $scope.callServer(tempTableState);
    };

    $scope.refresh = function(){
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (clientVersion) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/clientVersions/editClientVersion.html',
        controller: 'EditClientVersionCtrl',
        size: 'lg',
        resolve: {
          clientVersion: function () {
            return clientVersion;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.openInfoPage = function (value) {
      ModalsService.open('app/services/modals/staticModals/infoModal.html', 'mm', value);
    };

  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.clientVersions')
      .controller('EditClientVersionCtrl', EditClientVersionCtrl);

  /** @ngInject */
  function EditClientVersionCtrl($scope, $cookies, $state, $filter, clientVersion, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    $scope.ucidItems = [
      {label: 'Mynetvue-ios', value: '82db69b981'},
      {label: 'Mynetvue-android', value: 'f57ad0e472'},
      {label: 'Vuebell-ios', value: 'cabeffca09'},
      {label: 'Vuebell-android', value: '5821141b64'},
      {label: 'PPvue-android', value: '7ca25325bc'},
      {label: 'PPvue-ios', value: '24c7d4b73f'},
      {label: 'PPbell-ios', value: '3758b7239e'},
      {label: 'PPbell-android', value: 'cd87f930ab'},
      {label: 'QKeeper-ios', value: '228e7fac80'},
      {label: 'QKeeper-android', value: '702ea60d8e'},
      {label: 'Nightwatcher-ios', value: 'd651e93441'},
      {label: 'Nightwatcher-android', value: '7fc00e262d'},
      {label: 'Comdiy-ios', value: 'af8a8da62e'},
      {label: 'Comdiy-android', value: '5b762817c0'},
      {label: 'IISbell-ios', value: 'a2bedf63e5'},
      {label: 'IISBell-android', value: '3021f1ba13'},
      {label: 'Dorbell-ios', value: '96349756f3'},
      {label: 'Dorbell-android', value: '097e666c06'},
      {label: 'Marsboy-ios', value: 'cc51ebdce7'},
      {label: 'Marsboy-android', value: 'ea1ad72a34'},
      {label: 'Rintercom-ios', value: '7ed3282a6f'},
      {label: 'Rintercom-android', value: '9e70111eaf'},
    ];

    $scope.levelItems = [
      {label: $filter('translate')('low'), value: 0},
      {label: $filter('translate')('medium'), value: 1},
      {label: $filter('translate')('high'), value: 2},
    ];

    $scope.localeItems = [
      {label: $filter('translate')('cn'), value: 'cn'},
      {label: $filter('translate')('en'), value: 'en'},
    ];

    $scope.scopeItems = [
      {label: $filter('translate')('all_bm_users'), value: 0},
      {label: $filter('translate')('distributors'), value: 1},
      {label: $filter('translate')('developers'), value: 2},
    ];


    if (typeof clientVersion == 'undefined') {
      $scope.isNewClientVersion = true;
      $scope.data = {'ucid': '82db69b981', 'code': '', 'version': '', 'level': 0, 'locale': 'cn', 'note': '','scope': 0};
    } else {
      $scope.isNewClientVersion = false;
      $scope.data = {
        'code': clientVersion.code, 'version': clientVersion.version,
        'level': clientVersion.level, 'locale': clientVersion.locale, 'note': clientVersion.note,
        'scope': clientVersion.scope, 'url': clientVersion.url
      };

    }

    $scope.ucidSelected = $scope.ucidItems[0];
    $scope.levelSelected = $scope.levelItems[$scope.data.level];
    $scope.localeSelected = $scope.data.locale == 'cn' ? $scope.localeItems[0] : $scope.localeItems[1];
    $scope.scopeSelected = $scope.scopeItems[$scope.data.scope];

    $scope.submit = function () {
      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;
      if (!$scope.isNewClientVersion) {
        AjaxRequest.path('clientversion/' + clientVersion.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_client_version_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('clientVersions', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('clientversions').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'create_client_version_success');
              $state.go('clientVersions', {reloadParams: null}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.localeChange = function (localeSelected) {
      $scope.data.locale = localeSelected.value;
    };

    $scope.levelChange = function (levelSelected) {
      $scope.data.level = levelSelected.value;
    };

    $scope.ucidChange = function (ucidSelected) {
      $scope.data.ucid = ucidSelected.value;
    };

    $scope.scopeChange = function (scopeSelected) {
      $scope.data.scope = scopeSelected.value;
    };

    $scope.errors = false;
    $scope.errVersion = false;
    $scope.errCode = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errVersion = false;
      $scope.errCode = false;
    };


    $scope.isNotValidate = function () {
      var version = $scope.data.version;
      var code = $scope.data.code;
      var url = $scope.data.url;

      if (Validator.isNotStringValid(version)) {
        $scope.errVersion = true;
        $scope.errorMessage = Validator.isNotStringValid(version);
        return true;
      }

      if (Validator.isNotValidID(code)) {
        $scope.errCode = true;
        $scope.errorMessage = Validator.isNotValidID(code);
        return true;
      }

      if(Validator.isNotValidURL(url)){
        $scope.errUrl = true;
        $scope.errorMessage = Validator.isNotValidURL(url);
        return true;
      }

      return false;
    }

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.clients')
      .controller('ClientsPageCtrl', ClientsPageCtrl);

  /** @ngInject */
  function ClientsPageCtrl($scope, $uibModal, $cookies, $state, ModalsService, AjaxRequest,$stateParams) {

    if (!ACL.hasPermission($cookies, 'get_clients')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_clients');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_client_%s');

    $scope.data = {'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if($stateParams.reloadParams != null){
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.clientsEmpty = false;
      AjaxRequest.path('clients').get(
          $scope.data,
          function (data) {
            $scope.clients = data.clients;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if($scope.clients.length == 0 ){
              $scope.clientsEmpty = true;
            }else {
              $scope.clientsEmpty = false;
            }
            if($stateParams.reloadParams != null){
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.clientsEmpty = false;
            if($stateParams.reloadParams != null){
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.refresh = function(){
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (client) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/clients/editClient.html',
        controller: 'EditClientCtrl',
        size: 'lg',
        resolve: {
          client: function () {
            return client;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    }
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.clients')
      .controller('EditClientCtrl', EditClientCtrl);

  /** @ngInject */
  function EditClientCtrl($scope, $cookies, $state, client, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    if (typeof client == 'undefined') {
      $scope.isNewClient = true;
      $scope.data = {'clientName': '', 'clientInfo': '', 'appId': '', 'clientClass': '', 'clientPpm': '', 'clientSetting': ''};
    } else {
      $scope.isNewClient = false;
      $scope.data = {'clientName': client.clientName, 'clientInfo': client.clientInfo, 'appId': client.appId,
        'clientClass': client.clientClass, 'clientPpm': client.clientPpm, 'clientSetting': client.clientSetting};
    }

    $scope.submit = function () {

      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;
      if (!$scope.isNewClient) {
        AjaxRequest.path('client/' + client.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_client_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('clients', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('clients').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'create_client_success');
              $state.go('clients', {reloadParams: null}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.errors = false;
    $scope.errClientName = false;
    $scope.errClientInfo = false;
    $scope.errAppId = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errClientName = false;
      $scope.errClientInfo = false;
      $scope.errAppId = false;
    };


    $scope.isNotValidate = function () {
      var clientName = $scope.data.clientName;
      var clientInfo = $scope.data.clientInfo;
      var appId = $scope.data.appId;

      if (Validator.isNotStringValid(clientName)) {
        $scope.errClientName = true;
        $scope.errorMessage = Validator.isNotStringValid(clientName);
        return true;
      }

      if (Validator.isNotStringValid(clientInfo)) {
        $scope.errClientInfo = true;
        $scope.errorMessage = Validator.isNotStringValid(clientInfo);
        return true;
      }

      if (Validator.isNotValidID(appId)) {
        $scope.errAppId = true;
        $scope.errorMessage = Validator.isNotValidID(appId);
        return true;
      }

      return false;
    }

  }
})();

/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('DevicesPageCtrl', DevicesPageCtrl);

  /** @ngInject
   * 作用域 $scope
   * modal需要的 $uibModal
   * 权限验证需要的 $cookies
   * 页面跳转的需要的 $state
   * 静态modal用到的 ModalsService
   * 网络请求用到的 Devices
   */
  function DevicesPageCtrl($scope, $uibModal, $cookies, $filter, $state, $stateParams, ModalsService, AjaxRequest) {
    //权限校验
    if (!ACL.hasPermission($cookies, 'get_devices')) {
      $state.go('auth');
      return;
    }
    $scope.DEVICE_DETAIL = ACL.hasPermission($cookies, 'get_device_%s_detail');
    $scope.GET_DEVICE_PARAM = ACL.hasPermission($cookies, 'get_device_%s_params');
    $scope.PUT_DEVICE_RESET = ACL.hasPermission($cookies, 'put_device_%s_reset');
    $scope.PUT_DEVICE_ENABLED = ACL.hasPermission($cookies, 'put_device_%s_enabled');
    $scope.GET_DEVICE_LOGS = ACL.hasPermission($cookies, 'get_device_%s_logs');
    $scope.GET_DEVICE_SERVICE = ACL.hasPermission($cookies, 'get_device_%s_service');
    $scope.DEVICE_PARAM_BYFILE = ACL.hasPermission($cookies, 'post_devices_queries');
    $scope.DEVICE_SERVICE_BYFILE = ACL.hasPermission($cookies, 'put_devices_queries');
    $scope.DEVICE_DISTRIBUTOR_BYFILE = ACL.hasPermission($cookies, 'put_devices_distributors');
    $scope.DEVICE_SERVICE_CHANGE = ACL.hasPermission($cookies, 'post_deviceservice_change');
    $scope.DEVICE_DETAIL_INFO = ACL.hasPermission($cookies, 'get_device_detail_info');
    $scope.GET_DEVICE_MOTION_CALL_SERVICE = ACL.hasPermission($cookies, 'get_device_%s_motion_service');
    $scope.PUSH_DEVICE_UPGRADE = ACL.hasPermission($cookies, 'push_device_%s_upgrade');
    $scope.POST_FORMAT_SDCARD = ACL.hasPermission($cookies, 'post_device_%s_format_sdcard');
    $scope.POST_DEVICE_REBOOT = ACL.hasPermission($cookies, 'post_device_%s_reboot');
    $scope.CHECK_DEVICE_ID = ACL.hasPermission($cookies, 'check_device_id');

    $scope.data = {
      'serialNumber': undefined, 'deviceName': undefined, 'online': 'all', 'currentVersion': undefined,
      'ownerName': undefined, 'enabled': undefined, 'pgs': 10, 'pgn': 0
    };
    let tempTableState = null;

    $scope.onlineItems = [
      {label: $filter('translate')('all'), value: 'all'},
      {label: $filter('translate')('online'), value: 'on'},
      {label: $filter('translate')('offline'), value: 'off'},
    ];
    $scope.onlineSelected = $scope.onlineItems[0];

    $scope.statusItems = [
      {label: $filter('translate')('all'), value: 'all'},
      {label: $filter('translate')('normal'), value: 'on'},
      {label: $filter('translate')('lock_device'), value: 'off'},
    ];
    $scope.statusSelected = $scope.statusItems[0];

    //初始化网络请求
    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.devicesEmpty = false;
      //通过获取smart-table的tableState参数，得到必要的数据进行封装处理，发送网络请求
      let pagination = tableState.pagination;
      let params = tableState.search.predicateObject;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      if ($stateParams.reloadParams !== null && $stateParams.reloadParams.hasOwnProperty('deviceOwnerName')) {
        params.ownerName = $stateParams.reloadParams.deviceOwnerName;
      }

      //获取smart-table封装的搜索信息参数，如果存在则赋值
      if (typeof params !== 'undefined') {
        if (!params.hasOwnProperty('online')) {
          params.online = 'all';
        } else {
          $scope.data.online = params.online;
        }
        if (!params.hasOwnProperty('enabled')) {
          params.enabled = 'all';
        } else {
          $scope.data.enabled = params.enabled;
        }
        $scope.data.serialNumber = params.hasOwnProperty('serialNumber') ? params.serialNumber : undefined;
        $scope.data.deviceName = params.hasOwnProperty('deviceName') ? params.deviceName : undefined;
        $scope.data.ownerName = params.hasOwnProperty('ownerName') ? params.ownerName : undefined;
        $scope.data.currentVersion = params.hasOwnProperty('currentVersion') ? params.currentVersion : undefined;
      }

      if ($stateParams.reloadParams !== null && !$stateParams.reloadParams.hasOwnProperty('deviceOwnerName')) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      //进行get请求
      AjaxRequest.path('devices').get(
          $scope.data,
          function (data) {
            $scope.devices = data.devices;
            if ($scope.devices.length === 0) {
              $scope.devicesEmpty = true;
            } else {
              $scope.devicesEmpty = false;
            }
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($stateParams.reloadParams !== null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.devices = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.devicesEmpty = false;
            if ($stateParams.reloadParams !== null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.resetQuery = function () {
      tempTableState.pagination.start = 0;
      if (typeof tempTableState.search.predicateObject !== 'undefined') {
        tempTableState.search.predicateObject = {};
      }
      $scope.data = {
        'serialNumber': undefined, 'deviceName': undefined, 'online': 'all', 'currentVersion': undefined,
        'ownerName': undefined, 'enabled': undefined, 'pgs': 10, 'pgn': 0
      };
      $scope.callServer(tempTableState);
    };

    $scope.refresh = function () {
      $scope.callServer(tempTableState);
    };

    $scope.goOwner = function (deviceOwnerName) {
      $state.go('members', {reloadParams: {'deviceOwnerName': deviceOwnerName}}, {reload: true});
    };

    $scope.authData = {'user': "", 'pass': ""};

    $scope.getLocalToken = function (endpoint, modalObject) {
      $scope.holdSubmit = true;
      if ($cookies.get('endpoint') === endpoint && $cookies.get('local_token')) {
        $scope.holdSubmit = false;
        $uibModal.open(modalObject);
        return;
      }

      let userName = $cookies.get('userName');
      let pass = $cookies.get('upd');

      if (typeof userName !== "undefined") {
        $scope.authData.user = userName;
      }

      if (typeof pass !== "undefined") {
        $scope.authData.pass = pass;
      }

      AjaxRequest.path('token', endpoint).post(
          $scope.authData,
          function (data) {
            $scope.holdSubmit = false;
            let expires = new Date(data.expires);
            $cookies.put('local_token', data.token, {'expires': expires.toUTCString()});
            $cookies.put('endpoint', endpoint, {'expires': expires.toUTCString()});
            $uibModal.open(modalObject);
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
          }
      );
    };

    //以下为页面对应的actions
    $scope.lockDevice = function (deviceId, enabled) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/devices/modals/lockDevice.html',
        controller: 'LockDeviceCtrl',
        size: 'sm',
        resolve: {
          deviceInfo: function () {
            return {
              'deviceId': deviceId,
              'enabled': enabled,
            };
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.resetDevice = function (deviceId, endpoint, inNewServer) {
      if (inNewServer && endpoint === null) {
        ModalsService.open('app/services/modals/staticModals/infoModalTranslate.html', 'mm', "device_no_region");
        return;
      }
      endpoint += "/v1/bm";
      let deviceParam = {};
      let modalObject = {
        animation: true,
        templateUrl: 'app/pages/devices/modals/resetDevice.html',
        controller: 'ResetDeviceCtrl',
        size: 'sm',
        resolve: {
          deviceInfo: function () {
            return deviceParam;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      };
      deviceParam = {
        'deviceId': deviceId,
        'endpoint': endpoint
      };
      $scope.getLocalToken(endpoint, modalObject);
    };

    $scope.rebootDevice = function (deviceId, endpoint) {
      if (endpoint === null) {
        ModalsService.open('app/services/modals/staticModals/infoModalTranslate.html', 'mm', "device_no_region");
        return;
      }
      endpoint += "/v1/bm";
      let deviceParam = {};
      let modalObject = {
        animation: true,
        templateUrl: 'app/pages/devices/modals/rebootDevice.html',
        controller: 'RebootDeviceCtrl',
        size: 'sm',
        resolve: {
          deviceInfo: function () {
            return deviceParam;
          }
        }
      };
      deviceParam = {
        'deviceId': deviceId,
        'endpoint': endpoint
      };
      $scope.getLocalToken(endpoint, modalObject);
    };

    $scope.upgradeDevice = function (deviceId, endpoint) {
      if (endpoint === null) {
        ModalsService.open('app/services/modals/staticModals/infoModalTranslate.html', 'mm', "device_no_region");
        return;
      }
      endpoint += "/v1/bm";
      let deviceParam = {};
      let modalObject = {
        animation: true,
        templateUrl: 'app/pages/devices/modals/upgradeDevice.html',
        controller: 'UpgradeDeviceCtrl',
        size: 'sm',
        resolve: {
          deviceInfo: function () {
            return deviceParam;
          }
        }
      };
      deviceParam = {
        'deviceId': deviceId,
        'endpoint': endpoint
      };
      $scope.getLocalToken(endpoint, modalObject);
    };

    $scope.formatDeviceSDCard = function (deviceId, endpoint) {
      if (endpoint === null) {
        ModalsService.open('app/services/modals/staticModals/infoModalTranslate.html', 'mm', "device_no_region");
        return;
      }
      endpoint += "/v1/bm";
      let deviceParam = {};
      let modalObject = {
        animation: true,
        templateUrl: 'app/pages/devices/modals/sdCardFormat.html',
        controller: 'SDCardFormatCtrl',
        size: 'sm',
        resolve: {
          deviceInfo: function () {
            return deviceParam;
          }
        }
      };
      deviceParam = {
        'deviceId': deviceId,
        'endpoint': endpoint
      };
      $scope.getLocalToken(endpoint, modalObject);
    };

    // 单独打开对应的modal
    $scope.openDetailPage = function (deviceId, endpoint, inNewServer) {
      if (inNewServer && endpoint === null) {
        ModalsService.open('app/services/modals/staticModals/infoModalTranslate.html', 'mm', "device_no_region");
        return;
      }
      endpoint += "/v1/bm";
      let deviceParam = {};
      let modalObject = {
        animation: true,
        templateUrl: 'app/pages/devices/modals/deviceDetail.html',
        controller: 'DeviceDetailCtrl',
        size: 'mm',
        resolve: {
          deviceInfo: function () {
            return deviceParam;
          }
        }
      };
      deviceParam = {
        'deviceId': deviceId,
        'endpoint': endpoint
      };
      $scope.getLocalToken(endpoint, modalObject);
    };

    $scope.openServicePage = function (deviceId, serialNumber) {
      let deviceParam = {
        'deviceId': deviceId,
        'serialNumber': serialNumber
      };
      let modalObject = {
        animation: true,
        templateUrl: 'app/pages/devices/modals/deviceService.html',
        controller: 'DeviceServiceCtrl',
        size: 'lg',
        resolve: {
          deviceInfo: function () {
            return deviceParam;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      };
      $uibModal.open(modalObject);
    };


    $scope.openMotionCallServicePage = function (deviceId, serialNumber) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/devices/modals/motioncall/deviceMotionCallService.html',
        controller: 'DeviceMotionCallServiceCtrl',
        size: 'mm',
        resolve: {
          deviceInfo: function () {
            return {
              'deviceId': deviceId,
              'serialNumber': serialNumber
            };
          }
        }
      });
    };

    $scope.openParamPage = function (deviceId, endpoint, inNewServer) {
      if (inNewServer && endpoint === null) {
        ModalsService.open('app/services/modals/staticModals/infoModalTranslate.html', 'mm', "device_no_region");
        return;
      }
      endpoint += "/v1/bm";
      let deviceParam = {};
      let modalObject = {
        animation: true,
        templateUrl: 'app/pages/devices/modals/deviceParam.html',
        controller: 'DeviceParamCtrl',
        size: 'mm',
        resolve: {
          deviceInfo: function () {
            return deviceParam;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      };
      deviceParam = {
        'deviceId': deviceId,
        'endpoint': endpoint
      };
      $scope.getLocalToken(endpoint, modalObject);
    };

    // 单独打开对应的modal
    $scope.openLogPage = function (deviceId, deviceName, endpoint, inNewServer) {
      if (inNewServer && endpoint === null) {
        ModalsService.open('app/services/modals/staticModals/infoModalTranslate.html', 'mm', "device_no_region");
        return;
      }
      endpoint += "/v1/bm";
      let deviceParam = {};

      if (inNewServer) {
        let modalObject = {
          animation: true,
          templateUrl: 'app/pages/devices/logs/localDeviceLogs.html',
          controller: 'LocalDeviceLogsCtrl',
          size: 'lg',
          resolve: {
            deviceInfo: function () {
              return deviceParam;
            }
          }
        };
        deviceParam = {
          'deviceId': deviceId,
          'deviceName': deviceName,
          'endpoint': endpoint
        };
        $scope.getLocalToken(endpoint, modalObject);
      }
    };
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.distributors')
      .controller('DistributorsPageCtrl', DistributorsPageCtrl);

  /** @ngInject */
  function DistributorsPageCtrl($scope, $uibModal, $cookies, $state, ModalsService, AjaxRequest,$stateParams) {
    if (!ACL.hasPermission($cookies, 'get_distributors')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_DISTRIBUTOR = ACL.hasPermission($cookies, 'post_distributors');
    $scope.EDIT_DISTRIBUTOR = ACL.hasPermission($cookies, 'put_distributor_%s');

    $scope.data = {'pgs': 10, 'pgn': 0, 'appId': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      var params = tableState.search.predicateObject;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;

      if (typeof params != 'undefined') {
        $scope.data.appId = params.hasOwnProperty('appId') ? params.appId : 0;
      }

      if($stateParams.reloadParams != null){
        $scope.data = $stateParams.reloadParams;
        tableState.search.predicateObject = {};
        tableState.search.predicateObject.appId = $scope.data.appId;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.distributorsEmpty = false;
      AjaxRequest.path('distributors').get(
          $scope.data,
          function (data) {
            $scope.distributors = data.distributors;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if($scope.distributors.length == 0){
              $scope.distributorsEmpty = true;
            }else{
              $scope.distributorsEmpty = false;
            }
            if($stateParams.reloadParams != null){
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.distributorsEmpty = false;
            if($stateParams.reloadParams != null){
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.refresh = function(){
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (distributor) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/distributors/editDistributor.html',
        controller: 'EditDistributorCtrl',
        size: 'lg',
        resolve: {
          distributor: function () {
            return distributor;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    }
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.distributors')
      .controller('EditDistributorCtrl', EditDistributorCtrl);

  /** @ngInject */
  function EditDistributorCtrl($scope, $cookies, $state, $filter, distributor, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    $scope.isRootItems = [
      {label: $filter('translate')('false'), value: 'false'},
      {label: $filter('translate')('true'), value: 'true'},
    ];
    $scope.isRootSelected = $scope.isRootItems[0];

    if (typeof distributor == 'undefined') {
      $scope.isNewDistributor = true;
      $scope.data = {'distributorName': '', 'distributorInfo': '', 'appId': '', 'isRoot': false};
    } else {
      $scope.isNewDistributor = false;
      $scope.data = {'distributorName': distributor.distributorName, 'distributorInfo': distributor.distributorInfo,
        'appId': distributor.appId, 'isRoot': distributor.isRoot};
      $scope.isRootSelected = distributor.isRoot ? $scope.isRootItems[1] : $scope.isRootItems[0];
    }

    $scope.isRootChange = function (isRootSelected) {
      $scope.data.isRoot = isRootSelected.value;
    };

    $scope.submit = function () {

      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;
      if (!$scope.isNewDistributor) {
        AjaxRequest.path('distributor/' + distributor.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_distributor_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('distributors', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('distributors').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              NotificationsService.openToast('success', 'op_info', 'create_distributor_success', 'toast-top-center');
              $state.go('distributors', {reloadParams: null}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.errors = false;
    $scope.errDistributorName = false;
    $scope.errAppId = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errDistributorName = false;
      $scope.errAppId = false;
    };

    $scope.isNotValidate = function () {
      var distributorName = $scope.data.distributorName;
      var appId = $scope.data.appId;

      if (Validator.isNotValidAppDistributorName(distributorName)) {
        $scope.errDistributorName = true;
        $scope.errorMessage = Validator.isNotValidAppDistributorName(distributorName);
        return true;
      }

      if (Validator.isNotValidID(appId)) {
        $scope.errAppId = true;
        $scope.errorMessage = Validator.isNotValidID(appId);
        return true;
      }

      return false;
    }

  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.firmware')
      .controller('DisablePatchCtrl', DisablePatchCtrl);

  /** @ngInject */
  function DisablePatchCtrl($scope, $state, patchId, reloadParams, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_disable_firmware';
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('firmware/disable/' + patchId).put('',
          function (data) {
            NotificationsService.openToast('success', 'op_info', 'disable_firmware_success', 'toast-top-center');
            $state.go('firmware', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by John on 2017/2/9.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.firmware')
      .controller('EditPatchCtrl', EditPatchCtrl);

  function EditPatchCtrl($scope, $cookies, $filter, $state, patch, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    $scope.patchLevelItems = [
      {label: $filter('translate')('upgrade_reboot_immediately'), value: 0},
      {label: $filter('translate')('upgrade_on_idle'), value: 1},
      {label: $filter('translate')('upgrade_on_cloud_cmd'), value: 2},
    ];
    $scope.patchLevelSelected = $scope.patchLevelItems[0];

    $scope.isEnableItems = [
      {label: $filter('translate')('true'), value: 'true'},
      {label: $filter('translate')('false'), value: 'false'},
    ];
    $scope.isEnableSelected = $scope.isEnableItems[0];

    if (typeof patch == 'undefined') {
      $scope.isNewPatch = true;
      $scope.data = {'from': '', 'to': '', 'level': 0, 'md5': '', 'url': '', 'note': '', 'enable': true, "size": '', "spaceNeeded": ''};
    } else {
      $scope.isNewPatch = false;
      $scope.data = {'from': patch.from, 'to': patch.to, 'level': patch.level, 'md5': patch.md5,
        'url': patch.url, 'note': patch.note, 'enable': patch.enable, "size":patch.size, "spaceNeeded": patch.spaceNeeded};
      $scope.patchLevelSelected = $scope.patchLevelItems[patch.level];
      $scope.isEnableSelected = patch.enable ? $scope.isEnableItems[0] : $scope.isEnableItems[1];
    }

    $scope.patchLevelChange = function (patchLevelSelected) {
      $scope.data.level = patchLevelSelected.value;
    };
    $scope.isEnableChange = function (isEnableSelected) {
      $scope.data.enable = isEnableSelected.value;
    };

    $scope.submit = function () {

      if ($scope.isNotValidate()) {
        return;
      }

      $scope.holdSubmit = true;
      if ($scope.isNewPatch) {
        AjaxRequest.path('firmware/patches').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'create_patch_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('firmware', {reloadParams: null}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
            })
      } else {
        AjaxRequest.path('firmware/patch/' + patch.PID).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_patch_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('firmware', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
            });
      }
      $scope.$dismiss();
    };

    $scope.errors = false;
    $scope.errFrom = false;
    $scope.errTo = false;
    $scope.errMd5 = false;
    $scope.errUrl = false;
    $scope.errSize = false;
    $scope.errSpaceNeeded = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errFrom = false;
      $scope.errTo = false;
      $scope.errMd5 = false;
      $scope.errUrl = false;
      $scope.errSize = false;
      $scope.errSpaceNeeded = false;
    };


    $scope.isNotValidate = function () {
      var from = $scope.data.from;
      var to = $scope.data.to;
      var md5 = $scope.data.md5;
      var url = $scope.data.url;
      var size = $scope.data.size;
      var spaceNeeded = $scope.data.spaceNeeded;

      if (Validator.isNotValidVersion(from)) {
        $scope.errFrom = true;
        $scope.errorMessage = Validator.isNotValidVersion(from);
        return true;
      }

      if (Validator.isNotValidVersion(to)) {
        $scope.errTo = true;
        $scope.errorMessage = Validator.isNotValidVersion(to);
        return true;
      }

      if (Validator.isNotValidID(size)) {
        $scope.errSize = true;
        $scope.errorMessage = Validator.isNotValidID(size);
        return true;
      }

      if (Validator.isNotValidID(spaceNeeded)) {
        $scope.errSpaceNeeded = true;
        $scope.errorMessage = Validator.isNotValidID(spaceNeeded);
        return true;
      }

      if (Validator.isNotValidMD5(md5)) {
        $scope.errMd5 = true;
        $scope.errorMessage = Validator.isNotValidMD5(md5);
        return true;
      }

      if (Validator.isNotValidURL(url)) {
        $scope.errUrl = true;
        $scope.errorMessage = Validator.isNotValidURL(url);
        return true;
      }

      return false;
    };
  }
})();
/**
 * @author shenfeng
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.firmware')
      .controller('PatchesPageCtrl', PatchesPageCtrl);

  /** @ngInject */
  function PatchesPageCtrl($scope, $state, $uibModal, $cookies, $filter, AjaxRequest, ModalsService, $stateParams) {
    if (!ACL.hasPermission($cookies, 'get_firmware_patches')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_FIRMWARE = ACL.hasPermission($cookies, 'post_firmware_patches');
    $scope.UPDATE_FIRMWARE = ACL.hasPermission($cookies, 'put_firmware_patch');
    $scope.GET_UPGRADE_PATH = ACL.hasPermission($cookies, 'get_firmware_upgrade_paths');
    $scope.PUBLISH_FIRMWARE = ACL.hasPermission($cookies, 'put_firmware_publish_%s');
    $scope.SET_FIRMWARE_TESTED = ACL.hasPermission($cookies, 'put_firmware_tested_%s');
    $scope.BATCH_UPGRADE = ACL.hasPermission($cookies, 'post_devices_firmware');


    $scope.data = {'from': undefined, 'to': undefined, 'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.stateItems = [
      {label: $filter('translate')('all'), value: ''},
      {label: $filter('translate')('wait_for_test'), value: 'wait_for_test'},
      {label: $filter('translate')('tested'), value: 'tested'},
      {label: $filter('translate')('disabled'), value: 'disabled'},
    ];
    $scope.stateSelected = $scope.stateItems[0];

    $scope.publishedItems = [
      {label: $filter('translate')('all'), value: ''},
      {label: $filter('translate')('true'), value: 'true'},
      {label: $filter('translate')('false'), value: 'false'},
    ];
    $scope.publishedSelected = $scope.publishedItems[0];

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      if(typeof tableState.search.predicateObject == 'undefined'){
        tableState.search.predicateObject = {};
      }
      var params = tableState.search.predicateObject;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;

      if (typeof params != 'undefined') {
        $scope.data.from = params.hasOwnProperty('fromVersion') ? params.fromVersion : undefined;
        $scope.data.to = params.hasOwnProperty('toVerison') ? params.toVerison : undefined;
        $scope.data.state = params.hasOwnProperty('state') ? params.state : undefined;
        $scope.data.publish = params.hasOwnProperty('publish') ? params.publish : undefined;
      }

      if($stateParams.reloadParams != null){
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.patchesEmpty = false;
      AjaxRequest.path('firmware/patches').get(
          $scope.data,
          function (data) {
            $scope.patches = data.patches;
            if($scope.patches.length == 0){
              $scope.patchesEmpty = true;
            }else{
              $scope.patchesEmpty = false;
            }

            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if($stateParams.reloadParams != null){
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.patches = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.patchesEmpty = false;
            if($stateParams.reloadParams != null){
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.resetQuery = function () {
      tempTableState.pagination.start = 0;
      if (typeof tempTableState.search.predicateObject != 'undefined') {
        tempTableState.search.predicateObject = {};
      }
      $scope.callServer(tempTableState);
    };

    $scope.refresh = function(){
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (patch) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/firmware/editPatch.html',
        controller: 'EditPatchCtrl',
        size: 'lg',
        resolve: {
          patch: function () {
            return patch;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.openSetTestedPage = function (patchId) {
      console.log("set tested " + patchId);
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/firmware/publishPatch.html',
        controller: 'SetPatchTestedCtrl',
        size: 'sm',
        resolve: {
          patchId: function () {
            return patchId;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.openDisablePage = function (patchId) {
      console.log("set disable " + patchId);
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/firmware/publishPatch.html',
        controller: 'DisablePatchCtrl',
        size: 'sm',
        resolve: {
          patchId: function () {
            return patchId;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.openPublishPage = function (patchId) {
      console.log(patchId);
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/firmware/publishPatch.html',
        controller: 'PublishPatchCtrl',
        size: 'sm',
        resolve: {
          patchId: function () {
            return patchId;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };
  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.firmware')
      .controller('PublishPatchCtrl', PublishPatchCtrl);

  /** @ngInject */
  function PublishPatchCtrl($scope, $state, patchId, reloadParams, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_publish';
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('firmware/publish/' + patchId).put('',
          function (data) {
            NotificationsService.openToast('success', 'op_info', 'publish_success', 'toast-top-center');
            $state.go('firmware', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.firmware')
      .controller('SetPatchTestedCtrl', SetPatchTestedCtrl);

  /** @ngInject */
  function SetPatchTestedCtrl($scope, $state, patchId, reloadParams, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_set_tested';
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('firmware/set_tested/' + patchId).put('',
          function (data) {
            NotificationsService.openToast('success', 'op_info', 'set_tested_success', 'toast-top-center');
            $state.go('firmware', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.members')
      .controller('DeleteMemberCtrl', DeleteMemberCtrl);

  /** @ngInject */
  function DeleteMemberCtrl($scope, $state, $cookies, NotificationsService, ModalsService,
                            memberId, memberName, reloadParams, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'post_removemember')) {
      $state.go('auth');
      return;
    }

    $scope.message = 'confirm_to_delete_member';
    $scope.confirm = function () {
      $scope.holdSubmit = true;
      $scope.data = {'online': 'all', 'ownerName': memberName, 'pgs': 10, 'pgn': 0};
      AjaxRequest.path('devices').get(
          $scope.data,
          function (data) {
            $scope.isLoading = false;
            $scope.getDataError = false;
            let requestMap = generateRequestMap(memberId, memberName, data.devices);

            AjaxRequest.path('member/invalidate?uid=' + memberId).post(
                function (data) {},
                function (error) {
                  ModalsService.handleError(error);
                  $scope.$dismiss();
                }
            );

            requestToRemoveMember(requestMap);
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
          }
      );
    };

    function requestToRemoveMember(requestMap) {
      if (requestMap.size === 0) {
        return;
      }

      if (requestMap.size === 1) {
        AjaxRequest.path('removemember').post(
            requestMap.get("central"),
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              NotificationsService.openToast('success', 'op_info', 'delete_member_status_success', 'toast-top-center');
              $state.go('members', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              $scope.$dismiss();
            }
        );
      } else {
        var mapArray = Array.from(requestMap);
        for (var i = 0; i < mapArray.length; i++) {
          if (mapArray[i][0] !== "central") {
            //只要不是central的就可以执行ajax请求了，剩下的等ajax调用完回调就行了，可以break出去了
            getLocalTokenAndRequest(requestMap, mapArray[i][0], mapArray[i][1]);
            break;
          }
        }
      }
    }

    $scope.authData = {'user': "", 'pass': ""};

    function getLocalTokenAndRequest(requestMap, endpoint, request) {
      $scope.holdSubmit = true;
      if ($cookies.get('endpoint') == endpoint && $cookies.get('local_token')) {
        $scope.holdSubmit = false;
        requestToLocalRemoveMember(requestMap, endpoint, request);
        return;
      }

      var userName = $cookies.get('userName');
      var pass = $cookies.get('upd');
      if (typeof userName != "undefined") {
        $scope.authData.user = userName;
      }
      if (typeof pass != "undefined") {
        $scope.authData.pass = pass;
      }

      AjaxRequest.path('token', endpoint).post(
          $scope.authData,
          function (data) {
            $scope.holdSubmit = false;
            var expires = new Date(data.expires);
            $cookies.put('local_token', data.token, {'expires': expires.toUTCString()});
            $cookies.put('endpoint', endpoint, {'expires': expires.toUTCString()});
            requestToLocalRemoveMember(requestMap, endpoint, request);
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
          }
      );
    }

    function requestToLocalRemoveMember(requestMap, endpoint, request) {
      AjaxRequest.path('device/remove', endpoint).post(
          request,
          function (data) {
            requestMap.delete(endpoint);
            //接着回调删除逻辑，顺序进行删除
            requestToRemoveMember(requestMap);
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.$dismiss();
          }
      );
    }

    function generateRequestMap(memberId, memberName, devices) {
      var map = new Map();
      var centralRequest = {"userId": memberId, "username": memberName, "serialNumbers": []};
      map.set("central", centralRequest);

      for (var i = 0; i < devices.length; i++) {
        var device = devices[i];
        if (device.endpoint !== null) {
          device.endpoint += "/v1/bm";
          if (map.get(device.endpoint) === undefined) {
            var localRequest = {"userId": memberId, "username": memberName, "serialNumbers": []};
            localRequest.serialNumbers.push(device.serialNumber);
            map.set(device.endpoint, localRequest);
          } else {
            map.get(device.endpoint).serialNumbers.push(device.serialNumber);
          }
        }
      }
      return map;
    }
  }
})();

(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.members')
      .controller('MembersPageCtrl', MembersPageCtrl);

  /** @ngInject */
  function MembersPageCtrl($scope, $state, $uibModal, $cookies, $stateParams, AjaxRequest, ModalsService) {
    if (!ACL.hasPermission($cookies, 'get_members')) {
      $state.go('auth');
      return;
    }

    let wait1000 =  new Promise(function(resolve, reject) {
      setTimeout(resolve, 1000)
    }).then(function() {
      console.log('Yay support es6!')
    });

    $scope.EDIT_MEMBER = ACL.hasPermission($cookies, 'put_member_%s');
    $scope.GET_ACTIVITY = ACL.hasPermission($cookies, 'get_member_%s_activity');
    $scope.GET_UDID = ACL.hasPermission($cookies, 'get_member_udid');
    $scope.DELETE_MEMBER = ACL.hasPermission($cookies, 'post_removemember');

    $scope.data = {'userName': undefined, 'email': undefined, 'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      if (typeof tableState.search.predicateObject == 'undefined') {
        tableState.search.predicateObject = {};
      }
      var params = tableState.search.predicateObject;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.data.pgs = pagination.number || 10;

      if ($stateParams.reloadParams != null && $stateParams.reloadParams.hasOwnProperty('deviceOwnerName')) {
        params.userName = $stateParams.reloadParams.deviceOwnerName;
      }

      if (typeof params != 'undefined') {
        $scope.data.email = params.hasOwnProperty('email') ? params.email : undefined;
        $scope.data.userName = params.hasOwnProperty('userName') ? params.userName : undefined;
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.membersEmpty = false;

      if ($stateParams.reloadParams != null && !$stateParams.reloadParams.hasOwnProperty('deviceOwnerName')) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      AjaxRequest.path('members').get(
          $scope.data,
          function (data) {
            $scope.members = data.members;
            if ($scope.members.length == 0) {
              $scope.membersEmpty = true;
            } else {
              $scope.membersEmpty = false;
            }

            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.members = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.membersEmpty = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.resetQuery = function () {
      tempTableState.pagination.start = 0;
      if (typeof tempTableState.search.predicateObject != 'undefined') {
        tempTableState.search.predicateObject = {};
      }
      $scope.callServer(tempTableState);
    };

    $scope.refresh = function () {
      $scope.callServer(tempTableState);
    };

    $scope.goDevice = function (userName) {
      $state.go('devices', {reloadParams: {'deviceOwnerName': userName}}, {reload: true});
    };

    $scope.modifyEmail = function (memberId) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/members/modifyEmail.html',
        controller: 'ModifyEmailCtrl',
        size: 'sm',
        resolve: {
          memberId: function () {
            return memberId;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.modifyPassword = function (memberId) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/members/modifyPassword.html',
        controller: 'ModifyPasswordCtrl',
        size: 'sm',
        resolve: {
          memberId: function () {
            return memberId;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.deleteMember = function (memberId, memberName) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/members/deleteMember.html',
        controller: 'DeleteMemberCtrl',
        size: 'sm',
        resolve: {
          memberId: function () {
            return memberId;
          },
          memberName: function () {
            return memberName;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.getActivity = function (memberId, memberName) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/members/modals/newMemberActivity.html',
        controller: 'NewMemberActivityCtrl',
        size: 'lg',
        resolve: {
          member: function () {
            return {
              'id': memberId,
              'name': memberName,
            }
          }
        }
      });
    };

    $scope.getUdid = function (memberId) {
      AjaxRequest.path('member/udid').get(
          {"memberId": memberId},
          function (data) {
            ModalsService.open('app/services/modals/staticModals/infoModal.html', 'mm',  data.udidList);
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.$dismiss();
          }
      );

    };
  }
})();
/**
 * Created by John on 2017/2/14.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.members')
      .controller('ModifyEmailCtrl', ModifyEmailCtrl);

  /** @ngInject */
  function ModifyEmailCtrl($scope, $state, $cookies, NotificationsService, ModalsService, memberId, reloadParams, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'put_member_%s')) {
      $state.go('auth');
      return;
    }

    $scope.data = {'email': ''};

    $scope.errors = false;
    $scope.errEmail = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errEmail = false;
    };

    $scope.submit = function () {

      if (Validator.isNotValidEmail($scope.data.email)) {
        $scope.errEmail = true;
        $scope.errorMessage = Validator.isNotValidEmail($scope.data.email);
        return;
      }

      $scope.holdSubmit = true;
      AjaxRequest.path('member/' + memberId).put(
          $scope.data,
          function (data) {
            $scope.holdSubmit = false;
            $scope.newEmail = undefined;
            NotificationsService.openToast('success', 'op_info', 'change_email_success', 'toast-top-center');
            $scope.$dismiss();
            $state.go('members', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };

  }
})();
/**
 * Created by John on 2017/2/14.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.members')
      .controller('ModifyPasswordCtrl', ModifyPasswordCtrl);

  /** @ngInject */
  function ModifyPasswordCtrl($scope, $state, $cookies, NotificationsService, ModalsService, memberId, reloadParams, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'put_member_%s')) {
      $state.go('auth');
      return;
    }
    $scope.data = {'password': ''};

    $scope.errors = false;
    $scope.errPass = false;
    $scope.errConfirmPass = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errPass = false;
      $scope.errConfirmPass = false;
    };

    $scope.submit = function () {
      var pwd1 = $scope.plainPassword1;
      var pwd2 = $scope.plainPassword2;

      if (Validator.isNotValidPassword(pwd1)) {
        $scope.errPass = true;
        $scope.errorMessage = Validator.isNotValidPassword(pwd1);
        return;
      }

      if (Validator.isNotValidPassword(pwd2)) {
        $scope.errConfirmPass = true;
        $scope.errorMessage = Validator.isNotValidPassword(pwd2);
        return;
      }

      if (Validator.isNotPasswordEqual(pwd1, pwd2)) {
        $scope.errConfirmPass = true;
        $scope.errorMessage = Validator.isNotPasswordEqual(pwd1, pwd2);
        return;
      }

      $scope.data.password = hex_md5(pwd2);
      $scope.holdSubmit = true;
      AjaxRequest.path('member/' + memberId).put(
          $scope.data,
          function (data) {
            $scope.holdSubmit = false;
            $scope.plainPassword1 = undefined;
            $scope.plainPassword2 = undefined;
            NotificationsService.openToast('success', 'op_info', 'change_password_success', 'toast-top-center');
            $scope.$dismiss();
            $state.go('members', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };

  }
})();

/**
 * Created by ptx.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.pricing')
      .controller('EditPriceCtrl', EditPriceCtrl);

  /** @ngInject */
  function EditPriceCtrl($scope, $state, $filter, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    $scope.serviceTypeItems = [
      {label: $filter('translate')('cloud_record_month'), value: 1},
      {label: $filter('translate')('cloud_record_year'), value: 2},
      {label: $filter('translate')('full_record_month'), value: 3},
      {label: $filter('translate')('full_record_year'), value: 4},
      {label: $filter('translate')('cloud_record_triable'), value: 99},
      {label: $filter('translate')('full_record_triable'), value: 100}
    ];
    $scope.serviceTypeSelected = $scope.serviceTypeItems[0];

    $scope.currencyItems = [
      {label: $filter('translate')('USD'), value: 1},
      {label: $filter('translate')('CNY'), value: 2}
    ];
    $scope.currencySelected = $scope.currencyItems[0];

    $scope.isEnableItems = [
      {label: $filter('translate')('enable'), value: 'true'},
      {label: $filter('translate')('disable'), value: 'false'}
    ];
    $scope.isEnableSelected = $scope.isEnableItems[0];

    $scope.data = {
      'region': '', 'serviceType': 1, 'currency': 1, 'price': 0, 'appId': undefined, 'enable': 'true'
    };

    $scope.submit = function () {
      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;

      AjaxRequest.path('service/prices').post(
          $scope.data,
          function (data) {
            $scope.holdSubmit = false;
            $scope.$dismiss();
            NotificationsService.openToast('success', 'op_info', 'create_price_success', 'toast-top-center');
            $state.go('pricing', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };

    $scope.serviceTypeChange = function (serviceTypeSelected) {
      $scope.data.serviceType = serviceTypeSelected.value;
    };

    $scope.currencyChange = function (currencySelected) {
      $scope.data.currency = currencySelected.value;
    };

    $scope.isEnableChange = function (isEnableSelected) {
      $scope.data.enable = isEnableSelected.value;
    };

    $scope.errors = false;
    $scope.errRegion = false;
    $scope.errPrice = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errRegion = false;
      $scope.errPrice = false;
    };

    $scope.isNotValidate = function () {
      var region = $scope.data.region;
      var price = $scope.data.price;

      if (Validator.isNotStringValid(region)) {
        $scope.errRegion = true;
        $scope.errorMessage = Validator.isNotStringValid(region);
        return true;
      }

      if (Validator.isNotValidPrice(price)) {
        $scope.errPrice = true;
        $scope.errorMessage = Validator.isNotValidPrice(price);
        return true;
      }

      return false;
    }

  }
})();
/**
 * Created by ptx.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.pricing')
      .controller('PricingPageCtrl', PricingPageCtrl);

  /** @ngInject */
  function PricingPageCtrl($scope, $uibModal, $cookies, $state, $filter, ModalsService, AjaxRequest, $stateParams) {
    if (!ACL.hasPermission($cookies, 'get_prices')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_price');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_price');

    $scope.data = {'region': undefined, 'serviceType': undefined, 'currency': undefined, 'status': undefined,
      'appId':undefined, 'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.regions = [
      {label: $filter('translate')('all'), value: ''},
      {label: 'us-east-1', value: 'us-east-1'},
      {label: 'us-west-1', value: 'us-west-1'},
      {label: 'eu-west-1', value: 'eu-west-1'},
      {label: 'cn-north-1', value: 'cn-north-1'},
      {label: 'ap-southeast-1', value: 'ap-southeast-1'},
      {label: 'ap-northeast-1', value: 'ap-northeast-1'},
    ];
    if($scope.regionSelected === undefined){
      $scope.regionSelected = $scope.regions[0];
    }

    $scope.serviceTypes = [
      {label: $filter('translate')('all'), value: ''},
      {label: $filter('translate')('video_motion_month'), value: 'VIDEO_MOTION_MONTH'},
      {label: $filter('translate')('video_motion_year'), value: 'VIDEO_MOTION_YEAR'},
      {label: $filter('translate')('full_record_month'), value: 'FULL_RECORD_MONTH'},
      {label: $filter('translate')('full_record_year'), value: 'FULL_RECORD_YEAR'},
      {label: $filter('translate')('full_record_two_year'), value: 'FULL_RECORD_TWO_YEAR'},
      {label: $filter('translate')('cloud_record_month'), value: 'CLOUD_RECORD_MONTH'},
      {label: $filter('translate')('cloud_record_year'), value: 'CLOUD_RECORD_YEAR'},
      {label: $filter('translate')('cloud_record_triable'), value: 'CLOUD_RECORD_TRIABLE'},
      {label: $filter('translate')('full_record_triable'), value: 'FULL_RECORD_TRIABLE'}
    ];
    if($scope.serviceTypeSelected === undefined){
      $scope.serviceTypeSelected = $scope.serviceTypes[0];
    }

    $scope.currencys = [
      {label: $filter('translate')('all'), value: ''},
      {label: $filter('translate')('USD'), value: 'USD'},
      {label: $filter('translate')('CNY'), value: 'CNY'}
    ];
    if($scope.currencySelected === undefined){
      $scope.currencySelected = $scope.currencys[0];
    }

    $scope.statusSet = [
      {label: $filter('translate')('all'), value: ''},
      {label: $filter('translate')('enable'), value: 'true'},
      {label: $filter('translate')('disable'), value: 'false'},
    ];
    if($scope.statusSelected === undefined){
      $scope.statusSelected = $scope.statusSet[0];
    }

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.pricesEmpty = false;
      var pagination = tableState.pagination;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if($stateParams.reloadParams != null){
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      AjaxRequest.path('service/prices').get(
          $scope.data,
          function (data) {
            $scope.servicePrices = data.serviceInfos;
            if($scope.servicePrices.length == 0){
              $scope.pricesEmpty = true;
            }else {
              $scope.pricesEmpty = false;
            }
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if($stateParams.reloadParams != null){
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.servicePrices = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.pricesEmpty = false;
            if($stateParams.reloadParams != null){
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.search = function () {
      $scope.callServer(tempTableState);
    };

    $scope.refresh = function(){
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (servicePrice) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/pricing/editPrice.html',
        controller: 'EditPriceCtrl',
        size: 'lg',
        resolve: {
          servicePrice: function () {
            return servicePrice;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.modifyPriceStatus = function (servicePrice) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/pricing/modifyPriceStatus.html',
        controller: 'ModifyPriceStatusCtrl',
        size: 'sm',
        resolve: {
          servicePrice: function () {
            return servicePrice;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.regionChanged = function (regionSelected) {
      $scope.data.region = regionSelected.value;
    };

    $scope.serviceTypeChanged = function(serviceTypeSelected){
      $scope.data.serviceType = serviceTypeSelected.value;
    };

    $scope.currencyChanged = function(currencyChanged){
      $scope.data.currency = currencyChanged.value;
    };

    $scope.statusChanged = function(statusSelected){
      $scope.data.status = statusSelected.value;
      console.log($scope.data.status);
    }
  }
})();
/**
 * Created by ptx.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.pricing')
      .controller('ModifyPriceStatusCtrl', ModifyPriceStatusCtrl);

  /** @ngInject */
  function ModifyPriceStatusCtrl($scope, $cookies, $state, $filter, servicePrice, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    $scope.isEnableItems = [
      {label: $filter('translate')('enable'), value: 'true'},
      {label: $filter('translate')('disable'), value: 'false'}
    ];
    $scope.isEnableSelected = servicePrice.enable ? $scope.isEnableItems[0] : $scope.isEnableItems[1];

    $scope.trialEnableItems = [
      {label: $filter('translate')('enable'), value: 'true'},
      {label: $filter('translate')('disable'), value: 'false'}
    ];
    $scope.trialEnableSelected = servicePrice.trialEnable ? $scope.trialEnableItems[0] : $scope.trialEnableItems[1];

    $scope.currencyItems = [
      {label: $filter('translate')('USD'), value: 1},
      {label: $filter('translate')('CNY'), value: 2}
    ];
    $scope.currencySelected = servicePrice.currency === "USD" ? $scope.currencyItems[0] : $scope.currencyItems[1];

    $scope.data = {
      'price': servicePrice.price,
      'discountPrice': servicePrice.discountPrice,
      'currency': $scope.currencySelected.value,
      'enable': servicePrice.enable,
      'trialEnable': servicePrice.trialEnable,

    };

    $scope.submit = function () {
      $scope.holdSubmit = true;
      AjaxRequest.path('service/price/' + servicePrice.id).put(
          $scope.data,
          function (data) {
            $scope.holdSubmit = false;
            NotificationsService.openToast('success', 'op_info', 'modify_price_status_success', 'toast-top-center');
            $scope.$dismiss();
            $state.go('pricing', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };

    $scope.isEnableChange = function (isEnableSelected) {
      $scope.data.enable = isEnableSelected.value;
    };

    $scope.isTrialEnableChange = function (trialEnableSelected) {
      $scope.data.trialEnable = trialEnableSelected.value;
    };

    $scope.currencyChange = function (currencySelected) {
      $scope.data.currency = currencySelected.value;
    };

  }
})();
/**
 * Created by John on 2017/2/9.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.transactions')
      .controller('TransactionsPageCtrl', TransactionsPageCtrl);

  /** @ngInject */
  function TransactionsPageCtrl($scope, $state, $cookies, AjaxRequest, ModalsService) {
    if (!ACL.hasPermission($cookies, 'get_transactions')) {
      $state.go('auth');
      return;
    }
    $scope.data = {
      'appID': undefined, 'distributorID': undefined, 'startTime': undefined, 'endTime': undefined,
      'serialNumber': undefined, 'memberName': undefined, 'pgs': 10, 'pgn': 0
    };

    $scope.dateRangeStart = undefined;
    $scope.dateRangeEnd = undefined;

    $scope.callServer = function () {
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.transactionsEmpty = false;
      AjaxRequest.path('transactions').get(
          $scope.data,
          function (data) {
            $scope.transactions = data.transactions;
            if($scope.transactions.length == 0){
              $scope.transactionsEmpty = true;
            }else{
              $scope.transactionsEmpty = false;
            }
            $scope.currentPage = $scope.data.pgn + 1;
            $scope.numPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.pages = {};
            $scope.pages.length = $scope.numPages;
            $scope.isLoading = false;
            $scope.getDataError = false;
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.transactionsEmpty = false;
          });
    };

    $scope.callServer();

    $scope.search = function(){
      $scope.data.pgn = 0;
      $scope.callServer();
    };

    $scope.selectPage = function (page) {
      if (page > 0 && page <= $scope.numPages) {
        $scope.data.pgs = 10;
        $scope.data.pgn = page - 1;
        $scope.callServer();
      }
    };

    $scope.refresh = function(){
      $scope.selectPage($scope.data.pgn + 1);
    };

    $scope.resetSearch = function () {
      $scope.dateRangeStart = undefined;
      $scope.dateRangeEnd = undefined;
      $scope.data = {
        'appID': undefined, 'distributorID': undefined, 'startTime': undefined, 'endTime': undefined,
        'serialNumber': undefined, 'memberName': undefined, 'pgs': 10, 'pgn': 0
      };
      $scope.callServer();
    };

    $scope.startDateOnSetTime = function () {
      $scope.data.startTime = new Date($scope.dateRangeStart).getTime();
      $scope.dateRangeStart = new Date($scope.dateRangeStart).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('start-date-changed');
    };

    $scope.endDateOnSetTime = function () {
      $scope.data.endTime = new Date($scope.dateRangeEnd).getTime();
      $scope.dateRangeEnd = new Date($scope.dateRangeEnd).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('end-date-changed');
    };

    $scope.startDateBeforeRender = function ($dates) {
      if ($scope.dateRangeEnd) {
        var activeDate = moment($scope.dateRangeEnd);
        $dates.filter(function (date) {
          return date.localDateValue() >= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };

    $scope.endDateBeforeRender = function ($view, $dates) {
      if ($scope.dateRangeStart) {
        var activeDate = moment($scope.dateRangeStart).subtract(1, $view).add(1, 'minute');
        $dates.filter(function (date) {
          return date.localDateValue() <= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };
  }
})();
'use strict';

/* Filters */
var commonFilters = angular.module('NetviewAdmin.pages');

commonFilters.filter('level', function ($translate, patchLevelKeys) {
  return function (index) {
    if (index >= 0 && index < patchLevelKeys.length) {
      return $translate.instant(patchLevelKeys[index]);
    } else {
      return $translate.instant("patch_level_sim");
    }
  };
});

commonFilters.filter('bmUserStatus', function ($translate) {
  return function (value) {
    if (value) {
      return $translate.instant('enable');
    } else {
      return $translate.instant('disable');
    }
  };
});

commonFilters.filter('servicePriceStatus', function ($translate) {
  return function (value) {
    if (value) {
      return $translate.instant('enable');
    } else {
      return $translate.instant('disable');
    }
  };
});


commonFilters.filter('deviceStatus', function ($translate) {
  return function (value) {
    if (value) {
      return $translate.instant('normal');
    } else {
      return $translate.instant('lock_device');
    }
  };
});

commonFilters.filter('inNewServer', function ($translate) {
  return function (value) {
    if (value) {
      return $translate.instant('new_server');
    } else {
      return $translate.instant('old_server');
    }
  };
});

commonFilters.filter('onlineFilter', function ($translate) {
  return function (value) {
    if (value) {
      return $translate.instant('online');
    } else {
      return $translate.instant('offline');
    }
  };
});

commonFilters.filter('versionFilter', function ($translate) {
  return function (value) {
    switch (value) {
      case 0:
        return $translate.instant('low');
      case 1:
        return $translate.instant('medium');
      case 2:
        return $translate.instant('high');
      case "cn":
        return $translate.instant('cn');
      case "en":
        return $translate.instant('en');
      default:
        return "";
    }
  }
});

commonFilters.filter('bucketFilter', function ($translate) {
  return function (value) {
    switch (value) {
      case 'cn':
        return $translate.instant('CN');
      case 'us':
        return $translate.instant('US');
      default:
        return "";
    }
  }
});

commonFilters.filter('isRootFilter', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('true');
      case false:
        return $translate.instant('false');
      default:
        return "";
    }
  }
});

commonFilters.filter('logTypeFilter', function ($translate) {
  return function (value) {
    switch (value) {
      case 0:
        return $translate.instant('daily');
      case 1:
        return $translate.instant('crash');
      default:
        return "";
    }
  }
});

commonFilters.filter('pnMobileStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('pn_mobile_status_true');
      case false:
        return $translate.instant('pn_mobile_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('eventMotionStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('event_motion_status_true');
      case false:
        return $translate.instant('event_motion_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('eventDoorBellStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('event_door_bell_status_true');
      case false:
        return $translate.instant('event_door_bell_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('motionDetectionStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('motion_detection_status_true');
      case false:
        return $translate.instant('motion_detection_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('deviceFunctionAlarmTimeMode', function ($translate) {
  return function (value) {
    switch (value) {
      case 0:
        return $translate.instant('ALL_DAY');
      case 1:
        return $translate.instant('DAY_TIME');
      case 2:
        return $translate.instant('CUSTMISE');
      default:
        return "";
    }
  }
});

commonFilters.filter('smartGuardStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('smart_guard_status_true');
      case false:
        return $translate.instant('smart_guard_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('isSummerTimeStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('is_summer_time_status_true');
      case false:
        return $translate.instant('is_summer_time_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('deviceFunctionFlipStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('device_function_flip_status_true');
      case false:
        return $translate.instant('device_function_flip_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('deviceLiveStatusOnline', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('device_live_status_online_true');
      case false:
        return $translate.instant('device_live_status_online_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('deviceLiveStatusAudioStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('device_live_status_audio_status_true');
      case false:
        return $translate.instant('device_live_status_audio_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('deviceLiveStatusFlipStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('device_live_status_flip_status_true');
      case false:
        return $translate.instant('device_live_status_flip_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('deviceLiveStatusNightlightStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('device_live_status_nightlight_status_true');
      case false:
        return $translate.instant('device_live_status_nightlight_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('deviceLiveStatusAutoSyncTimeStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('device_live_status_autoSyncTime_status_true');
      case false:
        return $translate.instant('device_live_status_autoSyncTime_status_false');
      default:
        return "";
    }
  }
});

commonFilters.filter('deviceLiveStatusFullRecordOnStatus', function ($translate) {
  return function (value) {
    switch (value) {
      case true:
        return $translate.instant('device_live_status_full_record_status_true');
      case false:
        return $translate.instant('device_live_status_full_record_status_false');
      default:
        return "";
    }
  }
});


/**
 * @author ljf
 * created on 2017.0.09
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.modals')
      .controller('StaticModalsCtrl', StaticModalsCtrl);

  /** @ngInject */
  function StaticModalsCtrl($rootScope, $scope) {
    $scope.message = $rootScope.MODAL_MESSAGE;
    if($rootScope.hasOwnProperty('MODAL_MESSAGE')){
      $rootScope.MODAL_MESSAGE = undefined;
    }

    if($rootScope.CALLBACK){
      $scope.clickPositive = function () {
        $rootScope.CALLBACK.clickPositive();
        $scope.$dismiss();
      }
    }

  }

})();

/**
 * @author ljf
 * created on 2017.0.09
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.modals')
      .service('ModalsService', ModalsService);

  /** @ngInject */
  function ModalsService($rootScope, $uibModal, $state) {
    this.open = function (page, size, message, callback) {
      $rootScope.MODAL_MESSAGE = message;
      $rootScope.CALLBACK = callback;
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
      });
    };

    this.handleError = function (error) {
      var page = 'app/services/modals/staticModals/warningModal.html';
      if (error.status == -1) $rootScope.MODAL_MESSAGE = 'timeout';

      if (error.status == 401) {
        $state.go('auth');
      }

      if (error.data != null) {
        $rootScope.MODAL_MESSAGE = '';
        if (error.data.ret != null) {
          $rootScope.MODAL_MESSAGE = 'error_code_' + error.data.ret;
          if (error.data.ret == 16) {
            $state.go('auth');
          }
          if (error.data.ret == 47) {
            $rootScope.MODAL_MESSAGE = 'error_code_59';
            $state.go('auth');
          }
        }
        if (error.data.msg != null) {
          $rootScope.MODAL_MESSAGE += '\nerror message: ' + error.data.msg;
        }
      }

      if (error.status == 500) {
        page = 'app/services/modals/staticModals/dangerModal.html';
      }

      if (error.status == 404 && $rootScope.MODAL_MESSAGE == null) {
        $rootScope.MODAL_MESSAGE = 'not found';
      }

      if ($rootScope.MODAL_MESSAGE != null) {
        $uibModal.open({
          animation: true,
          templateUrl: page,
          size: 'sm',
        });
      }
    };
  }


})();

/**
 * @author ljf
 * created on 2017.0.09
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.notifications', [])
      .service('NotificationsService', NotificationsService);

  /** @ngInject */
  function NotificationsService(toastr, toastrConfig, $filter) {
    var defaultConfig = angular.copy(toastrConfig);
    this.types = ['success', 'error', 'info', 'warning'];

    this.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    this.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      timeOut: '3000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: true,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
    };


    this.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    this.clearToasts = function () {
      toastr.clear();
    };

    this.openRandomToast = function () {
      var type = Math.floor(Math.random() * this.types.length);
      var quote = Math.floor(Math.random() * this.quotes.length);
      var toastType = this.types[type];
      var toastQuote = this.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      this.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    this.openToast = function (type, title, msg, positionClass) {
      title = $filter('translate')(title);
      msg = $filter('translate')(msg);
      if(positionClass){
        this.options.positionClass = positionClass;
      }
      angular.extend(toastrConfig, this.options);
      openedToasts.push(toastr[type](msg, title));
      var strOptions = {};
      for (var o in  this.options) if (o != 'msg' && o != 'title') strOptions[o] = this.options[o];
      this.optionsStr = "toastr." + type + "(\'" + msg + "\', \'" + title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };


  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('NetviewAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * Created by ljf on 2017/1/20.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.auth')
      .controller('UpdatePasswordCtrl', UpdatePasswordCtrl);

  /** @ngInject */
  function UpdatePasswordCtrl($scope, ModalsService, userInfo, AjaxRequest) {
    $scope.updatePasswordData = {'old': userInfo.pass, 'new': '', 'user': userInfo.user};

    $scope.errors = false;
    $scope.errPass = false;
    $scope.errConfirmPass = false;

    $scope.clearError = function () {
      $scope.errPass = false;
      $scope.errConfirmPass = false;
      $scope.errors = false;
    };

    $scope.submit = function () {

      var pwd1 = $scope.plainPassword1;
      var pwd2 = $scope.plainPassword2;

      if (Validator.isNotValidPassword(pwd1)) {
        $scope.errPass = Validator.isNotValidPassword(pwd1);
        $scope.errorMessage = Validator.isNotValidPassword(pwd1);
        return;
      }

      if (Validator.isNotValidPassword(pwd2)) {
        $scope.errConfirmPass = Validator.isNotValidPassword(pwd2);
        $scope.errorMessage = Validator.isNotValidPassword(pwd2);
        return;
      }

      if (Validator.isNotPasswordEqual(pwd1, pwd2)) {
        $scope.errConfirmPass = Validator.isNotPasswordEqual(pwd1, pwd2);
        $scope.errorMessage = Validator.isNotPasswordEqual(pwd1, pwd2);
        return;
      }

      $scope.updatePasswordData.new = hex_md5(pwd2);
      $scope.holdSubmit = true;

      AjaxRequest.path('password/auto').put(
          $scope.updatePasswordData,
          function (data) {
            $scope.holdSubmit = false;
            $scope.$dismiss();
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.mine')
    .controller('ChangePasswordCtrl', ChangePasswordCtrl);

  /** @ngInject */
  function ChangePasswordCtrl($scope, $state, NotificationsService, AjaxRequest, ModalsService) {
    $scope.data = {'old': '', 'new': ''};

    $scope.errors = false;
    $scope.errOldPass = false;
    $scope.errPass = false;
    $scope.errConfirmPass = false;

    $scope.clearError = function () {
      $scope.errPass = false;
      $scope.errOldPass = false;
      $scope.errConfirmPass = false;
      $scope.errors = false;
    };

    $scope.submit = function () {

      var pwd0 = $scope.oldPlainPassword;
      var pwd1 = $scope.plainPassword1;
      var pwd2 = $scope.plainPassword2;

      if (Validator.isNotValidPassword(pwd0)) {
        $scope.errOldPass = Validator.isNotValidPassword(pwd0);
        $scope.errorMessage = Validator.isNotValidPassword(pwd0);
        return;
      }

      if (Validator.isNotValidPassword(pwd1)) {
        $scope.errPass = Validator.isNotValidPassword(pwd1);
        $scope.errorMessage = Validator.isNotValidPassword(pwd1);
        return;
      }

      if (Validator.isNotValidPassword(pwd2)) {
        $scope.errConfirmPass = Validator.isNotValidPassword(pwd2);
        $scope.errorMessage = Validator.isNotValidPassword(pwd2);
        return;
      }

      if (Validator.isNotPasswordEqual(pwd1, pwd2)) {
        $scope.errConfirmPass = Validator.isNotPasswordEqual(pwd1, pwd2);
        $scope.errorMessage = Validator.isNotPasswordEqual(pwd1, pwd2);
        return;
      }

      $scope.data.old = hex_md5(pwd0);
      $scope.data.new = hex_md5(pwd2);
      $scope.holdSubmit = true;
      AjaxRequest.path('password').put(
          $scope.data,
          function (data) {
            $scope.holdSubmit = false;
            $scope.oldPlainPassword = undefined;
            $scope.plainPassword1 = undefined;
            $scope.plainPassword2 = undefined;
            NotificationsService.openToast('success', 'op_info', 'change_password_success','toast-top-center');
            $state.go('auth');
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.mine')
      .controller('MinePageCtrl', MinePageCtrl);

  /** @ngInject */
  function MinePageCtrl($scope, $cookies, $uibModal, AjaxRequest, NotificationsService, ModalsService) {
    $scope.mine = {'email': ''};

    $scope.userName = $cookies.get('userName');
    $scope.appId = $cookies.get('appId');
    $scope.distributorId = $cookies.get('distributorId');
    $scope.mine.email = $cookies.get('email');
    $scope.permissionList = ACL.getMyPermissionList($cookies);
    $scope.errors = false;
    $scope.errorEmail = false;

    $scope.clearError = function () {
      $scope.errorEmail = false;
      $scope.errors = false;
    };

    $scope.submit = function () {
      if($cookies.get('email') === $scope.mine.email){
        return;
      }

      if (Validator.isNotValidEmail($scope.mine.email)) {
        $scope.errorEmail = true;
        $scope.errorMessage = Validator.isNotValidEmail($scope.mine.email);
        return;
      }

      $scope.holdSubmit = true;
      AjaxRequest.path('email').put(
          $scope.mine,
          function (data) {
            $scope.holdSubmit = false;
            $cookies.put('email', data.email);
            NotificationsService.openToast('success', 'op_info', 'change_email_success','toast-top-center');
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };

    $scope.getActivities = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/bmUsers/activity/bmUserActivity.html',
        controller: 'BmUserActivityCtrl',
        size: 'lg',
        resolve: {
          bmUser: function () {
            return {
              'Id': $cookies.get('userId'),
              'name': $scope.userName
            };
          }
        }
      });
    };

  }

})();

/**
 * @author ljf
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.clientVersions')
      .controller('UploadCNApkCtrl', UploadCNApkCtrl);

  /** @ngInject */
  function UploadCNApkCtrl($scope, $state, $cookies, FileUploader, NotificationsService, AjaxRequest, ModalsService) {
    var queryData = {
      'successAction': '/mine',
      'fileName': '',
      'bucket': 'cn.dl.mynetvue.com',
      'version': '',
      'ucid': 'f57ad0e472'
    };

    $scope.clientItems = [
      {label: 'Mynetvue-android', value: 'f57ad0e472'},
      {label: 'Vuebell-android', value: '5821141b64'},
      {label: 'PPvue-android', value: '7ca25325bc'},
      {label: 'PPbell-android', value: 'cd87f930ab'},
    ];
    $scope.clientSelected = $scope.clientItems[0];

    $scope.clientChange = function (clientSelected) {
      queryData.ucid = clientSelected.value;
    };

    $scope.errAppVersion = false;

    function getAuthorization(fileItem) {
      $scope.notReady = true;

      AjaxRequest.path('s3/signature').get(
          queryData,
          function (data) {
            fileItem.url = data.url;
            fileItem.formData[0]["key"] = data.key;
            fileItem.formData[0]["acl"] = data.acl;
            fileItem.formData[0]["X-Amz-Credential"] = data.credential;
            fileItem.formData[0]["X-Amz-Algorithm"] = data.algorithm;
            fileItem.formData[0]["X-Amz-Date"] = data.date;
            fileItem.formData[0]["Policy"] = data.policy;
            fileItem.formData[0]["X-Amz-Signature"] = data.signature;
            $scope.notReady = false;
          },
          function (error) {
            ModalsService.handleError(error);
          }
      );
    }

    var uploadFormData = {
      "key": "test",
      "acl": "private",
      "success_action_redirect": "/mine",
      "X-Amz-Credential": "",
      "X-Amz-Algorithm": "",
      "X-Amz-Date": "",
      "Policy": "",
      "X-Amz-Signature": ""
    };

    var uploader = $scope.uploader = new FileUploader({
      formData: [uploadFormData],
      alias: "file",
      method: "POST",
    });
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function (item, options, deferred) {
        if ($scope.errAppVersion) {
          $('#apkFile').val(null);
          return false;
        }
        setTimeout(deferred.resolve, 1e3);
      }
    });
    uploader.onAfterAddingFile = function (fileItem) {
      //firmware表示上传到firmware文件夹中
      queryData.fileName = "firmware/" + fileItem.file.name;
      queryData.version = $scope.appVersion;
      $('#apkFile').val(null);
      getAuthorization(fileItem);
    };
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.$emit('showInfoModal', {
        'langcontent': 'file_upload_success'
      });
    };
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      $scope.$emit('showInfoModal', {
        'langcontent': 'file_upload_error'
      });
    };

    $scope.$watch('appVersion', function (value) {
      if (Validator.isNotStringValid(value)) {
        $scope.errAppVersion = true;
        $scope.errorMessage = Validator.isNotStringValid(value);
      } else {
        $scope.errAppVersion = false;
      }
    });

  }

})();

/**
 * Created by ljf on 2017/2/10.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.clientVersions')
      .controller('UploadHistoryCtrl', UploadHistoryCtrl);

  /** @ngInject */
  function UploadHistoryCtrl($scope, $cookies, $filter, AjaxRequest, $state, ModalsService) {
    $scope.data = {'operator': '', 'ucid':'', 'startTime': undefined, 'endTime': undefined, 'pgs': 10, 'pgn': 0};
    $scope.isLoading = false;
    $scope.getDataError = false;

    $scope.clientChange = function (clientSelected) {
      $scope.data.ucid = clientSelected.value;
      resetCallServer();
    };

    $scope.callServer = function() {
      $scope.isLoading = true;
      $scope.historiesEmpty = false;
      AjaxRequest.path('clientfiles').get(
          $scope.data,
          function (data) {
            $scope.histories = data.histories;
            if($scope.histories.length == 0){
              $scope.historiesEmpty = true;
            }else{
              $scope.historiesEmpty = false;
            }
            $scope.currentPage = $scope.data.pgn + 1;
            $scope.numPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.pages = {};
            $scope.pages.length = $scope.numPages;
            $scope.isLoading = false;
            $scope.getDataError = false;
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.historiesEmpty = false;
          }
      );
    };

    function resetCallServer() {
      $scope.data.pgs = 10;
      $scope.data.pgn = 0;
      $scope.callServer();
    }

    $scope.resetSearch = function () {
      $scope.dateRangeStart = undefined;
      $scope.dateRangeEnd = undefined;
      $scope.clientSelected = $scope.clientItems[0];
      $scope.data = {'operator': '', 'ucid':'', 'startTime': undefined, 'endTime': undefined, 'pgs': 10, 'pgn': 0};
      $scope.callServer();
    };

    $scope.selectPage = function (page) {
      if (page > 0 && page <= $scope.numPages) {
        $scope.data.pgs = 10;
        $scope.data.pgn = page - 1;
        $scope.callServer();
      }
    };

    $scope.clientItems = [
      {label: $filter('translate')('all'), value: ''},
      {label: 'Mynetvue-android', value: 'f57ad0e472'},
      {label: 'Vuebell-android', value: '5821141b64'},
      {label: 'PPbell-android', value: 'cd87f930ab'},
    ];
    $scope.clientSelected = $scope.clientItems[0];

    $scope.startDateOnSetTime = function () {
      $scope.data.startTime = new Date($scope.dateRangeStart).getTime();
      $scope.dateRangeStart = new Date($scope.dateRangeStart).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('start-date-changed');
      if ($scope.data.endTime) {
        resetCallServer();
      }
    };

    $scope.endDateOnSetTime = function () {
      $scope.data.endTime = new Date($scope.dateRangeEnd).getTime();
      $scope.dateRangeEnd = new Date($scope.dateRangeEnd).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('end-date-changed');
      if ($scope.data.startTime) {
        resetCallServer();
      }
    };

    $scope.startDateBeforeRender = function ($dates) {
      if ($scope.dateRangeEnd) {
        var activeDate = moment($scope.dateRangeEnd);
        $dates.filter(function (date) {
          return date.localDateValue() >= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };

    $scope.endDateBeforeRender = function ($view, $dates) {
      if ($scope.dateRangeStart) {
        var activeDate = moment($scope.dateRangeStart).subtract(1, $view).add(1, 'minute');
        $dates.filter(function (date) {
          return date.localDateValue() <= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };
  }
})();

/**
 * @author ljf
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.clientVersions')
      .controller('UploadUSApkCtrl', UploadUSApkCtrl);

  /** @ngInject */
  function UploadUSApkCtrl($scope, $state, $cookies, FileUploader, NotificationsService, AjaxRequest, ModalsService) {
    var queryData = {
      'successAction': '/mine',
      'fileName': '',
      'bucket': 'en.dl.mynetvue.com',
      'version': '',
      'ucid': 'f57ad0e472'
    };

    $scope.clientItems = [
      {label: 'Mynetvue-android', value: 'f57ad0e472'},
      {label: 'Vuebell-android', value: '5821141b64'},
      {label: 'PPvue-android', value: '7ca25325bc'},
      {label: 'PPbell-android', value: 'cd87f930ab'},
    ];
    $scope.clientSelected = $scope.clientItems[0];

    $scope.clientChange = function (clientSelected) {
      queryData.ucid = clientSelected.value;
    };

    $scope.errAppVersion = false;

    function getAuthorization(fileItem) {
      $scope.notReady = true;

      AjaxRequest.path('s3/signature').get(
          queryData,
          function (data) {
            fileItem.url = data.url;
            fileItem.formData[0]["key"] = data.key;
            fileItem.formData[0]["acl"] = data.acl;
            fileItem.formData[0]["X-Amz-Credential"] = data.credential;
            fileItem.formData[0]["X-Amz-Algorithm"] = data.algorithm;
            fileItem.formData[0]["X-Amz-Date"] = data.date;
            fileItem.formData[0]["Policy"] = data.policy;
            fileItem.formData[0]["X-Amz-Signature"] = data.signature;
            $scope.notReady = false;
          },
          function (error) {
            ModalsService.handleError(error);
          }
      );
    }

    var uploadFormData = {
      "key": "test",
      "acl": "private",
      "success_action_redirect": "/mine",
      "X-Amz-Credential": "",
      "X-Amz-Algorithm": "",
      "X-Amz-Date": "",
      "Policy": "",
      "X-Amz-Signature": ""
    };

    var uploader = $scope.uploader = new FileUploader({
      formData: [uploadFormData],
      alias: "file",
      method: "POST",
    });
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function (item, options, deferred) {
        if ($scope.errAppVersion) {
          $('#apkUSFile').val(null);
          return false;
        }
        setTimeout(deferred.resolve, 1e3);
      }
    });
    uploader.onAfterAddingFile = function (fileItem) {
      //firmware表示上传到firmware文件夹中
      queryData.fileName = "firmware/" + fileItem.file.name;
      queryData.version = $scope.appVersion;
      $('#apkUSFile').val(null);
      getAuthorization(fileItem);
    };
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.$emit('showInfoModal', {
        'langcontent': 'file_upload_success'
      });
    };
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      $scope.$emit('showInfoModal', {
        'langcontent': 'file_upload_error'
      });
    };

    $scope.$watch('appVersion', function (value) {
      if (Validator.isNotStringValid(value)) {
        $scope.errAppVersion = true;
        $scope.errorMessage = Validator.isNotStringValid(value);
      } else {
        $scope.errAppVersion = false;
      }
    });

  }

})();

// /**
//  * Created by ljf.
//  */
// (function () {
//   'use strict';
//   angular.module('NetviewAdmin.pages.devices')
//       .controller('DeviceLogsCtrl', DeviceLogsCtrl);
//
//   /** @ngInject */
//   function DeviceLogsCtrl($scope, $cookies, $filter, $state, deviceInfo, AjaxRequest, ModalsService) {
//     $scope.data = {'pgs': 10, 'pgn': 0};
//
//     $scope.headerName = deviceInfo.deviceName;
//
//     $scope.callServer = function () {
//       $scope.isLoading = true;
//       $scope.getDataError = false;
//       AjaxRequest.path('device/' + deviceInfo.deviceId + '/logs').get(
//           '',
//           function (data) {
//             $scope.totalLogs = data.logs;
//             $scope.logs = $scope.totalLogs.slice(0, 10);
//             $scope.currentPage = 1;
//             $scope.total = $scope.totalLogs.length;
//             $scope.numPages = Math.ceil($scope.total / $scope.data.pgs);
//             $scope.inputPage = 1;
//             $scope.pages = {};
//             $scope.pages.length = $scope.numPages;
//             $scope.isLoading = false;
//             $scope.getDataError = false;
//           },
//           function (error) {
//             ModalsService.handleError(error);
//             $scope.getDataError = true;
//             $scope.isLoading = false;
//           }
//       );
//     };
//
//     $scope.callServer();
//
//     $scope.selectPage = function (page) {
//       if (page > 0 && page <= $scope.numPages) {
//         $scope.data.pgs = 10;
//         $scope.data.pgn = page - 1;
//         $scope.inputPage = page;
//         $scope.currentPage = page;
//         $scope.logs = $scope.totalLogs.slice($scope.data.pgn * $scope.data.pgs, page * $scope.data.pgs);
//       }
//     };
//
//     $scope.refresh = function(){
//       $scope.selectPage($scope.data.pgn + 1);
//     };
//   }
// })();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('LocalDeviceLogsCtrl', LocalDeviceLogsCtrl);

  /** @ngInject */
  function LocalDeviceLogsCtrl($scope, $cookies, $filter, $state, deviceInfo, AjaxRequest, ModalsService) {
    $scope.data = {'startTime': undefined, 'endTime': undefined, 'limit': 10, 'startKey': undefined};

    $scope.headerName = deviceInfo.deviceName;
    $scope.lastPages = [];
    $scope.lastPageLength = 0;

    $scope.callServer = function () {
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.allItemsSelected = false;
      AjaxRequest.path('device/' + deviceInfo.deviceId + '/logs', deviceInfo.endpoint).get(
          $scope.data,
          function (data) {
            $scope.logs = data.logs;
            $scope.nextPageKey = data.startKey;
            $scope.isLoading = false;
            $scope.getDataError = false;
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
          }
      );
    };

    $scope.callServer();

    $scope.selectPage = function (page) {
      if (page == 'last') {
        $scope.lastPageLength = $scope.lastPages.length;
        if ($scope.lastPageLength > 0) {
          $scope.data.startKey = $scope.lastPages.pop();
          $scope.lastPageLength = $scope.lastPages.length;
          $scope.callServer();
        }
      } else if (page == 'next') {
        if ($scope.nextPageKey != null) {
          $scope.lastPages.push($scope.data.startKey);
          $scope.lastPageLength = $scope.lastPages.length;
          $scope.data.startKey = $scope.nextPageKey;
          $scope.callServer();
        }
      }
    };

    $scope.startDateOnSetTime = function () {
      $scope.data.startTime = new Date($scope.dateRangeStart).getTime();
      $scope.dateRangeStart = new Date($scope.dateRangeStart).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('start-date-changed');
      $scope.lastPages = [];
      $scope.lastPageLength = 0;
      $scope.data.startKey = undefined;
      $scope.callServer();
    };

    $scope.startDateBeforeRender = function ($dates) {
      if ($scope.dateRangeEnd) {
        var activeDate = moment($scope.dateRangeEnd);
        $dates.filter(function (date) {
          return date.localDateValue() >= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };

    $scope.resetSearch = function () {
      $scope.dateRangeStart = undefined;
      $scope.dateRangeEnd = undefined;
      $scope.lastPages = [];
      $scope.lastPageLength = 0;
      $scope.data = {'startTime': undefined, 'endTime': undefined, 'limit': 10, 'startKey': undefined};
      $scope.callServer();
    };

    $scope.downloadSelect = function () {
      var downloadLinks = [];
      for (var i = 0; i < $scope.logs.length; i++) {
        if ($scope.logs[i].isChecked) {
          if ($scope.logs[i].logURL != "") {
            downloadLinks.push($scope.logs[i].url);
          }
        }
      }
      var link = document.createElement('a');
      link.setAttribute('download', null);
      link.style.display = 'none';
      document.body.appendChild(link);
      for (var i = 0; i < downloadLinks.length; i++) {
        link.setAttribute('href', downloadLinks[i]);
        link.click();
      }
      document.body.removeChild(link);
    };

    $scope.selectEntity = function () {
      for (var i = 0; i < $scope.logs.length; i++) {
        if (!$scope.logs[i].isChecked) {
          $scope.allItemsSelected = false;
          return;
        }
      }
      $scope.allItemsSelected = true;
    };

    $scope.selectAll = function () {
      for (var i = 0; i < $scope.logs.length; i++) {
        $scope.logs[i].isChecked = $scope.allItemsSelected;
      }
    };

  }
})();

/**
 * Created by ljf on 2017/2/14.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('DeviceDetailCtrl', DeviceDetailCtrl);

  /** @ngInject */
  function DeviceDetailCtrl($scope, $cookies, deviceInfo, AjaxRequest, ModalsService) {
    $scope.getDataError = false;
    $scope.isLoading = true;
    $scope.isLocal = false;

    if (deviceInfo.hasOwnProperty('endpoint')) {
      $scope.isLocal = true;
      AjaxRequest.path('device/' + deviceInfo.deviceId + '/detail', deviceInfo.endpoint).get('',
          function (data) {
            $scope.getDataError = false;
            $scope.isLoading = false;
            $scope.result = data;
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
          }
      )
    }else{
      AjaxRequest.path('device/' + deviceInfo.deviceId + '/detail').get('',
          function (data) {
            $scope.getDataError = false;
            $scope.isLoading = false;
            $scope.result = data;
            $cookies.put('currentServer', 'central');
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            $cookies.put('currentServer', 'central');
          }
      )
    }
  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('DeviceParamCtrl', DeviceParamCtrl);

  /** @ngInject */
  function DeviceParamCtrl($scope, $cookies, $filter, $state, deviceInfo, reloadParams, AjaxRequest, NotificationsService, ModalsService) {
    $scope.PUT_DEVICE_PARAM = ACL.hasPermission($cookies, 'put_device_%s_params');

    if (deviceInfo.hasOwnProperty('endpoint')) {
      AjaxRequest.path('device/' + deviceInfo.deviceId + '/params', deviceInfo.endpoint).get('',
          function (data) {
            $scope.data = {
              'DK': data.DK, 'MD': data.MD, 'SA': data.SA,
              'DID': data.DID, 'AID': data.AID, 'OE': data.OE,
              'CF': data.CF, 'NF': data.NF, 'toRegion':data.toRegion,
              'toEndpoint': data.toEndpoint,
            };
            $scope.statusItems = [
              {label: $filter('translate')('online'), value: true},
              {label: $filter('translate')('offline'), value: false},
            ];
            $scope.statusSelected = data.OE ? $scope.statusItems[0] : $scope.statusItems[1];
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.$dismiss();
          }
      );
    } else {
      AjaxRequest.path('device/' + deviceInfo.deviceId + '/params').get('',
          function (data) {
            $scope.data = {
              'DK': data.DK, 'MD': data.MD, 'SA': data.SA,
              'DID': data.DID, 'AID': data.AID, 'OE': data.OE,
              'CF': data.CF, 'NF': data.NF, 'toRegion': data.toRegion,
              'toEndpoint': data.toEndpoint,
            };
            $scope.statusItems = [
              {label: $filter('translate')('online'), value: true},
              {label: $filter('translate')('offline'), value: false},
            ];
            $scope.statusSelected = data.OE ? $scope.statusItems[0] : $scope.statusItems[1];
            $cookies.put('currentServer', 'central');
          },
          function (error) {
            $cookies.put('currentServer', 'central');
            ModalsService.handleError(error);
            $scope.$dismiss();
          }
      );
    }

    $scope.submit = function () {
      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;
      if (deviceInfo.hasOwnProperty('endpoint')) {
        AjaxRequest.path('device/' + deviceInfo.deviceId + '/params', deviceInfo.endpoint).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'change_device_params_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('devices', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('device/' + deviceInfo.deviceId + '/params').put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'change_device_params_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('devices', {reloadParams: reloadParams}, {reload: true});
              $cookies.put('currentServer', 'central');
            },
            function (error) {
              $scope.holdSubmit = false;
              $cookies.put('currentServer', 'central');
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.errors = false;
    $scope.errDesKey = false;
    $scope.errMd5 = false;
    $scope.errServerConnect = false;
    $scope.errAppId = false;
    $scope.errDistributorId = false;
    $scope.errCurrentFirmware = false;
    $scope.errNewestFirmware = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errDesKey = false;
      $scope.errMd5 = false;
      $scope.errServerConnect = false;
      $scope.errAppId = false;
      $scope.errDistributorId = false;
      $scope.errCurrentFirmware = false;
      $scope.errNewestFirmware = false;
    };

    $scope.statusChange = function (statusSelected) {
      $scope.data.OE = statusSelected.value;
    };

    $scope.isNotValidate = function () {
      var desKey = $scope.data.DK;
      var md5 = $scope.data.MD;
      var serverConnect = $scope.data.SA;
      var appId = $scope.data.AID;
      var distributorId = $scope.data.DID;
      var currentFirmware = $scope.data.CF;
      var newestFirmware = $scope.data.NF;

      if (Validator.isNotStringValid(desKey)) {
        $scope.errDesKey = true;
        $scope.errorMessage = Validator.isNotStringValid(desKey);
        return true;
      }

      if (Validator.isNotValidMD5(md5)) {
        $scope.errMd5 = true;
        $scope.errorMessage = Validator.isNotValidMD5(md5);
        return true;
      }

      if (Validator.isNotStringValid(serverConnect)) {
        $scope.errServerConnect = true;
        $scope.errorMessage = Validator.isNotStringValid(serverConnect);
        return true;
      }

      if (Validator.isNotValidID(appId)) {
        $scope.errAppId = true;
        $scope.errorMessage = Validator.isNotValidID(appId);
        return true;
      }

      if (Validator.isNotValidID(distributorId)) {
        $scope.errDistributorId = true;
        $scope.errorMessage = Validator.isNotValidID(distributorId);
        return true;
      }

      if (Validator.isNotStringValid(currentFirmware)) {
        $scope.errCurrentFirmware = true;
        $scope.errorMessage = Validator.isNotStringValid(currentFirmware);
        return true;
      }

      if (Validator.isNotStringValid(newestFirmware)) {
        $scope.errNewestFirmware = true;
        $scope.errorMessage = Validator.isNotStringValid(newestFirmware);
        return true;
      }

      return false;
    }

  }
})();

/**
 * Created by ljf on 2017/2/14.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('DeviceServiceCtrl', DeviceServiceCtrl);

  /** @ngInject */
  function DeviceServiceCtrl($scope, $uibModal, $cookies, $filter, deviceInfo, reloadParams, AjaxRequest, ModalsService) {
    $scope.RESET_DEVICE_SERVICE = ACL.hasPermission($cookies, 'delete_device_%s_service');
    $scope.SET_SERVICE_TIME = ACL.hasPermission($cookies, 'put_device_%s_service');
    $scope.getDataError = false;
    $scope.isLoading = true;
    $scope.serialNumber = deviceInfo.serialNumber;
    $scope.dataTimePicker = {};
    $scope.requestData = {};

    AjaxRequest.path('device/' + deviceInfo.deviceId + '/service').get(
        {'username': deviceInfo.username},
        function (data) {
          $scope.getDataError = false;
          $scope.isLoading = false;
          $scope.result = data;
          $scope.serviceType = ['cloudRecord', 'fullRecord', 'videoMotion', 'bodyDetection'];
        },
        function (error) {
          $scope.getDataError = true;
          $scope.isLoading = false;
          if (error.data !== undefined) {
            if (error.data.ret === 80) {
              $scope.serviceNotExist = true;
              return;
            }
          }
          ModalsService.handleError(error);
        }
    );

    $scope.resetService = function (type, onlyResetAutoCharge) {
      $scope.$dismiss();
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/devices/modals/resetService.html',
        controller: 'ResetServiceCtrl',
        size: 'sm',
        resolve: {
          deviceId: function () {
            return deviceInfo.deviceId;
          },
          username: function () {
            return deviceInfo.username;
          },
          serviceType: function () {
            return type;
          },
          onlyResetAutoCharge : function () {
            return onlyResetAutoCharge;
          },
        }
      });
    };

    $scope.modifyServiceTime = function () {
      $scope.requestData.username = deviceInfo.username;
      AjaxRequest.path('device/' + deviceInfo.deviceId + '/service').put($scope.requestData,
          function (data) {
            $scope.$dismiss();
            ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'modify_service_time_success');
          },
          function (error) {
            ModalsService.handleError(error);
          }
      );
    };

    $scope.serviceExpireOnSetTime = function () {
      $scope.requestData.serviceExpire = new Date($scope.dataTimePicker.newServiceExpire).getTime();
      $scope.dataTimePicker.newServiceExpire = new Date($scope.dataTimePicker.newServiceExpire).Format("yyyy-MM-dd HH:mm:ss");
    };

    $scope.fullRecordExpireOnSetTime = function () {
      $scope.requestData.fullRecordExpire = new Date($scope.dataTimePicker.newFullRecordExpire).getTime();
      $scope.dataTimePicker.newFullRecordExpire = new Date($scope.dataTimePicker.newFullRecordExpire).Format("yyyy-MM-dd HH:mm:ss");
    };

    $scope.videoExpireOnSetTime = function () {
      $scope.requestData.videoMotionExpire = new Date($scope.dataTimePicker.newVideoMotionExpire).getTime();
      $scope.dataTimePicker.newVideoMotionExpire = new Date($scope.dataTimePicker.newVideoMotionExpire).Format("yyyy-MM-dd HH:mm:ss");
    };

    $scope.bodyDetectionExpireExpireOnSetTime = function () {
      $scope.requestData.bodyDetectionExpire = new Date($scope.dataTimePicker.newBodyDetectionExpire).getTime();
      $scope.dataTimePicker.newBodyDetectionExpire = new Date($scope.dataTimePicker.newBodyDetectionExpire).Format("yyyy-MM-dd HH:mm:ss");
    };
  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('LockDeviceCtrl', LockDeviceCtrl);

  /** @ngInject */
  function LockDeviceCtrl($scope, $cookies, $state, deviceInfo, reloadParams, AjaxRequest, ModalsService, NotificationsService) {
    if (deviceInfo.enabled) {
      $scope.message = 'confirm_to_unlock_device';
    } else {
      $scope.message = 'confirm_to_lock_device';
    }
    $scope.data = {'enabled': deviceInfo.enabled};
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('device/' + deviceInfo.deviceId + '/enabled').put(
          $scope.data,
          function (data) {
            if (deviceInfo.enabled) {
              NotificationsService.openToast('success', 'op_info', 'device_unlock_success', 'toast-top-center');
            } else {
              NotificationsService.openToast('success', 'op_info', 'device_lock_success', 'toast-top-center');
            }
            $state.go('devices', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('RebootDeviceCtrl', RebootDeviceCtrl);

  /** @ngInject */
  function RebootDeviceCtrl($scope, $cookies, deviceInfo, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_reboot_device';
    $scope.confirm = function () {
      $scope.$dismiss();
      if (deviceInfo.hasOwnProperty('endpoint')) {
        AjaxRequest.path('device/' + deviceInfo.deviceId + '/reboot', deviceInfo.endpoint).post('',
            function (data) {
              NotificationsService.openToast('success', 'op_info', 'device_reboot_send_success', 'toast-top-center');
            },
            function (error) {
              ModalsService.handleError(error);
            }
        )
      } else {
        AjaxRequest.path('device/' + deviceInfo.deviceId + '/reboot').post('',
            function (data) {
              $cookies.put('currentServer', 'central');
              NotificationsService.openToast('success', 'op_info', 'device_reboot_send_success', 'toast-top-center');
            },
            function (error) {
              $cookies.put('currentServer', 'central');
              ModalsService.handleError(error);
            }
        )
      }
    };

  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('ResetDeviceCtrl', ResetDeviceCtrl);

  /** @ngInject */
  function ResetDeviceCtrl($scope, $cookies, $state, deviceInfo, reloadParams, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_reset_device';
    $scope.confirm = function () {
      $scope.$dismiss();
      if (deviceInfo.hasOwnProperty('endpoint')) {
        AjaxRequest.path('device/' + deviceInfo.deviceId + '/reset', deviceInfo.endpoint).put('',
            function (data) {
              NotificationsService.openToast('success', 'op_info', 'device_reset_success', 'toast-top-center');
              $state.go('devices', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              ModalsService.handleError(error);
            }
        )
      } else {
        AjaxRequest.path('device/' + deviceInfo.deviceId + '/reset').put('',
            function (data) {
              $cookies.put('currentServer', 'central');
              NotificationsService.openToast('success', 'op_info', 'device_reset_success', 'toast-top-center');
              $state.go('devices', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $cookies.put('currentServer', 'central');
              ModalsService.handleError(error);
            }
        )
      }
    };

  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('ResetServiceCtrl', ResetServiceCtrl);

  /** @ngInject */
  function ResetServiceCtrl($scope, $cookies, deviceId, username, serviceType, onlyResetAutoCharge, AjaxRequest, ModalsService) {
    $scope.message = 'confirm_to_reset_device_service';
    $scope.requesParams = {
      "serviceType": serviceType,
      'onlyResetAutoCharge': onlyResetAutoCharge,
      'username': username
    };
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('device/' + deviceId + '/service').delete($scope.requesParams,
          function (data) {
            if (onlyResetAutoCharge) {
              ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'device_service_reset_autocharge_success');
            } else {
              ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'device_service_reset_success');
            }
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('SDCardFormatCtrl', SDCardFormatCtrl);

  /** @ngInject */
  function SDCardFormatCtrl($scope, $cookies, deviceInfo, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_format_device_sdcard';
    $scope.confirm = function () {
      $scope.$dismiss();
      if (deviceInfo.hasOwnProperty('endpoint')) {
        AjaxRequest.path('device/' + deviceInfo.deviceId + '/sdcard/format', deviceInfo.endpoint).post('',
            function (data) {
              NotificationsService.openToast('success', 'op_info', 'sacard_format_success', 'toast-top-center');
            },
            function (error) {
              ModalsService.handleError(error);
            }
        )
      } else {
        AjaxRequest.path('device/' + deviceInfo.deviceId + '/upgrade').post('',
            function (data) {
              $cookies.put('currentServer', 'central');
              NotificationsService.openToast('success', 'op_info', 'sacard_format_success', 'toast-top-center');
            },
            function (error) {
              $cookies.put('currentServer', 'central');
              ModalsService.handleError(error);
            }
        )
      }
    };

  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('UpgradeDeviceCtrl', UpgradeDeviceCtrl);

  /** @ngInject */
  function UpgradeDeviceCtrl($scope, $cookies, deviceInfo, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_upgrade_device';
    $scope.confirm = function () {
      $scope.$dismiss();
      if (deviceInfo.hasOwnProperty('endpoint')) {
        AjaxRequest.path('device/' + deviceInfo.deviceId + '/upgrade', deviceInfo.endpoint).post('',
            function (data) {
              NotificationsService.openToast('success', 'op_info', 'device_upgrade_success', 'toast-top-center');
            },
            function (error) {
              ModalsService.handleError(error);
            }
        )
      } else {
        AjaxRequest.path('device/' + deviceInfo.deviceId + '/upgrade').post('',
            function (data) {
              $cookies.put('currentServer', 'central');
              NotificationsService.openToast('success', 'op_info', 'device_upgrade_success', 'toast-top-center');
            },
            function (error) {
              $cookies.put('currentServer', 'central');
              ModalsService.handleError(error);
            }
        )
      }
    };

  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.devices')
      .controller('ChangeDeviceDistributorCtrl', ChangeDeviceDistributorCtrl);

  /** @ngInject */
  function ChangeDeviceDistributorCtrl($scope, $state, $filter, $cookies, AjaxRequest, ModalsService, NotificationsService) {
    $scope.errors = false;
    $scope.error1 = false;
    $scope.error2 = false;
    $scope.errDistributorId = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.error1 = false;
      $scope.error2 = false;
      $scope.errDistributorId = false;
    };

    function completeFn(results) {
      var Data = results.data;
      var requestData = {
        'distributorId': $scope.distributorId,
        'deviceIds': []
      };
      for (var x in results.data) {
        requestData.deviceIds.push(Data[x][0]);
      }
      $scope.holdSubmit = true;
      AjaxRequest.path('devices/distributors').put(
          requestData,
          function (data) {
            $scope.holdSubmit = false;
            if(data.hasOwnProperty('permissionErrorIds') && data.permissionErrorIds.length > 0){
              $scope.error1 = true;
              $scope.errorMessage1 = $filter('translate')('no_P_change_distributor') + data.permissionErrorIds;
            }
            if(data.hasOwnProperty('distributorErrorIds') && data.distributorErrorIds.length > 0){
              $scope.error2 = true;
              $scope.errorMessage2 = $filter('translate')('change_distributor_error_compatibility') + data.distributorErrorIds;
            }
            if(!$scope.error1 && !$scope.error2)
            NotificationsService.openToast('success', 'op_info', 'batch_change_device_distributor_success', 'toast-top-center');

          },
          function (error) {
            $scope.holdSubmit = false;
            $scope.showPagination = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    }

    $scope.parseFile = function () {
      if (Validator.isNotValidID($scope.distributorId)) {
        $scope.errDistributorId = true;
        $scope.errorMessage = Validator.isNotValidID($scope.distributorId);
        return;
      }
      if (!$('#changeDistributorFile')[0].files.length) {
        ModalsService.open('app/services/modals/staticModals/warningModal.html', 'sm', 'please_to_choose_a_file');
      } else {
        var filePath = $('#changeDistributorFile').val();
        var ext = filePath.substring(filePath.lastIndexOf("."), filePath.length).toUpperCase();
        if (ext != ".CSV" && ext != ".TXT") {
          ModalsService.open('app/services/modals/staticModals/warningModal.html', 'sm', 'please_to_choose_format_file');
          return;
        }
        $scope.errors = false;
        var config = {
          delimiter: "",  // auto-detect
          newline: "",    // auto-detect
          header: false,
          dynamicTyping: false,
          preview: 0,
          encoding: "UTF-8",
          worker: false,
          comments: false,
          step: undefined,
          complete: completeFn,//上传成功时执行哪个函数
          error: undefined,
          download: false,
          skipEmptyLines: true,
          chunk: undefined,
          fastMode: undefined,
          beforeFirstChunk: undefined
        };
        $('#changeDistributorFile').parse({
          config: config
        });
      }
    };

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.devices')
      .controller('CheckDeviceIdCtrl', CheckDeviceIdCtrl);

  /** @ngInject */
  function CheckDeviceIdCtrl($scope, AjaxRequest, ModalsService) {
    $scope.data = {'serialnumber': ''};
    $scope.result = '';

    $scope.submit = function () {

      if (Validator.isNotValidSerialNumber($scope.data.serialnumber)) {
        $scope.result = Validator.isNotValidSerialNumber($scope.data.serialnumber);
        return;
      }

      $scope.holdSubmit = true;
      $scope.result = '';
      AjaxRequest.path('device/abnormal').get({'serialNumber': $scope.data.serialnumber},
          function (data) {
            $scope.holdSubmit = false;
            $scope.result = data.result == 0 ? "OK" : data.result == 1 ? "Missing" : data.result == 2 ? "Error Check Sum" : "Unknown";
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };

  }

})();

/**
 * Created by ptx.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('DeviceDetailInfoCtrl', DeviceDetailInfoCtrl);

  /** @ngInject */
  function DeviceDetailInfoCtrl($scope, $cookies, ModalsService, AjaxRequest, $stateParams) {
    if (!ACL.hasPermission($cookies, 'get_devices')) {
      $state.go('auth');
      return;
    }

    $scope.GET_DEVICE_PNS_INFO = ACL.hasPermission($cookies, 'get_device_pns_info');
    $scope.GET_DEVICE_FUNCTION_INFO = ACL.hasPermission($cookies, 'get_device_function_info');
    $scope.GET_DEVICE_LIVE_STATUS_INFO = ACL.hasPermission($cookies, 'get_device_live_status_info');
    $scope.GET_ALL = $scope.GET_DEVICE_PNS_INFO && $scope.GET_DEVICE_FUNCTION_INFO && $scope.GET_DEVICE_LIVE_STATUS_INFO;

    $scope.data = {
      'serialNumber': undefined, 'deviceName': undefined, 'online': 'all', 'currentVersion': undefined,
      'ownerName': undefined, 'enabled': undefined, 'pgs': 10, 'pgn': 0
    };
    $scope.serialNumber = "";
    $scope.endpoint = "";

    $scope.authData = {'user': "", 'pass': ""};

    $scope.getLocalToken = function (endpoint, optType, getDeviceInfo) {
      $scope.holdSubmit = true;
      if ($cookies.get('endpoint') == endpoint && $cookies.get('local_token')) {
        $scope.holdSubmit = false;
        getDeviceInfo(optType);
        return;
      }

      var userName = $cookies.get('userName');
      var pass = $cookies.get('upd');

      if(typeof userName != "undefined") {
        $scope.authData.user = userName;
      }

      if(typeof pass != "undefined"){
        $scope.authData.pass = pass;
      }
      AjaxRequest.path('token', endpoint).post(
          $scope.authData,
          function (data) {
            $scope.holdSubmit = false;
            var expires = new Date(data.expires);
            $cookies.put('local_token', data.token, {'expires': expires.toUTCString()});
            $cookies.put('endpoint', endpoint, {'expires': expires.toUTCString()});
            getDeviceInfo(optType);
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
          }
      );
    };

    $scope.getToken = function (optType, getDeviceInfo) {
      if ($scope.devicesEmpty == false) {
        $scope.endpoint = $scope.devices[0].endpoint;
        var inNewServer = $scope.devices[0].inNewServer;
        var deviceId = $scope.devices[0].Id;
        $scope.endpoint += "/v1/bm";
        var deviceParam = {};
        deviceParam = {
          'deviceId': deviceId,
          'endpoint': $scope.endpoint
        };
        $scope.getLocalToken($scope.endpoint, optType, getDeviceInfo);
      }
    };

    $scope.getPNSInfo = function () {
      if ($scope.devicesEmpty == false) {
        AjaxRequest.path('device/pns', $scope.endpoint).get(
            $scope.data,
            function (data) {
              $scope.devicePNS = data;
              if (typeof $scope.devicePNS != "undefined") {
                $scope.pnsExist = true;
              }
              $scope.isLoading = false;
              $scope.getDataError = false;
              if ($stateParams.reloadParams != null) {
                $stateParams.reloadParams = null;
              }
            },
            function (error) {
              ModalsService.handleError(error);
              $scope.getDataError = true;
              $scope.isLoading = false;
              $scope.devicesEmpty = false;
              if ($stateParams.reloadParams != null) {
                $stateParams.reloadParams = null;
              }
            }
        );
      }
    };

    $scope.getFunctionInfo = function () {
      if ($scope.devicesEmpty == false) {
        AjaxRequest.path('device/function', $scope.endpoint).get(
            $scope.data,
            function (data) {
              $scope.deviceFunction = data;
              if (typeof $scope.deviceFunction != "undefined") {
                $scope.functionExist = true;
              }
              $scope.isLoading = false;
              $scope.getDataError = false;
              if ($stateParams.reloadParams != null) {
                $stateParams.reloadParams = null;
              }
            },
            function (error) {
              ModalsService.handleError(error);
              $scope.getDataError = true;
              $scope.isLoading = false;
              $scope.devicesEmpty = false;
              if ($stateParams.reloadParams != null) {
                $stateParams.reloadParams = null;
              }
            }
        );
      }
    };

    $scope.getLiveStatusInfo = function () {
      if ($scope.devicesEmpty == false) {
        AjaxRequest.path('device/livestatus', $scope.endpoint).get(
            $scope.data,
            function (data) {
              $scope.deviceLiveStatus = data;
              if (typeof $scope.deviceLiveStatus != "undefined") {
                $scope.liveStatusExist = true;
              }
              $scope.isLoading = false;
              $scope.getDataError = false;
              if ($stateParams.reloadParams != null) {
                $stateParams.reloadParams = null;
              }
            },
            function (error) {
              ModalsService.handleError(error);
              $scope.getDataError = true;
              $scope.isLoading = false;
              $scope.devicesEmpty = false;
              if ($stateParams.reloadParams != null) {
                $stateParams.reloadParams = null;
              }
            }
        );
      }
    };

    $scope.getShadowInfo = function () {
      if ($scope.devicesEmpty == false) {
        AjaxRequest.path('device/livestatus?type=DeviceShadow', $scope.endpoint).get(
            $scope.data,
            function (data) {
              if (data) {
                var reported = {
                  reported: data.reported,
                };
                var desired = {
                  desired: data.desired,
                };
                $scope.shadowReportedInfo = JSON.stringify(reported, null, 2);
                $scope.shadowDesiredInfo = JSON.stringify(desired, null, 2);
                $scope.shadowExist = true;
              }
            },
            function (error) {
              ModalsService.handleError(error);
            }
        );
      }
    };

    $scope.getDeviceInfo = function (optType) {
      $scope.getEndPoint($scope.getToken, optType, function (optType) {
        if (optType == "pns" || optType == "all") {
          $scope.getPNSInfo();
        }

        if (optType == "function" || optType == "all") {
          $scope.getFunctionInfo();
        }

        if (optType == "liveStatus" || optType == "all") {
          $scope.getLiveStatusInfo();
        }

        if (optType == "shadow" || optType == "all") {
          $scope.getShadowInfo();
        }
      });
    };

    $scope.resetQuery = function () {
      $scope.pnsExist = false;
      $scope.functionExist = false;
      $scope.liveStatusExist = false;
      $scope.shadowExist = false;
    };

    $scope.getEndPoint = function (callback, optType, getDeviceInfo) {
      $scope.data.serialNumber = $scope.serialNumber;
      //进行get请求
      AjaxRequest.path('devices').get(
          $scope.data,
          function (data) {
            $scope.devices = data.devices;
            if ($scope.devices.length == 0) {
              $scope.devicesEmpty = true;
            } else {
              $scope.devicesEmpty = false;
              callback(optType, getDeviceInfo);
            }
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.devices = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.devicesEmpty = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    }
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.devices')
      .controller('GetDeviceServiceCtrl', GetDeviceServiceCtrl);

  /** @ngInject */
  function GetDeviceServiceCtrl($scope, $state, $cookies, NotificationsService, $uibModal, AjaxRequest, ModalsService) {
    $scope.data = {'userName': '', 'serialnumber': ''};

    $scope.errors = false;
    $scope.errUserName = false;
    $scope.errDeviceSn = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errUserName = false;
      $scope.errDeviceSn = false;
    };

    $scope.submit = function () {

      if (Validator.isNotValidUsername($scope.data.userName)) {
        $scope.errUserName = true;
        $scope.errorMessage = Validator.isNotValidUsername($scope.data.userName);
        return;
      }

      if (Validator.isNotValidSerialNumber($scope.data.serialnumber)) {
        $scope.errDeviceSn = true;
        $scope.errorMessage = Validator.isNotValidSerialNumber($scope.data.serialnumber);
        return;
      }

      $scope.holdSubmit = true;
      AjaxRequest.path('devices').get({'serialNumber': $scope.data.serialnumber},
          function (data) {
            $scope.holdSubmit = false;
            $scope.result = data.devices;
            if (Array.isArray($scope.result) && $scope.result.length === 0) {
              NotificationsService.openToast('warning', 'op_info', 'error_code_13', 'toast-top-center');

            } else {
              for (let i = 0; $scope.result.length; i++) {
                let camera = $scope.result[0];
                if (camera.serialNumber === $scope.data.serialnumber) {
                  let deviceParam = {
                    'deviceId': camera.id,
                    'serialNumber': $scope.data.serialnumber,
                    'username': $scope.data.userName
                  };
                  let modalObject = {
                    animation: true,
                    templateUrl: 'app/pages/devices/modals/deviceService.html',
                    controller: 'DeviceServiceCtrl',
                    size: 'lg',
                    resolve: {
                      deviceInfo: function () {
                        return deviceParam;
                      },
                      reloadParams: function () {
                        return $scope.data;
                      }
                    }
                  };
                  $uibModal.open(modalObject);
                  break;
                }

              }
            }
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };

  }

})();

/**
 * @author ljf
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.firmware')
      .controller('BatchUpgradeCtrl', BatchUpgradeCtrl);

  /** @ngInject */
  function BatchUpgradeCtrl($scope, AjaxRequest, ModalsService, NotificationsService) {

    function completeFn(results) {
      var Data = results.data;
      var requestData = {
        'toVersion': $scope.toVersion,
        'serialNumbers': []
      };
      for (var x in results.data) {
        requestData.serialNumbers.push(Data[x][0]);
      }
      $scope.holdSubmit = true;
      AjaxRequest.path('devices/firmware').post(
          requestData,
          function (data) {
            $scope.errors = false;
            $scope.holdSubmit = false;
            NotificationsService.openToast('success', 'op_info', 'batch_upgrade_device_success', 'toast-top-center');
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    }

    $scope.errors = false;
    $scope.errToVersion = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errToVersion = false;
    };

    $scope.parseFile = function () {
      if (Validator.isNotValidVersion($scope.toVersion)) {
        $scope.errToVersion = true;
        $scope.errorMessage = Validator.isNotValidVersion($scope.toVersion);
        return;
      }
      if (!$('#changeToVersionFile')[0].files.length) {
        ModalsService.open('app/services/modals/staticModals/warningModal.html', 'sm', 'please_to_choose_a_file');
      } else {
        var filePath = $('#changeToVersionFile').val();
        var ext = filePath.substring(filePath.lastIndexOf("."), filePath.length).toUpperCase();
        if (ext != ".CSV" && ext != ".TXT") {
          ModalsService.open('app/services/modals/staticModals/warningModal.html', 'sm', 'please_to_choose_format_file');
          return;
        }
        $scope.errors = false;
        var config = {
          delimiter: "",  // auto-detect
          newline: "",    // auto-detect
          header: false,
          dynamicTyping: false,
          preview: 0,
          encoding: "UTF-8",
          worker: false,
          comments: false,
          step: undefined,
          complete: completeFn,//上传成功时执行哪个函数
          error: undefined,
          download: false,
          skipEmptyLines: true,
          chunk: undefined,
          fastMode: undefined,
          beforeFirstChunk: undefined
        };
        $('#changeToVersionFile').parse({
          config: config
        });
      }
    };

  }
})();

/**
 * @author ljf
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.firmware')
      .controller('UpgradeCtrl', UpgradeCtrl);

  /** @ngInject */
  function UpgradeCtrl($scope, $state, $filter, $cookies, AjaxRequest, ModalsService) {
    $scope.GET_TEST = ACL.hasPermission($cookies, 'get_firmware_upgrade_tests');
    $scope.CREATE_UPGRADE_TEST = ACL.hasPermission($cookies, 'post_firmware_upgrade_tests');
    $scope.UPGRADE_DEVICE = ACL.hasPermission($cookies, 'put_devices_firmware');
    $scope.CLEAN_CACHE = ACL.hasPermission($cookies, 'delete_firmware_cleancache');

    $scope.showUpgradePath = false;
    $scope.showTestResult = false;

    $scope.data = {'from': '', 'to': ''};

    $scope.isLoading = false;
    $scope.getDataError = false;
    $scope.pathsEmpty = false;
    $scope.upgradeTestResultsEmpty = false;

    $scope.errors = false;
    $scope.errFrom = false;
    $scope.errTo = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errFrom = false;
      $scope.errTo = false;
    };

    $scope.resetSearch = function () {
      $scope.showUpgradePath = false;
      $scope.showTestResult = false;
      $scope.errors = false;
      $scope.errFrom = false;
      $scope.errTo = false;
      $scope.data = {'from': '', 'to': ''};
    };

    $scope.getPath = function () {

      var from = $scope.data.from;
      var to = $scope.data.to;

      if (Validator.isNotValidVersion(from)) {
        $scope.errFrom = true;
        $scope.errorMessage = Validator.isNotValidVersion(from);
        return;
      }

      if (Validator.isNotValidVersion(to)) {
        $scope.errTo = true;
        $scope.errorMessage = Validator.isNotValidVersion(to);
        return;
      }
      $scope.showTestResult = false;
      $scope.showUpgradePath = true;
      $scope.isLoading = true;
      $scope.pathsEmpty = false;

      AjaxRequest.path('firmware/upgrade/paths').get(
          $scope.data,
          function (data) {
            $scope.paths = data.path;

            if ($scope.paths.length == 0) {
              $scope.pathsEmpty = true;
            } else {
              $scope.pathsEmpty = false;
            }

            $scope.pathValidation = data.pathValidation;

            $scope.isLoading = false;
            $scope.getDataError = false;
          },
          function (error) {
            $scope.paths = null;
            $scope.isLoading = false;
            $scope.getDataError = true;
            $scope.pathsEmpty = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };
  }

})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.activities')
      .controller('ActivitiesPageCtrl', ActivitiesPageCtrl);

  /** @ngInject */
  function ActivitiesPageCtrl($scope, $uibModal, $cookies, $state, $filter, $stateParams, ModalsService, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_client_activities')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_client_activities');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_client_activities');

    $scope.data = {'title': undefined, 'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      var params = tableState.search.predicateObject;
      $scope.data.title = params && params.hasOwnProperty('title') ? params.title : undefined;

      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;

      if ($stateParams.reloadParams !== null) {
        $scope.data = $stateParams.reloadParams;
        tableState.search.predicateObject = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.activitiesEmpty = false;
      AjaxRequest.path('marketing/client/activities?parentId=0').get(
          $scope.data,
          function (data) {
            $scope.activities = data.activities;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            $scope.activitiesEmpty = $scope.activities.length === 0;
            if ($stateParams.reloadParams !== null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.activities = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.activitiesEmpty = false;
            if ($stateParams.reloadParams !== null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.resetQuery = function () {
      tempTableState.pagination.start = 0;
      if (typeof tempTableState.search.predicateObject != 'undefined') {
        tempTableState.search.predicateObject = {};
      }
      $scope.callServer(tempTableState);
    };

    $scope.search = function () {
      $scope.callServer(tempTableState);
    };

    $scope.refresh = function () {
      $scope.callServer(tempTableState);
    };

    //以下为页面对应的actions
    $scope.openPublishPage = function (activityId, publishStatus, isTop) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/activities/modals/publishActivities.html',
        controller: 'PublishActivitiesCtrl',
        size: 'sm',
        resolve: {
          activityInfo: function () {
            return {
              'activityId': activityId,
              'publishStatus': publishStatus,
              'isTop': isTop
            };
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.openEditPage = function (activity) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/activities/editActivity.html',
        controller: 'EditActivityCtrl',
        size: 'lg',
        resolve: {
          activityInfo: function () {
            return {
              'activity': activity
            };
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.openDeletePage = function (activityId, isTop) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/activities/modals/deleteActivities.html',
        controller: 'DeleteActivitiesCtrl',
        size: 'sm',
        resolve: {
          activityInfo: function () {
            return {
              'activityId': activityId,
              'isTop': isTop,
            };
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.openChildPage = function (parentActivity) {
      $state.go('marketing.childActivities', {reloadParams: {'parentActivity': parentActivity}}, {reload: true});
    };

    $scope.openInfoPage = function (value) {
      ModalsService.open('app/services/modals/staticModals/infoModal.html', 'mm', value);
    };
  }
})();
/**
 * Created by John on 2017/2/9.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.activities')
      .controller('EditActivityCtrl', EditActivityCtrl);

  function EditActivityCtrl($scope, $state, $cookies, activityInfo, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    if (!ACL.hasPermission($cookies, 'post_client_activities')) {
      $state.go('auth');
      return;
    }

    $scope.displayTypeItems = [
      {label: 'all', value: 'all'},
      {label: 'discovery', value: 'discovery'},
      {label: 'ad', value: 'ad'},
    ];
    $scope.displayTypeSelected = $scope.displayTypeItems[0];

    if (typeof activityInfo.activity === 'undefined') {
      $scope.isNewActivity = true;
      $scope.data = {
        'title': '', 'priority': 0, 'displayType': 'all', 'imageUrl': '', 'targetUrl': '',
        'description': '', "startTime": 0, "endTime": 0, 'publish': false, 'parentId': 0
      };
    } else {
      $scope.isNewActivity = false;
      $scope.data = {
        'title': activityInfo.activity.title,
        'priority': activityInfo.activity.priority,
        'displayType': activityInfo.activity.displayType,
        'imageUrl': activityInfo.activity.imageUrl,
        'targetUrl': activityInfo.activity.targetUrl,
        'description': activityInfo.activity.description,
        "startTime": activityInfo.activity.startTime,
        "endTime": activityInfo.activity.endTime,
        "publish": activityInfo.activity.publish,
        "parentId": 0,
      };

      if (activityInfo.activity.displayType === 'discovery') {
        $scope.displayTypeSelected = $scope.displayTypeItems[1];
      } else if (activityInfo.activity.displayType === 'ad') {
        $scope.displayTypeSelected = $scope.displayTypeItems[2];
      } else {
        $scope.displayTypeSelected = $scope.displayTypeItems[0];
      }
    }

    $scope.displayTypeChange = function (displayTypeSelected) {
      $scope.data.displayType = displayTypeSelected.value;
    };

    $scope.submit = function () {

      if ($scope.isNotValidate()) {
        return;
      }

      $scope.holdSubmit = true;
      if ($scope.isNewActivity) {
        AjaxRequest.path('marketing/client/activity').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'create_success', 'toast-top-center');
              $scope.$dismiss();

              $state.go('marketing.activities', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
            })
      } else {
        AjaxRequest.path('marketing/client/activity/' + activityInfo.activity.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_success', 'toast-top-center');
              $scope.$dismiss();

              $state.go('marketing.activities', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
            });
      }
      $scope.$dismiss();
    };

    $scope.errors = false;
    $scope.errTitle = false;
    $scope.errImageUrl = false;
    $scope.errTargetUrl = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errTitle = false;
      $scope.errImageUrl = false;
      $scope.errTargetUrl = false;
    };


    $scope.isNotValidate = function () {
      var title = $scope.data.title;
      var imageUrl = $scope.data.imageUrl;
      var targetUrl = $scope.data.targetUrl;

      if (Validator.isNotStringValid(title)) {
        $scope.errTitle = true;
        $scope.errorMessage = Validator.isNotStringValid(title);
        return true;
      }

      if (Validator.isNotValidURL(imageUrl)) {
        $scope.errImageUrl = true;
        $scope.errorMessage = Validator.isNotValidURL(imageUrl);
        return true;
      }

      if (Validator.isNotValidURL(targetUrl)) {
        $scope.errTargetUrl = true;
        $scope.errorMessage = Validator.isNotValidURL(targetUrl);
        return true;
      }
      return false;
    };
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.advertisements')
    .controller('AdvertisementsPageCtrl', AdvertisementsPageCtrl);

  /** @ngInject */
  function AdvertisementsPageCtrl($scope, $uibModal, $cookies, $state, $filter, $stateParams, ModalsService, NotificationsService, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_advertisements')) {
      $state.go('auth');
      return;
    }

    $scope.CREATE_P = ACL.hasPermission($cookies, 'post_advertisement');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_advertisement');
    $scope.DELETE_P = ACL.hasPermission($cookies, 'delete_advertisement');

    $scope.languages = [
      {label: $filter('translate')('language_zh_hans'), value: 'zh-Hans'},
      {label: $filter('translate')('language_zh_hant'), value: 'zh-Hant'},
      {label: $filter('translate')('language_en'), value: 'en'},
      {label: $filter('translate')('language_es'), value: 'es'},
      {label: $filter('translate')('language_fr'), value: 'fr'},
      {label: $filter('translate')('language_pt'), value: 'pt'},
      {label: $filter('translate')('language_de'), value: 'de'},
      {label: $filter('translate')('language_it'), value: 'it'},
      {label: $filter('translate')('language_ja'), value: 'ja'},
      {label: $filter('translate')('language_ru'), value: 'ru'},
    ];

    if($scope.languageSelected === undefined){
      $scope.languageSelected = $scope.languages[0];
    }

    $scope.carouselIndex = 0;

    $scope.callServer = function callServer() {
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.adsEmpty = false;

      AjaxRequest.path('marketing/advertisements').get(
        function (data) {
          $scope.allADs = data;
          $scope.ADs = $scope.allADs[$scope.languageSelected.value];
          $scope.isLoading = false;
          $scope.getDataError = false;
          $scope.adsEmpty = $scope.ADs.length === 0;
          if ($stateParams.reloadParams !== null) {
            $stateParams.reloadParams = null;
          }
        },
        function (error) {
          ModalsService.handleError(error);
          $scope.getDataError = true;
          $scope.isLoading = false;
          $scope.adsEmpty = false;
          if ($stateParams.reloadParams !== null) {
            $stateParams.reloadParams = null;
          }
        }
      );
    };

    $scope.search = function () {
      $scope.callServer();
    };

    $scope.refresh = function () {
      $scope.callServer();
    };

    $scope.removeAD = function (avdvertisement) {
      var deleteRequest = {
        "locale": $scope.languageSelected.value,
        "advertisementId": avdvertisement.id
      };
      AjaxRequest.path('marketing/advertisement').delete(
        deleteRequest,
        function (data) {
          NotificationsService.openToast('success', 'op_info', 'delete_advertisement_success', 'toast-top-center');
          $scope.callServer();
        },
        function (error) {
          ModalsService.handleError(error);
        }
      );
    };

    $scope.openEditPage = function (advertisement) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/advertisements/editAdvertisement.html',
        controller: 'EditAdvertisementCtrl',
        size: 'lg',
        resolve: {
          advertisement: function () {
            return advertisement;
          },
          locale: function () {
            return $scope.languageSelected.value;
          },
          refreshADsFunc:function () {
            return $scope.callServer;
          }
        }
      });
    };

    $scope.showADImage = function (pic) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/advertisements/image/showADImage.html',
        controller: 'ShowImageCtrl',
        size: 'sm',
        resolve: {
          adPic: function () {
            return pic;
          }
        }
      });
    };

    $scope.openEditPage = function (advertisement) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/advertisements/editAdvertisement.html',
        controller: 'EditAdvertisementCtrl',
        size: 'lg',
        resolve: {
          advertisement: function () {
            return advertisement;
          },
          locale: function () {
            return $scope.languageSelected.value;
          },
          refreshADsFunc:function () {
            return $scope.callServer;
          }
        }
      });
    };

    $scope.preview = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/advertisements/preview.html',
        controller: 'PreviewCtrl',
        windowClass:'ads-preview-modal-window',
        resolve: {
          advertisements: function () {
            return $scope.allADs;
          }
        }
      });
    };

    $scope.languageChanged = function (languageSelected) {
      $scope.ADs = $scope.allADs[languageSelected.value];
      $scope.languageSelected = languageSelected;
    };
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.advertisements')
    .controller('EditAdvertisementCtrl', EditAdvertisementCtrl);

  /** @ngInject */
  function EditAdvertisementCtrl($scope, $state, $cookies, $filter, FileUploader, refreshADsFunc, advertisement, locale, AjaxRequest, NotificationsService, ModalsService) {


    $scope.GET_LOCATION_URL = ACL.hasPermission($cookies, 'get_location_url');
    if(!$scope.GET_LOCATION_URL){
      $scope.$dismiss();
      $state.go('auth');
      return;
    }
    $scope.CREATE_LOCATION_URL = ACL.hasPermission($cookies, 'post_location_url');
    $scope.UPDATE_LOCATION_URL = ACL.hasPermission($cookies, 'put_location_url');


    $scope.languages = [
      {label: $filter('translate')('language_zh_hans'), value: 'zh-Hans'},
      {label: $filter('translate')('language_zh_hant'), value: 'zh-Hant'},
      {label: $filter('translate')('language_en'), value: 'en'},
      {label: $filter('translate')('language_es'), value: 'es'},
      {label: $filter('translate')('language_fr'), value: 'fr'},
      {label: $filter('translate')('language_pt'), value: 'pt'},
      {label: $filter('translate')('language_de'), value: 'de'},
      {label: $filter('translate')('language_it'), value: 'it'},
      {label: $filter('translate')('language_ja'), value: 'ja'},
      {label: $filter('translate')('language_ru'), value: 'ru'}
    ];
    $scope.linkTypes = [
      {label: $filter('translate')('link_type_nornal'), value: false},
      {label: $filter('translate')('link_type_based_on_location'), value: true}
    ];

    $scope.allAvaliableCountryCodes = [
      { label: $filter('translate')("CN"),value : "CN"},
      { label: $filter('translate')("US"),value : "US"},
      { label: $filter('translate')("GB"),value : "GB"},
      { label: $filter('translate')("CA"),value : "CA"},
      { label: $filter('translate')("NZ"),value : "NZ"},
      { label: $filter('translate')("AU"),value : "AU"},
      { label: $filter('translate')("DE"),value : "DE"},
      { label: $filter('translate')("FR"),value : "FR"},
      { label: $filter('translate')("RU"),value : "RU"},
      { label: $filter('translate')("IE"),value : "IE"},
      { label: $filter('translate')("IT"),value : "IT"},
      { label: $filter('translate')("FI"),value : "FI"},
      { label: $filter('translate')("JP"),value : "JP"},
      { label: $filter('translate')("NL"),value : "NL"},
      { label: $filter('translate')("BR"),value : "BR"},
      { label: $filter('translate')("SG"),value : "SG"},
      { label: $filter('translate')("OTHER"),value : "OTHER"}
    ];

    $scope.isNewAD = false;
    $scope.locale = locale;
    for (var i = 0; i < $scope.languages.length; i++) {
      if ($scope.languages[i].value === $scope.locale)
        $scope.localeToShow = $scope.languages[i].label;
    }


    if (advertisement === undefined) {
      $scope.isNewAD = true;
      $scope.advertisement = {
        "id": undefined,
        "publish_time": new Date().getTime(),
        "update_time": new Date().getTime(),
        "pic": "",
        "link": "",
        "repeat": 1,
        "expire_time": undefined,
        "is_location_based_link": false
      };
      $scope.shortLocationBasedUrl = { "shortUrlKey": undefined, "locationUrls":[]};
      updateCountryCodes();
    } else {
      $scope.advertisement = {
        "id": advertisement.id,
        "publish_time": advertisement.publish_time,
        "update_time": new Date().getTime(),
        "pic": advertisement.pic,
        "link": advertisement.link,
        "repeat": advertisement.repeat,
        "expire_time": advertisement.expire_time,
        "is_location_based_link": advertisement.is_location_based_link
      };

      if($scope.advertisement.is_location_based_link){
        var shortUrlKey = getShortUrlKey($scope.advertisement.link);
        if(shortUrlKey !== undefined){
          getShortUrlsFromServer(shortUrlKey);
        } else {
          $scope.shortLocationBasedUrl = { "shortUrlKey": undefined, "locationUrls":[]};
          updateCountryCodes();
        }
      } else {
        $scope.shortLocationBasedUrl = { "shortUrlKey": undefined, "locationUrls":[]};
      }

    }


    if($scope.advertisement.is_location_based_link === undefined){
      $scope.advertisement.is_location_based_link = false;
    }
    for (var j = 0; j < $scope.linkTypes.length; j++) {
      if ($scope.linkTypes[j].value === $scope.advertisement.is_location_based_link) {
        $scope.linkTypeSelected = $scope.linkTypes[j];
        break;
      }
    }

    var queryData = {
      'successAction': '/mine',
      'fileName': '',
      'bucket': 'resource-us-east-1',
      'version': '',
      'ucid': 'f57ad0e472'
    };

    if ($scope.advertisement.expire_time !== undefined) {
      $scope.expireDate = new Date($scope.advertisement.expire_time).Format("yyyy-MM-dd HH:mm:ss");
    }

    $scope.expireDateOnSetTime = function () {
      $scope.advertisement.expire_time = new Date($scope.expireDate).getTime();
      $scope.expireDate = new Date($scope.expireDate).Format("yyyy-MM-dd HH:mm:ss");
    };

    $scope.startDateBeforeRender = function ($dates) {
      if ($scope.dateRangeEnd) {
        var activeDate = moment($scope.dateRangeEnd);
        $dates.filter(function (date) {
          return date.localDateValue() >= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };

    $scope.linkTypeChanged = function (linkTypeSelected) {
      $scope.linkTypeSelected = linkTypeSelected;
      $scope.advertisement.is_location_based_link = linkTypeSelected.value;
      if($scope.advertisement.is_location_based_link){
        var shortUrlKey = getShortUrlKey($scope.advertisement.link);
        if (shortUrlKey !== undefined){
          getShortUrlsFromServer(shortUrlKey);
        }
        updateCountryCodes();
      }
    };

    $scope.countryCodeChanged = function (countryCodeSelected) {
      $scope.countryCodeSelected = countryCodeSelected;
    };

    $scope.submit = function () {
      var requestData = {
        "locale": $scope.locale,
        "advertisement": $scope.advertisement
      };
      if ($scope.advertisement.id !== undefined) {
        AjaxRequest.path("marketing/advertisement").put(requestData,
          function (data) {
            NotificationsService.openToast('success', 'op_info', 'update_advertisement_success', 'toast-top-center');
            $scope.$dismiss();
            refreshADsFunc();
          }, function (error) {
            ModalsService.handleError(error);
            $scope.$dismiss();
          })
      } else {
        if($scope.advertisement.pic === undefined
          || $scope.advertisement.pic === null
          || $scope.advertisement.pic === ''){
          NotificationsService.openToast('error', 'op_info', 'no_ad_image_was_configured', 'toast-top-center');
        }else {
          AjaxRequest.path("marketing/advertisement").post(requestData,
            function (data) {
              NotificationsService.openToast('success', 'op_info', 'create_advertisement_success', 'toast-top-center');
              $scope.$dismiss();
              refreshADsFunc();
            }, function (error) {
              ModalsService.handleError(error);
              $scope.$dismiss();
            });
        }
      }
    };

    $scope.isAddingLocationUrl = false;
    function updateUrls() {
      $scope.isAddingLocationUrl = true;
      if ($scope.shortLocationBasedUrl.shortUrlKey === undefined) {
        AjaxRequest.path("marketing/advertisement/shorturl").post($scope.shortLocationBasedUrl,
          function (data) {
            $scope.shortLocationBasedUrl = data;
            $scope.advertisement.link = "https://centralweb.nvts.co/v1/redirect?shortUrlKey=" + data.shortUrlKey;
            convertLocationUrlsForShow();
            updateCountryCodes();
            $scope.isAddingLocationUrl = false;
          }, function (error) {
            $scope.isAddingLocationUrl = false;
            ModalsService.handleError(error);
          });
      } else {
        AjaxRequest.path("marketing/advertisement/shorturl").put($scope.shortLocationBasedUrl,
          function (data) {
            $scope.shortLocationBasedUrl = data;
            convertLocationUrlsForShow();
            updateCountryCodes();
            $scope.isAddingLocationUrl = false;
          }, function (error) {
            $scope.isAddingLocationUrl = false;
            ModalsService.handleError(error);
          });
      }
    }

    $scope.addNewLocationUrl = function () {
      var newOne =
        {
          "countryCode": $scope.countryCodeSelected.value,
          "url":$scope.newUrl,
          "urlForShow":$scope.newUrl.length <= 30 ? $scope.newUrl : $scope.newUrl.substring(0, 30)
        };
      if($scope.locationUrlsForShow === undefined) {
        $scope.locationUrlsForShow = [];
      }
      $scope.locationUrlsForShow.push(newOne);
      convertLocationUrlsForRequest();
      updateUrls();
      $scope.newUrl = undefined;
    };

    Array.prototype.remove = function(val) {
      var index = this.indexOf(val);
      if (index > -1) {
        this.splice(index, 1);
      }
    };
    $scope.deleteLocationUrl = function (localtionUrl) {
      $scope.locationUrlsForShow.remove(localtionUrl);
      convertLocationUrlsForRequest();
      updateUrls()

    };

    function convertLocationUrlsForShow() {
      var urlsForShow = [];
      for(var i = 0 ;i < $scope.shortLocationBasedUrl.locationUrls.length ;i++){
        var locationUrl = $scope.shortLocationBasedUrl.locationUrls[i];
        urlsForShow.push(
          {
            "countryCode": locationUrl.countryCode,
            "url":locationUrl.url,
            "urlForShow":locationUrl.url.length <= 30 ? locationUrl.url : locationUrl.url.substring(0, 30)
          });
        console.log("convert i");
      }

      $scope.locationUrlsForShow = urlsForShow;

    }

    function convertLocationUrlsForRequest() {
      var urlsForRequest = [];
      for(var i = 0 ;i < $scope.locationUrlsForShow.length ;i++){
        var locationUrl = $scope.locationUrlsForShow[i];
        urlsForRequest.push(
          {
            "countryCode": locationUrl.countryCode,
            "url":locationUrl.url
          });
      }

      $scope.shortLocationBasedUrl.locationUrls = urlsForRequest;

    }

    function getAuthorization(fileItem) {
      $scope.notReady = true;
      AjaxRequest.path('s3/signature').get(
        queryData,
        function (data) {
          fileItem.url = data.url;
          fileItem.formData[0]["key"] = data.key;
          fileItem.formData[0]["acl"] = data.acl;
          fileItem.formData[0]["X-Amz-Credential"] = data.credential;
          fileItem.formData[0]["X-Amz-Algorithm"] = data.algorithm;
          fileItem.formData[0]["X-Amz-Date"] = data.date;
          fileItem.formData[0]["Policy"] = data.policy;
          fileItem.formData[0]["X-Amz-Signature"] = data.signature;
          $scope.notReady = false;
        },
        function (error) {
        }
      );
    }

    function getShortUrlKey(link) {
      if(link === undefined){
        return undefined;
      }

      var queryAll = link.substring(link.indexOf("?") + 1,link.length);
      var queries = queryAll.split("&");
      for(var index = 0 ;index < queries.length; index ++){
        var keyValues = queries[index].split("=");
        if(keyValues !== undefined && keyValues.length === 2){
          if(keyValues[0] === "shortUrlKey") {
            return keyValues[1];
          }
        }
      }
      return undefined;
    }

    function getCounrtyCodeCanBeAdded(locationUrls) {
      var countryCodeCountMap = {};
      for (var j = 0; j < $scope.allAvaliableCountryCodes.length; j++) {
        countryCodeCountMap[$scope.allAvaliableCountryCodes[j].value] = false;
      }

      for (j = 0; j < locationUrls.length; j++) {
        if (inAllCountryCodes(locationUrls[j].countryCode)) {
          countryCodeCountMap[locationUrls[j].countryCode] = true;
        }
      }

      var countryCodesToBeAdded = [];

      for (j = 0; j < $scope.allAvaliableCountryCodes.length; j++) {
        if(countryCodeCountMap[$scope.allAvaliableCountryCodes[j].value] === false){
          countryCodesToBeAdded.push($scope.allAvaliableCountryCodes[j]);
        }
      }

      return countryCodesToBeAdded;
    }

    function inAllCountryCodes(countryCode) {
      if(countryCode === undefined){
        return false;
      }
      for (var i = 0 ;i < $scope.allAvaliableCountryCodes.length ;i++){
        if($scope.allAvaliableCountryCodes[i].value === countryCode) {
          return true;
        }
      }
      return false;
    }

    function updateCountryCodes() {
      $scope.countryCodesCanBeAdded = getCounrtyCodeCanBeAdded($scope.shortLocationBasedUrl.locationUrls);
      if ($scope.countryCodesCanBeAdded.length > 0) {
        $scope.countryCodeSelected = $scope.countryCodesCanBeAdded[0];
      } else {
        $scope.countryCodeSelected = undefined;
      }
    }


    function getShortUrlsFromServer(shortUrlKey) {
      AjaxRequest.path("marketing/advertisement/shorturl?shortUrlKey="+shortUrlKey).get(
        function (data) {

          $scope.shortLocationBasedUrl =
            {
              "shortUrlKey": data.shortUrlKey,
              "locationUrls": data.locationUrls === undefined ? [] : data.locationUrls
            };

          convertLocationUrlsForShow();
          updateCountryCodes();

        }, function (error) {
        });
    }
    var uploadFormData = {
      "key": "test",
      "acl": "private",
      "success_action_redirect": "/mine",
      "X-Amz-Credential": "",
      "X-Amz-Algorithm": "",
      "X-Amz-Date": "",
      "Policy": "",
      "X-Amz-Signature": ""
    };

    var uploader = $scope.uploader = new FileUploader({
      formData: [uploadFormData],
      alias: "file",
      method: "POST"
    });


    $scope.invalidImage = false;
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function (item, options, deferred) {
        if (window.FileReader) {
          var reader = new FileReader();
          reader.readAsDataURL(item);
          //监听文件读取结束后事件
          reader.onloadend = function (e, isRight) {
            var img = document.getElementById("loc_img");
            img.src = e.target.result;
            img.onload = function () {
              var isRight = (this.width === 480 && this.height === 640);
              if (isRight) {
                setTimeout(deferred.resolve, 1e3);
              } else {
                $('#adImage').val(null);
                if (uploader.queue.length >= 1) {
                  uploader.removeFromQueue(uploader.queue[0]);
                }
                NotificationsService.openToast('error', 'op_info', 'ad_image_wrong_size_choose_another', 'toast-top-center');
              }
              return isRight;
            };
          };
        }
      }
    });
    uploader.onAfterAddingFile = function (fileItem) {
      if (uploader.queue.length > 1) {
        uploader.removeFromQueue(uploader.queue[0]);
      }
      queryData.fileName = "client_configuration/advertisements/" + $scope.advertisement.update_time + "/" + fileItem.file.name;
      $scope.uploadImageUrl = queryData.fileName;
      $('#adImage').val(null);
      getAuthorization(fileItem);
    };
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.advertisement.pic = fileItem.url + $scope.uploadImageUrl;
      $scope.$emit('showInfoModal', {
        'langcontent': 'file_upload_success'
      });
      $scope.uploadSuccess = true;
    };
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      $scope.$emit('showInfoModal', {
        'langcontent': 'file_upload_error'
      });
      $scope.uploadSuccess = false;
    };
  }

})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.advertisements')
    .controller('PreviewCtrl', PreviewCtrl);

  /** @ngInject */
  function PreviewCtrl($scope, $uibModal, $cookies, $state, $filter, advertisements) {
    $scope.PUBLISH_P = ACL.hasPermission($cookies, 'post_advertisements');

    $scope.languages = [
      {label: $filter('translate')('language_zh_hans'), value: 'zh-Hans'},
      {label: $filter('translate')('language_zh_hant'), value: 'zh-Hant'},
      {label: $filter('translate')('language_en'), value: 'en'},
      {label: $filter('translate')('language_es'), value: 'es'},
      {label: $filter('translate')('language_fr'), value: 'fr'},
      {label: $filter('translate')('language_pt'), value: 'pt'},
      {label: $filter('translate')('language_de'), value: 'de'},
      {label: $filter('translate')('language_it'), value: 'it'},
      {label: $filter('translate')('language_ja'), value: 'ja'},
      {label: $filter('translate')('language_ru'), value: 'ru'},
    ];

    if ($scope.languageSelected === undefined) {
      $scope.languageSelected = $scope.languages[0];
    }
    $scope.advertisements = advertisements;
    $scope.previewADs = advertisements[$scope.languageSelected.value];
    $scope.carouselIndex = 0;

    $scope.publishAdvertisements = function callServer() {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/advertisements/publishADsConfirm.html',
        controller: 'PublishAdvertisementsCtrl',
        size: 'sm'
      });
    };

    $scope.languageChanged = function (languageSelected) {
      $scope.languageSelected = languageSelected;
      $scope.previewADs = advertisements[$scope.languageSelected.value];
    };
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.advertisements')
    .controller('PublishAdvertisementsCtrl', PublishAdvertisementsCtrl);

  /** @ngInject */
  function PublishAdvertisementsCtrl($scope, $uibModal, $cookies, $state, $filter, ModalsService, NotificationsService, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'post_advertisements')) {
      $state.go('auth');
      return;
    }

    $scope.publishADs = function callServer() {
      AjaxRequest.path('marketing/advertisements').post(
        function (data) {
          NotificationsService.openToast('success', 'op_info', 'publish_advertisements_success', 'toast-top-center');
          $scope.$dismiss();
          },
        function (error) {
          ModalsService.handleError(error);
          $scope.$dismiss();
        }
      );
    };
  }
})();
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.notifications')
      .controller('EditNotificationCtrl', EditNotificationCtrl);

  /** @ngInject */
  function EditNotificationCtrl($scope, $state, $cookies, $filter, clientNotification, reloadParams,
                                AjaxRequest, NotificationsService, ModalsService) {
    $scope.CREATE_P = ACL.hasPermission($cookies, 'post_client_notification');
    $scope.UPDATE_P = ACL.hasPermission($cookies, 'put_client_notification');

    if (typeof clientNotification === 'undefined') {
      $scope.isNew = true;

      $scope.data = {
        "title": "",
        "imageUrl": "",
        "targetUrl": "",
        "note": "",
        "clientCondition": "",
      };
    } else {
      $scope.isNew = false;
      $scope.data = {
        'title': clientNotification.title, 'imageUrl': clientNotification.imageUrl,
        'targetUrl': clientNotification.targetUrl,
        'note': clientNotification.note, 'clientCondition': clientNotification.clientCondition
      };
    }

    $scope.submit = function () {
      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;

      if (!$scope.isNew) {
        AjaxRequest.path('client/notification/' + clientNotification.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_app_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('marketing.notifications', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data !== 'undefined' && error.data !== null) {
                let data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('client/notification').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              NotificationsService.openToast('success', 'op_info', 'create_app_success', 'toast-top-center');
              $state.go('marketing.notifications', {reloadParams: null}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data !== 'undefined' && error.data !== null) {
                let data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.errors = false;
    $scope.errTitle = false;
    $scope.errImageUrl = false;
    $scope.errTargetUrl = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errTitle = false;
      $scope.errImageUrl = false;
      $scope.errTargetUrl = false;
    };

    $scope.isNotValidate = function () {
      let title = $scope.data.title;
      let imageUrl = $scope.data.imageUrl;
      let targetUrl = $scope.data.targetUrl;

      if (Validator.isNotStringValid(title)) {
        $scope.errTitle = true;
        $scope.errorMessage = Validator.isNotStringValid(title);
        return true;
      }

      if (Validator.isNotStringValid(imageUrl)) {
        $scope.errImageUrl = true;
        $scope.errorMessage = Validator.isNotStringValid(imageUrl);
        return true;
      }

      if (Validator.isNotStringValid(targetUrl)) {
        $scope.errTargetUrl = true;
        $scope.errorMessage = Validator.isNotStringValid(targetUrl);
        return true;
      }

      return false;
    }


  }
})();

(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, $uibModal, $cookies, $state, $filter, $stateParams, ModalsService, NotificationsService, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_client_notification')) {
      $state.go('auth');
      return;
    }

    $scope.holdSubmit = false;
    $scope.CREATE_P = ACL.hasPermission($cookies, 'post_client_notification');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_client_notification');
    $scope.PUBLISH_P = ACL.hasPermission($cookies, 'post_client_notification_publish');
    $scope.TEST_PUBLISH_P = ACL.hasPermission($cookies, 'post_client_notification_publish_test');
    $scope.data = {'pgs': 10, 'pgn': 0};
    let tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.dataEmpty = false;
      let pagination = tableState.pagination;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if ($stateParams.reloadParams !== null) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      AjaxRequest.path('client/notification').get(
          $scope.data,
          function (data) {
            $scope.clientNotifications = data.clientNotifications;
            $scope.dataEmpty = $scope.clientNotifications.length === 0;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($stateParams.reloadParams !== null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.clientNotifications = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.dataEmpty = false;
            if($stateParams.reloadParams !== null){
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.search = function () {
      $scope.callServer();
    };

    $scope.refresh = function () {
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (clientNotification) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/notifications/editNotification.html',
        controller: 'EditNotificationCtrl',
        size: 'lg',
        resolve: {
          clientNotification: function () {
            return clientNotification;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.publish = function (clientNotification) {
      $scope.holdSubmit = true;
      AjaxRequest.path('client/notification/' + clientNotification.id + "/publish").post(
          function (data) {
            $scope.holdSubmit = false;
            NotificationsService.openToast('success', 'op_info', 'publish_success', 'toast-top-center');
            $scope.callServer(tempTableState);
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
          }
      );
    };

    $scope.testPublish = function (clientNotification) {
      $scope.holdSubmit = true;
      AjaxRequest.path('client/notification/' + clientNotification.id + "/testpublish").post(
          function (data) {
            $scope.holdSubmit = false;
            NotificationsService.openToast('success', 'op_info', 'publish_success', 'toast-top-center');
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
          }
      );
    };

    $scope.openInfoPage = function (value) {
      ModalsService.open('app/services/modals/staticModals/infoModal.html', 'mm', value);
    };
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.promotions')
      .controller('EditPromotionCtrl', EditPromotionCtrl);

  /** @ngInject */
  function EditPromotionCtrl($scope, $state, $filter, activity, AjaxRequest, reloadParams, NotificationsService, ModalsService) {

    $scope.activityTypes = [
      {label: $filter('translate')('NORMAL'), value: 'NORMAL'}
    ];

    $scope.activityStatus = [
      {label: $filter('translate')('UNPUBLISHED'), value: 'UNPUBLISHED'},
      {label: $filter('translate')('PUBLISHED'), value: 'PUBLISHED'},
      {label: $filter('translate')('REMOVED'), value: 'REMOVED'}
    ];

    if (typeof activity === 'undefined') {
      $scope.isNewPromotion = true;
      $scope.activity = {
        'id': undefined,
        'activityType': $scope.activityTypes[0].value,
        'details': '{}',
        'note': '',
        'activityStatus': undefined,
        'createTime': undefined,
        'publishTime': undefined
      };
    } else {
      $scope.isNewPromotion = false;
      $scope.activity = {
        'id': activity.id,
        'activityType': activity.activityType,
        'details': '{}',
        'note': activity.note,
        'activityStatus': activity.activityStatus,
        'createTime': activity.createTime,
        'publishTime': activity.publishTime
      };
    }

    $scope.activityChangeable = $scope.activity.activityStatus === undefined || $scope.activity.activityStatus !== "REMOVED";
    $scope.couponChangeable = $scope.activity.activityStatus === undefined || $scope.activity.activityStatus === "UNPUBLISHED";

    $scope.activityTypeSelected = $scope.activityTypes[0];
    for (var i = 0; i < $scope.activityTypes.length; i++) {
      if ($scope.activityTypes[i].value === $scope.activity.activityType) {
        $scope.activityTypeSelected = $scope.activityTypes[i];
        break;
      }
    }

    $scope.activityStatusSelected = $scope.activityStatus[0];
    for (var i = 0; i < $scope.activityStatus.length; i++) {
      if ($scope.activityStatus[i].value === $scope.activity.activityStatus) {
        $scope.activityStatusSelected = $scope.activityStatus[i];
        break;
      }
    }
    $scope.submit = function () {
      if (!$scope.isNewPromotion) {
        $scope.holdSubmit = true;
        AjaxRequest.path('marketing/activity').put(
            $scope.activity,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_activity_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('marketing.promotions', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data !== 'undefined' && error.data !== null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('marketing/activity').post(
            $scope.activity,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'create_activity_success');
              $state.go('marketing.promotions', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data !== 'undefined' && error.data !== null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.activityTypeChanged = function (activityTypeSelected) {
      $scope.activity.activityType = activityTypeSelected.value;
    };

    $scope.statusChanged = function (activityStatusSelected) {
      $scope.activity.activityStatus = activityStatusSelected.value;
    };

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.promotions')
    .controller('PromotionPageCtrl', PromotionPageCtrl);

  /** @ngInject */
  function PromotionPageCtrl($scope, $uibModal, $cookies, $state, $filter, $stateParams, ModalsService, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_promotions')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_promotions');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_promotions');

    $scope.requst = {'type': 'ALL', 'status': 'ALL', 'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.activityTypes = [
      {label: $filter('translate')('ALL'), value: 'ALL'},
      {label: $filter('translate')('NORMAL'), value: 'NORMAL'},
    ];
    if($scope.activityTypeSelected === undefined){
      $scope.activityTypeSelected = $scope.activityTypes[0];
    }

    $scope.activityStatus = [
      {label: $filter('translate')('ALL'), value: 'ALL'},
      {label: $filter('translate')('UNPUBLISHED'), value: 'UNPUBLISHED'},
      {label: $filter('translate')('PUBLISHED'), value: 'PUBLISHED'},
      {label: $filter('translate')('REMOVED'), value: 'REMOVED'},
    ];
    if($scope.activityStatusSelected === undefined){
      $scope.activityStatusSelected = $scope.activityStatus[0];
    }

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.promotionsEmpty = false;
      var pagination = tableState.pagination;

      $scope.requst.pgs = pagination.number || 10;
      $scope.requst.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if ($stateParams.reloadParams !== null) {
        $scope.requst = $stateParams.reloadParams;
        tableState.pagination.start = $scope.requst.pgn * 10;
      }
      AjaxRequest.path('marketing/activities').get(
        $scope.requst,
        function (data) {
          $scope.promotions = data.activities;
          tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.requst.pgs);
          $scope.isLoading = false;
          $scope.getDataError = false;
          $scope.promotionsEmpty = $scope.promotions.length === 0;
          if ($stateParams.reloadParams !== null) {
            $stateParams.reloadParams = null;
          }
        },
        function (error) {
          ModalsService.handleError(error);
          $scope.promotions = null;
          $scope.getDataError = true;
          $scope.isLoading = false;
          $scope.promotionsEmpty = false;
          if ($stateParams.reloadParams !== null) {
            $stateParams.reloadParams = null;
          }
        }
      );
    };

    $scope.search = function () {
      $scope.callServer(tempTableState);
    };

    $scope.refresh = function () {
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (activity) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/promotions/editPromotion.html',
        controller: 'EditPromotionCtrl',
        size: 'lg',
        resolve: {
          activity: function () {
            return activity;
          },
          reloadParams: function () {
            return $scope.requst;
          }
        }
      });
      $scope.activityTypeSelected = $scope.activityTypes[0];
      $scope.activityStatusSelected = $scope.activityStatus[0];
      $scope.requst.type = $scope.activityTypeSelected.value;
      $scope.requst.status = $scope.activityStatusSelected.value;
    };

    $scope.openEditDetailsPage = function (activity) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/promotions/details/editDetails.html',
        controller: 'EditPromotionDetailsCtrl',
        size: 'lg',
        resolve: {
          activityId: function () {
            return activity.id;
          },
          activityType : function () {
            return activity.activityType;
          },
          editable: function () {
            return activity.activityStatus !== 'REMOVED';
          }
        }
      });
    };

    $scope.showRelatedCoupons = function (activityId, activityStatus) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/promotions/coupons/relatedCoupons.html',
        controller: 'CouponsPageCtrl',
        size: 'lg',
        resolve: {
          activityId: function () {
            return activityId;
          },
          activityStatus: function () {
            return activityStatus;
          }
        }
      });
    };



    $scope.activityTypeChanged = function (activityTypeSelected) {
      $scope.requst.type = activityTypeSelected.value;
      $scope.refresh();
    };

    $scope.statusChanged = function (activityStatusSelected) {
      $scope.requst.status = activityStatusSelected.value;
      $scope.refresh();
    };
  }
})();
/**
 * Created by ptx.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.members')
      .controller('MemberActivityCtrl', MemberActivityCtrl);

  /** @ngInject */
  function MemberActivityCtrl($scope, $cookies, $filter, ModalsService, member, AjaxRequest) {
    $scope.data = {'type': 0, 'startTime': undefined, 'endTime': undefined, 'pgs': 10, 'pgn': 0};

    $scope.headerName = member.name;

    $scope.isOldServer = false;

    if ($cookies.get('currentServer') == 'old') {
      $scope.isOldServer = true;
    }

    $scope.typeChange = function (activitySelected) {
      $scope.data.type = activitySelected.value;
      resetCallServer();
    };

    $scope.callServer = function () {
      if ($cookies.get('currentServer') == 'old') {
        $scope.isOldServer = true;
      }
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.memberActivitiesEmpty = false;
      AjaxRequest.path('member/' + member.id + '/operationrecords').get(
          $scope.data,
          function (data) {
            $scope.memberActivities = data.records;

            if($scope.memberActivities.length == 0){
              $scope.memberActivitiesEmpty = true;
            }else{
              $scope.memberActivitiesEmpty = false;
            }

            $scope.currentPage = $scope.data.pgn + 1;
            $scope.numPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.pages = {};
            $scope.pages.length = $scope.numPages;
            $scope.isLoading = false;
            $scope.getDataError = false;
            $cookies.put('currentServer', 'central');
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.memberActivitiesEmpty = false;
            $cookies.put('currentServer', 'central');
          }
      );
    };

    $scope.callServer();

    function resetCallServer() {
      $scope.data.pgs = 10;
      $scope.data.pgn = 0;
      $scope.callServer();
    }

    $scope.resetSearch = function () {
      $scope.dateRangeStart = undefined;
      $scope.dateRangeEnd = undefined;
      $scope.activitySelected = $scope.activityTypeList[0];
      $scope.data = {'type': 0, 'startTime': undefined, 'endTime': undefined, 'pgs': 10, 'pgn': 0};
      $scope.callServer();
    };

    $scope.selectPage = function (page) {
      if (page > 0 && page <= $scope.numPages) {
        $scope.data.pgs = 10;
        $scope.data.pgn = page - 1;
        $scope.callServer();
      }
    };

    $scope.refresh = function(){
      $scope.selectPage($scope.data.pgn + 1);
    };

    $scope.activityTypeList = [
      {label: $filter('translate')('members_activity_types_0'), value: '0'},
      {label: $filter('translate')('members_activity_types_1'), value: '1'},
      {label: $filter('translate')('members_activity_types_2'), value: '2'},
      {label: $filter('translate')('members_activity_types_3'), value: '3'},
      {label: $filter('translate')('members_activity_types_4'), value: '4'},
      {label: $filter('translate')('members_activity_types_5'), value: '5'},
      {label: $filter('translate')('members_activity_types_6'), value: '6'},
      {label: $filter('translate')('members_activity_types_7'), value: '7'},
      {label: $filter('translate')('members_activity_types_8'), value: '8'},
      {label: $filter('translate')('members_activity_types_9'), value: '9'},
      {label: $filter('translate')('members_activity_types_10'), value: '10'},
      {label: $filter('translate')('members_activity_types_11'), value: '11'},
      {label: $filter('translate')('members_activity_types_12'), value: '12'},
      {label: $filter('translate')('members_activity_types_13'), value: '13'},
      {label: $filter('translate')('members_activity_types_14'), value: '14'},
      {label: $filter('translate')('members_activity_types_15'), value: '15'},
      {label: $filter('translate')('members_activity_types_16'), value: '16'},
      {label: $filter('translate')('members_activity_types_17'), value: '17'},
      {label: $filter('translate')('members_activity_types_18'), value: '18'},
      {label: $filter('translate')('members_activity_types_19'), value: '19'},
      {label: $filter('translate')('members_activity_types_20'), value: '20'},
      {label: $filter('translate')('members_activity_types_21'), value: '21'},
      {label: $filter('translate')('members_activity_types_22'), value: '22'},
      {label: $filter('translate')('members_activity_types_23'), value: '23'},
      {label: $filter('translate')('members_activity_types_24'), value: '24'},
      {label: $filter('translate')('members_activity_types_25'), value: '25'},
      {label: $filter('translate')('members_activity_types_26'), value: '26'},
      {label: $filter('translate')('members_activity_types_27'), value: '27'},
      {label: $filter('translate')('members_activity_types_28'), value: '28'},
      {label: $filter('translate')('members_activity_types_29'), value: '29'},
      {label: $filter('translate')('members_activity_types_30'), value: '30'},
      {label: $filter('translate')('members_activity_types_31'), value: '31'},
      {label: $filter('translate')('members_activity_types_32'), value: '32'},
      {label: $filter('translate')('members_activity_types_33'), value: '33'},
      {label: $filter('translate')('members_activity_types_34'), value: '34'},
      {label: $filter('translate')('members_activity_types_35'), value: '35'},
      {label: $filter('translate')('members_activity_types_36'), value: '36'},
      {label: $filter('translate')('members_activity_types_37'), value: '37'},
      {label: $filter('translate')('members_activity_types_38'), value: '38'},
      {label: $filter('translate')('members_activity_types_39'), value: '39'},
      {label: $filter('translate')('members_activity_types_40'), value: '40'},
      {label: $filter('translate')('members_activity_types_41'), value: '41'},
      {label: $filter('translate')('members_activity_types_42'), value: '42'},
      {label: $filter('translate')('members_activity_types_43'), value: '43'},
      {label: $filter('translate')('members_activity_types_44'), value: '44'},
      {label: $filter('translate')('members_activity_types_45'), value: '45'},
      {label: $filter('translate')('members_activity_types_46'), value: '46'},
      {label: $filter('translate')('members_activity_types_47'), value: '47'},
      {label: $filter('translate')('members_activity_types_48'), value: '48'},
      {label: $filter('translate')('members_activity_types_49'), value: '49'},
      {label: $filter('translate')('members_activity_types_50'), value: '50'},
      {label: $filter('translate')('members_activity_types_51'), value: '51'},
      {label: $filter('translate')('members_activity_types_52'), value: '52'},
      {label: $filter('translate')('members_activity_types_53'), value: '53'},
      {label: $filter('translate')('members_activity_types_54'), value: '54'},
      {label: $filter('translate')('members_activity_types_55'), value: '55'},
      {label: $filter('translate')('members_activity_types_56'), value: '56'},
      {label: $filter('translate')('members_activity_types_57'), value: '57'},
      {label: $filter('translate')('members_activity_types_58'), value: '58'},
      {label: $filter('translate')('members_activity_types_59'), value: '59'},
      {label: $filter('translate')('members_activity_types_60'), value: '60'},
      {label: $filter('translate')('members_activity_types_61'), value: '61'},
    ];
    $scope.activitySelected = $scope.activityTypeList[0];

    $scope.startDateOnSetTime = function () {
      $scope.data.startTime = new Date($scope.dateRangeStart).getTime();
      $scope.dateRangeStart = new Date($scope.dateRangeStart).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('start-date-changed');
      if ($scope.data.endTime) {
        resetCallServer();
      }
    };

    $scope.endDateOnSetTime = function () {
      $scope.data.endTime = new Date($scope.dateRangeEnd).getTime();
      $scope.dateRangeEnd = new Date($scope.dateRangeEnd).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('end-date-changed');
      if ($scope.data.startTime) {
        resetCallServer();
      }
    };

    $scope.startDateBeforeRender = function ($dates) {
      if ($scope.dateRangeEnd) {
        var activeDate = moment($scope.dateRangeEnd);
        $dates.filter(function (date) {
          return date.localDateValue() >= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };

    $scope.endDateBeforeRender = function ($view, $dates) {
      if ($scope.dateRangeStart) {
        var activeDate = moment($scope.dateRangeStart).subtract(1, $view).add(1, 'minute');
        $dates.filter(function (date) {
          return date.localDateValue() <= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };
  }
})();
/**
 * Created by John on 2017/2/14.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.members')
    .controller('NewMemberActivityCtrl', NewMemberActivityCtrl);

  /** @ngInject */
  function NewMemberActivityCtrl($scope, $filter, ModalsService, member, AjaxRequest) {

    $scope.data = {'memberName': member.name, 'statTime': undefined, 'pgs': 10, 'pgn': 0, 'endTime': undefined};

    $scope.callServer = function (tableState) {
      $scope.tableState = tableState;
      tableState.pagination.numberOfPages = 0;
      $scope.data.pgs = tableState.pagination.number || 10;
      $scope.data.pgn = parseInt(tableState.pagination.start / 10) || 0;

      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.newMemberActivitiesEmpty = false;

      AjaxRequest.path('member/activity').get(
        $scope.data,
        function (data) {
          tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);

          $scope.memberActivities = data.memberActivities;
          if($scope.memberActivities.length == 0){
            $scope.newMemberActivitiesEmpty = true;
          }else{
            $scope.newMemberActivitiesEmpty = false;
          }
          $scope.isLoading = false;
          $scope.getDataError = false;
        },
        function (error) {
          $scope.getDataError = true;
          $scope.isLoading = false;
          $scope.newMemberActivitiesEmpty = false;
          $scope.memberActivities = {};
          ModalsService.handleError(error);
        }
      );
    };

    $scope.resetSearch = function () {
      $scope.startDate = undefined;
      $scope.currentPage = 1;
      $scope.lastPages = [];
      $scope.data = {'memberName': member.name, 'statTime': undefined, 'pgs': 10, 'pgn': 0, 'endTime': undefined};
      $scope.callServer($scope.tableState)
    };

    $scope.startDateOnSetTime = function () {
      $scope.data.startTime = new Date($scope.dateRangeStart).getTime();
      $scope.dateRangeStart = new Date($scope.dateRangeStart).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('start-date-changed');
    };

    $scope.endDateOnSetTime = function () {
      $scope.data.endTime = new Date($scope.dateRangeEnd).getTime();
      $scope.dateRangeEnd = new Date($scope.dateRangeEnd).Format("yyyy-MM-dd HH:mm:ss");
      $scope.$broadcast('end-date-changed');
      $scope.callServer($scope.tableState)
    };

    $scope.startDateBeforeRender = function ($dates) {
      if ($scope.dateRangeEnd) {
        var activeDate = moment($scope.dateRangeEnd);
        $dates.filter(function (date) {
          return date.localDateValue() >= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };

    $scope.endDateBeforeRender = function ($view, $dates) {
      if ($scope.dateRangeStart) {
        var activeDate = moment($scope.dateRangeStart).subtract(1, $view).add(1, 'minute');
        $dates.filter(function (date) {
          return date.localDateValue() <= activeDate.valueOf()
        }).forEach(function (date) {
          date.selectable = false;
        })
      }
    };

  }
})();
/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.factory')
      .controller('DeleteFactoryCtrl', DeleteFactoryCtrl);

  /** @ngInject */
  function DeleteFactoryCtrl($scope, $cookies, $state, factoryId, reloadParams, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_delete';
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('production/factory/' + factoryId).delete('',
          function (data) {
            NotificationsService.openToast('success', 'op_info', 'delete_success', 'toast-top-center');
            $state.go('productionManage.factory', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.factory')
      .controller('EditFactoryCtrl', EditFactoryCtrl);

  /** @ngInject */
  function EditFactoryCtrl($scope, $cookies, $state, $filter, factory, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    if (typeof factory == 'undefined') {
      $scope.isNew = true;
      $scope.data = {'name': '', 'code': '', 'note': ''};
    } else {
      $scope.isNew = false;
      $scope.data = {'name': factory.name, 'code': factory.code, 'note': factory.note};
    }

    $scope.submit = function () {
      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;

      if (!$scope.isNew) {
        AjaxRequest.path('production/factory/' + factory.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('productionManage.factory', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('production/factory').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              NotificationsService.openToast('success', 'op_info', 'create_success', 'toast-top-center');
              $state.go('productionManage.factory', {reloadParams: null}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.errors = false;
    $scope.errName = false;
    $scope.errCode = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errName = false;
      $scope.errCode = false;
    };

    $scope.isNotValidate = function () {
      let name = $scope.data.name;
      let code = $scope.data.code;

      if (Validator.isNotStringValid(name)) {
        $scope.errName = true;
        $scope.errorMessage = Validator.isNotStringValid(name);
        return true;
      }

      if (Validator.isNotStringValid(code)) {
        $scope.errCode = true;
        $scope.errorMessage = Validator.isNotStringValid(code);
        return true;
      }

      return false;
    }

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.factory')
      .controller('FactoryPageCtrl', FactoryPageCtrl);

  /** @ngInject */
  function FactoryPageCtrl($scope, $uibModal, $cookies, $state, ModalsService, AjaxRequest, $stateParams) {
    if (!ACL.hasPermission($cookies, 'get_production_factory')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_production_factory');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_production_factory_%s');
    $scope.DELETE_P = ACL.hasPermission($cookies, 'delete_production_factory_%s');

    $scope.data = {'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if ($stateParams.reloadParams != null) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      AjaxRequest.path('production/factory').get(
          $scope.data,
          function (data) {
            $scope.factoryList = data.factoryList;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.refresh = function(){
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (factory) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/productionManage/factory/editFactory.html',
        controller: 'EditFactoryCtrl',
        size: 'lg',
        resolve: {
          factory: function () {
            return factory;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.deleteConfirm = function (factoryId) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/productionManage/factory/deleteFactory.html',
        controller: 'DeleteFactoryCtrl',
        size: 'sm',
        resolve: {
          factoryId: function () {
            return factoryId;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.plan')
      .controller('EditPlanCtrl', EditPlanCtrl);

  /** @ngInject */
  function EditPlanCtrl($scope, $cookies, $state, $filter, AjaxRequest, reloadParams, NotificationsService, ModalsService) {

    $scope.isNew = true;
    $scope.data = {'productId': '', 'factoryId': '', 'number': '', 'appId': '', 'distributorId': ''};

    $scope.appItems = [];
    $scope.distributorItems = [];
    $scope.factoryItems = [];
    $scope.productItems = [];

    $scope.getPreData = function () {
      function listToSelect(listFrom, listTo) {
        for (let i = 0; i < listFrom.length; i++) {
          listTo.push({label: listFrom[i].name, value: listFrom[i].id});
        }
      }
      AjaxRequest.path('production/plan/predata').get(
          $scope.data,
          function (data) {
            listToSelect(data.appSimpleList, $scope.appItems);
            listToSelect(data.distributorSimpleList, $scope.distributorItems);
            listToSelect(data.factorySimpleList, $scope.factoryItems);
            listToSelect(data.productSimpleList, $scope.productItems);
          },
          function (error) {
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };
    $scope.getPreData();
    $scope.appSelected = $scope.appItems[0];
    $scope.distributorSelected = $scope.distributorItems[0];
    $scope.factorySelected = $scope.factoryItems[0];
    $scope.productSelected = $scope.productItems[0];

    $scope.appIdChange = function (appSelected) {
      $scope.clearError();
      $scope.data.appId = appSelected.value;
    };
    $scope.distributorIdChange = function (distributorSelected) {
      $scope.clearError();
      $scope.data.distributorId = distributorSelected.value;
    };
    $scope.factoryChange = function (factorySelected) {
      $scope.clearError();
      $scope.data.factoryId = factorySelected.value;
    };
    $scope.productChange = function (productSelected) {
      $scope.clearError();
      $scope.data.productId = productSelected.value;
    };

    $scope.submit = function () {
      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;
      AjaxRequest.path('production/plan').post(
          $scope.data,
          function (data) {
            $scope.holdSubmit = false;
            $scope.$dismiss();
            NotificationsService.openToast('success', 'op_info', 'create_success', 'toast-top-center');
            $state.go('productionManage.plan', {reloadParams: null}, {reload: true});
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data != 'undefined' && error.data != null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };


    $scope.errors = false;
    $scope.errProduct = false;
    $scope.errFactory = false;
    $scope.errNumber = false;
    $scope.errApp = false;
    $scope.errDistributor = false;

    $scope.clearError = function () {
      $scope.errProduct = false;
      $scope.errFactory = false;
      $scope.errNumber = false;
      $scope.errApp = false;
      $scope.errDistributor = false;
    };

    $scope.isNotValidate = function () {
      var number = $scope.data.number;

      if (Validator.isNotValidNumber($scope.data.productId)) {
        $scope.errProduct = true;
        $scope.errorMessage = Validator.isNotValidNumber($scope.data.productId, "select_invalid");
        return true;
      }

      if (Validator.isNotValidNumber($scope.data.factoryId)) {
        $scope.errFactory = true;
        $scope.errorMessage = Validator.isNotValidNumber($scope.data.factoryId, "select_invalid");
        return true;
      }

      if (Validator.isNotValidNumber(number)) {
        $scope.errNumber = true;
        $scope.errorMessage = Validator.isNotValidNumber(number);
        return true;
      }

      if (Validator.isNotValidNumber($scope.data.appId)) {
        $scope.errApp = true;
        $scope.errorMessage = Validator.isNotValidNumber($scope.data.appId, "select_invalid");
        return true;
      }

      if (Validator.isNotValidNumber($scope.data.distributorId)) {
        $scope.errDistributor = true;
        $scope.errorMessage = Validator.isNotValidNumber($scope.data.distributorId, "select_invalid");
        return true;
      }

      return false;
    }

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.plan')
      .controller('PlanPageCtrl', PlanPageCtrl);

  /** @ngInject */
  function PlanPageCtrl($scope, $uibModal, $cookies, $state, ModalsService, AjaxRequest, $stateParams, FileSaver, Blob) {
    if (!ACL.hasPermission($cookies, 'get_production_plan')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_production_plan');
    $scope.DOWNLAOD_P = ACL.hasPermission($cookies, 'get_production_plan_%s_serialnumber');

    $scope.data = {'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if ($stateParams.reloadParams != null) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      AjaxRequest.path('production/plan').get(
          $scope.data,
          function (data) {
            $scope.planList = data.planList;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.refresh = function () {
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/productionManage/plan/editPlan.html',
        controller: 'EditPlanCtrl',
        size: 'lg',
        resolve: {
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.download_tc = function () {
      AjaxRequest.path('production/totalcount').get(
          $scope.data,
          function (data) {
            let exportData = [];
            for (let totalCountInfo of data.totalCountList) {
              exportData.push(totalCountInfo.idPrefix + "=" + totalCountInfo.totalCount + "\r\n");
            }
            let fileData = new Blob(exportData, {type: 'text/plain;charset=utf-8'});
            FileSaver.saveAs(fileData, data.fileName);
          },
          function (error) {
            ModalsService.handleError(error);
          }
      );
    };

    $scope.download = function (planId, type) {
      AjaxRequest.path('production/plan/' + planId + "/serialnumber?type=" + type).get(
          $scope.data,
          function (data) {
            let exportData = [];
            for (let serialnumber of data.serialnumberList) {
              exportData.push(serialnumber + "\r\n");
            }
            let fileData = new Blob(exportData, {type: 'text/plain;charset=utf-8'});
            FileSaver.saveAs(fileData, data.fileName);
          },
          function (error) {
            ModalsService.handleError(error);
          }
      );
    };

    $scope.openSerialnumberPage = function (planId, type) {
      AjaxRequest.path('production/plan/' + planId + "/serialnumber?type=" + type).get(
          $scope.data,
          function (data) {
            $uibModal.open({
              animation: true,
              templateUrl: 'app/pages/productionManage/plan/serialnumber.html',
              controller: 'PlanSerialnumberCtrl',
              size: 'lg',
              resolve: {
                serialnumberInfo: function () {
                  return data.serialnumberList;
                }
              }
            });
          },
          function (error) {
            ModalsService.handleError(error);
          }
      );
    }

  }
})();
/**
 * Created by ljf on 2017/2/14.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.plan')
      .controller('PlanSerialnumberCtrl', PlanSerialnumberCtrl);

  /** @ngInject */
  function PlanSerialnumberCtrl($scope, $cookies, serialnumberInfo, AjaxRequest, ModalsService) {
    $scope.serialnumberInfo = JSON.stringify(serialnumberInfo, null, 2);
  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.product')
      .controller('DeleteProductCtrl', DeleteProductCtrl);

  /** @ngInject */
  function DeleteProductCtrl($scope, $cookies, $state, productId, reloadParams, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_delete';
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('production/product/' + productId).delete('',
          function (data) {
            NotificationsService.openToast('success', 'op_info', 'delete_success', 'toast-top-center');
            $state.go('productionManage.product', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.product')
      .controller('EditProductCtrl', EditProductCtrl);

  /** @ngInject */
  function EditProductCtrl($scope, $cookies, $state, $filter, product, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    if (typeof product == 'undefined') {
      $scope.isNew = true;
      $scope.data = {'name': '', 'code': '', 'idPrefix': '', 'firmwarePrefix': '', 'note': ''};
    } else {
      $scope.isNew = false;
      $scope.data = {'name': product.name, 'code': product.code,
        'idPrefix': product.idPrefix, 'firmwarePrefix': product.firmwarePrefix, 'note': product.note};
    }

    $scope.submit = function () {
      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;

      if (!$scope.isNew) {
        AjaxRequest.path('production/product/' + product.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('productionManage.product', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('production/product').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              NotificationsService.openToast('success', 'op_info', 'create_success', 'toast-top-center');
              $state.go('productionManage.product', {reloadParams: null}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.errors = false;
    $scope.errName = false;
    $scope.errCode = false;
    $scope.errIdPrefix = false;
    $scope.errFirmwarePrefix = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errName = false;
      $scope.errCode = false;
      $scope.errIdPrefix = false;
      $scope.errFirmwarePrefix = false;
    };

    $scope.isNotValidate = function () {
      var name = $scope.data.name;
      var code = $scope.data.code;
      var idPrefix = $scope.data.idPrefix;
      var firmwarePrefix = $scope.data.firmwarePrefix;

      if (Validator.isNotStringValid(name)) {
        $scope.errName = true;
        $scope.errorMessage = Validator.isNotStringValid(name);
        return true;
      }

      if (Validator.isNotStringValid(code)) {
        $scope.errCode = true;
        $scope.errorMessage = Validator.isNotStringValid(code);
        return true;
      }

      if (Validator.isNotStringValid(idPrefix)) {
        $scope.errIdPrefix = true;
        $scope.errorMessage = Validator.isNotStringValid(idPrefix);
        return true;
      }

      if (Validator.isNotStringValid(firmwarePrefix)) {
        $scope.errFirmwarePrefix = true;
        $scope.errorMessage = Validator.isNotStringValid(firmwarePrefix);
        return true;
      }

      return false;
    }

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.product')
      .controller('ProductPageCtrl', ProductPageCtrl);

  /** @ngInject */
  function ProductPageCtrl($scope, $uibModal, $cookies, $state, ModalsService, AjaxRequest, $stateParams) {
    if (!ACL.hasPermission($cookies, 'get_production_product')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_production_product');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_production_product_%s');
    $scope.DELETE_P = ACL.hasPermission($cookies, 'delete_production_product_%s');

    $scope.data = {'pgs': 10, 'pgn': 0, "idPrefix": undefined};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      var params = tableState.search.predicateObject;

      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if (typeof params != 'undefined') {
        $scope.data.idPrefix = params.hasOwnProperty('idPrefix') ? params.idPrefix : undefined;
      }

      if ($stateParams.reloadParams != null) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      AjaxRequest.path('production/product').get(
          $scope.data,
          function (data) {
            $scope.productList = data.productList;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.refresh = function(){
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (product) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/productionManage/product/editProduct.html',
        controller: 'EditProductCtrl',
        size: 'lg',
        resolve: {
          product: function () {
            return product;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.deleteConfirm = function (productId) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/productionManage/product/deleteProduct.html',
        controller: 'DeleteProductCtrl',
        size: 'sm',
        resolve: {
          productId: function () {
            return productId;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

  }
})();
/**
 * Created by ljf on 2017/2/14.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.task')
      .controller('SerialnumberJsonPageCtrl', SerialnumberJsonPageCtrl);

  /** @ngInject */
  function SerialnumberJsonPageCtrl($scope, $cookies, serialnumberInfo, AjaxRequest, ModalsService) {

    try {
      $scope.serialnumberInfo = JSON.stringify(JSON.parse(serialnumberInfo), null, 2);
    } catch (e) {
      $scope.serialnumberInfo = JSON.stringify(serialnumberInfo, null, 2);
    }

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.productionManage.product')
      .controller('TaskPageCtrl', TaskPageCtrl);

  /** @ngInject */
  function TaskPageCtrl($scope, $uibModal, $cookies, $state, ModalsService, AjaxRequest, $stateParams) {
    if (!ACL.hasPermission($cookies, 'get_production_task')) {
      $state.go('auth');
      return;
    }

    $scope.data = {'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if ($stateParams.reloadParams != null) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      AjaxRequest.path('production/task').get(
          $scope.data,
          function (data) {
            $scope.taskList = data.taskList;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.refresh = function () {
      $scope.callServer(tempTableState);
    };

    $scope.openFailedPage = function (value) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/productionManage/task/serialnumber.html',
        controller: 'SerialnumberJsonPageCtrl',
        size: 'lg',
        resolve: {
          serialnumberInfo: function () {
            return value;
          }
        }
      });
    };

    $scope.openSerialnumberPage = function (taskId) {
      AjaxRequest.path('production/task/' + taskId + "/serialnumber").get(
          $scope.data,
          function (data) {
            $uibModal.open({
              animation: true,
              templateUrl: 'app/pages/productionManage/task/serialnumber.html',
              controller: 'SerialnumberJsonPageCtrl',
              size: 'lg',
              resolve: {
                serialnumberInfo: function () {
                  return data.serialnumberList;
                }
              }
            });
          },
          function (error) {
            ModalsService.handleError(error);
          }
      );
    }

  }
})();
/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.serverManage.permissions')
      .controller('DeletePermissionCtrl', DeletePermissionCtrl);

  /** @ngInject */
  function DeletePermissionCtrl($scope, $cookies, $state, permissionId, reloadParams, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_delete_permission';
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('permission/' + permissionId).delete('',
          function (data) {
            NotificationsService.openToast('success', 'op_info', 'delete_success', 'toast-top-center');
            $state.go('serverManage.permissions', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.serverManage.permissions')
      .controller('EditPermissionCtrl', EditPermissionCtrl);

  /** @ngInject */
  function EditPermissionCtrl($scope, $cookies, $state, permission, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    if (typeof permission == 'undefined') {
      $scope.isNewPermission = true;
      $scope.data = {'urlRegex': '', 'identification': '', 'group': ''};
    } else {
      $scope.isNewPermission = false;
      $scope.data = {'urlRegex': permission.urlRegex, 'identification': permission.identification, 'group': permission.group};
    }

    $scope.submit = function () {

      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;
      if (!$scope.isNewPermission) {
        AjaxRequest.path('permission/' + permission.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('serverManage.permissions', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('permissions').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'create_success');
              $state.go('serverManage.permissions', {reloadParams: null}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.errors = false;
    $scope.errUrlRegex = false;
    $scope.errIdentification = false;
    $scope.errGroup = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errUrlRegex = false;
      $scope.errIdentification = false;
      $scope.errGroup = false;
    };


    $scope.isNotValidate = function () {
      var urlRegex = $scope.data.urlRegex;
      var identification = $scope.data.identification;
      var group = $scope.data.group;

      if (Validator.isNotStringValid(urlRegex)) {
        $scope.errUrlRegex = true;
        $scope.errorMessage = Validator.isNotStringValid(urlRegex);
        return true;
      }

      if (Validator.isNotStringValid(identification)) {
        $scope.errIdentification = true;
        $scope.errorMessage = Validator.isNotStringValid(identification);
        return true;
      }

      if (Validator.isNotStringValid(group)) {
        $scope.errGroup = true;
        $scope.errorMessage = Validator.isNotValidID(group);
        return true;
      }

      return false;
    }

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.serverManage.permissions')
      .controller('PermissionsPageCtrl', PermissionsPageCtrl);

  /** @ngInject */
  function PermissionsPageCtrl($scope, $uibModal, $cookies, $state, ModalsService, AjaxRequest, $stateParams) {

    if (!ACL.hasPermission($cookies, 'get_permissions')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_permissions');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_permission_%s');
    $scope.DELETE_P = ACL.hasPermission($cookies, 'delete_permission_%s');

    $scope.data = {'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;
      $scope.start = pagination.start;

      if ($stateParams.reloadParams != null) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      AjaxRequest.path('permissions').get(
          $scope.data,
          function (data) {
            $scope.permissions = data.permissions;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.refresh = function(){
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (permission) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/serverManage/permissions/editPermission.html',
        controller: 'EditPermissionCtrl',
        size: 'lg',
        resolve: {
          permission: function () {
            return permission;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.deleteConfirm = function (permissionId) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/serverManage/permissions/deletePermission.html',
        controller: 'DeletePermissionCtrl',
        size: 'sm',
        resolve: {
          permissionId: function () {
            return permissionId;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

  }
})();
/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.serverManage.roles')
      .controller('DeleteRoleCtrl', DeleteRoleCtrl);

  /** @ngInject */
  function DeleteRoleCtrl($scope, $cookies, $state, roleId, reloadParams, AjaxRequest, ModalsService, NotificationsService) {
    $scope.message = 'confirm_to_delete_role';
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('role/' + roleId).delete('',
          function (data) {
            NotificationsService.openToast('success', 'op_info', 'delete_success', 'toast-top-center');
            $state.go('serverManage.roles', {reloadParams: reloadParams}, {reload: true});
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.serverManage.roles')
      .controller('EditRoleCtrl', EditRoleCtrl);

  /** @ngInject */
  function EditRoleCtrl($scope, $cookies, $state, $filter, role, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    AjaxRequest.path('profile').get('',
        function (data) {
          $scope.permissions = data.permissions;
          if (typeof role == 'undefined') {
            $scope.isNewRole = true;
            $scope.permissionTreeData = ACL.getAllPermissionTreeData($filter, $scope.permissions);
            $scope.treeData = $scope.permissionTreeData;
            $scope.basicConfig = treeViewConfig;
            $scope.data = {'name': '', 'description': '', 'permissionIds': ''};
          } else {
            $scope.isNewRole = false;
            var permissionIds = [];
            role.permissions.forEach(function (element) {
              permissionIds.push(element.id);
            });
            $scope.permissionTreeData = ACL.getPermissionTreeDataWithSelect($filter, $scope.permissions, permissionIds);
            $scope.basicConfig = treeViewConfig;
            $scope.treeData = $scope.permissionTreeData;
            $scope.data = {'name': role.name, 'description': role.description, 'permissionIds': permissionIds};
          }
        },
        function (error) {
          ModalsService.handleError(error);
        }
    );


    $scope.submit = function () {

      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;
      if (!$scope.isNewRole) {
        AjaxRequest.path('role/' + role.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_success', 'toast-top-center');
              $scope.$dismiss();
              $state.go('serverManage.roles', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      } else {
        AjaxRequest.path('roles').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              $scope.$dismiss();
              ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'create_success');
              $state.go('serverManage.roles', {reloadParams: null}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
              if (typeof error.data != 'undefined' && error.data != null) {
                var data = error.data;
                if (data.hasOwnProperty('ret')) {
                  $scope.errors = true;
                  $scope.errorMessage = "error_code_" + data.ret;
                }
              }
            }
        );
      }
    };

    $scope.checkNodes = function () {
      var selected = this.basicTree.jstree(true).get_selected();
      var permissionIds = [];
      selected.forEach(function (element) {
        var i = parseInt(element);
        if (!isNaN(i)) {
          permissionIds.push(i);
        }
      });
      $scope.data.permissionIds = permissionIds;
    };

    $scope.errors = false;
    $scope.errName = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errName = false;
    };

    $scope.isNotValidate = function () {
      var name = $scope.data.name;

      if (Validator.isNotStringValid(name)) {
        $scope.errName = true;
        $scope.errorMessage = Validator.isNotStringValid(name);
        return true;
      }
      return false;
    };

    var treeViewConfig = {
      core: {
        multiple: true,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-list'
        },
        'default': {
          'icon': 'ion-android-lock'
        }
      },
      'plugins': ['types', "checkbox"],
      'version': 1
    };

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.serverManage.roles')
      .controller('RolesPageCtrl', RolesPageCtrl);

  /** @ngInject */
  function RolesPageCtrl($scope, $uibModal, $cookies, $state, $timeout, $stateParams, $filter, ModalsService, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_roles')) {
      $state.go('auth');
      return;
    }
    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_roles');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_role_%s');
    $scope.DELETE_P = ACL.hasPermission($cookies, 'delete_role_%s');

    $scope.ignoreChanges = false;
    var number = 1;
    $scope.data = {'pgs': 10, 'pgn': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;

      if ($stateParams.reloadParams != null) {
        $scope.data = $stateParams.reloadParams;
        tableState.pagination.start = $scope.data.pgn * 10;
        $scope.start = pagination.start;
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      AjaxRequest.path('roles').get('',
          function (data) {
            $scope.totalRoles = data.roles;
            $scope.roles = $scope.totalRoles.slice($scope.data.pgn * $scope.data.pgs, ($scope.data.pgn + 1) * $scope.data.pgs);
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.currentPage = $scope.data.pgn+1;
            $scope.total = $scope.totalRoles.length;
            $scope.numPages = Math.ceil($scope.total / $scope.data.pgs);
            $scope.inputPage = $scope.data.pgn+1;
            $scope.pages = {};
            $scope.pages.length = $scope.numPages;
            $scope.isLoading = false;
            $scope.getDataError = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.getDataError = true;
            $scope.isLoading = false;
            if ($stateParams.reloadParams != null) {
              $stateParams.reloadParams = null;
            }
          }
      );
    };

    $scope.selectPage = function (page) {
      if (page > 0 && page <= $scope.numPages) {
        $scope.data.pgs = 10;
        $scope.data.pgn = page - 1;
        $scope.inputPage = page;
        $scope.currentPage = page;
        $scope.roles = $scope.totalRoles.slice($scope.data.pgn * $scope.data.pgs, page * $scope.data.pgs);
      }
    };

    $scope.refresh = function(){
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (role) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/serverManage/roles/editRole.html',
        controller: 'EditRoleCtrl',
        size: 'lg',
        resolve: {
          role: function () {
            return role;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.deleteConfirm = function (roleId) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/serverManage/roles/deleteRole.html',
        controller: 'DeleteRoleCtrl',
        size: 'sm',
        resolve: {
          roleId: function () {
            return roleId;
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.showPermissionPage = function (permissionData) {
      $scope.basicConfig = {
        core: {
          multiple: false,
          check_callback: true,
          worker: true
        },
        'types': {
          'folder': {
            'icon': 'ion-ios-list'
          },
          'default': {
            'icon': 'ion-android-lock'
          }
        },
        'plugins': ['types'],
        'version': number++
      };
      var newSet = new Set();
      permissionData.forEach(function (element) {
        newSet.add(element.group);
      });

      var rootData = [];
      newSet.forEach(function (value) {
        rootData.push({
          id: value,
          parent: '#',
          type: "folder",
          text: $filter('translate')(value),
          state: {opened: true}
        });
      });

      permissionData.forEach(function (element) {
        rootData.push({
          id: element.id,
          parent: element.group,
          text: $filter('translate')(element.identification),
          state: {opened: false}
        });
      });
      $scope.treeData = rootData;
    };

    $scope.applyModelChanges = function () {
      console.log("apply changes");
      return !$scope.ignoreChanges;
    };
    $scope.readyCB = function () {
      console.log("ready cb");
      $timeout(function () {
        $scope.ignoreChanges = false;
      });
    };
    $scope.checkNodes = function () {
      console.log("select node");
      var selected = this.basicTree.jstree(true).get_selected();
      console.log(selected);
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('NetviewAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('NetviewAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, $cookies, $filter, baSidebarService) {

    var allMenuItems = baSidebarService.getMenuItems();
    $scope.menuItems = allMenuItems.filter(function (item) {
      var permissionCheck;
      switch (item.order) {
        case SIDEBAR_ORDER.BM_USER:
          permissionCheck = 'get_bmusers';
          break;
        case SIDEBAR_ORDER.MEMBER:
          permissionCheck = 'get_members';
          break;
        case SIDEBAR_ORDER.DEVICE:
          permissionCheck = 'get_devices';
          break;
        case SIDEBAR_ORDER.FIRMWARE:
          permissionCheck = 'get_firmware_patches';
          break;
        case SIDEBAR_ORDER.APP:
          permissionCheck = 'get_apps';
          break;
        case SIDEBAR_ORDER.DISTRIBUTOR:
          permissionCheck = 'get_distributors';
          break;
        case SIDEBAR_ORDER.CLIENT:
          permissionCheck = 'get_clients';
          break;
        case SIDEBAR_ORDER.CLIENT_VERSION:
          permissionCheck = 'get_clientversions';
          break;
        case SIDEBAR_ORDER.CLIENT_LOG:
          permissionCheck = 'get_clientlogs';
          break;
        case SIDEBAR_ORDER.PRICING:
          permissionCheck = 'get_prices';
          break;
        case SIDEBAR_ORDER.TRANSACTION:
          permissionCheck = 'get_transactions';
          break;
        case SIDEBAR_ORDER.SERVER_MANAGE:
          permissionCheck = 'get_permissions';
          break;
        case SIDEBAR_ORDER.STATISTICS:
          permissionCheck = 'get_statistics';
          break;
        case SIDEBAR_ORDER.MARKETING:
          permissionCheck = 'get_marketing';
          break;
        case SIDEBAR_ORDER.PRODUCTION_MANAGE:
          permissionCheck = 'get_production_product';
          break;
        default:
          permissionCheck = 'NO_P';
      }
      item.title = $filter('translate')(item.title);
      if (item.order === SIDEBAR_ORDER.SERVER_MANAGE || item.order === SIDEBAR_ORDER.PRODUCTION_MANAGE) {
        item.subMenu = item.subMenu.filter(function (item) {
          var childPermissionCheck;
          item.title = $filter('translate')(item.title);
          switch (item.order) {
            case SIDEBAR_SUB_ORDER.ROLES:
              childPermissionCheck = 'get_roles';
              break;
            case SIDEBAR_SUB_ORDER.PERMISSIONS:
              childPermissionCheck = 'get_permissions';
              break;
            case SIDEBAR_SUB_ORDER.SERVER_CONFIGS:
              childPermissionCheck = 'get_server_config';
              break;
            case SIDEBAR_SUB_ORDER.FACTORY:
              childPermissionCheck = 'get_production_factory';
              break;
            case SIDEBAR_SUB_ORDER.PRODUCT:
              childPermissionCheck = 'get_production_product';
              break;
            case SIDEBAR_SUB_ORDER.PLAN:
              childPermissionCheck = 'get_production_plan';
              break;
            case SIDEBAR_SUB_ORDER.TASK:
              childPermissionCheck = 'get_production_task';
              break;
            default:
              childPermissionCheck = 'no_P';
          }
          return ACL.hasPermission($cookies, childPermissionCheck);
        });
        if (item.subMenu.length > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item.order === SIDEBAR_ORDER.STATISTICS) {
        //统计
        item.subMenu = item.subMenu.filter(function (item) {
          var childPermissionCheck;
          item.title = $filter('translate')(item.title);
          switch (item.order) {
            case SIDEBAR_SUB_ORDER.STATISTICS_CHART:
              childPermissionCheck = 'get_statistics_chart';
              break;
            case SIDEBAR_SUB_ORDER.STATISTICS_LOG_LIST:
              childPermissionCheck = 'get_statistics_loglist';
              break;
            case SIDEBAR_SUB_ORDER.STATISTICS_TASK:
              childPermissionCheck = 'get_statistics_tasks';
              break;
            default:
              childPermissionCheck = 'no_P';
          }
          return ACL.hasPermission($cookies, childPermissionCheck);
        });
        if (item.subMenu.length > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (item.order === SIDEBAR_ORDER.MARKETING) {
        //统计
        item.subMenu = item.subMenu.filter(function (item) {
          var childPermissionCheck;
          item.title = $filter('translate')(item.title);
          switch (item.order) {
            case SIDEBAR_SUB_ORDER.PROMOTIONS:
              childPermissionCheck = 'get_promotions';
              break;
            case SIDEBAR_SUB_ORDER.NOTIFICATIONS:
              childPermissionCheck = 'get_client_notification';
              break;
            case SIDEBAR_SUB_ORDER.ADVERTISEMENTS:
              childPermissionCheck = 'get_advertisements';
              break;
            case SIDEBAR_SUB_ORDER.ACTIVITIES:
              childPermissionCheck = 'get_client_activities';
              break;
            case SIDEBAR_SUB_ORDER.FEEDBACK:
              childPermissionCheck = 'get_feedback';
              break;
            default:
              childPermissionCheck = 'no_P';
          }
          return ACL.hasPermission($cookies, childPermissionCheck);
        });
        if (item.subMenu.length > 0) {
          return true;
        } else {
          return false;
        }
      }
      return ACL.hasPermission($cookies, permissionCheck);
    });
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight = $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();
        //获取右侧菜单栏的信息
        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            // return item.level == 0 && item.name!='login';
            return item.level == 0;
          });
          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };
        //从$state拿到注册的ui-router，返回给上面
        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state, $filter) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $filter('translate')($state.current.title);
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'pageTopCtrl'
    };
  }

})();
/**
 * Created by ljf on 2017/1/21.
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .controller('pageTopCtrl', pageTopCtrl);

  /** @ngInject */
  function pageTopCtrl($rootScope, $scope, $cookies, $state, ModalsService, AjaxRequest) {
    $scope.pageTop = {'userName': $cookies.get('userName')};

    $scope.titleName = "Netvue";
    if (!WEB_ENDPOINT.includes("nvts.co")) {
      $scope.titleName = "BM";
    }

    $scope.minePage = function () {
      $state.go('mine');
    };

    $scope.signOut = function () {

      AjaxRequest.path('token').delete(
          '',
          function (data) {
            $cookies.remove('email');
            $cookies.remove('userName');
            $cookies.remove('currentServer');
            $cookies.remove('central_token');
            $cookies.remove('old_token');
            $cookies.remove('local_token');
            $cookies.remove('appId');
            $cookies.remove('distributorId');
            $cookies.remove('isRootApp');
            $cookies.remove('isRootDistributor');
            $cookies.remove('acl');
            $cookies.remove('userId');
            $cookies.remove('permissions');
            $rootScope.$authed = false;
            $state.go('auth');
          },
          function (error) {
            ModalsService.handleError(error);
          }
      );


    }
  }
})();


/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .directive('pageSelect', pageSelect)
      .directive('loadPage',loadPage);

  /** @ngInject */
  function pageSelect() {
    return {
      restrict: 'E',
      template: '<input type="text" class="select-page" ng-model="inputPage" ng-blur="selectPage(inputPage)">',
      link: function (scope, element, attrs) {
        scope.$watch('currentPage', function (c) {
          scope.inputPage = c;
        });
      }
    }
  }

  function loadPage() {
    return {
      restrict: 'E',
      template: '<input type="text" class="select-page" ng-model="inputPage" ng-change="load_page(inputPage)">',
      link: function (scope, element, attrs) {
        scope.$watch('currentPage', function (c) {
          scope.inputPage = c;
        });
      }
    }
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('NetviewAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('NetviewAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * Created by ljf on 2017/2/14.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
    .controller('DeviceMotionCallServiceCtrl', DeviceMotionCallServiceCtrl);

  /** @ngInject */
  function DeviceMotionCallServiceCtrl($scope, $uibModal, $cookies, $filter, deviceInfo, AjaxRequest, ModalsService) {
    $scope.RESET_DEVICE_MOTION_CALL_SERVICE = ACL.hasPermission($cookies, 'delete_device_%s_motion_call_service');

    $scope.serivceStatuses = {"1":"INIT", "2":"IN_TRIAL", "3":"TRIAL_EXPIRED","4":"PURCHASED","5":"PURCHASE_EXPIRED"};

    $scope.isLoading = true;
    $scope.serialNumber = deviceInfo.serialNumber;
    AjaxRequest.path('device/' + deviceInfo.deviceId + '/motioncallservice').get('',
      function (data) {
        $scope.notExist = false;
        $scope.motionCall = data;
        $scope.isLoading = false;
        $scope.hasServiceList = data.services !== undefined && data.services !== null && data.services.length !== 0;
        console.log($scope.hasServiceList);
        if(data.currentService !== undefined){
          $scope.serviceStatus = $scope.serivceStatuses[data.currentService.serviceStatus+""];
        }
      },
      function (error) {
        $scope.$dismiss();
        $scope.isLoading = false;
        ModalsService.handleError(error);
      }
    );

    $scope.resetMotionCallService = function () {
      $scope.$dismiss();
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/devices/modals/motioncall/resetMotionCallService.html',
        controller: 'ResetMotionCallServiceCtrl',
        size: 'sm',
        resolve: {
          deviceId: function () {
            return deviceInfo.deviceId;
          }
        }
      });
    }
  }
})();

/**
 * Created by ljf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.devices')
      .controller('ResetMotionCallServiceCtrl', ResetMotionCallServiceCtrl);

  /** @ngInject */
  function ResetMotionCallServiceCtrl($scope, $cookies, deviceId, AjaxRequest, ModalsService) {
    $scope.message = 'confirm_to_reset_device_service';
    $scope.confirm = function () {
      $scope.$dismiss();
      AjaxRequest.path('device/' + deviceId + '/motioncallservice')
        .delete(
          function (data) {
            ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'device_motion_call_service_reset_success');
          },
          function (error) {
            ModalsService.handleError(error);
          }
      )
    };

  }
})();

/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.childActivities')
      .controller('ChildActivitiesPageCtrl', ChildActivitiesPageCtrl);

  /** @ngInject */
  function ChildActivitiesPageCtrl($scope, $uibModal, $cookies, $state, $stateParams, ModalsService, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_client_activities')) {
      $state.go('auth');
      return;
    }

    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_client_activities');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_client_activities');

    $scope.data = {'title': undefined, 'pgs': 20, 'pgn': 0};
    var tempTableState = null;

    $scope.callServer = function callServer(tableState) {
      tempTableState = tableState;
      var pagination = tableState.pagination;
      $scope.data.pgs = pagination.number || 10;
      $scope.data.pgn = parseInt(pagination.start / 10) || 0;

      if ($stateParams.reloadParams !== null) {
        $scope.data.parentId = $stateParams.reloadParams.parentActivity.id;
        tableState.pagination.start = $scope.data.pgn * 10;
      } else {
        $state.go('marketing.activities', null, {reload: true});
      }

      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.activitiesEmpty = false;
      AjaxRequest.path('marketing/client/activities').get(
          $scope.data,
          function (data) {
            $scope.activities = data.activities;
            tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pgs);
            $scope.isLoading = false;
            $scope.getDataError = false;
            $scope.activitiesEmpty = $scope.activities.length === 0;
          },
          function (error) {
            ModalsService.handleError(error);
            $scope.activities = null;
            $scope.getDataError = true;
            $scope.isLoading = false;
            $scope.activitiesEmpty = false;
          }
      );
    };

    // 以下为页面对应的actions
    $scope.openPublishPage = function (activityId, publishStatus) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/activities/modals/publishActivities.html',
        controller: 'PublishActivitiesCtrl',
        size: 'sm',
        resolve: {
          activityInfo: function () {
            return {
              'parentActivity': $stateParams.reloadParams.parentActivity,
              'activityId': activityId,
              'publishStatus': publishStatus,
              'isTop': false
            };
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.openEditPage = function (activity) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/activities/child/editChildActivity.html',
        controller: 'EditChildActivityCtrl',
        size: 'lg',
        resolve: {
          activityInfo: function () {
            return {
              'parentActivity': $stateParams.reloadParams.parentActivity,
              'activity': activity,
              'isTop': false,
            };
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.openDeletePage = function (activityId, isTop) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/activities/modals/deleteActivities.html',
        controller: 'DeleteActivitiesCtrl',
        size: 'sm',
        resolve: {
          activityInfo: function () {
            return {
              'parentActivity': $stateParams.reloadParams.parentActivity,
              'activityId': activityId,
              'isTop': false,
            };
          },
          reloadParams: function () {
            return $scope.data;
          }
        }
      });
    };

    $scope.goBack = function () {
      $state.go('marketing.activities', null, {reload: true});
    };

    $scope.openInfoPage = function (value) {
      ModalsService.open('app/services/modals/staticModals/infoModal.html', 'mm', value);
    };
  }
})();
/**
 * Created by John on 2017/2/9.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.childActivities')
      .controller('EditChildActivityCtrl', EditChildActivityCtrl);

  function EditChildActivityCtrl($scope, $state, $cookies, activityInfo, AjaxRequest, reloadParams, NotificationsService, ModalsService) {
    if (!ACL.hasPermission($cookies, 'post_client_activities')) {
      $state.go('auth');
      return;
    }
    $scope.displayTypeItems = [
      {label: 'all', value: 'all'},
      {label: 'discovery', value: 'discovery'},
      {label: 'ad', value: 'ad'},
    ];
    $scope.displayTypeSelected = $scope.displayTypeItems[0];

    if (typeof activityInfo.activity === 'undefined') {
      $scope.isNewActivity = true;
      $scope.data = {
        'countryCode': 'all',
        'locale': 'all',
        'title': activityInfo.parentActivity.title,
        'priority': activityInfo.parentActivity.priority,
        'displayType': activityInfo.parentActivity.displayType,
        'imageUrl': activityInfo.parentActivity.imageUrl,
        'targetUrl': activityInfo.parentActivity.targetUrl,
        'description': activityInfo.parentActivity.description,
        "startTime": activityInfo.parentActivity.startTime,
        "endTime": activityInfo.parentActivity.endTime,
        'parentId': activityInfo.parentActivity.id,
        'publish': false,
      };
    } else {
      $scope.isNewActivity = false;
      $scope.data = {
        'countryCode': activityInfo.activity.countryCode,
        'locale': activityInfo.activity.locale,
        'title': activityInfo.activity.title,
        'priority': activityInfo.activity.priority,
        'displayType': activityInfo.activity.displayType,
        'imageUrl': activityInfo.activity.imageUrl,
        'targetUrl': activityInfo.activity.targetUrl,
        'description': activityInfo.activity.description,
        "startTime": activityInfo.activity.startTime,
        "endTime": activityInfo.activity.endTime,
        "publish": activityInfo.activity.publish,
        'parentId': activityInfo.activity.parentId,
      };
    }

    if ($scope.data.displayType === 'discovery') {
      $scope.displayTypeSelected = $scope.displayTypeItems[1];
    } else if ($scope.data.displayType === 'ad') {
      $scope.displayTypeSelected = $scope.displayTypeItems[2];
    } else {
      $scope.displayTypeSelected = $scope.displayTypeItems[0];
    }

    $scope.displayTypeChange = function (displayTypeSelected) {
      $scope.data.displayType = displayTypeSelected.value;
    };

    $scope.submit = function () {
      if ($scope.isNotValidate()) {
        return;
      }
      $scope.holdSubmit = true;
      if ($scope.isNewActivity) {
        AjaxRequest.path('marketing/client/activity').post(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'create_success', 'toast-top-center');
              $scope.$dismiss();

              $state.go('marketing.childActivities', {reloadParams: {'parentActivity': activityInfo.parentActivity}}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
            })
      } else {
        AjaxRequest.path('marketing/client/activity/' + activityInfo.activity.id).put(
            $scope.data,
            function (data) {
              $scope.holdSubmit = false;
              NotificationsService.openToast('success', 'op_info', 'update_success', 'toast-top-center');
              $scope.$dismiss();

              $state.go('marketing.childActivities', {reloadParams: {'parentActivity': activityInfo.parentActivity}}, {reload: true});
            },
            function (error) {
              $scope.holdSubmit = false;
              ModalsService.handleError(error);
            });
      }
      $scope.$dismiss();
    };

    $scope.errors = false;
    $scope.errCountryCode = false;
    $scope.errLocaleCode = false;
    $scope.errImageUrl = false;
    $scope.errTargetUrl = false;

    $scope.clearError = function () {
      $scope.errors = false;
      $scope.errCountryCode = false;
      $scope.errImageUrl = false;
      $scope.errTargetUrl = false;
    };


    $scope.isNotValidate = function () {
      var countryCode = $scope.data.countryCode;
      var locale = $scope.data.locale;
      var imageUrl = $scope.data.imageUrl;
      var targetUrl = $scope.data.targetUrl;

      if (Validator.isNotStringValid(countryCode)) {
        $scope.errCountryCode = true;
        $scope.errorMessage = Validator.isNotStringValid(countryCode);
        return true;
      }

      if (Validator.isNotStringValid(locale)) {
        $scope.errLocaleCode = true;
        $scope.errorMessage = Validator.isNotStringValid(locale);
        return true;
      }

      if (Validator.isNotValidURL(imageUrl)) {
        $scope.errImageUrl = true;
        $scope.errorMessage = Validator.isNotValidURL(imageUrl);
        return true;
      }

      if (Validator.isNotValidURL(targetUrl)) {
        $scope.errTargetUrl = true;
        $scope.errorMessage = Validator.isNotValidURL(targetUrl);
        return true;
      }
      return false;
    };
  }
})();
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.activities')
      .controller('DeleteActivitiesCtrl', DeleteActivitiesCtrl);

  /** @ngInject */
  function DeleteActivitiesCtrl($scope, $state, activityInfo, reloadParams, AjaxRequest, ModalsService) {
    if (activityInfo.isTop) {
      $scope.message = 'confirm_to_delete_all_activities_with_child';
      $scope.confirm = function () {
        $scope.$dismiss();
        AjaxRequest.path('marketing/client/activity/' + activityInfo.activityId).delete(
            function (data) {
              ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'activities_delete_success');
              $state.go('marketing.activities', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              ModalsService.handleError(error);
            }
        )
      };
    } else {
      $scope.message = 'confirm_to_delete_this_activity';
      $scope.confirm = function () {
        $scope.$dismiss();
        AjaxRequest.path('marketing/client/activity/' + activityInfo.activityId).delete(
            function (data) {
              ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'activity_delete_success');
              $state.go('marketing.childActivities', {reloadParams: {'parentActivity': activityInfo.parentActivity}}, {reload: true});
            },
            function (error) {
              ModalsService.handleError(error);
            }
        )
      };
    }
  }
})();

(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.activities')
      .controller('PublishActivitiesCtrl', PublishActivitiesCtrl);

  /** @ngInject */
  function PublishActivitiesCtrl($scope, $state, activityInfo, reloadParams, AjaxRequest, ModalsService) {
    if (activityInfo.isTop) {
      if (activityInfo.publishStatus) {
        $scope.message = 'confirm_to_publish_all_activities_with_child';
      } else {
        $scope.message = 'confirm_to_cancel_publish_all_activities_with_child';
      }
      $scope.confirm = function () {
        $scope.$dismiss();
        AjaxRequest.path('marketing/client/activity/' + activityInfo.activityId + '/publish').put(
            {"publish": activityInfo.publishStatus},
            function (data) {
              if (activityInfo.publishStatus) {
                ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'activities_publish_success');
              } else {
                ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'activities_cancel_publish_success');
              }

              $state.go('marketing.activities', {reloadParams: reloadParams}, {reload: true});
            },
            function (error) {
              ModalsService.handleError(error);
            }
        )
      };
    } else {

      if (activityInfo.publishStatus) {
        $scope.message = 'confirm_to_publish_this_activity';
      } else {
        $scope.message = 'confirm_to_cancel_publish_this_activity';
      }

      $scope.confirm = function () {
        $scope.$dismiss();
        AjaxRequest.path('marketing/client/activity/' + activityInfo.activityId + '/publish').put(
            {"publish": activityInfo.publishStatus},
            function (data) {

              if (activityInfo.publishStatus) {
                ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'activity_publish_success');
              } else {
                ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'activity_cancel_publish_success');
              }
              $state.go('marketing.childActivities', {reloadParams: {'parentActivity': activityInfo.parentActivity}}, {reload: true});
            },
            function (error) {
              ModalsService.handleError(error);
            }
        )
      };
    }
  }
})();

(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.activities')
      .controller('MockClientQueryCtrl', MockClientQueryCtrl);

  /** @ngInject */
  function MockClientQueryCtrl($scope, $filter, $cookies, ModalsService, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_client_activities')) {
      $state.go('auth');
      return;
    }
    $scope.groupItems = [
      {label: $filter('translate')('discovery'), value: 1},
      {label: $filter('translate')('ad'), value: 2},
    ];
    $scope.groupSelected = $scope.groupItems[0];

    $scope.data = {
      'countryCode': undefined,
      'locale': undefined,
      "group": 1,
    };

    $scope.callServer = function callServer() {
      $scope.data.group = $scope.groupSelected.value;
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.logsEmpty = false;
      $scope.holdSubmit = true;

      AjaxRequest.path('marketing/client/activities/mock').get(
          $scope.data,
          function (data) {
            $scope.isLoading = false;
            $scope.getDataError = false;
            $scope.mockClientActivities = data.activities;
            $scope.logsEmpty = $scope.mockClientActivities.length === 0;
            $scope.holdSubmit = false;
          },
          function (error) {
            $scope.isLoading = false;
            $scope.getDataError = true;
            $scope.logsEmpty = false;
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
          }
      )
    };

    $scope.openInfoPage = function (value) {
      ModalsService.open('app/services/modals/staticModals/infoModal.html', 'mm', value);
    };

    $scope.resetSearch = function () {
      $scope.data = {
        'countryCode': undefined,
        'locale': undefined,
        "group": undefined,
      };

      $scope.callServer()
    };
  }

})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.advertisements')
    .controller('ShowImageCtrl', ShowImageCtrl);

  /** @ngInject */
  function ShowImageCtrl($scope, $uibModal, $cookies, $state, $filter, $stateParams, adPic, ModalsService, AjaxRequest) {
    $scope.adPicUrl = adPic;
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.coupons',
    ['pascalprecht.translate',
      'ngResource',
      'ngCookies',
      'ui.router'])
    .controller('CouponsPageCtrl', CouponsPageCtrl);

  /** @ngInject */
  function CouponsPageCtrl($scope, $uibModal, $cookies, $state, $filter, $stateParams,
                           activityId, activityStatus, NotificationsService, ModalsService, AjaxRequest) {

    if (!ACL.hasPermission($cookies, 'get_coupons')) {
      $state.go('auth');
      return;
    }
    var ACTIVITY_STATUS_PUBLISHED = 'PUBLISHED';
    var ACTIVITY_STATUS_REMOVED = 'REMOVED';
    $scope.couponChangeable = activityStatus !== ACTIVITY_STATUS_PUBLISHED && activityStatus !== ACTIVITY_STATUS_REMOVED;

    $scope.WRITE_P = ACL.hasPermission($cookies, 'post_coupon');
    $scope.EDIT_P = ACL.hasPermission($cookies, 'put_coupon');
    $scope.DELETE_P = ACL.hasPermission($cookies, 'delete_coupon');

    $scope.coupon = {
      'id': undefined,
      'couponType': 0,
      'purchaseRestrictionType': 1,
      'canObtainMultiTimes': false,
      'deviceBind': false,
      'cumulativeUse': false,
      'currency': 0,
      'concessionalDays': 0,
      'concessionalCashInCents': 0,
      'discount': 0.0,
      'minDaysForServiceTakeEffect': 0,
      'minCentsForCashToTakeEffect': 0,
      'minCentsForDiscountToTakeEffect': 0,
      'daysToExpire':30,
      'createTime': undefined,
      'activityId': undefined
    };
    $scope.isNewCoupon = false;
    $scope.data = {'pgs': 10, 'pgn': 0};
    var tempTableState = null;
    $scope.showEditView = false;


    $scope.couponTypes = [
      {label: $filter('translate')('service_coupon'), value: 0},
      {label: $filter('translate')('cash_coupon'), value: 1},
      {label: $filter('translate')('discount_coupon'), value: 2}
    ];
    $scope.couponTypeSelected = $scope.couponTypes[0];

    $scope.purchaseRestrictionTypes = [
      {label: $filter('translate')('ALL'), value: 0},
      {label: $filter('translate')('cloud_record_service'), value: 1},
      {label: $filter('translate')('full_record_service'), value: 2}
    ];
    $scope.purchaseRestrictionTypeSelected = $scope.purchaseRestrictionTypes[1];

    $scope.currencyTypes = [
      {label: $filter('translate')('unknown'), value: 0},
      {label: $filter('translate')('USD'), value: 1},
      {label: $filter('translate')('CNY'), value: 2}
    ];
    $scope.currencySelected = $scope.currencyTypes[0];

    $scope.booleans = [
      {label: $filter('translate')('boolean_false'), value: false},
      {label: $filter('translate')('boolean_true'), value: true}
    ];

    $scope.deviceBindSelected = $scope.booleans[0];
    $scope.cumulativeUseSelected = $scope.booleans[0];

    $scope.callServer = function callServer(tableState) {
      AjaxRequest.path('marketing/' + activityId + '/coupons').get(
        $scope.data,
        function (response) {
          $scope.coupons = response.coupons;
          $scope.getDataError = false;
          $scope.isLoading = false;
        },
        function (error) {
          ModalsService.handleError(error);
          $scope.coupons = null;
          $scope.getDataError = true;
          $scope.isLoading = false;
          if ($stateParams.reloadParams !== null) {
            $stateParams.reloadParams = null;
          }
        }
      );
    };

    $scope.refresh = function () {
      $scope.callServer(tempTableState);
    };

    $scope.openEditPage = function (coupon) {

      $scope.purchaseRestrictionTypeSelected = $scope.purchaseRestrictionTypes[1];
      $scope.couponTypeSelected = $scope.couponTypes[0];
      $scope.deviceBindSelected = $scope.booleans[0];
      $scope.cumulativeUseSelected = $scope.booleans[0];
      $scope.currencySelected = $scope.currencyTypes[0];

      if (coupon === undefined) {
        $scope.isNewCoupon = true;
        $scope.coupon = {
          'id': undefined,
          'couponType': 0,
          'purchaseRestrictionType': 1,
          'maxObtainCount': 1,
          'deviceBind': false,
          'cumulativeUse': false,
          'currency': 0,
          'concessionalDays': 0,
          'concessionalCashInCents': 0,
          'discount': 0.0,
          'minDaysForServiceTakeEffect': 0,
          'minCentsForCashToTakeEffect': 0,
          'minCentsForDiscountToTakeEffect': 0,
          'daysToExpire':30,
          'createTime': undefined,
          'activityId': undefined
        };
      } else {
        $scope.isNewCoupon = false;
        $scope.coupon = {
          'id': coupon.id,
          'couponType': coupon.couponType,
          'purchaseRestrictionType': coupon.purchaseRestrictionType,
          'maxObtainCount': coupon.maxObtainCount,
          'deviceBind': coupon.deviceBind,
          'cumulativeUse': coupon.cumulativeUse,
          'currency': coupon.currency,
          'concessionalDays': coupon.concessionalDays,
          'concessionalCashInCents': coupon.concessionalCashInCents,
          'discount': coupon.discount,
          'minDaysForServiceTakeEffect': coupon.minDaysForServiceTakeEffect,
          'minCentsForCashToTakeEffect': coupon.minCentsForCashToTakeEffect,
          'minCentsForDiscountToTakeEffect': coupon.minCentsForDiscountToTakeEffect,
          'createTime': coupon.createTime,
          'daysToExpire':coupon.daysToExpire,
          'activityId': activityId
        };
      }

      for (var i = 0; i < $scope.couponTypes.length; i++) {
        if ($scope.couponTypes[i].value === $scope.coupon.couponType) {
          $scope.couponTypeSelected = $scope.couponTypes[i];
          break;
        }
      }

      for (var i = 0; i < $scope.purchaseRestrictionTypes.length; i++) {
        if ($scope.purchaseRestrictionTypes[i].value === $scope.coupon.purchaseRestrictionType) {
          $scope.purchaseRestrictionTypeSelected = $scope.purchaseRestrictionTypes[i];
          break;
        }
      }

      if ($scope.coupon.deviceBind) {
        $scope.deviceBindSelected = $scope.booleans[1];
      }
      if ($scope.coupon.cumulativeUse) {
        $scope.cumulativeUseSelected = $scope.booleans[1];
      }

      for (var i = 0; i < $scope.currencyTypes.length; i++) {
        if ($scope.currencyTypes[i].value === $scope.coupon.currency) {
          $scope.currencySelected = $scope.currencyTypes[i];
          break;
        }
      }
      $scope.showEditView = true;
    };

    $scope.createNewCoupon = function () {
      $scope.coupon.activityId = activityId;
      AjaxRequest.path('marketing/coupon').post(
        $scope.coupon,
        function (data) {
          NotificationsService.openToast('success', 'op_info', 'create_coupon_success', 'toast-top-center');
          $scope.refresh();
          $scope.showEditView = false;
        },
        function (error) {
          ModalsService.handleError(error);
          if (typeof error.data !== 'undefined' && error.data !== null) {
            var data = error.data;
            if (data.hasOwnProperty('ret')) {
              $scope.errors = true;
              $scope.errorMessage = "error_code_" + data.ret;
            }
          }
        }
      );
    };

    $scope.updateCoupon = function () {
      AjaxRequest.path('marketing/coupon').put(
        $scope.coupon,
        function (data) {
          ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'update_coupon_success');
          $scope.refresh();
          $scope.showEditView = false;
        },
        function (error) {
          ModalsService.handleError(error);
          if (typeof error.data !== 'undefined' && error.data !== null) {
            var data = error.data;
            if (data.hasOwnProperty('ret')) {
              $scope.errors = true;
              $scope.errorMessage = "error_code_" + data.ret;
            }
          }
        }
      );
    };

    $scope.deleteCouponConfirm = function (couponId) {

      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/marketing/promotions/coupons/deleteCouponConfirm.html',
        controller: 'DeleteCouponCtrl',
        size: 'sm',
        resolve: {
          couponId:function () {
            return couponId;
          },
          couponsPageCtrlScope: function () {
            return $scope;
          }
        }
      });
    };

    $scope.hideEditView = function () {
      $scope.showEditView = false;
    };

    $scope.createOrUpdate = function () {
      if($scope.isNewCoupon){
        $scope.createNewCoupon()
      }else{
        $scope.updateCoupon()
      }
    };

    $scope.couponTypeChanged = function (couponTypeSelected) {
      $scope.coupon.couponType = couponTypeSelected.value;
    };

    $scope.purchaseRestrictionTypeChanged = function (purchaseRestrictionTypeSelected) {
      $scope.coupon.purchaseRestrictionType = purchaseRestrictionTypeSelected.value;
    };

    $scope.deviceBindChanged = function (deviceBindSelected) {
      $scope.coupon.deviceBind = deviceBindSelected.value;
    };

    $scope.cumulativeUseChanged = function (cumulativeUseSelected) {
      $scope.coupon.cumulativeUse = cumulativeUseSelected.value;
    };
    $scope.currencyChanged = function (currencySelected) {
      $scope.coupon.currency = currencySelected.value;
    }

    $scope.discountChanged = function () {
      if ($scope.coupon.discount > 100) {
        $scope.coupon.discount = 100
      }
      if ($scope.coupon.discount < 0) {
        $scope.coupon.discount = 0;
      }
    }
  }
})();
/**
 * Created by sf
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.coupons')
    .controller('DeleteCouponCtrl', DeleteCouponCtrl);

  /** @ngInject */
  function DeleteCouponCtrl($scope, couponId, couponsPageCtrlScope, ModalsService, AjaxRequest) {
    $scope.deleteCoupon = function () {
      AjaxRequest.path('marketing/coupon?couponId=' + couponId).delete(
        function (data) {
          ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'delete_coupon_success');
          $scope.$dismiss();
          couponsPageCtrlScope.refresh();
          couponsPageCtrlScope.showEditView = false;
        },
        function (error) {
          ModalsService.handleError(error);
          $scope.$dismiss();
          couponsPageCtrlScope.$dismiss();
          if (typeof error.data !== 'undefined' && error.data !== null) {
            var data = error.data;
            if (data.hasOwnProperty('ret')) {
              $scope.errors = true;
              $scope.errorMessage = "error_code_" + data.ret;
            }
          }
        }
      );
    }
  }
})();
/**
 * Created by ljf.
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.marketing.promotions')
      .controller('EditPromotionDetailsCtrl', EditPromotionDetailsCtrl);

  /** @ngInject */
  function EditPromotionDetailsCtrl($scope, $filter, activityId, activityType, editable,
                                    FileUploader, AjaxRequest, NotificationsService, ModalsService) {

    $scope.needRule = activityType === 'GET_COUPONS_VIA_COMMENT';
    $scope.shortUrlPrefix = "https://centralweb.nvts.co/v1/redirect?shortUrlKey=";
    $scope.S3_IMAGE_BUCKET = "resource-us-east-1";
    $scope.ACTIVITY_CLOUD_FRONT = "https://resource-us-east-1.s3.amazonaws.com/";

    $scope.languages = [
      {label: $filter('translate')('language_zh_hans'), value: 'zh-Hans'},
      {label: $filter('translate')('language_zh_hant'), value: 'zh-Hant'},
      {label: $filter('translate')('language_en'), value: 'en'},
      {label: $filter('translate')('language_es'), value: 'es'},
      {label: $filter('translate')('language_fr'), value: 'fr'},
      {label: $filter('translate')('language_pt'), value: 'pt'},
      {label: $filter('translate')('language_de'), value: 'de'},
      {label: $filter('translate')('language_it'), value: 'it'},
      {label: $filter('translate')('language_ja'), value: 'ja'},
      {label: $filter('translate')('language_ru'), value: 'ru'}
    ];

    $scope.linkTypes = [
      {label: $filter('translate')('link_type_nornal'), value: false},
      {label: $filter('translate')('link_type_based_on_location'), value: true}
    ];

    $scope.allAvaliableCountryCodes = [
      {label: $filter('translate')("CN"), value: "CN"},
      {label: $filter('translate')("US"), value: "US"},
      {label: $filter('translate')("GB"), value: "GB"},
      {label: $filter('translate')("CA"), value: "CA"},
      {label: $filter('translate')("NZ"), value: "NZ"},
      {label: $filter('translate')("AU"), value: "AU"},
      {label: $filter('translate')("DE"), value: "DE"},
      {label: $filter('translate')("FR"), value: "FR"},
      {label: $filter('translate')("RU"), value: "RU"},
      {label: $filter('translate')("IE"), value: "IE"},
      {label: $filter('translate')("IT"), value: "IT"},
      {label: $filter('translate')("FI"), value: "FI"},
      {label: $filter('translate')("JP"), value: "JP"},
      {label: $filter('translate')("NL"), value: "NL"},
      {label: $filter('translate')("BR"), value: "BR"},
      {label: $filter('translate')("SG"), value: "SG"},
      {label: $filter('translate')("OTHER"), value: "OTHER"}
    ];

    var uploadFormData = {
      "key": "test",
      "acl": "private",
      "success_action_redirect": "/mine",
      "X-Amz-Credential": "",
      "X-Amz-Algorithm": "",
      "X-Amz-Date": "",
      "Policy": "",
      "X-Amz-Signature": ""
    };
    var queryData = {
      'successAction': '/mine',
      'fileName': '',
      'bucket': $scope.S3_IMAGE_BUCKET,
      'version': '',
      'ucid': 'f57ad0e472'
    };
    var uploader = $scope.uploader = new FileUploader({
      formData: [uploadFormData],
      alias: "file",
      method: "POST"
    });

    resetAll();

    $scope.callServer = function () {
      AjaxRequest.path('marketing/activity/detail').get(
          {"activityId": activityId},
          function (data) {
            $scope.details = data;
            updateLanguagesLeft(Object.keys($scope.details))
          },
          function (error) {
          }
      );
    };
    $scope.callServer();

    $scope.submit = function () {

      if (!$scope.validParamPassed()) {
        return;
      }

      $scope.newDetail.locale = $scope.languageSelected.value;
      $scope.holdSubmit = true;
      AjaxRequest.path('marketing/activity/detail').post(
          $scope.newDetail,
          function (data) {
            $scope.holdSubmit = false;
            resetAll();
            ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'create_activity_detail_success');
            $scope.callServer();
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data !== 'undefined' && error.data !== null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };

    $scope.deleteDetail = function (locale) {
      $scope.holdSubmit = true;
      $scope.newDetail.locale = $scope.languageSelected.value;
      AjaxRequest.path('marketing/activity/detail').delete(
          {"activityId": activityId, "locale": locale},
          function (data) {
            $scope.holdSubmit = false;
            ModalsService.open('app/services/modals/staticModals/successModal.html', 'sm', 'delete_activity_detail_success');
            $scope.callServer();
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
            if (typeof error.data !== 'undefined' && error.data !== null) {
              var data = error.data;
              if (data.hasOwnProperty('ret')) {
                $scope.errors = true;
                $scope.errorMessage = "error_code_" + data.ret;
              }
            }
          }
      );
    };

    $scope.validParamPassed = function () {

      if (isNullOrEmpty($scope.newDetail.title)) {
        NotificationsService.openToast('warning', 'op_info', 'activity_detail_invalid', 'toast-top-center');
        return false
      }

      if (activityType === 'GET_COUPONS_VIA_COMMENT' && !$scope.isJsonStr($scope.newDetail.rule)) {
        NotificationsService.openToast('warning', 'op_info', 'activity_rule_invalid', 'toast-top-center');
        return false;
      }

      if (!$scope.newDetail.isLocationBasedLink) {
        $scope.newDetail.imageUrl = $scope.imageUrl;
      }

      if (isNullOrEmpty($scope.newDetail.imageUrl)
          || isNullOrEmpty($scope.newDetail.target)) {
        NotificationsService.openToast('warning', 'op_info', 'target_or_imageUrl_is_invalid', 'toast-top-center');
        return false;
      }

      if ($scope.newDetail.isLocationBasedLink) {
        if ($scope.targetLocaltionBasedUrl.locationUrls.length === 0
            || $scope.imageLocationBaseUrl.locationUrls.length === 0) {
          NotificationsService.openToast('warning', 'op_info', 'at_least_has_no_location_url', 'toast-top-center');
          return false;
        }
      }
      return true;
    };

    $scope.isJsonStr = function (stringToBeVerified) {
      try {
        JSON.parse(stringToBeVerified);
        return true;
      } catch (e) {
        return false;
      }
    };

    function isNullOrEmpty(string) {
      return string === undefined || string === null || string === '';
    }

    $scope.languageChanged = function (languageSelected) {
      $scope.languageSelected = languageSelected;
    };

    $scope.linkTypeChanged = function (linkTypeSelected) {
      $scope.linkTypeSelected = linkTypeSelected;
      $scope.newDetail.isLocationBasedLink = linkTypeSelected.value;
      $('#adImage').val(null);
      $scope.newDetail.imageUrl = undefined;
      uploader.removeFromQueue(uploader.queue[0]);
    };

    $scope.openOrCloseEditor = function () {
      $scope.addLanguageDetail = !$scope.addLanguageDetail;
      if ($scope.addLanguageDetail) {
        $scope.openOrCloseEditorView = 'close_editor';
      } else {
        $scope.openOrCloseEditorView = 'open_editor';
      }
    };

    Array.prototype.remove = function (val) {
      var index = this.indexOf(val);
      if (index > -1) {
        this.splice(index, 1);
      }
    };
    $scope.deleteLocationUrl = function (localtionUrl) {
      $scope.locationUrlsForShow.remove(localtionUrl);
      updateUrls();
      updateImageUrls()
    };

    $scope.addNewLocationUrl = function () {
      $scope.newDetail.imageUrl = $scope.imageUrl;
      if (isNullOrEmpty($scope.newUrl)
          || isNullOrEmpty($scope.newDetail.imageUrl)) {
        NotificationsService.openToast('warning', 'op_info', 'target_or_imageUrl_is_invalid', 'toast-top-center');
        return;
      }
      var newOne = {
        "countryCode": $scope.countryCodeSelected.value,
        "url": $scope.newUrl,
        "urlForShow": $scope.newUrl.length <= 30 ? $scope.newUrl : $scope.newUrl.substring(0, 30),
        "imageUrl": $scope.imageUrl,
        "imageUrlForShow": $scope.imageUrl.length <= 30 ? $scope.imageUrl : $scope.imageUrl.substring(0, 30)
      };
      if ($scope.locationUrlsForShow === undefined) {
        $scope.locationUrlsForShow = [];
      }
      $scope.locationUrlsForShow.push(newOne);

      updateUrls();
      updateImageUrls();
      $('#adImage').val(null);
      uploader.removeFromQueue(uploader.queue[0]);
      $scope.newUrl = undefined;
      $scope.imageUrl = undefined;
    };


    function resetAll() {
      $scope.newDetail = {
        "activityId": activityId,
        "locale": undefined,
        "title": undefined,
        "description": "",
        "imageUrl": undefined,
        "target": undefined,
        "isLocationBasedLink": false,
        "rule": "{}"
      };
      $scope.targetLocaltionBasedUrl = {"shortUrlKey": undefined, "locationUrls": []};
      $scope.imageLocationBaseUrl = {"shortUrlKey": undefined, "locationUrls": []};
      updateCountryCodes();

      $scope.editable = editable;
      $scope.languagesLeft = $scope.languages;
      $scope.languagesUsed = [];
      $scope.languageSelected = $scope.languagesLeft[0];
      $scope.addLanguageDetail = false;
      $scope.openOrCloseEditorView = "open_editor";
      $scope.linkTypeSelected = $scope.linkTypes[0];
      $scope.locationUrlsForShow = undefined;
      if (uploader.queue !== undefined && uploader.queue.length > 0) {
        uploader.removeFromQueue(uploader.queue[0]);
      }
      $('#adImage').val(null);
      $scope.imageUrl = undefined;
    }

    function updateUrls() {
      convertLocationUrlsForRequest();
      $scope.isAddingLocationUrl = true;
      if ($scope.targetLocaltionBasedUrl.shortUrlKey === undefined) {
        AjaxRequest.path("marketing/advertisement/shorturl").post($scope.targetLocaltionBasedUrl,
            function (data) {
              $scope.targetLocaltionBasedUrl = data;
              $scope.newDetail.target = $scope.shortUrlPrefix + data.shortUrlKey;
              updateCountryCodes();
              $scope.isAddingLocationUrl = false;
            }, function (error) {
              $scope.isAddingLocationUrl = false;
              ModalsService.handleError(error);
            });
      } else {
        AjaxRequest.path("marketing/advertisement/shorturl").put($scope.targetLocaltionBasedUrl,
            function (data) {
              $scope.targetLocaltionBasedUrl = data;
              updateCountryCodes();
              $scope.isAddingLocationUrl = false;
            }, function (error) {
              $scope.isAddingLocationUrl = false;
              ModalsService.handleError(error);
            });
      }
    }

    function updateImageUrls() {
      convertImageUrlLocationUrlsForRequest();
      if ($scope.imageLocationBaseUrl.shortUrlKey === undefined) {
        AjaxRequest.path("marketing/advertisement/shorturl").post($scope.imageLocationBaseUrl,
            function (data) {
              $scope.imageLocationBaseUrl = data;
              $scope.newDetail.imageUrl = $scope.shortUrlPrefix + data.shortUrlKey;
            }, function (error) {
              ModalsService.handleError(error);
            });
      } else {
        AjaxRequest.path("marketing/advertisement/shorturl").put($scope.imageLocationBaseUrl,
            function (data) {
              if ($scope.newDetail.isLocationBasedLink) {
                $scope.newDetail.imageUrl = $scope.shortUrlPrefix + data.shortUrlKey;
              }
              $scope.imageLocationBaseUrl = data;
            }, function (error) {
              ModalsService.handleError(error);
            });
      }
    }

    $scope.invalidImage = false;
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function (item, options, deferred) {
        if (window.FileReader) {
          var reader = new FileReader();
          reader.readAsDataURL(item);
          //监听文件读取结束后事件
          reader.onloadend = function (e, isRight) {
            var img = document.getElementById("loc_img");
            img.src = e.target.result;
            img.onload = function () {
              setTimeout(deferred.resolve, 1e3);
              return true;
            };
          };
        }
      }
    });
    uploader.onAfterAddingFile = function (fileItem) {
      if (uploader.queue.length > 1) {
        uploader.removeFromQueue(uploader.queue[0]);
      }
      queryData.fileName = "client_configuration/activities/" + new Date().getTime() + "/" + fileItem.file.name;
      $scope.uploadImageUrl = queryData.fileName;
      $('#adImage').val(null);
      getAuthorization(fileItem);
    };
    uploader.onSuccessItem = function (fileItem, response, status, headers) {
      $scope.imageUrl = $scope.ACTIVITY_CLOUD_FRONT + $scope.uploadImageUrl;
      $scope.$emit('showInfoModal', {
        'langcontent': 'file_upload_success'
      });
      $scope.uploadSuccess = true;
    };
    uploader.onErrorItem = function (fileItem, response, status, headers) {
      $scope.$emit('showInfoModal', {
        'langcontent': 'file_upload_error'
      });
      $scope.uploadSuccess = false;
    };

    function updateLanguagesLeft(languagesAlreadyUsed) {
      if (languagesAlreadyUsed === undefined
          || languagesAlreadyUsed.length === 0) {
        return;
      }
      $scope.languagesLeft = [];
      $scope.languagesUsed = [];
      var flagMap = new Map();
      for (var i = 0; i < languagesAlreadyUsed.length; i++) {
        for (var j = 0; j < $scope.languages.length; j++) {
          if ($scope.languages[j].value === languagesAlreadyUsed[i]
              && !flagMap.has(languagesAlreadyUsed[i])) {
            flagMap.set(languagesAlreadyUsed[i], true)
          }
        }
      }
      for (j = 0; j < $scope.languages.length; j++) {
        if (!flagMap.has($scope.languages[j].value)) {
          $scope.languagesLeft.push($scope.languages[j]);
        } else {
          $scope.languagesUsed.push($scope.languages[j]);
        }
      }
      if ($scope.languagesLeft.length === 0) {
        $scope.languageSelected = undefined;
      } else {
        $scope.languageSelected = $scope.languagesLeft[0];
      }
    }

    function getAuthorization(fileItem) {
      $scope.notReady = true;
      AjaxRequest.path('s3/signature').get(
          queryData,
          function (data) {
            fileItem.url = data.url;
            fileItem.formData[0]["key"] = data.key;
            fileItem.formData[0]["acl"] = data.acl;
            fileItem.formData[0]["X-Amz-Credential"] = data.credential;
            fileItem.formData[0]["X-Amz-Algorithm"] = data.algorithm;
            fileItem.formData[0]["X-Amz-Date"] = data.date;
            fileItem.formData[0]["Policy"] = data.policy;
            fileItem.formData[0]["X-Amz-Signature"] = data.signature;
            $scope.notReady = false;
          },
          function (error) {
          }
      );
    }

    function updateCountryCodes() {
      $scope.countryCodesCanBeAdded = getCounrtyCodeCanBeAdded($scope.targetLocaltionBasedUrl.locationUrls);
      if ($scope.countryCodesCanBeAdded.length > 0) {
        $scope.countryCodeSelected = $scope.countryCodesCanBeAdded[0];
      } else {
        $scope.countryCodeSelected = undefined;
      }
    }

    function getCounrtyCodeCanBeAdded(locationUrls) {
      var countryCodeCountMap = {};
      for (var j = 0; j < $scope.allAvaliableCountryCodes.length; j++) {
        countryCodeCountMap[$scope.allAvaliableCountryCodes[j].value] = false;
      }

      for (j = 0; j < locationUrls.length; j++) {
        if (inAllCountryCodes(locationUrls[j].countryCode)) {
          countryCodeCountMap[locationUrls[j].countryCode] = true;
        }
      }

      var countryCodesToBeAdded = [];

      for (j = 0; j < $scope.allAvaliableCountryCodes.length; j++) {
        if (countryCodeCountMap[$scope.allAvaliableCountryCodes[j].value] === false) {
          countryCodesToBeAdded.push($scope.allAvaliableCountryCodes[j]);
        }
      }

      return countryCodesToBeAdded;
    }

    function inAllCountryCodes(countryCode) {
      if (countryCode === undefined) {
        return false;
      }
      for (var i = 0; i < $scope.allAvaliableCountryCodes.length; i++) {
        if ($scope.allAvaliableCountryCodes[i].value === countryCode) {
          return true;
        }
      }
      return false;
    }

    function convertLocationUrlsForRequest() {
      var urlsForRequest = [];
      for (var i = 0; i < $scope.locationUrlsForShow.length; i++) {
        var locationUrl = $scope.locationUrlsForShow[i];
        urlsForRequest.push(
            {
              "countryCode": locationUrl.countryCode,
              "url": locationUrl.url
            });
      }
      $scope.targetLocaltionBasedUrl.locationUrls = urlsForRequest;
    }

    function convertImageUrlLocationUrlsForRequest() {
      var urlsForRequest = [];
      for (var i = 0; i < $scope.locationUrlsForShow.length; i++) {
        var locationUrl = $scope.locationUrlsForShow[i];
        urlsForRequest.push(
            {
              "countryCode": locationUrl.countryCode,
              "url": locationUrl.imageUrl
            });
      }
      $scope.imageLocationBaseUrl.locationUrls = urlsForRequest;
    }
  }
})();

(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.statistics.charts')
      .controller('DeviceStatisticsChartCtrl', DeviceStatisticsChartCtrl);

  function DeviceStatisticsChartCtrl($scope, $filter, $cookies, $state, ModalsService, layoutPaths, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_statistics_chart')) {
      $state.go('auth');
      return;
    }
    $scope.logTypeItems = [
      {label: $filter('translate')('DeviceOnlineCount'), value: 'DeviceOnlineCount'},
      {label: $filter('translate')('DeviceStatistics'), value: 'DeviceStatistics'}
    ];
    $scope.logTypeSelected = $scope.logTypeItems[0];

    $scope.changeLogType = function (logTypeSelected) {
      $scope.requestData.logType = logTypeSelected.value;
      $scope.callServer();
    };

    $scope.requestData = {'logType': $scope.logTypeItems[0].value};

    $scope.callServer = function () {
      $scope.holdSubmit = true;
      AjaxRequest.path('statistics/chart').get(
          $scope.requestData,
          function (data) {
            $scope.holdSubmit = false;
            $scope.data = data.chartData;
            if ($scope.data.length > 0) {
              $scope.data.sort(function (a, b) {
                return a.time - b.time;
              });
              $scope.data.forEach(function (element) {
                element.time = new Date(parseInt(element.time, 10));
              });
            } else {
              $scope.noDataMsg = "No data for " + $scope.requestData.logType;
            }
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
          }
      );
    };

    $scope.$watch("data", function () {
      var chart = AmCharts.makeChart('zoomAxisChart', {
        "pathToImages": layoutPaths.images.amChart,
        "type": "serial",
        "theme": "light",
        "legend": {
          "useGraphSettings": true
        },
        "dataProvider": $scope.data,
        "synchronizeGrid": true,
        "valueAxes": [{
          "id": "v1",
          "axisColor": "#FF6600",
          "axisThickness": 2,
          "axisAlpha": 1,
          "position": "left"
        }],
        "graphs": [{
          "valueAxis": "v1",
          "lineColor": "#FF6600",
          "bullet": "round",
          "bulletBorderThickness": 1,
          "hideBulletsCount": 30,
          "title": "us-east-1",
          "valueField": "us-east-1",
          "balloonFunction": function (graphDataItem) {
            if (graphDataItem.dataContext["us-east-1-description"]) {
              return "<lable>" + graphDataItem.dataContext["us-east-1-description"] + "</lable>";
            } else {
              return "<lable>" + graphDataItem.dataContext["us-east-1"] + "</lable>";
            }
          },
          "fillAlphas": 0
        }, {
          "valueAxis": "v1",
          "lineColor": "#FCD202",
          "bullet": "square",
          "bulletBorderThickness": 1,
          "hideBulletsCount": 30,
          "title": "us-west-1",
          "valueField": "us-west-1",
          "balloonFunction": function (graphDataItem) {
            if (graphDataItem.dataContext["us-west-1-description"]) {
              return "<lable style='white-space:nowrap'>" + graphDataItem.dataContext["us-west-1-description"] + "</lable>";
            } else {
              return "<lable>" + graphDataItem.dataContext["us-west-1"] + "</lable>";
            }
          },
          "fillAlphas": 0
        }, {
          "valueAxis": "v1",
          "lineColor": "#B0DE09",
          "bullet": "triangleUp",
          "bulletBorderThickness": 1,
          "hideBulletsCount": 30,
          "title": "eu-west-1",
          "valueField": "eu-west-1",
          "balloonFunction": function (graphDataItem) {
            if (graphDataItem.dataContext["eu-west-1-description"]) {
              return "<lable>" + graphDataItem.dataContext["eu-west-1-description"] + "</lable>";
            } else {
              return "<lable>" + graphDataItem.dataContext["eu-west-1"] + "</lable>";
            }
          },
          "fillAlphas": 0
        }, {
          "valueAxis": "v1",
          "lineColor": "#0099FF",
          "bullet": "triangleUp",
          "bulletBorderThickness": 1,
          "hideBulletsCount": 30,
          "title": "eu-central-1",
          "valueField": "eu-central-1",
          "balloonFunction": function (graphDataItem) {
            if (graphDataItem.dataContext["eu-central-1-description"]) {
              return "<lable>" + graphDataItem.dataContext["eu-central-1-description"] + "</lable>";
            } else {
              return "<lable>" + graphDataItem.dataContext["eu-central-1"] + "</lable>";
            }
          },
          "fillAlphas": 0
        }, {
          "valueAxis": "v1",
          "lineColor": "#993399",
          "bullet": "triangleUp",
          "bulletBorderThickness": 1,
          "hideBulletsCount": 30,
          "title": "cn-north-1",
          "valueField": "cn-north-1",
          "balloonFunction": function (graphDataItem) {
            if (graphDataItem.dataContext["cn-north-1-description"]) {
              return "<lable>" + graphDataItem.dataContext["cn-north-1-description"] + "</lable>";
            } else {
              return "<lable>" + graphDataItem.dataContext["cn-north-1"] + "</lable>";
            }
          },
          "fillAlphas": 0
        }, {
          "valueAxis": "v1",
          "lineColor": "#999999",
          "bullet": "triangleUp",
          "bulletBorderThickness": 1,
          "hideBulletsCount": 30,
          "title": "ap-southeast-1",
          "valueField": "ap-southeast-1",
          "balloonFunction": function (graphDataItem) {
            if (graphDataItem.dataContext["ap-southeast-1-description"]) {
              return "<lable>" + graphDataItem.dataContext["ap-southeast-1-description"] + "</lable>";
            } else {
              return "<lable>" + graphDataItem.dataContext["ap-southeast-1"] + "</lable>";
            }
          },
          "fillAlphas": 0
        }],
        "chartScrollbar": {},
        "chartCursor": {
          "cursorPosition": "mouse"
        },
        "categoryField": "time",
        "categoryAxis": {
          "parseDates": true,
          "axisColor": "#DADADA",
          "minorGridEnabled": true
        },
        "balloon": {
          "borderThickness": 1,
          "shadowAlpha": 0,
          "maxWidth": 1000
        },
        "export": {
          "enabled": true,
          "position": "bottom-right"
        }
      })
    });
  }
})();
(function () {
  'use strict';

  angular.module('NetviewAdmin.pages.statistics.charts')
      .controller('OrderLineChartCtrl', OrderLineChartCtrl);

  /** @ngInject */
  function OrderLineChartCtrl($scope, $filter, $cookies, $state, ModalsService, layoutPaths, AjaxRequest) {
    if (!ACL.hasPermission($cookies, 'get_statistics_chart')) {
      $state.go('auth');
      return;
    }
    $scope.logTypeItems = [
      {label: $filter('translate')('OrdersIncomeCount'), value: 'OrdersIncomeCount'},
      {label: $filter('translate')('OrdersTotalIncome'), value: 'OrdersTotalIncome'},
      {label: $filter('translate')('OrdersAverageCount'), value: 'OrdersAverageCount'},
      {label: $filter('translate')('DailyCashIncome'), value: 'DailyCashIncome'}
    ];
    $scope.logTypeSelected = $scope.logTypeItems[0];

    $scope.changeLogType = function (logTypeSelected) {
      $scope.requestData.logType = logTypeSelected.value;
      $scope.callServer();
    };

    $scope.requestData = {'logType': $scope.logTypeItems[0].value, endTime: new Date().getTime()};

    $scope.endDateOnSetTime = function () {
      $scope.requestData.endTime = new Date($scope.dateRangeEnd).getTime();
      $scope.dateRangeEnd = new Date($scope.dateRangeEnd).Format("yyyy-MM-dd");
      $scope.$broadcast('end-date-changed');
    };

    $scope.callServer = function () {
      $scope.holdSubmit = true;
      AjaxRequest.path('statistics/chart').get(
          $scope.requestData,
          function (data) {
            $scope.holdSubmit = false;
            $scope.data = data.chartData;
            if ($scope.data.length > 0) {
              $scope.data.sort(function (a, b) {
                return a.time - b.time;
              });
              $scope.data.forEach(function (element) {
                element.time = new Date(parseInt(element.time, 10));
              });
            } else {
              $scope.noDataMsg = "No data for " + $scope.requestData.logType;
            }
          },
          function (error) {
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
          }
      );
    };

    $scope.$watch("data", function () {
      var chart;

      if ($scope.requestData.logType == "OrdersIncomeCount") {
        chart = AmCharts.makeChart('orderChart', {
          "pathToImages": layoutPaths.images.amChart,
          "type": "serial",
          "theme": "light",
          "titles": [{
            "text": "过去三十天每天的购买数量和收入"
          }],
          "legend": {
            "useGraphSettings": true
          },
          "dataProvider": $scope.data,
          "synchronizeGrid": true,
          "valueAxes": [{
            "id": "v1",
            "axisColor": "#FF6600",
            "axisThickness": 2,
            "axisAlpha": 1,
            "position": "left"
          }],
          "graphs": [
            {
              "valueAxis": "v1",
              "lineColor": "#FF6600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 30,
              "title": "All",
              "valueField": "ALL",
              "balloonFunction": function (graphDataItem) {
                return "<lable>" + graphDataItem.dataContext["ALL-DESCRIPTION"] + "</lable>";
              },
              "fillAlphas": 0
            },
            {
              "valueAxis": "v1",
              "lineColor": "#fc8025",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 30,
              "title": "FULL_RECORD_MONTH",
              "valueField": "FULL_RECORD_MONTH",
              "balloonFunction": function (graphDataItem) {
                return "<lable>" + graphDataItem.dataContext["FULL_RECORD_MONTH-DESCRIPTION"] + "</lable>";
              },
              "fillAlphas": 0
            },
            {
              "valueAxis": "v1",
              "lineColor": "#FCD202",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 30,
              "title": "FULL_RECORD_YEAR",
              "valueField": "FULL_RECORD_YEAR",
              "balloonFunction": function (graphDataItem) {
                return "<lable>" + graphDataItem.dataContext["FULL_RECORD_YEAR-DESCRIPTION"] + "</lable>";
              },
              "fillAlphas": 0
            },
            {
              "valueAxis": "v1",
              "lineColor": "#29c7de",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 30,
              "title": "VIDEO_MOTION_MONTH",
              "valueField": "VIDEO_MOTION_MONTH",
              "balloonFunction": function (graphDataItem) {
                return "<lable>" + graphDataItem.dataContext["VIDEO_MOTION_MONTH-DESCRIPTION"] + "</lable>";
              },
              "fillAlphas": 0
            },
            {
              "valueAxis": "v1",
              "lineColor": "#68de32",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 30,
              "title": "VIDEO_MOTION_YEAR",
              "valueField": "VIDEO_MOTION_YEAR",
              "balloonFunction": function (graphDataItem) {
                return "<lable>" + graphDataItem.dataContext["VIDEO_MOTION_YEAR-DESCRIPTION"] + "</lable>";
              },
              "fillAlphas": 0
            },
            {
              "valueAxis": "v1",
              "lineColor": "#993399",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 30,
              "title": "CLOUD_RECORD_MONTH",
              "valueField": "CLOUD_RECORD_MONTH",
              "balloonFunction": function (graphDataItem) {
                return "<lable>" + graphDataItem.dataContext["CLOUD_RECORD_MONTH-DESCRIPTION"] + "</lable>";
              },
              "fillAlphas": 0
            },
            {
              "valueAxis": "v1",
              "lineColor": "#4d2799",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 30,
              "title": "CLOUD_RECORD_YEAR",
              "valueField": "CLOUD_RECORD_YEAR",
              "balloonFunction": function (graphDataItem) {
                return "<lable>" + graphDataItem.dataContext["CLOUD_RECORD_YEAR-DESCRIPTION"] + "</lable>";
              },
              "fillAlphas": 0
            },
          ],
          "chartScrollbar": {},
          "chartCursor": {
            "cursorPosition": "mouse"
          },
          "categoryField": "time",
          "categoryAxis": {
            "parseDates": true,
            "axisColor": "#DADADA",
            "minorGridEnabled": true
          },
          "balloon": {
            "borderThickness": 1,
            "shadowAlpha": 0,
            "maxWidth": 1000
          },
          "export": {
            "enabled": true,
            "position": "bottom-right"
          }
        });
      }

      if ($scope.requestData.logType == "DailyCashIncome") {
        chart = AmCharts.makeChart('cashChart', {
          "pathToImages": layoutPaths.images.amChart,
          "type": "serial",
          "theme": "light",
          "titles": [{
            "text": "每天的折合现金收入"
          }],
          "legend": {
            "useGraphSettings": true
          },
          "dataProvider": $scope.data,
          "synchronizeGrid": true,
          "valueAxes": [{
            "id": "v1",
            "axisColor": "#FF6600",
            "axisThickness": 2,
            "axisAlpha": 1,
            "position": "left"
          }],
          "graphs": [
            {
              "valueAxis": "v1",
              "lineColor": "#1ea9ff",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 30,
              "title": "折算现金收入",
              "valueField": "income",
              "balloonFunction": function (graphDataItem) {
                return "<lable>" + '$' + graphDataItem.dataContext["income"] + "</lable>";
              },
              "fillAlphas": 0
            },
            {
              "valueAxis": "v1",
              "lineColor": "#FF6600",
              "bullet": "round",
              "bulletBorderThickness": 1,
              "hideBulletsCount": 30,
              "title": "当日新增收入",
              "valueField": "today_income",
              "balloonFunction": function (graphDataItem) {
                return "<lable>" + '$' + graphDataItem.dataContext["today_income"] + "</lable>";
              },
              "fillAlphas": 0
            },
          ],
          "chartScrollbar": {},
          "chartCursor": {
            "cursorPosition": "mouse"
          },
          "categoryField": "time",
          "categoryAxis": {
            "parseDates": true,
            "axisColor": "#DADADA",
            "minorGridEnabled": true
          },
          "balloon": {
            "borderThickness": 1,
            "shadowAlpha": 0,
            "maxWidth": 1000
          },
          "export": {
            "enabled": true,
            "position": "bottom-right"
          }
        });
      }

      function handleInit(object) {
        object.legend.addListener("rollOverItem", handleRollOver);
      }

      function handleRollOver(e) {
        var wedge = e.dataItem.wedge.node;
        wedge.parentNode.appendChild(wedge);
      }

      if ($scope.requestData.logType == "OrdersAverageCount") {
        var pieChart = AmCharts.makeChart("orderPieChart", {
          "type": "pie",
          "theme": "light",
          "addClassNames": true,
          "legend": {
            "position": "right",
            "marginRight": 100,
            "autoMargins": false
          },
          "innerRadius": "30%",
          "defs": {
            "filter": [{
              "id": "shadow",
              "width": "200%",
              "height": "200%",
              "feOffset": {
                "result": "offOut",
                "in": "SourceAlpha",
                "dx": 0,
                "dy": 0
              },
              "feGaussianBlur": {
                "result": "blurOut",
                "in": "offOut",
                "stdDeviation": 5
              },
              "feBlend": {
                "in": "SourceGraphic",
                "in2": "blurOut",
                "mode": "normal"
              }
            }]
          },
          "dataProvider": $scope.data,
          "valueField": "averageCount",
          "titleField": "serviceType",
          "balloon": {
            "fixedPosition": true
          },
          "titles": [{
            "text": "过去三十天平均每天的购买数量"
          }],
        });
        pieChart.addListener("init", handleInit(pieChart));

        pieChart.addListener("rollOverSlice", function (e) {
          handleRollOver(e);
        });
      }
      if ($scope.requestData.logType == "OrdersTotalIncome") {
        var pieChart = AmCharts.makeChart("totalIncomePieChart", {
          "type": "pie",
          "theme": "light",
          "addClassNames": true,
          "legend": {
            "position": "right",
            "marginRight": 100,
            "autoMargins": false
          },
          "innerRadius": "30%",
          "defs": {
            "filter": [{
              "id": "shadow",
              "width": "200%",
              "height": "200%",
              "feOffset": {
                "result": "offOut",
                "in": "SourceAlpha",
                "dx": 0,
                "dy": 0
              },
              "feGaussianBlur": {
                "result": "blurOut",
                "in": "offOut",
                "stdDeviation": 5
              },
              "feBlend": {
                "in": "SourceGraphic",
                "in2": "blurOut",
                "mode": "normal"
              }
            }]
          },
          "dataProvider": $scope.data,
          "valueField": "totalIncome",
          "titleField": "serviceType",
          "balloon": {
            "fixedPosition": true
          },
          "titles": [{
            "text": "过去三十天各项服务的总收入情况"
          }],
        });
        pieChart.addListener("init", handleInit(pieChart));

        pieChart.addListener("rollOverSlice", function (e) {
          handleRollOver(e);
        });
      }
    });
  }
})();

// /**
//  * @author shenfeng
//  */
// (function () {
//   'use strict';
//   angular.module('NetviewAdmin.pages.statistics.logs')
//     .controller('CloudStorageServiceCtrl', CloudStorageServiceCtrl);
//
//   /** @ngInject */
//   function CloudStorageServiceCtrl($scope, $state, $uibModal, $cookies, $stateParams, $filter, ModalsService, AjaxRequest) {
//
//     $scope.data = {
//       'pageSize': 10,
//       'pageNumber': 0,
//       'logType': 'CLOUD_STORAGE_SERVICE',
//       'deviceId': null,
//       'startTime': 0,
//       'endTime': -1
//     };
//
//     $scope.callServer = function callServer(tableState) {
//       $scope.tableState = tableState;
//       tableState.pagination.numberOfPages = 0;
//       $scope.isLoading = true;
//       $scope.getDataError = false;
//       $scope.logsEmpty = false;
//       var pagination = tableState.pagination;
//       $scope.data.pageSize = pagination.number || 10;
//       $scope.data.pageNumber = parseInt(pagination.start / 10) || 0;
//       $scope.data.deviceId = $scope.serialNumber;
//
//       if ($stateParams.reloadParams != null) {
//         $scope.data = $stateParams.reloadParams;
//         tableState.pagination.start = $scope.data.pageNumber * 10;
//       }
//
//       AjaxRequest.path('statistics/list').get(
//         $scope.data,
//         function (data) {
//           tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pageSize);
//           $scope.isLoading = false;
//           $scope.getDataError = false;
//           $scope.logs = data.logs;
//           if ($scope.logs.length == 0) {
//             $scope.logsEmpty = true;
//           } else {
//             $scope.logsEmpty = false;
//           }
//         },
//         function (error) {
//           $scope.isLoading = false;
//           $scope.getDataError = true;
//           $scope.logsEmpty = false;
//           ModalsService.handleError(error);
//         }
//       )
//     };
//
//     $scope.serialNumberInputBlurred = function () {
//       if($scope.data.deviceId != $scope.serialNumber){
//         $scope.callServer($scope.tableState);
//       }
//     };
//
//     $scope.startDateOnSetTime = function () {
//       $scope.data.startTime = new Date($scope.dateRangeStart).getTime();
//       $scope.dateRangeStart = new Date($scope.dateRangeStart).Format("yyyy-MM-dd HH:mm:ss");
//       $scope.$broadcast('start-date-changed');
//       if($scope.dateRangeEnd != undefined){
//         $scope.callServer($scope.tableState);
//       }
//     };
//
//     $scope.endDateOnSetTime = function () {
//       $scope.data.endTime = new Date($scope.dateRangeEnd).getTime();
//       $scope.dateRangeEnd = new Date($scope.dateRangeEnd).Format("yyyy-MM-dd HH:mm:ss");
//       $scope.$broadcast('end-date-changed');
//       if($scope.dateRangeStart != undefined){
//         $scope.callServer($scope.tableState);
//       }
//     };
//
//     $scope.startDateBeforeRender = function ($dates) {
//       if ($scope.dateRangeEnd) {
//         var activeDate = moment($scope.dateRangeEnd);
//         $dates.filter(function (date) {
//           return date.localDateValue() >= activeDate.valueOf()
//         }).forEach(function (date) {
//           date.selectable = false;
//         })
//       }
//     };
//
//     $scope.endDateBeforeRender = function ($view, $dates) {
//       if ($scope.dateRangeStart) {
//         var activeDate = moment($scope.dateRangeStart).subtract(1, $view).add(1, 'minute');
//         $dates.filter(function (date) {
//           return date.localDateValue() <= activeDate.valueOf()
//         }).forEach(function (date) {
//           date.selectable = false;
//         })
//       }
//     };
//
//     $scope.resetSearch = function () {
//       $scope.data = {
//         'pageSize': 10,
//         'pageNumber': 0,
//         'logType': 'CLOUD_STORAGE_SERVICE',
//         'deviceId': undefined,
//         'startTime': 0,
//         'endTime': -1
//       };
//       $scope.dateRangeEnd = undefined;
//       $scope.dateRangeStart = undefined;
//       $scope.serialNumber = undefined;
//       $scope.tableState.pagination.start = 0;
//       $scope.callServer($scope.tableState)
//     };
//   }
//
// })();

// /**
//  * @author shenfeng
//  */
// (function () {
//   'use strict';
//   angular.module('NetviewAdmin.pages.statistics.logs')
//     .controller('DeviceCallCtrl', DeviceCallCtrl);
//
//   /** @ngInject */
//   function DeviceCallCtrl($scope, $state, $uibModal, $cookies, $stateParams, $filter, ModalsService, AjaxRequest) {
//
//     $scope.data = {
//       'pageSize': 10,
//       'pageNumber': 0,
//       'logType': 'DEVICE_CALL',
//       'deviceId': undefined,
//       'startTime': 0,
//       'endTime': -1
//     };
//
//     $scope.callServer = function callServer(tableState) {
//       $scope.tableState = tableState;
//       tableState.pagination.numberOfPages = 0;
//       $scope.isLoading = true;
//       $scope.getDataError = false;
//       $scope.logsEmpty = false;
//       var pagination = tableState.pagination;
//       $scope.data.pageSize = pagination.number || 10;
//       $scope.data.pageNumber = parseInt(pagination.start / 10) || 0;
//       $scope.data.deviceId = $scope.serialNumber;
//       $scope.data.deviceId = $scope.serialNumber;
//
//       if ($stateParams.reloadParams != null) {
//         $scope.data = $stateParams.reloadParams;
//         tableState.pagination.start = $scope.data.pageNumber * 10;
//       }
//
//       AjaxRequest.path('statistics/list').get(
//         $scope.data,
//         function (data) {
//           tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pageSize);
//           $scope.isLoading = false;
//           $scope.getDataError = false;
//           $scope.logs = data.logs;
//           if($scope.logs.length == 0 ){
//             $scope.logsEmpty = true;
//           }else{
//             $scope.logsEmpty = false;
//           }
//         },
//         function (error) {
//           $scope.isLoading = false;
//           $scope.getDataError = true;
//           ModalsService.handleError(error);
//         }
//       )
//     };
//
//     $scope.serialNumberInputBlurred = function () {
//       if($scope.data.deviceId != $scope.serialNumber){
//         $scope.callServer($scope.tableState);
//       }
//     };
//
//     $scope.startDateOnSetTime = function () {
//       $scope.data.startTime = new Date($scope.dateRangeStart).getTime();
//       $scope.dateRangeStart = new Date($scope.dateRangeStart).Format("yyyy-MM-dd HH:mm:ss");
//       $scope.$broadcast('start-date-changed');
//       if($scope.dateRangeEnd != undefined){
//         $scope.callServer($scope.tableState);
//       }
//     };
//
//     $scope.endDateOnSetTime = function () {
//       $scope.data.endTime = new Date($scope.dateRangeEnd).getTime();
//       $scope.dateRangeEnd = new Date($scope.dateRangeEnd).Format("yyyy-MM-dd HH:mm:ss");
//       $scope.$broadcast('end-date-changed');
//       if($scope.dateRangeStart != undefined){
//         $scope.callServer($scope.tableState);
//       }
//     };
//
//     $scope.startDateBeforeRender = function ($dates) {
//       if ($scope.dateRangeEnd) {
//         var activeDate = moment($scope.dateRangeEnd);
//         $dates.filter(function (date) {
//           return date.localDateValue() >= activeDate.valueOf()
//         }).forEach(function (date) {
//           date.selectable = false;
//         })
//       }
//     };
//
//     $scope.endDateBeforeRender = function ($view, $dates) {
//       if ($scope.dateRangeStart) {
//         var activeDate = moment($scope.dateRangeStart).subtract(1, $view).add(1, 'minute');
//         $dates.filter(function (date) {
//           return date.localDateValue() <= activeDate.valueOf()
//         }).forEach(function (date) {
//           date.selectable = false;
//         })
//       }
//     };
//
//     $scope.resetSearch = function () {
//       $scope.data = {
//         'pageSize': 10,
//         'pageNumber': 0,
//         'logType': 'DEVICE_CALL',
//         'deviceId': undefined,
//         'startTime': 0,
//         'endTime': -1
//       };
//       $scope.dateRangeEnd = undefined;
//       $scope.dateRangeStart = undefined;
//       $scope.serialNumber = undefined;
//       $scope.tableState.pagination.start = 0;
//       $scope.callServer($scope.tableState)
//     };
//   }
//
// })();

/**
 * @author shenfeng
 */
(function () {
  'use strict';
  angular.module('NetviewAdmin.pages.statistics.logs')
      .controller('LoginOrLogoutCtrl', LoginOrLogoutCtrl);

  /** @ngInject */
  function LoginOrLogoutCtrl($scope, ModalsService, AjaxRequest) {
    $scope.data = {
      'logType': "DeviceLoginRecord",
      'deviceId': undefined
    };

    $scope.callServer = function callServer(tableState) {
      if ($scope.data.deviceId === undefined) {
        return;
      }

      $scope.tableState = tableState;
      $scope.isLoading = true;
      $scope.getDataError = false;
      $scope.logsEmpty = false;
      $scope.holdSubmit = true;

      AjaxRequest.path('statistics/list').get(
          $scope.data,
          function (data) {
            $scope.isLoading = false;
            $scope.getDataError = false;
            $scope.logs = data.logs;
            $scope.logsEmpty = $scope.logs.length === 0;
            $scope.holdSubmit = false;
          },
          function (error) {
            $scope.isLoading = false;
            $scope.getDataError = true;
            $scope.logsEmpty = false;
            $scope.holdSubmit = false;
            ModalsService.handleError(error);
          }
      )
    };

    $scope.serialNumberInputBlurred = function () {
      if ($scope.data.deviceId != $scope.serialNumber) {
        $scope.data.deviceId = $scope.serialNumber;
        $scope.callServer($scope.tableState);
      }
    };

    $scope.resetSearch = function () {
      $scope.data = {
        'logType': "DeviceLoginRecord",
        'deviceId': undefined,
      };

      $scope.serialNumber = undefined;
      $scope.callServer($scope.tableState)
    };
  }

})();

// /**
//  * @author shenfeng
//  */
// (function () {
//   'use strict';
//   angular.module('NetviewAdmin.pages.statistics.logs')
//     .controller('SmartHomeCtrl', SmartHomeCtrl);
//
//   /** @ngInject */
//   function SmartHomeCtrl($scope, $state, $uibModal, $cookies, $stateParams, $filter, ModalsService, AjaxRequest) {
//
//     $scope.data = {
//       'pageSize': 10,
//       'pageNumber': 0,
//       'logType': 'SMART_HOME_NOTIFY',
//       'deviceId': undefined,
//       'startTime': 0,
//       'endTime': -1
//     };
//
//     $scope.callServer = function callServer(tableState) {
//       $scope.tableState = tableState;
//       tableState.pagination.numberOfPages = 0;
//       $scope.isLoading = true;
//       $scope.getDataError = false;
//       $scope.logsEmpty = false;
//       var pagination = tableState.pagination;
//       $scope.data.pageSize = pagination.number || 10;
//       $scope.data.pageNumber = parseInt(pagination.start / 10) || 0;
//       $scope.data.deviceId = $scope.serialNumber;
//
//       if ($stateParams.reloadParams != null) {
//         $scope.data = $stateParams.reloadParams;
//         tableState.pagination.start = $scope.data.pageNumber * 10;
//       }
//
//       AjaxRequest.path('statistics/list').get(
//         $scope.data,
//         function (data) {
//           tableState.pagination.numberOfPages = Math.ceil(data.total / $scope.data.pageSize);
//           $scope.isLoading = false;
//           $scope.getDataError = false;
//           $scope.logs = data.logs;
//           if($scope.logs.length == 0 ){
//             $scope.logsEmpty = true;
//           }else{
//             $scope.logsEmpty = false;
//           }
//         },
//         function (error) {
//           $scope.isLoading = false;
//           $scope.getDataError = true;
//           $scope.logsEmpty = false;
//           ModalsService.handleError(error);
//         }
//       )
//     };
//
//     $scope.serialNumberInputBlurred = function () {
//       if($scope.data.deviceId != $scope.serialNumber){
//         $scope.callServer($scope.tableState);
//       }
//     };
//
//     $scope.startDateOnSetTime = function () {
//       $scope.data.startTime = new Date($scope.dateRangeStart).getTime();
//       $scope.dateRangeStart = new Date($scope.dateRangeStart).Format("yyyy-MM-dd HH:mm:ss");
//       $scope.$broadcast('start-date-changed');
//       if($scope.dateRangeEnd != undefined){
//         $scope.callServer($scope.tableState);
//       }
//     };
//
//     $scope.endDateOnSetTime = function () {
//       $scope.data.endTime = new Date($scope.dateRangeEnd).getTime();
//       $scope.dateRangeEnd = new Date($scope.dateRangeEnd).Format("yyyy-MM-dd HH:mm:ss");
//       $scope.$broadcast('end-date-changed');
//       if($scope.dateRangeStart != undefined){
//         $scope.callServer($scope.tableState);
//       }
//     };
//
//     $scope.startDateBeforeRender = function ($dates) {
//       if ($scope.dateRangeEnd) {
//         var activeDate = moment($scope.dateRangeEnd);
//         $dates.filter(function (date) {
//           return date.localDateValue() >= activeDate.valueOf()
//         }).forEach(function (date) {
//           date.selectable = false;
//         })
//       }
//     };
//
//     $scope.endDateBeforeRender = function ($view, $dates) {
//       if ($scope.dateRangeStart) {
//         var activeDate = moment($scope.dateRangeStart).subtract(1, $view).add(1, 'minute');
//         $dates.filter(function (date) {
//           return date.localDateValue() <= activeDate.valueOf()
//         }).forEach(function (date) {
//           date.selectable = false;
//         })
//       }
//     };
//
//     $scope.resetSearch = function () {
//       $scope.data = {
//         'pageSize': 10,
//         'pageNumber': 0,
//         'logType': 'SMART_HOME_NOTIFY',
//         'deviceId': undefined,
//         'startTime': 0,
//         'endTime': -1
//       };
//       $scope.dateRangeEnd = undefined;
//       $scope.dateRangeStart = undefined;
//       $scope.serialNumber = undefined;
//       $scope.tableState.pagination.start = 0;
//       $scope.callServer($scope.tableState)
//     };
//   }
//
// })();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('NetviewAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/apps/apps.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-info btn-mm" style="margin-bottom: 10px">{{\'createApp\' | translate }}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="apps"><thead><tr class="black-muted-bg"><th>#</th><th>{{\'name\' | translate }}</th><th class="hidden-text">{{\'display_name\' | translate }}</th><th>{{\'email\' | translate }}</th><th>{{\'uaid\' | translate }}</th><th class="hidden-text">{{\'is_root\' | translate }}</th><th class="hidden-text">{{\'app_pg\' | translate }}</th><th>{{\'app_info\' | translate }}</th><th ng-if="EDIT_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="app in apps" class="no-top-border"><td><a>{{app.id}}</a></td><td>{{app.appName}}</td><td>{{app.displayName}}</td><td>{{app.emailAddress}}</td><td>{{app.uaid}}</td><td>{{app.isRoot | isRootFilter}}</td><td>{{app.appPG}}</td><td>{{app.appInfo}}</td><td ng-if="EDIT_P"><div class="buttons"><button class="btn btn-info btn-xs" ng-click="openEditPage(app)">{{\'editApp\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="8" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="appsEmpty"><td colspan="8" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/apps/editApp.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{isNewApp ? (\'createApp\' | translate) : (\'editApp\' | translate)}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="appName">{{\'name\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="appName" ng-model="data.appName" ng-focus="clearError()"><p class="help-block red-color" ng-show="errAppName">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="displayName">{{\'display_name\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="displayName" ng-model="data.displayName" ng-focus="clearError()"><p class="help-block red-color" ng-show="errDisplayName">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="email">{{\'email\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="email" ng-model="data.emailAddress" ng-focus="clearError()"><p class="help-block red-color" ng-show="errEmail">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="appInfo">{{\'app_info\' | translate }}</label> <input type="text" class="form-control" id="appInfo" ng-model="data.appInfo" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label>{{\'is_root\' | translate }}</label><select class="form-control" ng-model="isRootSelected" ng-change="isRootChange(isRootSelected)" ng-options="item as item.label for item in isRootItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label for="appPG">{{\'app_pg\' | translate }}</label> <input type="number" class="form-control" id="appPG" ng-model="data.appPG" ng-focus="clearError()"></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/auth/auth.html','<style>\n  html {\n    min-height: 520px;\n    height: 100%;\n  }\n\n  body {\n    height: 100%;\n  }\n\n  body::before {\n    content: \'\';\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: url("assets/img/blur-bg.jpg") no-repeat center center;\n    background-size: cover;\n    will-change: transform;\n    z-index: -1;\n  }\n\n  .form-control, .form-control:focus {\n    background-color: rgba(0, 0, 0, 0.4);\n    border-radius: 5px;\n    color: #ffffff;\n  }\n\n  .form-control::-webkit-input-placeholder, .form-control:focus::-webkit-input-placeholder {\n    color: #ffffff;\n    opacity: 0.9;\n  }\n\n  .form-control:-moz-placeholder, .form-control:focus:-moz-placeholder {\n    /* Firefox 18- */\n    color: #ffffff;\n    opacity: 0.9;\n  }\n\n  .form-control::-moz-placeholder, .form-control:focus::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #ffffff;\n    opacity: 0.9;\n  }\n\n  .form-control:-ms-input-placeholder, .form-control:focus:-ms-input-placeholder {\n    color: #ffffff;\n    opacity: 0.9;\n  }\n\n  .form-horizontal label {\n    line-height: 34px;\n    margin-bottom: 0;\n    padding-top: 0 !important; }\n\n  .auth-main {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n  }\n\n  .auth-block {\n    width: 540px;\n    height: 300px;\n    margin: 0 auto;\n    border-radius: 5px;\n    background: rgba(0, 0, 0, 0.55);\n    color: #fff;\n    padding: 32px;\n  }\n\n  .auth-block h1 {\n    font-weight: 300;\n    margin-bottom: 28px;\n    text-align: center;\n  }\n\n  .auth-block p {\n    font-size: 16px;\n  }\n\n  .auth-block a {\n    text-decoration: none;\n    outline: none;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n    color: #209e91;\n  }\n\n  .auth-block a:hover {\n    color: #1b867b;\n  }\n\n  .auth-block .control-label {\n    padding-top: 11px;\n    color: #ffffff;\n  }\n\n  .auth-block .form-group {\n    margin-bottom: 12px;\n  }\n\n  .btn-auth {\n    color: #ffffff !important;\n  }\n\n  .red-color {\n    color: #FF3300;\n  }\n\n  .language-select {\n    float: right;\n    margin-right: 10px;\n    margin-top: 10px;\n  }\n\n</style><div class="language-select"><select id="lan_select" ng-model="language" ng-change="changeLanguage()" ng-options="v.value as v.name for v in LocaleList"></select></div><main class="auth-main"><div class="auth-block"><h1>{{\'login_title\' | translate }}</h1><form class="form-horizontal"><div class="form-group"><label for="userName" class="col-sm-2 control-label">{{\'user_name\' | translate }}</label><div class="col-sm-10"><input type="text" class="form-control" id="userName" placeholder="User Name" ng-model="authData.user" ng-focus="clearError()"><p class="help-block red-color" ng-show="errorUser">{{errorMessage | translate}}</p></div></div><div class="form-group" style="margin-top: 10px"><label for="password" class="col-sm-2 control-label">{{\'password\' | translate }}</label><div class="col-sm-10"><input type="password" class="form-control" id="password" placeholder="Password" ng-model="plainPassword" ng-focus="clearError()"><p class="help-block red-color" ng-show="errorPassword">{{errorMessage | translate}}</p></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10" style="margin-top: 20px"><button type="submit" class="btn btn-default btn-auth" ng-click="submit()" ng-disabled="holdSubmit">{{\'sign_in\' | translate }}</button></div></div><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></form></div></main>');
$templateCache.put('app/pages/bmUsers/bmUsers.html','<div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel large-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'data_list\' | translate}}"><div><button ng-click="openEditPage()" class="btn btn-primary btn-mm" style="margin-bottom: 10px" ng-if="WRITE_P">{{\'new_bmUser\' | translate }}</button><table class="table table-hover" st-pipe="callServer" st-table="bmUsers"><thead><tr><th><input st-search="userName" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></th><th><input st-search="email" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></th><th colspan="2"><select st-search="enable" class="form-control" ng-model="statusSelected" ng-options="item as item.label for item in statusItems track by item.value"></select></th><th><div style="width: 1px"><button type="button" class="btn btn-info">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetQuery()">{{\'reset_search\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="refresh()">{{\'refresh\' | translate}}</button></div></th></tr><tr class="black-muted-bg"><th>{{\'user_name\' | translate }}</th><th>{{\'email\' | translate }}</th><th>{{\'status\' | translate }}</th><th>{{\'app_id\' | translate }}</th><th>{{\'distributor_id\' | translate }}</th><th>{{\'last_login_time\' | translate }}</th><th>{{\'note\' | translate }}</th><th>{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="bmUser in bmUsers" class="no-top-border"><td class="text-center"><a>{{bmUser.userName}}</a></td><td>{{bmUser.email}}</td><td>{{bmUser.enable | bmUserStatus}}</td><td>{{bmUser.appId}}</td><td>{{bmUser.distributorId}}</td><td>{{(bmUser.lastLogin > 0) ? (bmUser.lastLogin | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td><td>{{bmUser.note}}</td><td><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditPage(bmUser)" ng-if="EDIT_P">{{\'edit\' | translate}}</button> <button class="btn btn-warning btn-xs" ng-click="resetPassword(bmUser.userId)" ng-if="RESET_PASS_P">{{\'reset_password\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="8" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="bmUsersEmpty"><td colspan="8" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/bmUsers/editBmUser.html','<div class="modal-content"><div class="modal-header bg-info"><span ng-if="isNewBmUser">{{\'new_bmUser\' | translate}}</span> <span ng-if="!isNewBmUser">{{\'edit\' | translate}}</span></div><div class="modal-body"><div class="row"><div class="col-md-7"><form><div class="form-group margin-thirdPx has-error" ng-if="isNewBmUser"><label for="userName">{{\'user_name\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="userName" ng-model="data.user" ng-focus="clearError()"><p class="help-block red-color" ng-show="errUser">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="email">{{\'email\' | translate }}{{\'not_null\' | translate}}</label> <input type="email" class="form-control" id="email" ng-model="data.email" ng-focus="clearError()"><p class="help-block red-color" ng-show="errEmail">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="appId">{{\'app_id\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="appId" ng-model="data.appId" ng-focus="clearError()"><p class="help-block red-color" ng-show="errAppId">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="distributorId">{{\'distributor_id\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="distributorId" ng-model="data.distributorId" ng-focus="clearError()"><p class="help-block red-color" ng-show="errDistributorId">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx" ng-if="!isNewBmUser"><label>{{\'status\' | translate }}</label><select class="form-control" ng-model="statusSelected" ng-change="statusChange(statusSelected)" ng-options="item as item.label for item in statusItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label for="note">{{\'note\' | translate }}</label> <textarea class="form-control" id="note" ng-model="data.note" ng-focus="clearError()"></textarea></div><div class="form-group margin-thirdPx"><label>{{\'role\' | translate }}{{\'not_null\' | translate}}</label><div class="category-item checkbox-label" ng-repeat="role in roleList"><input type="checkbox" ng-model="roleList[$index].checked" class="instrument"> <a href="" ng-click="openInfoPage(role)">{{role.name | translate}}</a></div><p class="help-block red-color" ng-show="errRole">{{errorMessage | translate}}</p></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="col-md-5"><div ba-panel="" ba-panel-title="Permission TreeView" ba-panel-class="with-scroll tree-panel"><div js-tree="basicConfig" ng-model="treeData" tree="basicTree" tree-events="changed:checkNodes"></div></div></div></div><div style="margin-top: 20px"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div></div>');
$templateCache.put('app/pages/bmUsers/resetPassword.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/clientLogs/clientLogs.html','<div class="panel panel-default bootstrap-panel with-scroll"><div class="panel-heading">{{\'details_title\' | translate}}</div><div class="panel-body"><form class="row form-inline"><div class="col-md-2"><div class="form-group"><label>{{\'user_name\' | translate}}</label> <input type="text" class="form-control" ng-model="data.userName"></div></div><div class="dropdown form-group col-md-1"><label>{{\'log_type\' | translate}}</label><div class="dropdown-toggle"><select class="form-control" ng-change="clientLogTypeChange(clientLogTypeSelected)" ng-model="clientLogTypeSelected" ng-options="item as item.label for item in clientLogTypeItems track by item.value"></select></div></div><div class="dropdown form-group col-md-2"><label>{{\'start_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownStart" role="button" data-toggle="dropdown"><div class="input-group date"><input type="text" class="form-control" data-ng-model="dateRangeStart"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeStart" data-datetimepicker-config="{ dropdownSelector: \'#dropdownStart\', renderOn: \'end-date-changed\' }" data-on-set-time="startDateOnSetTime()" data-before-render="startDateBeforeRender($dates)"></datetimepicker></ul></div><div class="dropdown form-group col-md-2"><label>{{\'end_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownEnd" role="button" data-toggle="dropdown"><div class="input-group date"><input class="form-control" data-ng-model="dateRangeEnd"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeEnd" data-datetimepicker-config="{ dropdownSelector: \'#dropdownEnd\', renderOn: \'start-date-changed\' }" data-on-set-time="endDateOnSetTime()" data-before-render="endDateBeforeRender($view, $dates, $leftDate, $upDate, $rightDate)"></datetimepicker></ul></div><div class="dropdown form-group col-md-4" style="margin-top: 20px"><button type="button" class="btn btn-info" ng-click="search()">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetSearch()">{{\'reset_search\' | translate}}</button></div></form><table class="table table-hover"><thead><tr class="black-muted-bg"><th>{{\'user_name\' | translate}}</th><th>{{\'app_name\' | translate}}</th><th>{{\'app_version\' | translate}}</th><th>{{\'log_type\' | translate}}</th><th>{{\'system_version\' | translate}}</th><th>{{\'IMEI\' | translate}}</th><th>{{\'exception_name\' | translate}}</th><th>{{\'time\' | translate}}</th><th>{{\'log_dowload\' | translate}}</th><th>{{\'device_id\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="log in newlogs" class="no-top-border"><td>{{log.userName}}</td><td>{{log.appName}}</td><td>{{log.appv}}</td><td>{{log.deviceType}}</td><td>{{log.sysv}}</td><td>{{log.imei}}</td><td>{{log.exceptionName}}</td><td>{{log.date > 0 ? (log.date | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td><td ng-show="log.logURL"><button class="btn btn-info btn-xs" ng-click="download(log.logURL)">{{\'log_dowload\' | translate}}</button></td><td ng-show="!log.logURL"></td><td><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openInfoPage(log.deviceIds)">{{\'show\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="10" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError && !isLoading"><td colspan="10" class="text-center"><nav><ul class="pagination"><li ng-if="lastPageLength > 0"><a ng-click="selectPage(\'last\')">{{\'prevPage\' | translate}}</a></li><li ng-if="nextPageKey != null"><a ng-click="selectPage(\'next\')">{{\'nextPage\' | translate}}</a></li></ul></nav></td></tr><tr ng-show="getDataError"><td colspan="3" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/clientVersions/clientVersions.html','<div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel large-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'data_list\' | translate}}"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create_client_version\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="clientVersions"><thead><tr><th><select st-search="ucid" class="form-control" ng-model="ucidSelected" ng-options="item as item.label for item in ucidItems track by item.value"></select></th><th><input st-search="code" st-input-event="change" type="number" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></th><th><input st-search="version" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></th><th><select st-search="level" class="form-control" ng-model="levelSelected" ng-options="item as item.label for item in levelItems track by item.value"></select></th><th><select st-search="locale" class="form-control" ng-model="localeSelected" ng-options="item as item.label for item in localeItems track by item.value"></select></th><th><div style="width: 1px"><button type="button" class="btn btn-info">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetQuery()">{{\'reset_search\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="refresh()">{{\'refresh\' | translate}}</button></div></th></tr><tr class="black-muted-bg"><th>{{\'client\' | translate }}</th><th>{{\'code\' | translate }}</th><th>{{\'version\' | translate }}</th><th>{{\'client_version_level\' | translate }}</th><th>{{\'language\' | translate }}</th><th>{{\'description\' | translate }}</th><th>{{\'operator\' | translate }}</th><th>{{\'date\' | translate }}</th><th ng-if="EDIT_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="clientVersion in clientVersions" class="no-top-border"><td><a>{{clientVersion.clientName}}</a></td><td>{{clientVersion.code}}</td><td>{{clientVersion.version}}</td><td>{{clientVersion.level | versionFilter}}</td><td>{{clientVersion.locale | versionFilter}}</td><td><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openInfoPage(clientVersion.note)">{{\'show\' | translate}}</button></div></td><td>{{clientVersion.operator}}</td><td>{{clientVersion.date > 0 ? (clientVersion.date | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td><td ng-if="EDIT_P"><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditPage(clientVersion)">{{\'modify_details\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="9" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="9" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="clientVersionsEmpty"><td colspan="9" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown" ng-if="WRITE_FILE"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">{{\'upload_apk\' | translate}} <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">{{\'CN\' | translate}}</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">{{\'US\' | translate}}</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><div ng-include="\'app/pages/clientVersions/tabs/uploadCNApk.html\'"></div></div><div ng-show="$dropdownTabActive == 2"><div ng-include="\'app/pages/clientVersions/tabs/uploadUSApk.html\'"></div></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/clientVersions/editClientVersion.html','<div class="modal-content"><div class="modal-header bg-info"><span ng-if="isNewClientVersion">{{\'create_client_version\' | translate}}</span> <span ng-if="!isNewClientVersion">{{\'modify_details\' | translate}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error" ng-if="isNewClientVersion"><label>{{\'client\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" ng-model="ucidSelected" ng-change="ucidChange(ucidSelected)" ng-options="item as item.label for item in ucidItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label for="code">{{\'code\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="code" ng-model="data.code" ng-focus="clearError()"><p class="help-block red-color" ng-show="errCode">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="version">{{\'version\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="version" ng-model="data.version" ng-focus="clearError()"><p class="help-block red-color" ng-show="errVersion">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'client_version_level\' | translate }}</label><select class="form-control" ng-model="levelSelected" ng-change="levelChange(levelSelected)" ng-options="item as item.label for item in levelItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label>{{\'language\' | translate }}</label><select class="form-control" ng-model="localeSelected" ng-change="localeChange(localeSelected)" ng-options="item as item.label for item in localeItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label>{{\'clientScope\' | translate }}</label><select class="form-control" ng-model="scopeSelected" ng-change="scopeChange(scopeSelected)" ng-options="item as item.label for item in scopeItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label for="url">{{\'url\' | translate }}</label> <input type="text" class="form-control" id="url" ng-model="data.url" ng-focus="clearError()"><p class="help-block red-color" ng-show="errUrl">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="note">{{\'description\' | translate }}</label> <textarea class="form-control" id="note" ng-model="data.note" ng-focus="clearError()"></textarea></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/clients/clients.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create_client\' | translate }}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="clients"><thead><tr class="black-muted-bg"><th>{{\'client_name\' | translate }}</th><th>{{\'client_info\' | translate }}</th><th>{{\'client_ucid\' | translate }}</th><th>{{\'app_id\' | translate }}</th><th>{{\'client_class\' | translate }}</th><th>{{\'client_ppm\' | translate }}</th><th>{{\'client_setting\' | translate }}</th><th ng-if="EDIT_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="client in clients" class="no-top-border"><td><a>{{client.clientName}}</a></td><td>{{client.clientInfo}}</td><td>{{client.clientUcid}}</td><td>{{client.appId}}</td><td>{{client.clientClass}}</td><td>{{client.clientPpm}}</td><td>{{client.clientSetting}}</td><td ng-if="EDIT_P"><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditPage(client)">{{\'edit_client\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="7" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="clientsEmpty"><td colspan="7" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/clients/editClient.html','<div class="modal-content"><div class="modal-header bg-info"><span ng-if="isNewClient">{{\'create_client\' | translate}}</span> <span ng-if="!isNewClient">{{\'edit_client\' | translate}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="clientName">{{\'client_name\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="clientName" ng-model="data.clientName" ng-focus="clearError()"><p class="help-block red-color" ng-show="errClientName">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="clientInfo">{{\'client_info\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="clientInfo" ng-model="data.clientInfo" ng-focus="clearError()"><p class="help-block red-color" ng-show="errClientInfo">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="appId">{{\'app_id\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="appId" ng-model="data.appId" ng-focus="clearError()"><p class="help-block red-color" ng-show="errAppId">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="clientClass">{{\'client_class\' | translate }}</label> <input type="number" class="form-control" id="clientClass" ng-model="data.clientClass" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label for="clientPpm">{{\'client_ppm\' | translate }}</label> <input type="number" class="form-control" id="clientPpm" ng-model="data.clientPpm" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label for="clientSetting">{{\'client_setting\' | translate }}</label> <textarea class="form-control" id="clientSetting" ng-model="data.clientSetting" ng-focus="clearError()"></textarea></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/devices.html','<div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel large-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'data_list\' | translate}}"><div class="widgets"><div class="row"><div class="col-md-12"><table class="table table-hover" st-pipe="callServer" st-table="devices"><thead><tr><th><div class="form-group"><label style="float: left">{{\'device_sn\' | translate }}:</label> <input st-search="serialNumber" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control"></div></th><th><div class="form-group"><label>{{\'device_owner\' | translate }}:</label> <input st-search="ownerName" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control"></div></th><th><div class="form-group"><label>{{\'current_version\' | translate }}:</label> <input st-search="currentVersion" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control"></div></th><th><div class="form-group"><label>{{\'status\' | translate }}:</label><select st-search="enabled" class="form-control" ng-model="statusSelected" ng-options="item as item.label for item in statusItems track by item.value"></select></div></th><th><div class="form-group" style="width: 1px"><button type="button" class="btn btn-info">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetQuery()">{{\'reset_search\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="refresh()">{{\'refresh\' | translate}}</button></div></th></tr><tr class="black-muted-bg"><th>{{\'device_sn\' | translate }}</th><th>{{\'device_name\' | translate }}</th><th>{{\'device_owner\' | translate }}</th><th class="hidden-text">{{\'region\' | translate }}</th><th class="hidden-text">{{\'online_status\' | translate }}</th><th class="hidden-text">{{\'current_version\' | translate }}</th><th class="hidden-text">{{\'distributor_id\' | translate }}</th><th>{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="device in devices" class="no-top-border"><td>{{device.serialNumber}}</td><td>{{device.deviceName}}</td><td><a ng-click="goOwner(device.ownerName)">{{device.ownerName}}</a></td><td>{{device.region}}</td><td ng-show="device.online"><span class="label label-success" style="color: #ffffff">{{device.online | onlineFilter}}</span></td><td ng-show="!device.online"><span class="label label-danger" style="color: #ffffff">{{device.online | onlineFilter}}</span></td><td>{{device.currentVersion}}</td><td>{{device.distributorId}}</td><td><div class="buttons"><button class="btn btn-info btn-xs" ng-click="openDetailPage(device.id, device.endpoint, device.inNewServer)" ng-disabled="holdSubmit" ng-if="DEVICE_DETAIL">{{\'detail_info\' | translate}}</button> <button class="btn btn-primary btn-xs" ng-click="openServicePage(device.id, device.serialNumber)" ng-if="GET_DEVICE_SERVICE">{{\'service\' | translate}}</button><button class="btn btn-warning btn-xs" ng-if="PUT_DEVICE_RESET" ng-click="resetDevice(device.id, device.endpoint, device.inNewServer)" ng-disabled="holdSubmit">{{\'reset_device\' | translate}}</button> <button class="btn btn-primary btn-xs" ng-if="PUSH_DEVICE_UPGRADE" ng-click="upgradeDevice(device.id, device.endpoint)" ng-disabled="holdSubmit">{{\'upgrade_device\' | translate}}</button> <button class="btn btn-primary btn-xs" ng-if="POST_DEVICE_REBOOT" ng-click="rebootDevice(device.id, device.endpoint)" ng-disabled="holdSubmit">{{\'reboot\' | translate}}</button> <button class="btn btn-warning btn-xs" ng-if="POST_FORMAT_SDCARD" ng-click="formatDeviceSDCard(device.id, device.endpoint)" ng-disabled="holdSubmit">{{\'format_device_sdcard\' | translate}}</button> <button class="btn btn-info btn-xs" ng-if="GET_DEVICE_PARAM" ng-click="openParamPage(device.id, device.endpoint, device.inNewServer)" ng-disabled="holdSubmit">{{\'param_config\' | translate}}</button> <button class="btn btn-primary btn-xs" ng-if="GET_DEVICE_LOGS" ng-click="openLogPage(device.id, device.deviceName, device.endpoint, device.inNewServer)">{{\'device_log\' | translate}}</button> <button class="btn btn-danger btn-xs" ng-if="device.enabled && PUT_DEVICE_ENABLED" ng-click="lockDevice(device.id, false)">{{\'lock_device\' | translate}}</button> <button class="btn btn-success btn-xs" ng-if="!device.enabled && PUT_DEVICE_ENABLED" ng-click="lockDevice(device.id, true)">{{\'unlock_device\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="8" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="devicesEmpty"><td colspan="8" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></uib-tab><uib-tab heading="{{\'device_detail_info\' | translate}}" ng-if="DEVICE_DETAIL_INFO"><div ng-include="\'app/pages/devices/tabs/deviceDetailInfo.html\'"></div></uib-tab><uib-tab heading="{{\'get_device_%s_service\' | translate}}" ng-if="DEVICE_SERVICE_CHANGE"><div ng-include="\'app/pages/devices/tabs/getDeviceService.html\'"></div></uib-tab><uib-tab heading="{{\'check_device_id_valid\' | translate}}" ng-if="CHECK_DEVICE_ID"><div ng-include="\'app/pages/devices/tabs/checkDeviceId.html\'"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/distributors/distributors.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_DISTRIBUTOR" class="btn btn-info btn-mm" style="margin-bottom: 10px">{{\'createDistributor\' | translate }}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="distributors"><thead><tr><th style="width: 150px"><input st-search="appId" st-input-event="change" type="number" class="form-control search-input" placeholder="{{\'app_id\' | translate}}"></th></tr><tr class="black-muted-bg"><th>#</th><th>{{\'name\' | translate }}</th><th>{{\'uaid\' | translate }}</th><th>{{\'info\' | translate }}</th><th>{{\'app_id\' | translate }}</th><th>{{\'is_root\' | translate }}</th><th ng-if="EDIT_DISTRIBUTOR">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="distributor in distributors" class="no-top-border"><td><a>{{distributor.id}}</a></td><td>{{distributor.distributorName}}</td><td>{{distributor.distributorUAID}}</td><td>{{distributor.distributorInfo}}</td><td>{{distributor.appId}}</td><td>{{distributor.isRoot | isRootFilter}}</td><td ng-if="EDIT_DISTRIBUTOR"><div class="buttons"><button class="btn btn-info btn-xs" ng-click="openEditPage(distributor)">{{\'editDistributor\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="11" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="11" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="11" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="distributorsEmpty"><td colspan="11" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/distributors/editDistributor.html','<div class="modal-content"><div class="modal-header bg-info"><span ng-if="isNewDistributor">{{\'createDistributor\' | translate}}</span> <span ng-if="!isNewDistributor">{{\'editDistributor\' | translate}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="distributorName">{{\'name\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="distributorName" ng-model="data.distributorName" ng-focus="clearError()"><p class="help-block red-color" ng-show="errDistributorName">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="distributorInfo">{{\'info\' | translate }}</label> <input type="text" class="form-control" id="distributorInfo" ng-model="data.distributorInfo" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label for="appId">{{\'app_id\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="appId" ng-model="data.appId" ng-focus="clearError()"><p class="help-block red-color" ng-show="errAppId">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'is_root\' | translate }}</label><select class="form-control" ng-model="isRootSelected" ng-change="isRootChange(isRootSelected)" ng-options="item as item.label for item in isRootItems track by item.value"></select></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/firmware/editPatch.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{isNewPatch ? (\'new_patch\' | translate) : (\'edit\' | translate)}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="from">{{\'from_version\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="from" ng-model="data.from" ng-focus="clearError()"><p class="help-block red-color" ng-show="errFrom">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="to">{{\'to_version\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="to" ng-model="data.to" ng-focus="clearError()"><p class="help-block red-color" ng-show="errTo">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="md5">MD5 {{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="md5" ng-model="data.md5" ng-focus="clearError()"><p class="help-block red-color" ng-show="errMd5">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>URL {{\'not_null\' | translate}}</label> <input type="text" class="form-control" ng-model="data.url" ng-focus="clearError()"><p class="help-block red-color" ng-show="errUrl">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="firmware_size">{{\'firmware_size\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="firmware_size" ng-model="data.size" ng-focus="clearError()"><p class="help-block red-color" ng-show="errSize">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="firmware_space_needed">{{\'firmware_space_needed\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="firmware_space_needed" ng-model="data.spaceNeeded" ng-focus="clearError()"><p class="help-block red-color" ng-show="errSpaceNeeded">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'level\' | translate }}</label><select class="form-control" ng-model="patchLevelSelected" ng-change="patchLevelChange(patchLevelSelected)" ng-options="item as item.label for item in patchLevelItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label for="note">{{\'note\' | translate }}</label> <input type="text" class="form-control" id="note" ng-model="data.note" ng-focus="clearError()"></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/firmware/patches.html','<div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel large-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'data_list\' | translate}}"><div><button type="button" class="btn btn-primary btn-mm" ng-show="WRITE_FIRMWARE" style="margin-bottom: 10px" data-toggle="modal" ng-click="openEditPage()">{{\'new_patch\' | translate}}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="patches"><thead><tr><th></th><th><input st-search="fromVersion" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></th><th><input st-search="toVerison" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></th><th></th><th><div class="form-group"><label>{{\'state\' | translate }}:</label><select st-search="state" class="form-control" ng-model="stateSelected" ng-options="item as item.label for item in stateItems track by item.value"></select></div></th><th></th><th><div class="form-group"><label>{{\'published\' | translate }}:</label><select st-search="publish" class="form-control" ng-model="publishedSelected" ng-options="item as item.label for item in publishedItems track by item.value"></select></div></th><th><div style="width: 1px"><button type="button" class="btn btn-info">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetQuery()">{{\'reset_search\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="refresh()">{{\'refresh\' | translate}}</button></div></th></tr><tr class="black-muted-bg"><th>{{\'patch_id\' | translate}}</th><th>{{\'from_version\' | translate}}</th><th>{{\'to_version\' | translate}}</th><th>{{\'level\' | translate}}</th><th>MD5</th><th>{{\'firmware_size\' | translate}}</th><th>{{\'firmware_space_needed\' | translate}}</th><th>{{\'state\' | translate}}</th><th>{{\'published\' | translate}}</th><th>{{\'create_time\' | translate}}</th><th>{{\'note\' | translate}}</th><th ng-show="UPDATE_FIRMWARE || PUBLISH_FIRMWARE || SET_FIRMWARE_TESTED">{{\'manage\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="patch in patches" class="no-top-border"><td><a href="{{patch.url}}" target="_blank">{{patch.PID}}</a></td><td>{{patch.from}}</td><td>{{patch.to}}</td><td>{{patch.level| level}}</td><td>{{patch.md5}}</td><td>{{patch.size}}</td><td>{{patch.spaceNeeded}}</td><td>{{patch.state}}</td><td ng-show="patch.publish"><span class="label label-primary">{{patch.publish | translate}}</span></td><td ng-show="!patch.publish"><span class="label label-danger">{{patch.publish | translate}}</span></td><td>{{patch.created > 0 ? (patch.created | date:\'yyyy-MM-dd HH:mm:ss\') : \'\' }}</td><td>{{patch.note}}</td><td ng-show="UPDATE_FIRMWARE || PUBLISH_FIRMWARE || SET_FIRMWARE_TESTED"><button ng-show="UPDATE_FIRMWARE" class="btn btn-primary editable-table-button btn-xs" ng-click="openEditPage(patch)">{{\'edit\' | translate}}</button> <button ng-show="SET_FIRMWARE_TESTED && patch.state == \'wait_for_test\'" class="btn btn-warning editable-table-button btn-xs" ng-click="openSetTestedPage(patch.PID)">{{\'set_tested\' | translate}}</button> <button ng-show="UPDATE_FIRMWARE && patch.state == \'tested\'" class="btn btn-success editable-table-button btn-xs" ng-click="openDisablePage(patch.PID)">{{\'disable\' | translate}}</button> <button ng-show="PUBLISH_FIRMWARE && patch.state == \'tested\' && !patch.publish" class="btn btn-info editable-table-button btn-xs" ng-click="openPublishPage(patch.PID)">{{\'publish\' | translate}}</button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="12" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="patchesEmpty"><td colspan="4" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></uib-tab><uib-tab heading="{{\'upgrade\' | translate}}" ng-if="GET_UPGRADE_PATH"><div ng-include="\'app/pages/firmware/tabs/upgrade.html\'"></div></uib-tab><uib-tab heading="{{\'batch_upgrade\' | translate}}" ng-if="BATCH_UPGRADE"><div ng-include="\'app/pages/firmware/tabs/batchUpgrade.html\'"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/firmware/publishPatch.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/members/deleteMember.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()" ng-disabled="holdSubmit">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/members/members.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><table class="table table-hover" st-pipe="callServer" st-table="members"><thead><tr><th><input st-search="userName" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></th><th><input st-search="email" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></th><th><div style="width: 1px"><button type="button" class="btn btn-info">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetQuery()">{{\'reset_search\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="refresh()">{{\'refresh\' | translate}}</button></div></th></tr><tr class="black-muted-bg"><th>{{\'user_name\' | translate}}</th><th>{{\'email\' | translate}}</th><th>{{\'app_id\' | translate}}</th><th>{{\'my_devices\' | translate}}</th><th class="hidden-text">{{\'in_new_server\' | translate }}</th><th>{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="member in members" class="no-top-border"><td><a>{{member.userName}}</a></td><td>{{member.email}}</td><td>{{member.appId}}</td><td><a href="" ng-click="goDevice(member.userName)">{{\'my_devices\' | translate}}</a></td><td ng-show="member.inNewServer"><span class="label label-primary">{{member.inNewServer | inNewServer}}</span></td><td ng-show="!member.inNewServer"><span class="label label-danger">{{member.inNewServer | inNewServer}}</span></td><td><div class="buttons"><button class="btn btn-info btn-xs" ng-if="GET_ACTIVITY" ng-click="getActivity(member.id, member.userName)" ng-disabled="holdSubmit">{{\'record\' | translate}}</button> <button class="btn btn-warning btn-xs" ng-if="GET_UDID" ng-click="getUdid(member.id)" ng-disabled="holdSubmit">UDID</button> <button ng-show="EDIT_MEMBER" class="btn btn-primary btn-xs" ng-click="modifyEmail(member.id)">{{\'modify_email\' | translate}}</button> <button ng-show="EDIT_MEMBER" class="btn btn-warning btn-xs" ng-click="modifyPassword(member.id)">{{\'modify_password\' | translate}}</button> <button ng-show="DELETE_MEMBER" class="btn btn-danger btn-xs" ng-click="deleteMember(member.id, member.userName)">{{\'delete_member\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="6" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="membersEmpty"><td colspan="6" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/members/modifyEmail.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{\'modify_email\' | translate}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx"><label for="email">{{\'new_email\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="email" ng-model="data.email" ng-focus="clearError()"><p class="help-block red-color" ng-show="errEmail">{{errorMessage | translate}}</p></div></form></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/members/modifyPassword.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{\'new_password\' | translate}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx"><label for="plainPassword1">{{\'new_password\' | translate }}{{\'not_null\' | translate}}</label> <input type="password" class="form-control" id="plainPassword1" ng-model="plainPassword1" ng-focus="clearError()"><p class="help-block red-color" ng-show="errPass">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="plainPassword2">{{\'confirm_password\' | translate }}{{\'not_null\' | translate}}</label> <input type="password" class="form-control" id="plainPassword2" ng-model="plainPassword2" ng-focus="clearError()"><p class="help-block red-color" ng-show="errConfirmPass">{{errorMessage | translate}}</p></div></form></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/pricing/editPrice.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{isNewPrice ? (\'makePrice\' | translate) : (\'editPrice\' | translate)}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="region">{{\'region\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="region" ng-model="data.region" ng-focus="clearError()"><p class="help-block red-color" ng-show="errRegion">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'service_type\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="serviceType" ng-model="data.serviceType" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label>{{\'currency\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" ng-model="currencySelected" ng-change="currencyChange(currencySelected)" ng-options="item as item.label for item in currencyItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label for="price">{{\'price\' | translate }}(cent){{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="price" ng-model="data.price" ng-focus="clearError()"><p class="help-block red-color" ng-show="errPrice">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="discount_price">{{\'discount_price\' | translate }}(cent){{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="discount_price" ng-model="data.discountPrice" ng-focus="clearError()"><p class="help-block red-color" ng-show="errPrice">{{errorMessage | translate}}</p></div><div class="form-group"><label>{{\'app_id\' | translate }}</label> <input type="number" class="form-control" ng-model="data.appId" ng-focus="clearError()"><p class="help-block red-color" ng-show="errAppId">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'enable\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" ng-model="isEnableSelected" ng-change="isEnableChange(isEnableSelected)" ng-options="item as item.label for item in isEnableItems track by item.value"></select></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/pricing/modifyPriceStatus.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{\'modifyPriceStatus\' | translate}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx"><label>{{\'currency\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" ng-model="currencySelected" ng-change="currencyChange(currencySelected)" ng-options="item as item.label for item in currencyItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label for="price">{{\'price\' | translate }}(cent){{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="price" ng-model="data.price" ng-focus="clearError()"><p class="help-block red-color" ng-show="errPrice">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="discount_price">{{\'discount_price\' | translate }}(cent){{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="discount_price" ng-model="data.discountPrice" ng-focus="clearError()"><p class="help-block red-color" ng-show="errPrice">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'enable\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" ng-model="isEnableSelected" ng-change="isEnableChange(isEnableSelected)" ng-options="item as item.label for item in isEnableItems track by item.value"></select><label>{{\'trial_enable\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" ng-model="trialEnableSelected" ng-change="isTrialEnableChange(trialEnableSelected)" ng-options="item as item.label for item in trialEnableItems track by item.value"></select></div></form></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/pricing/pricing.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-info btn-mm" style="margin-bottom: 10px">{{\'makePrice\' | translate }}</button><table class="table table-hover" st-pipe="callServer" st-table="servicePrices"><thead><tr><th></th><th><select class="form-control" ng-model="regionSelected" ng-change="regionChanged(regionSelected)" ng-options="item as item.label for item in regions track by item.value"></select></th><th><select class="form-control" ng-model="serviceTypeSelected" ng-change="serviceTypeChanged(serviceTypeSelected)" ng-options="item as item.label for item in serviceTypes track by item.value"></select></th><th><select class="form-control" ng-model="currencySelected" ng-change="currencyChanged(currencySelected)" ng-options="item as item.label for item in currencys track by item.value"></select></th><th></th><th><input type="text" class="form-control" ng-model="data.appId" placeholder="{{\'search_placeholder\' | translate}}"></th><th><select class="form-control" ng-model="statusSelected" ng-change="statusChanged(statusSelected)" ng-options="item as item.label for item in statusSet track by item.value"></select></th><th><button type="button" class="btn btn-info" ng-click="search()">{{\'search\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="refresh()">{{\'refresh\' | translate}}</button></th></tr><tr class="black-muted-bg"><th>#</th><th>{{\'region\' | translate }}</th><th>{{\'service_type\' | translate }}</th><th>{{\'currency\' | translate}}</th><th>{{\'price\' | translate }}(cent)</th><th>{{\'discount_price\' | translate }}(cent)</th><th>{{\'app_id\' | translate}}</th><th>{{\'status\' | translate}}</th><th>{{\'trial_status\' | translate}}</th><th></th><th ng-if="EDIT_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="servicePrice in servicePrices" class="no-top-border"><td><a>{{servicePrice.id}}</a></td><td>{{servicePrice.region}}</td><td>{{servicePrice.serviceType}}</td><td>{{servicePrice.currency}}</td><td>{{servicePrice.price}}</td><td>{{servicePrice.discountPrice}}</td><td>{{servicePrice.appId}}</td><td>{{servicePrice.enable | servicePriceStatus}}</td><td>{{servicePrice.trialEnable | servicePriceStatus}}</td><td></td><td ng-if="EDIT_P"><div class="buttons"><button class="btn btn-info btn-xs" ng-click="modifyPriceStatus(servicePrice)">{{\'edit\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="8" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="pricesEmpty"><td colspan="8" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/transactions/transactions.html','<div class="panel panel-default bootstrap-panel with-scroll"><div class="panel-heading">{{\'details_title\' | translate}}</div><div class="panel-body"><form class="row form-inline"><div class="col-md-12"><div class="col-md-2"><div class="form-group"><label>{{\'device_sn\' | translate}}</label> <input type="text" class="form-control" ng-model="data.serialNumber"></div></div><div class="col-md-2"><div class="form-group"><label>{{\'user_name\' | translate}}</label> <input type="text" class="form-control" ng-model="data.memberName"></div></div><div class="col-md-2"><div class="form-group"><label>{{\'app_id\' | translate}}</label> <input type="number" class="form-control" ng-model="data.appID"></div></div><div class="col-md-2"><div class="form-group"><label>{{\'distributor_id\' | translate}}</label> <input type="number" class="form-control" ng-model="data.distributorID"></div></div></div><div class="col-md-12" style="margin-top: 10px"><div class="dropdown form-group col-md-2"><label>{{\'start_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownStart" role="button" data-toggle="dropdown"><div class="input-group date"><input type="text" class="form-control" data-ng-model="dateRangeStart"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeStart" data-datetimepicker-config="{ dropdownSelector: \'#dropdownStart\', renderOn: \'end-date-changed\' }" data-on-set-time="startDateOnSetTime()" data-before-render="startDateBeforeRender($dates)"></datetimepicker></ul></div><div class="dropdown form-group col-md-2"><label>{{\'end_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownEnd" role="button" data-toggle="dropdown"><div class="input-group date"><input class="form-control" data-ng-model="dateRangeEnd"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeEnd" data-datetimepicker-config="{ dropdownSelector: \'#dropdownEnd\', renderOn: \'start-date-changed\' }" data-on-set-time="endDateOnSetTime()" data-before-render="endDateBeforeRender($view, $dates, $leftDate, $upDate, $rightDate)"></datetimepicker></ul></div><div class="dropdown form-group col-md-4" style="margin-top: 20px"><button type="button" class="btn btn-info" ng-click="search()">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetSearch()">{{\'reset_search\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="refresh()">{{\'refresh\' | translate}}</button></div></div></form><table class="table table-hover"><thead><tr class="black-muted-bg"><th>{{\'device_sn\' | translate}}</th><th>{{\'user_name\' | translate}}</th><th>{{\'customer_id\' | translate}}</th><th>{{\'app_id\' | translate}}</th><th>{{\'distributor_id\' | translate}}</th><th>{{\'pay_method\' | translate}}</th><th>{{\'amount\' | translate}}</th><th>{{\'create_time\' | translate}}</th><th>{{\'pay_status\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="transaction in transactions" class="no-top-border"><td>{{transaction.serialNumber}}</td><td>{{transaction.memberName}}</td><td>{{transaction.customerId}}</td><td>{{transaction.appID}}</td><td>{{transaction.distributorID}}</td><td>{{transaction.payMethod}}</td><td>{{transaction.amount}}</td><td>{{transaction.createTime > 0 ? (transaction.createTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td><td>{{transaction.payStatus}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="11" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="11" class="text-center"><div ng-include="\'app/theme/components/pagination/pagination.custom.html\'"></div></td></tr><tr ng-show="getDataError"><td colspan="11" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="transactionsEmpty"><td colspan="12" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div>');
$templateCache.put('app/services/modals/confirmModal.html','<div class="modal-content" ng-controller="StaticModalsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center" style="word-wrap: break-word;">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="clickPositive()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/auth/modals/updatePassword.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{\'modify_password\' | translate}}</h4></div><div class="modal-body"><form><div class="form-group"><label for="newPassword">{{\'new_password\' | translate}}</label> <input type="password" class="form-control" id="newPassword" ng-model="plainPassword1" ng-focus="clearError()"><p class="help-block red-color" ng-show="errPass">{{errorMessage | translate}}</p></div><div class="form-group"><label for="confirmPassword">{{\'confirm_password\' | translate}}</label> <input type="password" class="form-control" id="confirmPassword" ng-model="plainPassword2" ng-focus="clearError()"><p class="help-block red-color" ng-show="errConfirmPass">{{errorMessage | translate}}</p></div><button type="submit" class="btn btn-danger" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></form></div></div>');
$templateCache.put('app/pages/bmUsers/mine/changePassword.html','<form class="form-horizontal" ng-controller="ChangePasswordCtrl"><div class="form-group"><label for="oldPassword" class="col-sm-2 control-label">{{\'old_password\' | translate}}</label><div class="col-sm-5"><input type="password" class="form-control" id="oldPassword" ng-model="oldPlainPassword" ng-focus="clearError()"><p class="help-block red-color" ng-show="errOldPass">{{errorMessage | translate}}</p></div></div><div class="form-group"><label for="newPassword" class="col-sm-2 control-label">{{\'new_password\' | translate}}</label><div class="col-sm-5"><input type="password" class="form-control" id="newPassword" ng-model="plainPassword1" ng-focus="clearError()"><p class="help-block red-color" ng-show="errPass">{{errorMessage | translate}}</p></div></div><div class="form-group"><label for="confirmPassword" class="col-sm-2 control-label">{{\'confirm_password\' | translate}}</label><div class="col-sm-5"><input type="password" class="form-control" id="confirmPassword" ng-model="plainPassword2" ng-focus="clearError()"><p class="help-block red-color" ng-show="errConfirmPass">{{errorMessage | translate}}</p></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-5"><button type="submit" class="btn btn-warning" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div></div></form>');
$templateCache.put('app/pages/bmUsers/mine/mine.html','<div class="widgets"><div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel large-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'details\' | translate}}"><form class="form-horizontal"><div class="form-group"><label for="userName" class="col-md-1 control-label">{{\'user_name\' | translate}}</label><div class="col-md-5"><input type="text" class="form-control" id="userName" ng-model="userName" disabled=""></div></div><div class="form-group"><label for="appId" class="col-md-1 control-label">{{\'app_id\' | translate}}</label><div class="col-md-5"><input type="text" class="form-control" id="appId" ng-model="appId" disabled=""></div></div><div class="form-group"><label for="distributorId" class="col-md-1 control-label">{{\'distributor_id\' | translate}}</label><div class="col-md-5"><input type="text" class="form-control" id="distributorId" ng-model="distributorId" disabled=""></div></div><div class="form-group"><label for="email" class="col-md-1 control-label">{{\'email\' | translate}}</label><div class="col-md-5"><input type="email" class="form-control" id="email" ng-model="mine.email" ng-focus="clearError()"><p class="help-block red-color" ng-show="errorEmail">{{errorMessage | translate}}</p></div></div><div class="form-group"><div class="col-md-offset-1 col-md-2"><button ng-click="submit()" class="btn btn-warning" ng-disabled="holdSubmit">{{\'modify_email\' | translate}}</button><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="col-md-2"><button ng-click="getActivities()" class="btn btn-primary">{{\'get_activity\' | translate}}</button></div></div><div><label class="custom-checkbox upper-text bold-text">{{\'permission\' | translate}}</label></div><div ng-repeat="p in permissionList"><input type="checkbox" ng-model="permissionList[$index].checked" disabled=""> <span>{{ p.value | translate}}</span></div></form></uib-tab><uib-tab heading="{{\'modify_password\' | translate}}"><div ng-include="\'app/pages/bmUsers/mine/changePassword.html\'"></div></uib-tab></uib-tabset></div></div></div></div></div>');
$templateCache.put('app/pages/clientVersions/tabs/uploadCNApk.html','<div class="row" ng-controller="UploadCNApkCtrl"><div class="col-md-12"><h3>{{\'CN\' | translate}}:</h3><form><div class="form-group"><label>{{\'client\' | translate }}</label><select class="form-control" ng-model="clientSelected" ng-change="clientChange(clientSelected)" style="width: 400px" ng-options="item as item.label for item in clientItems track by item.value"></select></div><div class="form-group"><label for="appVersion">{{\'app_version\' | translate}}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="appVersion" style="width: 400px" ng-model="appVersion"><p class="help-block red-color" ng-show="errAppVersion">{{errorMessage | translate}}</p></div><div class="form-group"><label for="apkFile">{{\'please_to_choose_a_file\' | translate}}</label> <input type="file" id="apkFile" nv-file-select="" uploader="uploader"></div><div class="col-md-12"><h3>{{\'upload_queue\' | translate}}</h3><table class="table text-center"><thead><tr><th>{{\'name\' | translate}}</th><th class="text-center" ng-show="uploader.isHTML5">{{\'size\' | translate}}</th><th class="text-center" ng-show="uploader.isHTML5">{{\'progress\' | translate}}</th><th class="text-center">{{\'status\' | translate}}</th><th class="text-center">{{\'actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in uploader.queue"><td><strong>{{ item.file.name }}</strong></td><td ng-show="uploader.isHTML5" nowrap="">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show="uploader.isHTML5"><div class="progress" style="margin-bottom: 0;"><div class="progress-bar" role="progressbar" ng-style="{ \'width\': item.progress + \'%\' }"></div></div><span>{{item.progress}}%</span></td><td><span ng-show="item.isSuccess"><i class="glyphicon glyphicon-ok"></i></span> <span ng-show="item.isCancel"><i class="glyphicon glyphicon-ban-circle"></i></span> <span ng-show="item.isError"><i class="glyphicon glyphicon-remove"></i></span></td><td><button type="button" class="btn btn-success btn-xs" ng-click="item.upload()" ng-disabled="item.isReady || item.isUploading || item.isSuccess || notReady"><span class="glyphicon glyphicon-upload"></span> {{\'upload\' | translate}}</button> <button type="button" class="btn btn-warning btn-xs" ng-click="item.cancel()" ng-disabled="!item.isUploading"><span class="glyphicon glyphicon-ban-circle"></span> {{\'cancel\' | translate}}</button> <button type="button" class="btn btn-danger btn-xs" ng-click="item.remove()"><span class="glyphicon glyphicon-trash"></span> {{\'remove\' | translate}}</button></td></tr></tbody></table><div><div>{{\'queue_progress\' | translate}}<div class="progress" style=""><div class="progress-bar" role="progressbar" ng-style="{ \'width\': uploader.progress + \'%\' }"></div></div></div></div></div></form></div></div>');
$templateCache.put('app/pages/clientVersions/tabs/uploadHistory.html','<div ng-controller="UploadHistoryCtrl"><form class="row form-inline"><div class="dropdown form-group col-md-2"><label>{{\'client\' | translate}}</label><div class="dropdown-toggle"><select class="form-control" ng-change="clientChange(clientSelected)" ng-model="clientSelected" ng-options="item as item.label for item in clientItems track by item.value"></select></div></div><div class="dropdown form-group col-md-2"><label>{{\'operator\' | translate}}</label><div class="dropdown-toggle"><input type="text" class="form-control" ng-model="data.operator"></div></div><div class="dropdown form-group col-md-2"><label>{{\'start_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownStart" role="button" data-toggle="dropdown"><div class="input-group date"><input type="text" class="form-control" data-ng-model="dateRangeStart"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeStart" data-datetimepicker-config="{ dropdownSelector: \'#dropdownStart\', renderOn: \'end-date-changed\' }" data-on-set-time="startDateOnSetTime()" data-before-render="startDateBeforeRender($dates)"></datetimepicker></ul></div><div class="dropdown form-group col-md-2"><label>{{\'end_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownEnd" role="button" data-toggle="dropdown"><div class="input-group date"><input class="form-control" data-ng-model="dateRangeEnd"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeEnd" data-datetimepicker-config="{ dropdownSelector: \'#dropdownEnd\', renderOn: \'start-date-changed\' }" data-on-set-time="endDateOnSetTime()" data-before-render="endDateBeforeRender($view, $dates, $leftDate, $upDate, $rightDate)"></datetimepicker></ul></div><div class="dropdown form-group col-md-4" style="margin-top: 20px"><button type="button" class="btn btn-info" ng-click="callServer()">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetSearch()">{{\'reset_search\' | translate}}</button></div></form><table class="table table-hover"><thead><tr class="black-muted-bg"><th>{{\'client\' | translate }}</th><th>{{\'version\' | translate }}</th><th>{{\'operator\' | translate }}</th><th>{{\'bucket\' | translate }}</th><th>{{\'file_name\' | translate }}</th><th>{{\'time\' | translate }}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="history in histories" class="no-top-border"><td><a>{{history.clientName}}</a></td><td>{{history.version}}</td><td>{{history.operator}}</td><td>{{history.bucket | bucketFilter}}</td><td>{{history.fileName}}</td><td>{{history.createTime > 0 ? (history.createTime | date:\'yyyy-MM-dd HH:mm:ss\') : 0 }}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="5" class="text-center"><div ng-include="\'app/theme/components/pagination/pagination.custom.html\'"></div></td></tr><tr ng-show="getDataError"><td colspan="5" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="historiesEmpty"><td colspan="5" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div>');
$templateCache.put('app/pages/clientVersions/tabs/uploadUSApk.html','<div class="row" ng-controller="UploadUSApkCtrl"><div class="col-md-12"><h3>{{\'US\' | translate}}:</h3><form><div class="form-group"><label>{{\'client\' | translate }}</label><select class="form-control" ng-model="clientSelected" ng-change="clientChange(clientSelected)" style="width: 400px" ng-options="item as item.label for item in clientItems track by item.value"></select></div><div class="form-group"><label for="appVersion">{{\'app_version\' | translate}}</label> <input type="text" class="form-control" id="appVersion" style="width: 400px" ng-model="appVersion"><p class="help-block red-color" ng-show="errAppVersion">{{errorMessage | translate}}</p></div><div class="form-group"><label for="apkUSFile">{{\'please_to_choose_a_file\' | translate}}</label> <input type="file" id="apkUSFile" nv-file-select="" uploader="uploader"></div><div class="col-md-12"><h3>{{\'upload_queue\' | translate}}</h3><table class="table text-center"><thead><tr><th>{{\'name\' | translate}}</th><th class="text-center" ng-show="uploader.isHTML5">{{\'size\' | translate}}</th><th class="text-center" ng-show="uploader.isHTML5">{{\'progress\' | translate}}</th><th class="text-center">{{\'status\' | translate}}</th><th class="text-center">{{\'actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in uploader.queue"><td><strong>{{ item.file.name }}</strong></td><td ng-show="uploader.isHTML5" nowrap="">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show="uploader.isHTML5"><div class="progress" style="margin-bottom: 0;"><div class="progress-bar" role="progressbar" ng-style="{ \'width\': item.progress + \'%\' }"></div></div><span>{{item.progress}}%</span></td><td><span ng-show="item.isSuccess"><i class="glyphicon glyphicon-ok"></i></span> <span ng-show="item.isCancel"><i class="glyphicon glyphicon-ban-circle"></i></span> <span ng-show="item.isError"><i class="glyphicon glyphicon-remove"></i></span></td><td><button type="button" class="btn btn-success btn-xs" ng-click="item.upload()" ng-disabled="item.isReady || item.isUploading || item.isSuccess || notReady"><span class="glyphicon glyphicon-upload"></span> {{\'upload\' | translate}}</button> <button type="button" class="btn btn-warning btn-xs" ng-click="item.cancel()" ng-disabled="!item.isUploading"><span class="glyphicon glyphicon-ban-circle"></span> {{\'cancel\' | translate}}</button> <button type="button" class="btn btn-danger btn-xs" ng-click="item.remove()"><span class="glyphicon glyphicon-trash"></span> {{\'remove\' | translate}}</button></td></tr></tbody></table><div><div>{{\'queue_progress\' | translate}}<div class="progress" style=""><div class="progress-bar" role="progressbar" ng-style="{ \'width\': uploader.progress + \'%\' }"></div></div></div></div></div></form></div></div>');
$templateCache.put('app/pages/devices/logs/deviceLogs.html','');
$templateCache.put('app/pages/devices/logs/localDeviceLogs.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'device_log\' | translate}} {{headerName}}</span></div><div class="modal-body"><div class="row"><div class="col-md-12"><div><form class="row form-inline"><div class="dropdown form-group col-md-4"><label>{{\'start_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownStart" role="button" data-toggle="dropdown"><div class="input-group date"><input type="text" class="form-control" data-ng-model="dateRangeStart"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeStart" data-datetimepicker-config="{ dropdownSelector: \'#dropdownStart\', renderOn: \'end-date-changed\' }" data-on-set-time="startDateOnSetTime()" data-before-render="startDateBeforeRender($dates)"></datetimepicker></ul></div></form><table class="table table-hover"><colgroup><col class="col-md-1"><col class="col-md-6"><col class="col-md-3"><col class="col-md-2"></colgroup><thead><tr class="black-muted-bg"><th><input type="checkbox" ng-model="allItemsSelected" ng-change="selectAll()"></th><th>{{\'name\' | translate }}</th><th>{{\'time\' | translate }}</th><th>{{\'log_dowload\' | translate}}</th></tr></thead><tbody><tr ng-repeat="log in logs" class="no-top-border" ng-show="!isLoading"><td><input type="checkbox" ng-model="log.isChecked" ng-change="selectEntity()"></td><td>{{log.name}}</td><td>{{(log.time > 0) ? (log.time | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td><td ng-show="log.url"><a href="{{log.url}}" target="_blank">{{\'log_dowload\' | translate}}</a></td><td ng-show="!log.url"></td></tr><tr ng-show="isLoading"><td colspan="3" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError && !isLoading"><td colspan="3" class="text-center"><nav><ul class="pagination"><li ng-if="lastPageLength > 0"><a ng-click="selectPage(\'last\')">{{\'prevPage\' | translate}}</a></li><li ng-if="nextPageKey != null"><a ng-click="selectPage(\'next\')">{{\'nextPage\' | translate}}</a></li></ul></nav></td></tr><tr ng-show="getDataError"><td colspan="3" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr></tfoot></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="downloadSelect()">{{\'download_select\'| translate}}</button> <button type="button" class="btn btn-warning" ng-click="resetSearch()">{{\'reset_search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'close\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/modals/deviceDetail.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'detail_info\' | translate}}</span></div><div class="modal-body"><div class="table-responsive"><span ng-show="getDataError" class="red-color">{{\'unable_get_data\' | translate}}</span> <span ng-show="isLoading">{{\'loading\' | translate}}</span><table class="table" ng-show="!getDataError && !isLoading"><tr><th class="text-center">{{\'device_sn\' | translate}}</th><th>{{result.serialNumber}}</th></tr><tr><td>{{\'device_name\' | translate}}</td><td>{{result.deviceName}}</td></tr><tr><td>{{\'online_status\' | translate}}</td><td ng-show="result.online"><span class="label label-success" style="color: #ffffff">{{result.online | onlineFilter}}</span></td><td ng-show="!result.online"><span class="label label-danger" style="color: #ffffff">{{result.online | onlineFilter}}</span></td></tr><tr><td>{{\'default_server\' | translate}}</td><td>{{result.serverToConnect}}</td></tr><tr><td>{{\'current_firmware\' | translate}}</td><td>{{result.currentVersion}}</td></tr><tr><td>{{\'newest_firmware\' | translate}}</td><td>{{result.newestVersion}}</td></tr><tr><td>{{\'connected_server\' | translate}}</td><td>{{result.lastConnectedServer}}</td></tr><tr><td>{{\'last_connected_time\' | translate}}</td><td>{{result.lastConnectTime > 0 ? (result.lastConnectTime | date:\'yyyy-MM-dd HH:mm:ss\') : 0 }}</td></tr><tr ng-show="isLocal"><td>{{\'last_off_server\' | translate}}</td><td>{{result.lastOffServer}}</td></tr><tr ng-show="isLocal"><td>{{\'last_logoff_time\' | translate}}</td><td>{{result.lastOffTime > 0 ? (result.lastOffTime | date:\'yyyy-MM-dd HH:mm:ss\') : 0}}</td></tr><tr><td>{{\'lan_addr\' | translate}}</td><td>{{result.lanAddr}}</td></tr><tr><td>{{\'pub_addr\' | translate}}</td><td>{{result.publicAddr}}</td></tr><tr><td>{{\'upnp_addr\' | translate}}</td><td>{{result.upnpAddr}}</td></tr></table></div></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">{{\'close\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/modals/deviceParam.html','<div class="modal-content"><div class="modal-header bg-info"><span ng-if="isNewBmUser">{{\'new_bmUser\' | translate}}</span> <span ng-if="!isNewBmUser">{{\'edit\' | translate}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx"><label for="des">{{\'des_key\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="des" ng-model="data.DK" ng-focus="clearError()" ng-disabled="true"><p class="help-block red-color" ng-show="errDesKey">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="md5">{{\'md5_sum\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="md5" ng-model="data.MD" ng-focus="clearError()" ng-disabled="true"><p class="help-block red-color" ng-show="errMd5">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="stc">{{\'server_to_connect\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="stc" ng-model="data.toEndpoint" ng-focus="clearError()" ng-disabled="!PUT_DEVICE_PARAM"><p class="help-block red-color" ng-show="errServerConnect">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="region">{{\'region_to_connect\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="region" ng-model="data.toRegion" ng-focus="clearError()" ng-disabled="!PUT_DEVICE_PARAM"></div><div class="form-group margin-thirdPx"><label for="appId">{{\'app_id\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="appId" ng-model="data.AID" ng-focus="clearError()" ng-disabled="!PUT_DEVICE_PARAM"><p class="help-block red-color" ng-show="errAppId">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="distributorId">{{\'distributor_id\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="distributorId" ng-model="data.DID" ng-focus="clearError()" ng-disabled="!PUT_DEVICE_PARAM"><p class="help-block red-color" ng-show="errDistributorId">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'online_status\' | translate }}</label><select class="form-control" ng-model="statusSelected" ng-change="statusChange(statusSelected)" ng-disabled="true" ng-options="item as item.label for item in statusItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label for="cf">{{\'current_firmware\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="cf" ng-model="data.CF" ng-focus="clearError()" ng-disabled="true"><p class="help-block red-color" ng-show="errCurrentFirmware">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="nf">{{\'newest_firmware\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="nf" ng-model="data.NF" ng-focus="clearError()" ng-disabled="!PUT_DEVICE_PARAM"><p class="help-block red-color" ng-show="errNewestFirmware">{{errorMessage | translate}}</p></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-if="PUT_DEVICE_PARAM" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'close\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/modals/deviceService.html','<div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel middle-panel"><div class="modal-body" ng-if="!isLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'details_of_current_cloud_service\' | translate}}"><div class="table-responsive"><table class="table" ng-show="!getDataError && !isLoading"><tr><th class="text-center">{{\'user_name\' | translate}}</th><th>{{result.username}}</th></tr><tr><th class="text-center">{{\'serialNumber\' | translate}}</th><th>{{result.serialnumber}}</th></tr><tr><td>{{\'full_record_service_expire\' | translate}}</td><td>{{result.fullRecordExpire > 0 ? (result.fullRecordExpire | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td></tr><tr><td>{{\'full_record_auto_charge_status\' | translate}}</td><td ng-show="result.fullRecordAutoChargeOn"><span class="label label-primary" style="color: #ffffff">{{result.fullRecordAutoChargeOn | translate}}</span></td><td ng-show="!result.fullRecordAutoChargeOn"><span class="label label-danger" style="color: #ffffff">{{result.fullRecordAutoChargeOn | translate}}</span></td></tr><tr><td>{{\'video_motion_expire\' | translate}}</td><td>{{result.videoMotionExpire > 0 ? (result.videoMotionExpire | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td></tr><tr><td>{{\'video_motion_auto_charge_status\' | translate}}</td><td ng-show="result.videoMotionAutoChargeOn"><span class="label label-primary" style="color: #ffffff">{{result.videoMotionAutoChargeOn | translate}}</span></td><td ng-show="!result.videoMotionAutoChargeOn"><span class="label label-danger" style="color: #ffffff">{{result.videoMotionAutoChargeOn | translate}}</span></td></tr><tr><td>{{\'ring_call_service_expire\' | translate}}</td><td>{{result.serviceExpire > 0 ? (result.serviceExpire | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td></tr><tr><td>{{\'ring_call_trial_expire\' | translate}}</td><td>{{result.trialExpire > 0 ? (result.trialExpire | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td></tr><tr><td>{{\'ring_call_auto_charge_status\' | translate}}</td><td ng-show="result.serviceAutoChargeOn"><span class="label label-primary" style="color: #ffffff">{{result.serviceAutoChargeOn | translate}}</span></td><td ng-show="!result.serviceAutoChargeOn"><span class="label label-danger" style="color: #ffffff">{{result.serviceAutoChargeOn | translate}}</span></td></tr><tr><td>{{\'ai_motion_video_service_expire\' | translate}}</td><td>{{result.bodyDetectionExpire > 0 ? (result.bodyDetectionExpire | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td></tr><tr><td>{{\'ai_motion_video_auto_charge_status\' | translate}}</td><td ng-show="result.bodyDetectionAutoChargeOn"><span class="label label-primary" style="color: #ffffff">{{result.bodyDetectionAutoChargeOn | translate}}</span></td><td ng-show="!result.bodyDetectionAutoChargeOn"><span class="label label-danger" style="color: #ffffff">{{result.bodyDetectionAutoChargeOn | translate}}</span></td></tr></table></div><div class="modal-footer"><br><div class="row"><div class="col-md-12"><button type="button" class="btn btn-primary btn-sm pull-left" ng-show="RESET_DEVICE_SERVICE" ng-click="resetService(serviceType[1])" ng-disabled="serviceNotExist">{{\'reset_full_record_service\' | translate}}</button> <button type="button" class="btn btn-info btn-sm pull-left" ng-show="RESET_DEVICE_SERVICE" ng-click="resetService(serviceType[2])" ng-disabled="serviceNotExist">{{\'reset_video_motion_service\' | translate}}</button> <button type="button" class="btn btn-warning btn-sm pull-left" ng-show="RESET_DEVICE_SERVICE" ng-click="resetService(serviceType[0])" ng-disabled="serviceNotExist">{{\'reset_cloud_record_service\' | translate}}</button> <button type="button" class="btn btn-warning btn-sm pull-left" ng-show="RESET_DEVICE_SERVICE" ng-click="resetService(serviceType[3])" ng-disabled="serviceNotExist">{{\'reset_ai_motion_video_service\' | translate}}</button></div><br><br><div class="col-md-12"><button type="button" class="btn btn-primary btn-sm pull-left" ng-show="RESET_DEVICE_SERVICE" ng-click="resetService(serviceType[1], true)" ng-disabled="serviceNotExist">{{\'reset_full_record_autocharge\' | translate}}</button> <button type="button" class="btn btn-info btn-sm pull-left" ng-show="RESET_DEVICE_SERVICE" ng-click="resetService(serviceType[2], true)" ng-disabled="serviceNotExist">{{\'reset_video_motion_autocharge\' | translate}}</button> <button type="button" class="btn btn-warning btn-sm pull-left" ng-show="RESET_DEVICE_SERVICE" ng-click="resetService(serviceType[0], true)" ng-disabled="serviceNotExist">{{\'reset_cloud_record_autocharge\' | translate}}</button> <button type="button" class="btn btn-warning btn-sm pull-left" ng-show="RESET_DEVICE_SERVICE" ng-click="resetService(serviceType[3], true)" ng-disabled="serviceNotExist">{{\'reset_ai_motion_video_autocharge\' | translate}}</button></div><br><br><div class="col-md-12"><button type="button" class="btn btn-info btn-sm pull-left" ng-click="$dismiss()">{{\'close\' | translate}}</button></div></div></div></uib-tab><uib-tab heading="{{\'modify_current_cloud_service_time\' | translate}}" ng-show="SET_SERVICE_TIME"><div class="col-md-12" style="height: 420px"><form><div class="dropdown form-group col-md-8"><label>{{\'full_record_service_expire\' | translate}}</label> <a class="dropdown-toggle" id="dropdownEnd" role="button" data-toggle="dropdown"><div class="input-group date"><input class="form-control" data-ng-model="dataTimePicker.newFullRecordExpire"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dataTimePicker.newFullRecordExpire" data-datetimepicker-config="{ dropdownSelector: \'#dropdownEnd\'}" data-on-set-time="fullRecordExpireOnSetTime()"></datetimepicker></ul></div><div class="dropdown form-group col-md-8"><label>{{\'video_motion_expire\' | translate}}</label> <a class="dropdown-toggle" id="videoMotionSet" role="button" data-toggle="dropdown"><div class="input-group date"><input class="form-control" data-ng-model="dataTimePicker.newVideoMotionExpire"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dataTimePicker.newVideoMotionExpire" data-datetimepicker-config="{ dropdownSelector: \'#videoMotionSet\'}" data-on-set-time="videoExpireOnSetTime()"></datetimepicker></ul></div><div class="dropdown form-group col-md-8"><label>{{\'ring_call_service_expire\' | translate}}</label> <a class="dropdown-toggle" id="dropdownStart" role="button" data-toggle="dropdown"><div class="input-group date"><input class="form-control" data-ng-model="dataTimePicker.newServiceExpire"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dataTimePicker.newServiceExpire" data-datetimepicker-config="{ dropdownSelector: \'#dropdownStart\'}" data-on-set-time="serviceExpireOnSetTime()"></datetimepicker></ul></div><div class="dropdown form-group col-md-8"><label>{{\'ai_motion_video_service_expire\' | translate}}</label> <a class="dropdown-toggle" id="bodyDetectionSet" role="button" data-toggle="dropdown"><div class="input-group date"><input class="form-control" data-ng-model="dataTimePicker.newBodyDetectionExpire"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dataTimePicker.newBodyDetectionExpire" data-datetimepicker-config="{ dropdownSelector: \'#aiVideoMotionSet\'}" data-on-set-time="bodyDetectionExpireExpireOnSetTime()"></datetimepicker></ul></div><div class="form-group col-md-8"><button type="button" class="btn btn-primary" ng-click="modifyServiceTime()">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">{{\'close\' | translate}}</button></div></form></div><div class="modal-footer"></div></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/pages/devices/modals/lockDevice.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/modals/rebootDevice.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/modals/resetDevice.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/modals/resetService.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/modals/sdCardFormat.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/modals/upgradeDevice.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/tabs/changeDeviceDistributor.html','<div class="row" ng-controller="ChangeDeviceDistributorCtrl"><div class="col-md-12"><form><div class="form-group"><label for="distributorId">{{\'distributor_id\' | translate}}</label> <input type="number" class="form-control" id="distributorId" style="width: 400px" ng-model="distributorId" ng-click="clearError()"><p class="help-block red-color" ng-show="errDistributorId">{{errorMessage | translate}}</p></div><div class="form-group"><label for="changeDistributorFile">{{\'please_to_choose_format_file\' | translate}}</label> <input type="file" id="changeDistributorFile"><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p><p class="help-block red-color" ng-show="error1">{{errorMessage1 | translate}}</p><p class="help-block red-color" ng-show="error2">{{errorMessage2 | translate}}</p></div><button type="submit" class="btn btn-warning" ng-click="parseFile()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button></form></div></div>');
$templateCache.put('app/pages/devices/tabs/checkDeviceId.html','<form class="form-horizontal" ng-controller="CheckDeviceIdCtrl"><div class="form-group"><label for="newDeviceSn" class="col-md-3 control-label">{{\'serialNumber\' | translate}}</label><div class="col-md-5"><input type="text" class="form-control" id="newDeviceSn" ng-model="data.serialnumber"></div></div><div class="form-group"><div class="col-md-offset-3 col-md-5"><button type="button" class="btn btn-warning" ng-click="submit()" ng-disabled="holdSubmit">{{\'search\' | translate}}</button></div></div><p>{{result}}</p></form>');
$templateCache.put('app/pages/devices/tabs/deviceDetailInfo.html','<div class="row" ng-controller="DeviceDetailInfoCtrl"><form class="form-inline"><div class="form-group col-md-2" style="top: 1px"><input type="text" class="form-control" ng-model="serialNumber" placeholder="Device Serial Number"></div><div class="form-group col-md-10"><button type="submit" class="btn btn-info" ng-click="getDeviceInfo(\'shadow\')" ng-disabled="holdSubmit" ng-if="GET_DEVICE_LIVE_STATUS_INFO">{{\'Search Shadow Info\' | translate}}</button> <button type="submit" class="btn btn-success" ng-click="getDeviceInfo(\'pns\')" ng-disabled="holdSubmit" ng-if="GET_DEVICE_PNS_INFO">{{\'Search PNS Info\' | translate}}</button> <button type="submit" class="btn btn-info" ng-click="getDeviceInfo(\'function\')" ng-disabled="holdSubmit" ng-if="GET_DEVICE_FUNCTION_INFO">{{\'Search Function Info\' | translate}}</button> <button type="submit" class="btn btn-primary" ng-click="getDeviceInfo(\'liveStatus\')" ng-disabled="holdSubmit" ng-if="GET_DEVICE_LIVE_STATUS_INFO">{{\'Search Live Status Info\' | translate}}</button> <button type="submit" class="btn btn-warning" ng-click="getDeviceInfo(\'all\')" ng-disabled="holdSubmit" ng-if="GET_ALL">{{\'Search All\' | translate}}</button> <button type="submit" class="btn btn-danger" ng-click="resetQuery()">{{\'reset_search\' | translate}}</button></div></form><div class="col-md-12" style="margin-top: 20px"><div class="panel-group"><div class="panel panel-default bootstrap-panel" ng-show="pnsExist" style="width: 100%"><div class="panel-heading">{{\'Device PNS\' | translate}}</div><br><div class="panel-body" style="height: 40px"><div class="col-md-2"><label>{{\'serialNumber\' | translate }}</label><br>{{devicePNS.serialNumber}}</div><div class="col-md-2"><label>{{\'pnMobileOn\' | translate }}</label><br><span class="label label-primary">{{devicePNS.pnMobileOn | pnMobileStatus}}</span></div><div class="col-md-2"><label>{{\'eventMotionOn\' | translate }}</label><br><span class="label label-primary">{{devicePNS.eventMotionOn | eventMotionStatus}}</span></div><div class="col-md-2"><label>{{\'eventDoorBellOn\' | translate }}</label><br><span class="label label-primary">{{devicePNS.eventDoorBellOn | eventDoorBellStatus}}</span></div><div class="col-md-2"><label>{{\'appID\' | translate }}</label><br>{{devicePNS.appID}}</div></div><br></div><div class="panel panel-default bootstrap-panel" ng-show="functionExist"><div class="panel-heading">{{\'Device Function Setting\' | translate}}</div><br><div class="panel-body" style="height: 40px"><div class="col-md-2"><label>{{\'serialNumber\' | translate }}</label><br>{{deviceFunction.serialNumber}}</div><div class="col-md-2"><label>{{\'motionDetectionOn\' | translate }}</label><br><span class="label label-primary">{{deviceFunction.motionDetectionOn | motionDetectionStatus}}</span></div><div class="col-md-2"><label>{{\'alarmTimeMode\' | translate }}</label><br><span class="label label-primary">{{deviceFunction.alarmTimeMode | deviceFunctionAlarmTimeMode}}</span></div><div class="col-md-2"><label>{{\'alarmPeriod\' | translate }}</label><br>{{deviceFunction.alarmPeriod}}</div><div class="col-md-2"><label>{{\'sensitivity\' | translate }}</label><br>{{deviceFunction.sensitivity}}</div></div><br><div class="panel-body" style="height: 40px"><div class="col-md-2"><label>{{\'motionZones\' | translate }}</label><br>{{deviceFunction.motionZones}}</div><div class="col-md-2"><label>{{\'smartGuardOn\' | translate }}</label><br><span class="label label-primary">{{deviceFunction.smartGuardOn | smartGuardStatus}}</span></div><div class="col-md-2"><label>{{\'isSummerTime\' | translate }}</label><br><span class="label label-primary">{{deviceFunction.isSummerTime | isSummerTimeStatus}}</span></div><div class="col-md-2"><label>{{\'timeZone\' | translate }}</label><br>{{deviceFunction.timeZone}}</div><div class="col-md-2"><label>{{\'speakerVolume\' | translate }}</label><br>{{deviceFunction.speakerVolume}}</div></div><br><div class="panel-body" style="height: 40px"><div class="col-md-2"><label>{{\'flipOn\' | translate }}</label><br><span class="label label-primary">{{deviceFunction.flipOn | deviceFunctionFlipStatus}}</span></div><div class="col-md-2"><label>{{\'voiceCharacter\' | translate }}</label><br>{{deviceFunction.voiceCharacter}}</div><div class="col-md-2"><label>{{\'chimeType\' | translate }}</label><br>{{deviceFunction.chimeType}}</div><div class="col-md-2"><label>{{\'chimeDuration\' | translate }}</label><br>{{deviceFunction.chimeDuration}}</div></div><br></div><div class="panel panel-default bootstrap-panel" ng-show="liveStatusExist"><div class="panel-heading">{{\'Device Live Status\' | translate}}</div><br><div class="panel-body" style="height: 40px"><div class="col-md-2"><label>{{\'serialNumber\' | translate }}</label><br>{{deviceLiveStatus.serialNumber}}</div><div class="col-md-2"><label>{{\'ownerName\' | translate }}</label><br>{{deviceLiveStatus.ownerName}}</div><div class="col-md-2"><label>{{\'deviceName\' | translate }}</label><br>{{deviceLiveStatus.deviceName}}</div><div class="col-md-2"><label>{{\'online\' | translate }}</label><br><span class="label label-primary">{{deviceLiveStatus.online | deviceLiveStatusOnline}}</span></div><div class="col-md-2"><label>{{\'serverVersion\' | translate }}</label><br>{{deviceLiveStatus.serverVersion}}</div></div><br><div class="panel-body" style="height: 40px"><div class="col-md-2"><label>{{\'currentVersion\' | translate }}</label><br>{{deviceLiveStatus.currentVersion}}</div><div class="col-md-2"><label>{{\'nextVersion\' | translate }}</label><br>{{deviceLiveStatus.nextVersion}}</div><div class="col-md-2"><label>{{\'audioOn\' | translate }}</label><br><span class="label label-primary">{{deviceLiveStatus.audioOn | deviceLiveStatusAudioStatus}}</span></div><div class="col-md-2"><label>{{\'flipOn\' | translate }}</label><br><span class="label label-primary">{{deviceLiveStatus.flipOn | deviceLiveStatusFlipStatus}}</span></div><div class="col-md-2"><label>{{\'nightlightOn\' | translate }}</label><br><span class="label label-primary">{{deviceLiveStatus.nightlightOn | deviceLiveStatusNightlightStatus}}</span></div></div><br><div class="panel-body" style="height: 40px"><div class="col-md-2"><label>{{\'upgradeState\' | translate }}</label><br>{{deviceLiveStatus.upgradeState}}</div><div class="col-md-2"><label>{{\'autoSyncTime\' | translate }}</label><br><span class="label label-primary">{{deviceLiveStatus.autoSyncTime | deviceLiveStatusAutoSyncTimeStatus}}</span></div><div class="col-md-2"><label>{{\'timeZone\' | translate }}</label><br>{{deviceLiveStatus.timeZone}}</div><div class="col-md-2"><label>{{\'speakerVolume\' | translate }}</label><br>{{deviceLiveStatus.speakerVolume}}</div><div class="col-md-2"><label>{{\'powerPercent\' | translate }}</label><br>{{deviceLiveStatus.powerPercent}}</div></div><br><div class="panel-body" style="height: 40px"><div class="col-md-2"><label>{{\'charging\' | translate }}</label><br>{{deviceLiveStatus.charging}}</div><div class="col-md-2"><label>{{\'fullRecordOn\' | translate }}</label><br><span class="label label-primary">{{deviceLiveStatus.fullRecordOn | deviceLiveStatusFullRecordOnStatus}}</span></div><div class="col-md-2"><label>{{\'clientVersion\' | translate }}</label><br>{{deviceLiveStatus.clientVersion}}</div><div class="col-md-4"><label>{{\'serverAddr\' | translate }}</label><br>{{deviceLiveStatus.serverAddr}}</div></div><br></div><div class="panel panel-default bootstrap-panel" ng-show="shadowExist"><div class="panel-heading">Device Shadow</div><div class="panel-body"><pre class="col-md-6" style="background-color: white">{{shadowReportedInfo}}</pre><pre class="col-md-6" style="background-color: white">{{shadowDesiredInfo}}</pre></div></div></div></div></div>');
$templateCache.put('app/pages/devices/tabs/getDeviceService.html','<form class="form-horizontal" ng-controller="GetDeviceServiceCtrl"><div class="form-group"><label for="userName" class="col-md-3 control-label">{{\'user_name\' | translate}}</label><div class="col-md-5"><input type="text" class="form-control" id="userName" ng-model="data.userName" ng-focus="clearError()"><p class="help-block red-color" ng-show="errUserName">{{errorMessage | translate}}</p></div></div><div class="form-group"><label for="newDeviceSn" class="col-md-3 control-label">{{\'serialNumber\' | translate}}</label><div class="col-md-5"><input type="text" class="form-control" id="newDeviceSn" ng-model="data.serialnumber" ng-focus="clearError()"><p class="help-block red-color" ng-show="errDeviceSn">{{errorMessage | translate}}</p></div></div><div class="form-group"><div class="col-md-offset-3 col-md-5"><button type="button" class="btn btn-warning" ng-click="submit()" ng-disabled="holdSubmit">{{\'get_info\' | translate}}</button><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div></div></form>');
$templateCache.put('app/pages/firmware/tabs/batchUpgrade.html','<div class="row" ng-controller="BatchUpgradeCtrl"><div class="col-md-12"><form><div class="form-group"><label for="toVersion">{{\'to_version\' | translate}}</label> <input type="text" class="form-control" id="toVersion" style="width: 400px" ng-model="toVersion" ng-click="clearError()"><p class="help-block red-color" ng-show="errToVersion">{{errorMessage | translate}}</p></div><div class="form-group"><label for="changeToVersionFile">{{\'please_to_choose_format_file\' | translate}}</label> <input type="file" id="changeToVersionFile"><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><button type="submit" class="btn btn-warning" ng-click="parseFile()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button></form></div></div>');
$templateCache.put('app/pages/firmware/tabs/upgrade.html','<div ng-controller="UpgradeCtrl"><form class="form-horizontal"><div class="form-group"><label for="from" class="col-md-2 control-label">{{\'from_version\' | translate}}{{\'not_null\' | translate}}</label><div class="col-md-5"><input type="text" class="form-control" id="from" ng-model="data.from" ng-focus="clearError()"><p class="help-block red-color" ng-show="errFrom">{{errorMessage | translate}}</p></div></div><div class="form-group"><label for="to" class="col-md-2 control-label">{{\'to_version\' | translate}}{{\'not_null\' | translate}}</label><div class="col-md-5"><input type="text" class="form-control" id="to" ng-model="data.to" ng-focus="clearError()"><p class="help-block red-color" ng-show="errTo">{{errorMessage | translate}}</p></div></div><div class="form-group"><div class="col-md-offset-2 col-md-11 right10px"><button class="btn btn-primary" ng-click="getPath()">{{\'get_path\' | translate}}</button> <button class="btn btn-danger" ng-click="resetSearch()">{{\'reset_search\' | translate}}</button></div></div></form><table class="table table-hover" ng-if="showUpgradePath"><thead><tr><th></th><th colspan="3" class="align-right"><span ng-show="pathValidation === undefined" class="label label-default">Status</span> <span ng-show="pathValidation === true" class="label label-success">{{\'valid_upgrade_path\' | translate}}</span> <span ng-show="pathValidation === false" class="label label-danger">{{\'invalid_upgrade_path\' | translate}}</span></th></tr><tr class="black-muted-bg"><th>{{\'patchID\' | translate }}</th><th>{{\'from_version\' | translate }}</th><th>{{\'to_version\' | translate }}</th><th>{{\'level\' | translate }}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="path in paths" class="no-top-border"><td><a>{{path.pid}}</a></td><td>{{path.from}}</td><td>{{path.to}}</td><td>{{path.level}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="getDataError"><td colspan="4" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="pathsEmpty"><td colspan="4" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table><table class="table table-hover" ng-if="showTestResult"><thead><tr class="black-muted-bg"><th>{{\'from_version\' | translate }}</th><th>{{\'to_version\' | translate }}</th><th>{{\'create_time\' | translate }}</th><th>{{\'status\' | translate }}</th><th>{{\'issues\' | translate }}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="upgradeTestResult in upgradeTestResults" class="no-top-border"><td><a>{{upgradeTestResult.oldV}}</a></td><td>{{upgradeTestResult.newV}}</td><td>{{upgradeTestResult.createTime > 0 ? (upgradeTestResult.createTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'\'}}</td><td ng-show="upgradeTestResult.status === \'SUCCESS\'"><span class="label label-success">{{upgradeTestResult.status}}</span></td><td ng-show="upgradeTestResult.status === \'PENDING\'"><span class="label label-warning">{{upgradeTestResult.status}}</span></td><td ng-show="upgradeTestResult.status === \'IN_PROGRESS\'"><span class="label label-warning">{{upgradeTestResult.status}}</span></td><td ng-show="upgradeTestResult.status === \'FAILURE\'"><span class="label label-danger">{{upgradeTestResult.status}}</span></td><td>{{upgradeTestResult.issues}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="getDataError"><td colspan="4" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="upgradeTestResultsEmpty"><td colspan="4" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div>');
$templateCache.put('app/pages/marketing/activities/activities.html','<div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel large-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'details_title\' | translate}}"><div class="widgets"><div class="row"><div class="col-md-12"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="activities"><thead><tr><th><div class="form-group"><input st-search="title" st-input-event="change" placeholder="{{\'search_placeholder\' | translate}}" class="form-control"></div></th><th></th><th colspan="3"><div class="form-group"><button type="button" class="btn btn-info" ng-click="search()">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetQuery()">{{\'reset_search\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="refresh()">{{\'refresh\' | translate}}</button></div></th></tr><tr class="black-muted-bg"><th>{{\'activity_title\' | translate }}</th><th>{{\'published\' | translate }}</th><th>{{\'activity_priority\' | translate }}</th><th>{{\'activity_type\' | translate }}</th><th>{{\'activity_image_url\' | translate }}</th><th>{{\'activity_target\' | translate }}</th><th>{{\'activity_description\' | translate }}</th><th>{{\'activity_start_time\' | translate}}</th><th>{{\'activity_end_time\' | translate}}</th><th>{{\'create_time\' | translate }}</th><th ng-if="EDIT_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="activity in activities" class="no-top-border"><td><a ng-click="openChildPage(activity)">{{activity.title}}</a></td><td>{{activity.childPublishCount}} / {{activity.childCount}}</td><td>{{activity.priority}}</td><td>{{activity.displayType}}</td><td><a href="" ng-click="openInfoPage(activity.imageUrl)">{{\'activity_image_url\' | translate}}</a></td><td><a href="" ng-click="openInfoPage(activity.targetUrl)">{{\'activity_target\' | translate}}</a></td><td><a href="" ng-click="openInfoPage(activity.description)">{{\'activity_description\' | translate}}</a></td><td>{{activity.startTime > 0 ? (activity.startTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td>{{activity.endTime > 0 ? (activity.endTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td>{{activity.createTime > 0 ? (activity.createTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td ng-if="EDIT_P"><div class="buttons"><button class="btn btn-info btn-xs" ng-click="openEditPage(activity)">{{\'edit\' | translate}}</button> <button ng-show="!activity.publish" class="btn btn-primary btn-xs" ng-click="openPublishPage(activity.id, true, activity.parentId === 0)">{{\'publish\' | translate}}</button> <button ng-show="activity.publish" class="btn btn-warning btn-xs" ng-click="openPublishPage(activity.id, false, activity.parentId === 0)">{{\'cancel_publish\' | translate}}</button> <button class="btn btn-danger btn-xs" ng-click="openDeletePage(activity.id, activity.parentId === 0)">{{\'delete\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="9" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="9" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="activitiesEmpty"><td colspan="9" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div></uib-tab><uib-tab heading="{{\'mock_client_show_activities\' | translate}}"><div ng-include="\'app/pages/marketing/activities/tabs/mockClientQuery.html\'"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/marketing/activities/editActivity.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{isNewActivity ? (\'create_activity\' | translate) : (\'edit\' | translate)}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="title">{{\'activity_title\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="title" ng-model="data.title" ng-focus="clearError()"><p class="help-block red-color" ng-show="errTitle">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="priority">{{\'activity_priority\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="priority" ng-model="data.priority" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label>{{\'activity_type\' | translate }}</label><select class="form-control" ng-model="displayTypeSelected" ng-change="displayTypeChange(displayTypeSelected)" ng-options="item as item.label for item in displayTypeItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label for="imageUrl">{{\'activity_image_url\' | translate }} {{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="imageUrl" ng-model="data.imageUrl" ng-focus="clearError()"><p class="help-block red-color" ng-show="errImageUrl">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'activity_target\' | translate }} {{\'not_null\' | translate}}</label> <input type="text" class="form-control" ng-model="data.targetUrl" ng-focus="clearError()"><p class="help-block red-color" ng-show="errTargetUrl">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="description">{{\'activity_description\' | translate }}{{\'not_null\' | translate}}</label> <textarea class="form-control" id="description" ng-model="data.description" ng-focus="clearError()"></textarea></div><div class="form-group margin-thirdPx"><label for="startTime">{{\'activity_start_time\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="startTime" ng-model="data.startTime" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label for="endTime">{{\'activity_end_time\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="endTime" ng-model="data.endTime" ng-focus="clearError()"></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/advertisements/advertisements.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="CREATE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create_advertisement\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="ADs"><thead><tr><th><select class="form-control" ng-model="languageSelected" ng-change="languageChanged(languageSelected)" ng-options="item as item.label for item in languages track by item.value"></select></th><th><div style="width: 1px"><button type="button" class="btn btn-primary" ng-click="refresh()">{{\'refresh\' | translate}}</button></div></th><th><div style="width: 1px"><button type="button" class="btn btn-warning" ng-click="preview()">{{\'preview_ads\' | translate}}</button></div></th><th></th></tr><tr class="black-muted-bg"><th width="12%">{{\'advertisement_link\' | translate }}</th><th>{{\'advertisement_repeat\' | translate }}</th><th>{{\'public_time\' | translate }}</th><th>{{\'update_time\' | translate }}</th><th>{{\'expire_time\' | translate }}</th><th>{{\'ad_image\' | translate }}</th><th ng-if="EDIT_P" width="20%">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="advertisement in ADs" class="no-top-border"><td><a href="{{advertisement.link}}" target="_blank">{{advertisement.link}}</a></td><td>{{advertisement.repeat}}</td><td>{{advertisement.publish_time > 0 ? (advertisement.publish_time | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td>{{advertisement.update_time > 0 ? (advertisement.update_time | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td>{{advertisement.expire_time > 0 ? (advertisement.expire_time | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="showADImage(advertisement.pic)">{{\'show_ad_image\' | translate}}</button></div></td><td ng-if="EDIT_P || DELETE_P" width="20%"><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditPage(advertisement)" ng-if="EDIT_P">{{\'modify_details\' | translate}}</button> <button class="btn btn-danger btn-xs" ng-click="removeAD(advertisement)" ng-if="DELETE_P">{{\'delete\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="9" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="getDataError"><td colspan="9" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="adsEmpty"><td colspan="9" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/marketing/advertisements/editAdvertisement.html','<div class="modal-content"><div class="modal-header bg-info"><span ng-if="isNewAD">{{\'create_advertisement\' | translate}}</span> <span ng-if="!isNewAD">{{\'edit_advertisement\' | translate}}</span></div><div class="modal-body"><form><div class="form-group"><select class="form-control" style="margin-bottom: 15px" ng-model="linkTypeSelected" ng-change="linkTypeChanged(linkTypeSelected)" ng-options="item as item.label for item in linkTypes track by item.value"></select></div><div class="form-group" ng-show="!advertisement.is_location_based_link"><input class="form-control" id="adLink" ng-model="advertisement.link" placeholder="please input ad link"></div><div class="form-group" ng-show="advertisement.is_location_based_link"><div ng-show="countryCodesCanBeAdded.length != 0" style="margin-bottom: 5px"><select class="btn-group bootstrap-select form-control" ng-model="countryCodeSelected" ng-change="countryCodeChanged(countryCodeSelected)" ng-options="item as item.label for item in countryCodesCanBeAdded track by item.value"></select></div><div class="input-group"><input class="form-control" ng-model="newUrl" placeholder="please input ad link"> <span class="input-group-btn"><button class="btn btn-info" type="button" ng-click="addNewLocationUrl()" ng-if="UPDATE_LOCATION_URL === true || CREATE_LOCATION_URL === true" ng-disabled="isAddingLocationUrl">{{\'create\' | translate}}</button></span></div><div ng-repeat="locationUrl in locationUrlsForShow"><div class="col-md-2" style="margin-left: 15px">{{locationUrl.countryCode | translate}}</div><div class="col-md-8"><a href="{{locationUrl.url}}" target="_blank">{{locationUrl.urlForShow}}</a></div><button class="col-md-1 btn btn-raised btn-danger btn-xs" style="margin-bottom: 5px" ng-click="deleteLocationUrl(locationUrl)" ng-if="UPDATE_LOCATION_URL">{{\'remove\' | translate}}</button></div></div><div class="form-group margin-thirdPx"><label for="adRepeat">{{\'advertisement_repeat\' | translate }}</label> <input class="form-control" id="adRepeat" ng-model="advertisement.repeat"></div><div class="form-group margin-thirdPx dropdown"><label>{{\'expire_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownStart" role="button" data-toggle="dropdown"><div class="input-group date"><input type="text" class="form-control" data-ng-model="expireDate"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="expireDate" data-datetimepicker-config="{ dropdownSelector: \'#dropdownStart\'}" data-on-set-time="expireDateOnSetTime()"></datetimepicker></ul></div><div style="margin-bottom: 20px"><label for="adImage"><span>{{\'please_to_choose_a_file\' | translate}}</span>, <span>{{"ad_image_size_limit" | translate}}</span></label> <input type="file" accept=".jpeg,.png,.jpg" id="adImage" nv-file-select="" uploader="uploader"> <img src="" id="loc_img" hidden=""></div><label>{{\'upload_queue\' | translate}}</label><table class="table text-center"><thead><tr><th>{{\'name\' | translate}}</th><th class="text-center" ng-show="uploader.isHTML5">{{\'size\' | translate}}</th><th class="text-center" ng-show="uploader.isHTML5">{{\'progress\' | translate}}</th><th class="text-center">{{\'status\' | translate}}</th><th class="text-center">{{\'actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in uploader.queue"><td><strong>{{ item.file.name }}</strong></td><td ng-show="uploader.isHTML5" nowrap="">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show="uploader.isHTML5"><div class="progress" style="margin-bottom: 0;"><div class="progress-bar" role="progressbar" ng-style="{ \'width\': item.progress + \'%\' }"></div></div><span>{{item.progress}}%</span></td><td><span ng-show="item.isSuccess"><i class="glyphicon glyphicon-ok"></i></span> <span ng-show="item.isCancel"><i class="glyphicon glyphicon-ban-circle"></i></span> <span ng-show="item.isError"><i class="glyphicon glyphicon-remove"></i></span></td><td><button type="button" class="btn btn-success btn-xs" ng-click="item.upload()" ng-disabled="item.isReady || item.isUploading || item.isSuccess || notReady"><span class="glyphicon glyphicon-upload"></span> {{\'upload\' | translate}}</button> <button type="button" class="btn btn-warning btn-xs" ng-click="item.cancel()" ng-disabled="!item.isUploading"><span class="glyphicon glyphicon-ban-circle"></span> {{\'cancel\' | translate}}</button> <button type="button" class="btn btn-danger btn-xs" ng-click="item.remove()"><span class="glyphicon glyphicon-trash"></span> {{\'remove\' | translate}}</button></td></tr></tbody></table></form></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/advertisements/preview.html','<style>\n  .ads-preview-modal-window .modal-dialog {\n    width: 375px;\n    padding-top: 2%;\n    margin: 0 0 0 -10%;\n    position: fixed;\n  }\n\n  .ads-preview-modal {\n    margin: 0;\n    padding: 0;\n    background-image: url("assets/img/ads-preview-bg.png");\n    height: 667px;\n    width: inherit;\n    max-height: 100%;\n    max-width: 100%;\n  }\n\n  .show-ads-area {\n    height: 320px;\n    width: 240px;\n    margin: 0;\n  }\n\n  .carousel-dots li {\n    margin: 0;\n  }\n\n</style><div class="modal-content"><div class="modal-header"><select class="form-control" ng-model="languageSelected" ng-change="languageChanged(languageSelected)" ng-options="item as item.label for item in languages track by item.value"></select></div><div class="separator" style="margin: 0; padding: 0"></div><div class="modal-body ads-preview-modal"><div style="padding-top: 173px; padding-left: 67px;margin: 0"><div class="show-ads-area"><ui-carousel slides="previewADs" slides-to-show="1" slides-to-scroll="1" initial-slide="0" autoplay="false" dots="true"><carousel-item><a href="{{item.link}}" target="_blank"><img class="show-ads-area" src="{{item.pic}}"></a></carousel-item></ui-carousel></div></div></div><div class="separator" style="margin: 0; padding: 0"></div><div class="modal-footer modal-buttons" ng-if="PUBLISH_P"><button type="submit" class="btn btn-warning col-md-5" ng-click="publishAdvertisements()">{{\'publish\' | translate}}</button> <button type="button" class="btn btn-info col-md-5" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/advertisements/publishADsConfirm.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{\'are_you_sure_to_publish_all_ads\' | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="publishADs()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/notifications/editNotification.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{isNew ? (\'create\' | translate) : (\'edit\' | translate)}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="title">{{\'title\' | translate }}{{\'not_null\' | translate}}</label> <input class="form-control" id="title" ng-model="data.title" ng-focus="clearError()"><p class="help-block red-color" ng-show="errTitle">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="imageUrl">{{\'image_url\' | translate }}{{\'not_null\' | translate}}</label> <input class="form-control" id="imageUrl" ng-model="data.imageUrl" ng-focus="clearError()"><p class="help-block red-color" ng-show="errImageUrl">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="targetUrl">{{\'target_url\' | translate }}{{\'not_null\' | translate}}</label> <input class="form-control" id="targetUrl" ng-model="data.targetUrl" ng-focus="clearError()"><p class="help-block red-color" ng-show="errTargetUrl">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="note">{{\'note\' | translate }}</label> <input class="form-control" id="note" ng-model="data.note" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label for="condition">{{\'condition\' | translate }}</label> <input class="form-control" id="condition" ng-model="data.clientCondition" ng-focus="clearError()"></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/notifications/notifications.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="CREATE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create\' | translate}}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="ADs"><thead><tr></tr><tr class="black-muted-bg"><th>{{\'id\' | translate }}</th><th>{{\'title\' | translate }}</th><th>{{\'create_time\' | translate }}</th><th>{{\'status\' | translate }}</th><th>{{\'publish_time\' | translate }}</th><th>{{\'note\' | translate }}</th><th>{{\'image_url\' | translate }}</th><th>{{\'target_url\' | translate }}</th><th>{{\'condition\' | translate }}</th><th ng-if="EDIT_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="clientNotification in clientNotifications" class="no-top-border"><td><a href="#" target="_blank">{{clientNotification.id}}</a></td><td>{{clientNotification.title}}</td><td>{{clientNotification.createTime > 0 ? (clientNotification.createTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td>{{clientNotification.status}}</td><td>{{clientNotification.publishTime > 0 ? (clientNotification.publishTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td><a href="" ng-click="openInfoPage(clientNotification.note)">{{\'note\' | translate}}</a></td><td><a href="" ng-click="openInfoPage(clientNotification.imageUrl)">{{\'image_url\' | translate}}</a></td><td><a href="" ng-click="openInfoPage(clientNotification.targetUrl)">{{\'target_url\' | translate}}</a></td><td><a href="" ng-click="openInfoPage(clientNotification.clientCondition)">{{\'condition\' | translate}}</a></td><td ng-if="EDIT_P || DELETE_P"><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditPage(clientNotification)" ng-disabled="holdSubmit" ng-if="EDIT_P && clientNotification.status == \'INIT\'">{{\'edit\' | translate}}</button> <button class="btn btn-info btn-xs" ng-click="testPublish(clientNotification)" ng-disabled="holdSubmit" ng-if="TEST_PUBLISH_P">{{\'test_publish\' | translate}}</button> <button class="btn btn-warning btn-xs" ng-click="publish(clientNotification)" ng-disabled="holdSubmit" ng-if="PUBLISH_P && clientNotification.status == \'INIT\'">{{\'publish\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="9" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="9" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="dataEmpty"><td colspan="9" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/marketing/promotions/editPromotion.html','<style>\n  .margin-bottom-well {\n    margin-bottom: 10px;\n  }\n</style><div class="modal-content"><div class="modal-header bg-info"><span>{{\'basic_info\' | translate}}</span></div><div class="modal-body"><form><div id="basicInfo"><div class="form-group margin-thirdPx has-error margin-bottom-well" ng-if="isNewPromotion"><label for="activity_type_select">{{\'activity_type\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" id="activity_type_select" ng-model="activityTypeSelected" ng-change="activityTypeChanged(activityTypeSelected)" ng-options="item as item.label for item in activityTypes track by item.value"></select></div><div class="form-group margin-thirdPx has-error margin-bottom-well" ng-if="!isNewPromotion"><label for="activity_type_span">{{\'activity_type\' | translate }}</label><div><span id="activity_type_span" style="color: #0b93d5">{{activity.activityType | translate }}</span></div></div><div class="form-group margin-thirdPx margin-bottom-well"><label for="note">{{\'activity_note\' | translate }}{{\'not_null\' | translate}}</label> <input class="form-control" id="note" ng-model="activity.note" ng-disabled="!activityChangeable"></div><div class="form-group margin-thirdPx margin-bottom-well"><label>{{\'activity_status\' | translate }}</label><select class="form-control" ng-model="activityStatusSelected" ng-change="statusChanged(activityStatusSelected)" ng-disabled="!activityChangeable || isNewPromotion" ng-options="item as item.label for item in activityStatus track by item.value"></select></div></div></form></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/promotions/promotions.html','<style type="text/css">\n  .REMOVED {\n    color: #e85656;\n  }\n  .PUBLISHED {\n    color: #dfb81c;\n  }\n  .UNPUBLISHED {\n    color: #2dacd1;\n  }\n\n</style><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create_promotion\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="promotions"><thead><tr><th><select class="form-control" ng-model="activityTypeSelected" ng-change="activityTypeChanged(activityTypeSelected)" ng-options="item as item.label for item in activityTypes track by item.value"></select></th><th></th><th><select class="form-control" ng-model="activityStatusSelected" ng-change="statusChanged(activityStatusSelected)" ng-options="item as item.label for item in activityStatus track by item.value"></select></th><th><div style="width: 1px"><button type="button" class="btn btn-info" ng-click="search()">{{\'search\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="refresh()">{{\'refresh\' | translate}}</button></div></th></tr><tr class="black-muted-bg"><th>{{\'activity_type\' | translate }}</th><th>{{\'activity_note\' | translate }}</th><th>{{\'activity_status\' | translate }}</th><th>{{\'create_time\' | translate }}</th><th>{{\'publish_time\' | translate }}</th><th>{{\'config_for_languages\' | translate}}</th><th ng-if="EDIT_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="activity in promotions" class="no-top-border"><td><a>{{activity.activityType | translate }}</a></td><td>{{activity.note | limitTo:50}}{{configMap[configName].length > 50 ? \'...\' : \'\'}}</td><td class="{{activity.activityStatus}}">{{activity.activityStatus}}</td><td>{{activity.createTime > 0 ? (activity.createTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td>{{activity.publishTime > 0 ? (activity.publishTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td ng-if="EDIT_P"><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditDetailsPage(activity)">{{\'show_config_for_language\' | translate}}</button></div></td><td ng-if="EDIT_P"><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditPage(activity)">{{\'show_basic_info\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="9" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="9" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="promotionsEmpty"><td colspan="9" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/members/modals/memberActivity.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'member_activities\' | translate}} {{headerName}}</span></div><div class="modal-body"><div class="row"><div class="col-lg-12 col-md-12"><div><form class="row form-inline"><div class="dropdown form-group col-md-4"><label>{{\'type\' | translate}}</label><div class="dropdown-toggle"><select class="form-control" ng-change="typeChange(activitySelected)" ng-model="activitySelected" ng-options="item as item.label for item in activityTypeList track by item.value"></select></div></div><div class="dropdown form-group col-md-4"><label>{{\'start_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownStart" role="button" data-toggle="dropdown"><div class="input-group date"><input type="text" class="form-control" data-ng-model="dateRangeStart"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeStart" data-datetimepicker-config="{ dropdownSelector: \'#dropdownStart\', renderOn: \'end-date-changed\' }" data-on-set-time="startDateOnSetTime()" data-before-render="startDateBeforeRender($dates)"></datetimepicker></ul></div><div class="dropdown form-group col-md-4"><label>{{\'end_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownEnd" role="button" data-toggle="dropdown"><div class="input-group date"><input class="form-control" data-ng-model="dateRangeEnd"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeEnd" data-datetimepicker-config="{ dropdownSelector: \'#dropdownEnd\', renderOn: \'start-date-changed\' }" data-on-set-time="endDateOnSetTime()" data-before-render="endDateBeforeRender($view, $dates, $leftDate, $upDate, $rightDate)"></datetimepicker></ul></div></form><table class="table table-hover"><colgroup><col class="col-md-1"><col class="col-md-3"><col class="col-md-1"><col class="col-md-3"><col class="col-md-4"></colgroup><thead><tr class="black-muted-bg"><th>{{\'activity_id\' | translate }}</th><th>{{\'type\' | translate }}</th><th>{{\'target_id\' | translate }}</th><th>{{\'time\' | translate }}</th><th>{{\'note\' | translate }}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="activity in memberActivities" class="no-top-border"><td><a>{{activity.id}}</a></td><td>{{\'members_activity_types_\'+activity.optype | translate}}</td><td>{{activity.target_id}}</td><td>{{activity.optime > 0 ? (activity.optime | date:\'yyyy-MM-dd HH:mm:ss\'):\'\'}}</td><td><span ng-if="activity.opdes.length <= 60">{{activity.opdes }}</span> <span ng-if="activity.opdes.length > 60" data-toggle="tooltip" data-placement="right" title="{{activity.opdes }}">{{activity.opdes | limitTo:10}}...</span></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="7" class="text-center"><div ng-include="\'app/theme/components/pagination/pagination.custom.html\'"></div></td></tr><tr ng-show="getDataError"><td colspan="7" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="memberActivitiesEmpty"><td colspan="7" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="refresh()">{{\'refresh\' | translate}}</button> <button type="button" class="btn btn-info" ng-click="resetSearch()">{{\'reset_search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'close\' | translate}}</button></div></div>');
$templateCache.put('app/pages/members/modals/newMemberActivity.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'member_activities\' | translate}} {{headerName}}</span></div><div class="modal-body"><div class="row"><div class="col-lg-12 col-md-12"><div><form class="row form-inline"><div class="dropdown form-group col-md-4"><label>{{\'start_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownStart" role="button" data-toggle="dropdown"><div class="input-group date"><input type="text" class="form-control" data-ng-model="dateRangeStart"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeStart" data-datetimepicker-config="{ dropdownSelector: \'#dropdownStart\', renderOn: \'end-date-changed\' }" data-on-set-time="startDateOnSetTime()" data-before-render="startDateBeforeRender($dates)"></datetimepicker></ul></div><div class="dropdown form-group col-md-4"><label>{{\'end_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownEnd" role="button" data-toggle="dropdown"><div class="input-group date"><input class="form-control" data-ng-model="dateRangeEnd"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeEnd" data-datetimepicker-config="{ dropdownSelector: \'#dropdownEnd\', renderOn: \'start-date-changed\' }" data-on-set-time="endDateOnSetTime()" data-before-render="endDateBeforeRender($view, $dates, $leftDate, $upDate, $rightDate)"></datetimepicker></ul></div></form><table class="table table-hover" st-pipe="callServer" st-table="memberActivities"><colgroup><col class="col-md-3"><col class="col-md-1"><col class="col-md-4"><col class="col-md-4"></colgroup><thead><tr class="black-muted-bg"><th>{{\'memberName\' | translate }}</th><th>{{\'type\' | translate }}</th><th>{{\'serialnumber\' | translate }}</th><th>{{\'time\' | translate }}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="activity in memberActivities" class="no-top-border"><td><a>{{activity.memberName}}</a></td><td>{{activity.type}}</td><td>{{activity.serialnumber}}</td><td>{{activity.time > 0 ? (activity.time | date:\'yyyy-MM-dd HH:mm:ss\') : \'\' }}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="7" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="newMemberActivitiesEmpty"><td colspan="7" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div><div class="modal-footer dropdown form-group"><button type="button" class="btn btn-warning" ng-click="callServer(tableState)">{{\'refresh\' | translate}}</button> <button type="button" class="btn btn-info" ng-click="resetSearch()">{{\'reset_search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'close\' | translate}}</button></div></div>');
$templateCache.put('app/pages/productionManage/factory/deleteFactory.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/productionManage/factory/editFactory.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{isNew ? (\'create\' | translate) : (\'edit\' | translate)}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="name">{{\'name\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="name" ng-model="data.name" ng-focus="clearError()"><p class="help-block red-color" ng-show="errName">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx has-error"><label for="code">{{\'code\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="code" ng-model="data.code" ng-focus="clearError()" ng-disabled="!isNew"><p class="help-block red-color" ng-show="errCode">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="note">{{\'note\' | translate }}</label> <input type="text" class="form-control" id="note" ng-model="data.note" ng-focus="clearError()"></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/productionManage/factory/factory.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create\' | translate }}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="clients"><thead><tr class="black-muted-bg"><th>#</th><th>{{\'name\' | translate }}</th><th>{{\'code\' | translate }}</th><th>{{\'secret_key\' | translate }}</th><th>{{\'note\' | translate }}</th><th ng-if="EDIT_P || DELETE_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="factory in factoryList" class="no-top-border"><td><a>{{factory.id}}</a></td><td>{{factory.name}}</td><td>{{factory.code}}</td><td>{{factory.secretKey}}</td><td>{{factory.note}}</td><td ng-if="EDIT_P || DELETE_P"><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditPage(factory)" ng-if="EDIT_P">{{\'edit\' | translate}}</button> <button class="btn btn-danger btn-xs" ng-click="deleteConfirm(factory.id)" ng-if="DELETE_P">{{\'delete\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="5" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/productionManage/plan/editPlan.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{\'create\' | translate }}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx"><label>{{\'product_name\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" ng-model="productSelected" ng-change="productChange(productSelected)" ng-options="item as item.label for item in productItems track by item.value"></select><p class="help-block red-color" ng-show="errProduct">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'factory_name\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" ng-model="factorySelected" ng-change="factoryChange(factorySelected)" ng-options="item as item.label for item in factoryItems track by item.value"></select><p class="help-block red-color" ng-show="errFactory">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx has-error"><label for="number">{{\'number\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="number" ng-model="data.number" ng-focus="clearError()"><p class="help-block red-color" ng-show="errNumber">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'app\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" ng-model="appSelected" ng-change="appIdChange(appSelected)" ng-options="item as item.label for item in appItems track by item.value"></select><p class="help-block red-color" ng-show="errApp">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'distributor\' | translate }}{{\'not_null\' | translate}}</label><select class="form-control" ng-model="distributorSelected" ng-change="distributorIdChange(distributorSelected)" ng-options="item as item.label for item in distributorItems track by item.value"></select><p class="help-block red-color" ng-show="errDistributor">{{errorMessage | translate}}</p></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/productionManage/plan/plan.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create\' | translate }}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button> <button type="button" class="btn btn-info btn-mm" ng-click="download_tc()" style="margin-bottom: 10px" ng-show="DOWNLAOD_P">{{\'download_tc\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="clients"><thead><tr class="black-muted-bg"><th>#</th><th>{{\'product_name\' | translate }}</th><th>{{\'factory_name\' | translate }}</th><th>{{\'plan_amount\' | translate }}</th><th>{{\'app_id\' | translate }}</th><th>{{\'distributor_id\' | translate }}</th><th>{{\'create_time\' | translate }}</th><th ng-show="DOWNLAOD_P">{{\'download\' | translate }}</th><th ng-show="DOWNLAOD_P">{{\'actions\' | translate }}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="plan in planList" class="no-top-border"><td><a>{{plan.id}}</a></td><td>{{plan.productName}}</td><td>{{plan.factoryName}}</td><td>{{plan.uploadedNumber}} / {{plan.number}}</td><td>{{plan.appId}}</td><td>{{plan.distributorId}}</td><td>{{plan.createTime > 0 ? (plan.createTime | date:\'yyyy-MM-dd HH:mm:ss\') : 0}}</td><td ng-show="DOWNLAOD_P"><button class="btn btn-info btn-xs" ng-click="download(plan.id, 0)">{{\'download_all\' | translate}}</button> <button class="btn btn-primary btn-xs" ng-click="download(plan.id, 2)">{{\'download_unuploaded\' | translate}}</button></td><td ng-show="DOWNLAOD_P"><button class="btn btn-info btn-xs" ng-click="openSerialnumberPage(plan.id, 1)">{{\'uploaded_list\' | translate}}</button> <button class="btn btn-warning btn-xs" ng-click="openSerialnumberPage(plan.id, 2)">{{\'unuploaded_list\' | translate}}</button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="5" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/productionManage/plan/serialnumber.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'detail_info\' | translate}}</span></div><div class="modal-body"><div class="panel-body"><pre style="background-color: white">{{serialnumberInfo}}</pre></div></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">{{\'close\' | translate}}</button></div></div>');
$templateCache.put('app/pages/productionManage/product/deleteProduct.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/productionManage/product/editProduct.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{isNew ? (\'create\' | translate) : (\'edit\' | translate)}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="name">{{\'name\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="name" ng-model="data.name" ng-focus="clearError()"><p class="help-block red-color" ng-show="errName">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx has-error"><label for="code">{{\'code\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="code" ng-model="data.code" ng-focus="clearError()" ng-disabled="!isNew"><p class="help-block red-color" ng-show="errCode">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx has-error"><label for="idPrefix">{{\'id_prefix\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="idPrefix" ng-model="data.idPrefix" ng-focus="clearError()" ng-disabled="!isNew"><p class="help-block red-color" ng-show="errIdPrefix">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx has-error"><label for="firmwarePrefix">{{\'firmware_prefix\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="firmwarePrefix" ng-model="data.firmwarePrefix" ng-focus="clearError()" ng-disabled="!isNew"><p class="help-block red-color" ng-show="errFirmwarePrefix">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="note">{{\'note\' | translate }}</label> <input type="text" class="form-control" id="note" ng-model="data.note" ng-focus="clearError()"></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/productionManage/product/product.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create\' | translate }}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="clients"><thead><tr><th style="width: 150px"><input st-search="idPrefix" st-input-event="change" class="form-control search-input" placeholder="{{\'id_prefix\' | translate}}"></th></tr><tr class="black-muted-bg"><th>#</th><th>{{\'name\' | translate }}</th><th>{{\'code\' | translate }}</th><th>{{\'id_prefix\' | translate }}</th><th>{{\'firmware_prefix\' | translate }}</th><th>{{\'note\' | translate }}</th><th ng-if="EDIT_P || DELETE_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="product in productList" class="no-top-border"><td><a>{{product.id}}</a></td><td>{{product.name}}</td><td>{{product.code}}</td><td>{{product.idPrefix}}</td><td>{{product.firmwarePrefix}}</td><td>{{product.note}}</td><td ng-if="EDIT_P || DELETE_P"><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditPage(product)" ng-if="EDIT_P">{{\'edit\' | translate}}</button> <button class="btn btn-danger btn-xs" ng-click="deleteConfirm(product.id)" ng-if="DELETE_P">{{\'delete\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="5" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/productionManage/task/serialnumber.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'detail_info\' | translate}}</span></div><div class="modal-body"><div class="panel-body"><pre style="background-color: white">{{serialnumberInfo}}</pre></div></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">{{\'close\' | translate}}</button></div></div>');
$templateCache.put('app/pages/productionManage/task/task.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create\' | translate }}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="clients"><thead><tr class="black-muted-bg"><th>#</th><th>{{\'factory_name\' | translate }}</th><th>{{\'system_id\' | translate }}</th><th>{{\'s3_key\' | translate }}</th><th>{{\'create_time\' | translate }}</th><th>{{\'actions\' | translate }}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="task in taskList" class="no-top-border"><td><a>{{task.id}}</a></td><td>{{task.factoryName}}</td><td>{{task.systemId}}</td><td>{{task.serialnumberListUrl}}</td><td>{{task.createTime > 0 ? (task.createTime | date:\'yyyy-MM-dd HH:mm:ss\') : 0}}</td><td><button class="btn btn-info btn-xs" ng-click="openSerialnumberPage(task.id)">{{\'uploaded_list\' | translate}}</button> <button class="btn btn-warning btn-xs" ng-click="openFailedPage(task.failedDescription)" ng-show="task.failedDescription">{{\'failed_list\' | translate}}</button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="5" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/serverManage/permissions/deletePermission.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/serverManage/permissions/editPermission.html','<div class="modal-content"><div class="modal-header bg-info"><span ng-if="isNewPermission">{{\'create\' | translate}}</span> <span ng-if="!isNewPermission">{{\'edit\' | translate}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="urlRegex">{{\'url_regex\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="urlRegex" ng-model="data.urlRegex" ng-focus="clearError()"><p class="help-block red-color" ng-show="errUrlRegex">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="identification">{{\'identification\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="identification" ng-model="data.identification" ng-focus="clearError()"><p class="help-block red-color" ng-show="errIdentification">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="group">{{\'group\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="group" ng-model="data.group" ng-focus="clearError()"><p class="help-block red-color" ng-show="errGroup">{{errorMessage | translate}}</p></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/serverManage/permissions/permissions.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create\' | translate }}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="clients"><thead><tr class="black-muted-bg"><th>{{\'id\'}}</th><th>{{\'url_regex\' | translate }}</th><th>{{\'identification\' | translate }}</th><th>{{\'group\' | translate }}</th><th ng-if="EDIT_P || DELETE_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="permission in permissions" class="no-top-border"><td><a>{{permission.id}}</a></td><td>{{permission.urlRegex}}</td><td>{{permission.identification}}</td><td>{{permission.group}}</td><td ng-if="EDIT_P || DELETE_P"><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditPage(permission)" ng-if="EDIT_P">{{\'edit\' | translate}}</button> <button class="btn btn-danger btn-xs" ng-click="deleteConfirm(permission.id)" ng-if="DELETE_P">{{\'delete\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="5" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/serverManage/roles/deleteRole.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/serverManage/roles/editRole.html','<div class="modal-content"><div class="modal-header bg-info"><span ng-if="isNewClient">{{\'create_client\' | translate}}</span> <span ng-if="!isNewClient">{{\'edit_client\' | translate}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx has-error"><label for="name">{{\'name\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="name" ng-model="data.name" ng-focus="clearError()"><p class="help-block red-color" ng-show="errName">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx has-error"><label for="description">{{\'description\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="description" ng-model="data.description"></div><div class="form-group margin-thirdPx has-error"><label>{{\'permission\' | translate }}{{\'not_null\' | translate}}</label><div js-tree="basicConfig" ng-model="treeData" tree="basicTree" tree-events="changed:checkNodes"></div><p class="help-block red-color" ng-show="errName">{{errorMessage | translate}}</p></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/serverManage/roles/roles.html','<div class="widgets"><div class="row"><div class="col-md-9"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create\' | translate }}</button> <button type="button" class="btn btn-warning btn-refresh" ng-click="refresh()">{{\'refresh\' | translate}}</button><table class="table table-hover fixed-the-table" st-pipe="callServer" st-table="clients"><thead><tr class="black-muted-bg"><th>id</th><th>{{\'name\' | translate }}</th><th>{{\'description\' | translate }}</th><th>{{\'permissions\' | translate }}</th><th ng-if="EDIT_P || DELETE_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="role in roles" class="no-top-border"><td><a>{{role.id}}</a></td><td><a>{{role.name}}</a></td><td><a>{{role.description}}</a></td><td><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="showPermissionPage(role.permissions)">{{\'show\' | translate}}</button></div></td><td ng-if="EDIT_P || DELETE_P"><div class="buttons"><button class="btn btn-primary btn-xs" ng-click="openEditPage(role)" ng-if="EDIT_P">{{\'edit\' | translate}}</button> <button class="btn btn-danger btn-xs" ng-click="deleteConfirm(role.id)" ng-if="DELETE_P">{{\'delete\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="4" class="text-center"><nav ng-if="pages.length >= 2"><ul class="pagination"><li><a ng-click="selectPage(1)">{{\'pagination_first\' | translate}}</a></li><li><a ng-click="selectPage(currentPage - 1)">&lt;</a></li><li><a><input type="text" class="select-page" ng-model="inputPage" ng-change="selectPage(inputPage)"> of {{numPages}}</a></li><li><a ng-click="selectPage(currentPage + 1)">&gt;</a></li><li><a ng-click="selectPage(numPages)">{{\'pagination_last\' | translate}}</a></li></ul></nav></td></tr><tr ng-show="getDataError"><td colspan="4" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr></tfoot></table></div></div></div><div class="col-md-3"><div ba-panel="" ba-panel-title="{{\'role_permissions\' | translate}}" ba-panel-class="with-scroll tree-panel"><div js-tree="basicConfig" ng-model="treeData" tree="basicTree" tree-events="changed:checkNodes"></div></div></div></div></div>');
$templateCache.put('app/pages/statistics/charts/main.html','<div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel large-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'order_info\' | translate}}"><div ng-include="\'app/pages/statistics/charts/order/orderLineChart.html\'"></div></uib-tab><uib-tab heading="{{\'device_detail_info\' | translate}}"><div ng-include="\'app/pages/statistics/charts/device/deviceStatisticsChart.html\'"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/statistics/logs/main.html','<div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel large-panel"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'login_and_logout\' | translate}}"><div ng-include="\'app/pages/statistics/logs/loginandout/loglist.html\'"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/services/modals/staticModals/basicModal.html','<div class="modal-content" ng-controller="StaticModalsCtrl"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">{{\'op_info\' | translate}}</h4></div><div class="modal-body text-center" style="word-wrap: break-word;">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">{{\'yes\' | translate}}</button></div></div>');
$templateCache.put('app/services/modals/staticModals/dangerModal.html','<div class="modal-content" ng-controller="StaticModalsCtrl"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center" style="word-wrap: break-word;">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'yes\' | translate}}</button></div></div>');
$templateCache.put('app/services/modals/staticModals/infoModal.html','<div class="modal-content" ng-controller="StaticModalsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center" style="word-wrap: break-word;">{{message}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">{{\'yes\' | translate}}</button></div></div>');
$templateCache.put('app/services/modals/staticModals/infoModalTranslate.html','<div class="modal-content" ng-controller="StaticModalsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center" style="word-wrap: break-word;">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">{{\'yes\' | translate}}</button></div></div>');
$templateCache.put('app/services/modals/staticModals/largeModal.html','<div class="modal-content" ng-controller="StaticModalsCtrl"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">{{\'op_info\' | translate}}</h4></div><div class="modal-body text-center" style="word-wrap: break-word;">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">{{\'yes\' | translate}}</button></div></div>');
$templateCache.put('app/services/modals/staticModals/smallModal.html','<div class="modal-content" ng-controller="StaticModalsCtrl"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">{{\'op_info\' | translate}}</h4></div><div class="modal-body text-center" style="word-wrap: break-word;">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">{{\'yes\' | translate}}</button></div></div>');
$templateCache.put('app/services/modals/staticModals/successModal.html','<div class="modal-content" ng-controller="StaticModalsCtrl"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center" style="word-wrap: break-word;">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">{{\'yes\' | translate}}</button></div></div>');
$templateCache.put('app/services/modals/staticModals/warningModal.html','<div class="modal-content" ng-controller="StaticModalsCtrl"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center" style="word-wrap: break-word;">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'yes\' | translate}}</button></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/mine">{{\'home\' | translate}}</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/mine" class="al-logo clearfix"><span>{{titleName}}</span>Admin</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{::( \'admin\' | profilePicture )}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a ng-click="minePage()"><i class="fa fa-info-circle"></i>{{\'my_info\' | translate}}</a></li><li><a class="signout" ng-click="signOut()"><i class="fa fa-power-off"></i>{{\'sign_out\' | translate}}</a></li></ul></div><div class="user-welcome"><span>{{\'hello\' | translate}},{{pageTop.userName}}</span></div></div></div>');
$templateCache.put('app/theme/components/pagination/pagination.custom.html','<nav ng-if="pages.length >= 2"><ul class="pagination"><li><a ng-click="selectPage(1)">{{\'pagination_first\' | translate}}</a></li><li><a ng-click="selectPage(currentPage - 1)">&lt;</a></li><li><a><page-select></page-select>of {{numPages}}</a></li><li><a ng-click="selectPage(currentPage + 1)">&gt;</a></li><li><a ng-click="selectPage(numPages)">{{\'pagination_last\' | translate}}</a></li></ul></nav>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/devices/modals/motioncall/deviceMotionCallService.html','<style>\n  .INIT {\n    color: #0b93d5;\n  }\n\n  .IN_TRIAL {\n    color: green;\n  }\n\n  .TRIAL_EXPIRED {\n    color: yellow;\n  }\n\n  .PURCHASED {\n    color: green;\n  }\n\n  .PURCHASE_EXPIRED {\n    color: yellow;\n  }\n</style><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel middle-panel"><div class="modal-body" ng-if="!isLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="{{\'details_of_current_motion_call_service\' | translate}}"><div class="table-responsive"><table class="table text-center" ng-if="motionCall.currentService !== undefined"><thead><tr><td>{{\'motion_call_service_status\' | translate}}</td><td class="{{serviceStatus}}">{{serviceStatus | translate}}</td></tr></thead><tbody ng-if="serviceStatus !== \'INIT\'"><tr><td>{{\'motion_call_service_region\' | translate}}</td><td>{{motionCall.currentService.serviceRegion}}</td></tr><tr ng-if="serviceStatus !== \'INIT\' && serviceStatus !== \'IN_TRIAL\'"><td>{{\'motion_call_service_type\' | translate}}</td><td>{{motionCall.currentService.serviceType + \'_service_type\' | translate}}</td></tr><tr ng-if="serviceStatus !== \'INIT\' && serviceStatus !== \'IN_TRIAL\'"><td>{{\'motion_call_auto_charge\' | translate}}</td><td>{{ \'is_auto_change_\' + motionCall.currentService.autoCharge | translate}}</td></tr><tr ng-if="serviceStatus !== \'TRIAL_EXPIRED\' && serviceStatus !== \'PURCHASE_EXPIRED\'"><td>{{\'total_count_of_current_service\' | translate}}</td><td>{{motionCall.currentService.totalCount}}</td></tr><tr ng-if="serviceStatus !== \'TRIAL_EXPIRED\' && serviceStatus !== \'PURCHASE_EXPIRED\'"><td>{{\'remain_count_of_current_service\' | translate}}</td><td>{{motionCall.currentService.remainCount}}</td></tr><tr ng-if="serviceStatus !== \'TRIAL_EXPIRED\' && serviceStatus !== \'PURCHASE_EXPIRED\'"><td>{{\'end_time_of_current_service\' | translate}}</td><td>{{motionCall.currentService.endTimeOfCurrentService > 0 ? (motionCall.currentService.endTimeOfCurrentService | date:\'yyyy-MM-dd\') : \'-\'}}</td></tr></tbody></table></div></uib-tab><uib-tab heading="{{\'the_last_12_motion_call_services\' | translate}}"><div class="table-responsive" ng-if="motionCall.services !== undefined"><table class="table table-hover text-center" st-table="motionCall.services"><thead ng-if="hasServiceList"><tr><th class="text-center">{{ \'start_time\' | translate}}</th><th class="text-center">{{ \'end_time\' | translate}}</th><th class="text-center">{{ \'total_count\' | translate}}</th><th class="text-center">{{ \'remain_count\' | translate}}</th></tr></thead><tbody><tr ng-repeat="service in motionCall.services" class="no-top-border"><td>{{service.startTime > 0 ? (service.startTime | date:\'yyyy-MM-dd\') : \'-\'}}</td><td>{{service.endTime > 0 ? (service.endTime | date:\'yyyy-MM-dd\') : \'-\'}}</td><td>{{service.totalCount}}</td><td>{{service.remainCount}}</td></tr></tbody></table></div><div ng-show="!hasServiceList" class="text-center">{{\'no_data\' | translate}}</div></uib-tab></uib-tabset></div><div class="modal-footer" ng-show="motionCall.currentService !== undefined || motionCall.services != undefined"><button type="button" class="btn btn-danger pull-left" ng-if="RESET_DEVICE_MOTION_CALL_SERVICE" ng-disabled="serviceStatus == \'INIT\'" ng-click="resetMotionCallService()">{{\'reset_motion_call_service\' | translate}}</button> <button type="button" class="btn btn-info pull-left" ng-click="$dismiss()">{{\'close\' | translate}}</button></div></div>');
$templateCache.put('app/pages/devices/modals/motioncall/resetMotionCallService.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/activities/child/childActivities.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'child_activities\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="goBack()" class="btn btn-info btn-mm" style="margin-bottom: 10px">{{\'back\' | translate}}</button> <button ng-click="openEditPage()" ng-if="WRITE_P" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="activities"><thead><tr class="black-muted-bg"><th>{{\'activity_country_code\' | translate }}</th><th>{{\'activity_locale_code\' | translate }}</th><th>{{\'activity_title\' | translate }}</th><th>{{\'published\' | translate }}</th><th>{{\'activity_priority\' | translate }}</th><th>{{\'activity_type\' | translate }}</th><th>{{\'activity_image_url\' | translate }}</th><th>{{\'activity_target\' | translate }}</th><th>{{\'activity_description\' | translate }}</th><th>{{\'activity_start_time\' | translate}}</th><th>{{\'activity_end_time\' | translate}}</th><th>{{\'create_time\' | translate }}</th><th ng-if="EDIT_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="activity in activities" class="no-top-border"><td><a>{{activity.countryCode}}</a></td><td>{{activity.locale}}</td><td>{{activity.title}}</td><td ng-show="activity.publish"><span class="label label-primary">{{activity.publish | translate}}</span></td><td ng-show="!activity.publish"><span class="label label-danger">{{activity.publish | translate}}</span></td><td>{{activity.priority}}</td><td>{{activity.displayType}}</td><td><a href="" ng-click="openInfoPage(activity.imageUrl)">{{\'activity_image_url\' | translate}}</a></td><td><a href="" ng-click="openInfoPage(activity.targetUrl)">{{\'activity_target\' | translate}}</a></td><td><a href="" ng-click="openInfoPage(activity.description)">{{\'activity_description\' | translate}}</a></td><td>{{activity.startTime > 0 ? (activity.startTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td>{{activity.endTime > 0 ? (activity.endTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td>{{activity.createTime > 0 ? (activity.createTime | date:\'yyyy-MM-dd HH:mm:ss\') : \'-\'}}</td><td ng-if="EDIT_P"><div class="buttons"><button class="btn btn-info btn-xs" ng-click="openEditPage(activity)">{{\'edit\' | translate}}</button> <button ng-show="!activity.publish" class="btn btn-primary btn-xs" ng-click="openPublishPage(activity.id, true)">{{\'publish\' | translate}}</button> <button ng-show="activity.publish" class="btn btn-warning btn-xs" ng-click="openPublishPage(activity.id, false)">{{\'cancel_publish\' | translate}}</button> <button class="btn btn-danger btn-xs" ng-click="openDeletePage(activity.id)">{{\'delete\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="9" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="9" class="text-center"><div st-pagination="" st-items-by-page="20" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="9" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="activitiesEmpty"><td colspan="9" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/marketing/activities/child/editChildActivity.html','<div class="modal-content"><div class="modal-header bg-info"><span>{{isNewActivity ? (\'create_activity\' | translate) : (\'edit\' | translate)}}</span></div><div class="modal-body"><form><div class="form-group margin-thirdPx"><label for="countryCode">{{\'activity_country_code\' | translate }} {{\'not_null\' | translate}} <a href="https://www.science.co.il/international/Country-codes.php" target="_blank">reference</a></label> <input type="text" class="form-control" id="countryCode" ng-model="data.countryCode" ng-focus="clearError()"><p class="help-block red-color" ng-show="errCountryCode">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'activity_locale_code\' | translate }} {{\'not_null\' | translate}} <a href="https://www.science.co.il/language/Locale-codes.php" target="_blank">reference</a></label> <input type="text" class="form-control" ng-model="data.locale" ng-focus="clearError()"><p class="help-block red-color" ng-show="errLocaleCode">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx has-error"><label for="title">{{\'activity_title\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="title" ng-model="data.title" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label for="priority">{{\'activity_priority\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="priority" ng-model="data.priority" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label>{{\'activity_type\' | translate }}</label><select class="form-control" ng-model="displayTypeSelected" ng-change="displayTypeChange(displayTypeSelected)" ng-options="item as item.label for item in displayTypeItems track by item.value"></select></div><div class="form-group margin-thirdPx"><label for="imageUrl">{{\'activity_image_url\' | translate }} {{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="imageUrl" ng-model="data.imageUrl" ng-focus="clearError()"><p class="help-block red-color" ng-show="errImageUrl">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label>{{\'activity_target\' | translate }} {{\'not_null\' | translate}}</label> <input type="text" class="form-control" ng-model="data.targetUrl" ng-focus="clearError()"><p class="help-block red-color" ng-show="errTargetUrl">{{errorMessage | translate}}</p></div><div class="form-group margin-thirdPx"><label for="description">{{\'activity_description\' | translate }}{{\'not_null\' | translate}}</label> <textarea class="form-control" id="description" ng-model="data.description" ng-focus="clearError()"></textarea></div><div class="form-group margin-thirdPx"><label for="startTime">{{\'activity_start_time\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="startTime" ng-model="data.startTime" ng-focus="clearError()"></div><div class="form-group margin-thirdPx"><label for="endTime">{{\'activity_end_time\' | translate }}{{\'not_null\' | translate}}</label> <input type="number" class="form-control" id="endTime" ng-model="data.endTime" ng-focus="clearError()"></div></form><p class="help-block red-color" ng-show="errors">{{errorMessage | translate}}</p></div><div class="modal-footer modal-buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/activities/modals/deleteActivities.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/activities/modals/publishActivities.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{message | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="confirm()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/activities/tabs/mockClientQuery.html','<div ng-controller="MockClientQueryCtrl"><div class="form-group col-md-2"><label>{{\'activity_country_code\' | translate}}</label> <input ng-model="data.countryCode" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></div><div class="form-group col-md-2"><label>{{\'activity_locale_code\' | translate}}</label> <input ng-model="data.locale" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></div><div class="form-group col-md-2"><label>{{\'group\' | translate }}:</label><select class="form-control" ng-model="groupSelected" ng-options="item as item.label for item in groupItems track by item.value"></select></div><div class="dropdown form-group col-md-4" style="margin-top: 20px"><button type="button" class="btn btn-info" ng-disabled="holdSubmit" ng-click="callServer()">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetSearch()">{{\'reset_search\' | translate}}</button></div><table class="table table-hover" st-pipe="callServer" st-table="logs"><thead><tr><th><span class="label label-info">{{\'count\' | translate}} : {{mockClientActivities.length}}</span></th></tr><tr class="black-muted-bg"><th>{{\'activity_title\' | translate}}</th><th>{{\'activity_image_url\' | translate}}</th><th>{{\'activity_target\' | translate}}</th><th>{{\'activity_description\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="activity in mockClientActivities" class="no-top-border"><td>{{activity.title}}</td><td><a href="" ng-click="openInfoPage(activity.imageUrl)">{{\'activity_image_url\' | translate}}</a></td><td><a href="" ng-click="openInfoPage(activity.targetUrl)">{{\'activity_target\' | translate}}</a></td><td><a href="" ng-click="openInfoPage(activity.description)">{{\'activity_description\' | translate}}</a></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="getDataError"><td colspan="12" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="logsEmpty"><td colspan="12" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div>');
$templateCache.put('app/pages/marketing/advertisements/image/showADImage.html','<div class="row"><div style="width: 480px;height: 640px"><img src="{{adPicUrl}}"></div></div>');
$templateCache.put('app/pages/marketing/promotions/coupons/deleteCouponConfirm.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-information-circled modal-icon"></i><span>{{\'op_info\' | translate}}</span></div><div class="modal-body text-center">{{\'are_you_sure_to_delete_this_coupon\' | translate}}</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="deleteCoupon()">{{\'yes\' | translate}}</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div>');
$templateCache.put('app/pages/marketing/promotions/coupons/relatedCoupons.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{\'details_title\' | translate}}" ba-panel-class="with-scroll"><div><button ng-click="openEditPage()" ng-if="WRITE_P && couponChangeable" class="btn btn-primary btn-mm" style="margin-bottom: 10px">{{\'create_promotion\' | translate}}</button><table class="table table-hover" st-pipe="callServer" st-table="coupons"><thead><tr class="black-muted-bg"><th>{{\'coupon_type\' | translate }}</th><th>{{\'purchase_restriction_type\' | translate }}</th><th>{{\'device_bind\' | translate }}</th><th>{{\'cumulative_use\' | translate }}</th><th>{{\'max_obtain_count\' | translate }}</th><th>{{\'currency\' | translate }}</th><th ng-if="EDIT_P">{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="coupon in coupons" class="no-top-border"><td><a>{{couponTypes[coupon.couponType].label | translate }}</a></td><td>{{purchaseRestrictionTypes[coupon.purchaseRestrictionType].label | translate}}</td><td>{{coupon.deviceBind}}</td><td>{{coupon.cumulativeUse}}</td><td>{{coupon.maxObtainCount}}</td><td>{{coupon.currency+\'_currency\' | translate}}</td><td ng-if="EDIT_P || DELETE_P"><div class="buttons"><button ng-if="EDIT_P" class="btn btn-primary btn-xs" ng-click="openEditPage(coupon)">{{\'details\' | translate}}</button> <button ng-if="DELETE_P" class="btn btn-primary btn-xs" ng-click="deleteCouponConfirm(coupon.id)" ng-disabled="!couponChangeable">{{\'delete\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="9" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="getDataError"><td colspan="9" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="promotionsEmpty"><td colspan="9" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div></div></div><div class="row" ng-show="showEditView"><div class="col-md-12" style="padding: 0 50px 20px;font-size: large; color:#00cc66"><div style="padding-bottom: 5px"><span ng-if="isNewCoupon">{{\'create_coupon\' | translate}}</span> <span ng-if="!isNewCoupon">{{\'modify_details\' | translate}}</span></div><div><form><div class="row"><div class="col-md-4"><div class="form-group margin-thirdPx"><label>{{\'coupon_type\' | translate }}</label><select class="form-control" ng-model="couponTypeSelected" ng-disabled="!couponChangeable" ng-change="couponTypeChanged(couponTypeSelected)" ng-options="item as item.label for item in couponTypes track by item.value"></select></div></div><div class="col-md-4"><div class="form-group margin-thirdPx"><label>{{\'purchase_restriction_type\' | translate }}</label><select class="form-control" ng-model="purchaseRestrictionTypeSelected" ng-change="purchaseRestrictionTypeChanged(purchaseRestrictionTypeSelected)" ng-disabled="!couponChangeable" ng-options="item as item.label for item in purchaseRestrictionTypes track by item.value"></select></div></div><div class="col-md-4"><div class="form-group margin-thirdPx"><label>{{\'purchase_restriction_type\' | translate }}</label> <input type="number" class="form-control" ng-model="coupon.daysToExpire" min="0" ng-disabled="!couponChangeable"></div></div></div><div class="row"><div class="col-md-3"><div class="form-group margin-thirdPx"><label>{{\'device_bind\' | translate }}</label><select class="form-control" ng-model="deviceBindSelected" ng-change="deviceBindChanged(deviceBindSelected)" ng-disabled="!couponChangeable" ng-options="item as item.label for item in booleans track by item.value"></select></div></div><div class="col-md-3"><div class="form-group margin-thirdPx"><label>{{\'max_obtain_count\' | translate }}</label> <input type="number" class="form-control" ng-model="coupon.maxObtainCount" min="0" ng-disabled="!couponChangeable"></div></div><div class="col-md-3"><div class="form-group margin-thirdPx"><label>{{\'cumulative_use\' | translate }}</label><select class="form-control" ng-model="cumulativeUseSelected" ng-change="cumulativeUseChanged(cumulativeUseSelected)" ng-disabled="!couponChangeable" ng-options="item as item.label for item in booleans track by item.value"></select></div></div><div class="col-md-3"><div class="form-group margin-thirdPx"><label>{{\'currency\' | translate }}</label><select class="form-control" ng-model="currencySelected" ng-change="currencyChanged(currencySelected)" ng-disabled="!couponChangeable" ng-options="item as item.label for item in currencyTypes track by item.value"></select></div></div></div><div class="row"><div class="col-md-6 form-group margin-thirdPx"><label>{{\'concessional_days\' | translate }}</label> <input type="number" class="form-control" ng-model="coupon.concessionalDays" min="0" ng-disabled="!couponChangeable"></div><div class="col-md-6 form-group margin-thirdPx"><label>{{\'min_days_for_service_to_take_effect\' | translate }}</label> <input type="number" class="form-control" ng-model="coupon.minDaysForServiceTakeEffect" min="0" ng-disabled="!couponChangeable"></div></div><div class="row"><div class="col-md-6 form-group margin-thirdPx"><label>{{\'concessional_cash_cents\' | translate }}</label> <input type="number" class="form-control" ng-model="coupon.concessionalCashInCents" min="0" ng-disabled="!couponChangeable"></div><div class="col-md-6 form-group margin-thirdPx"><label>{{\'min_cents_for_cash_to_take_effect\' | translate }}</label> <input type="number" class="form-control" ng-model="coupon.minCentsForCashToTakeEffect" min="0" ng-disabled="!couponChangeable"></div></div><div class="row"><div class="col-md-6 form-group margin-thirdPx"><label>{{\'discount\' | translate }}</label> <input type="number" class="form-control" ng-model="coupon.discount" max="100" min="0" ng-disabled="!couponChangeable" ng-blur="discountChanged()"></div><div class="col-md-6 form-group margin-thirdPx"><label>{{\'min_cents_for_discount_to_take_effect\' | translate }}</label> <input type="number" class="form-control" ng-model="coupon.minCentsForDiscountToTakeEffect" min="0" ng-disabled="!couponChangeable"></div></div></form></div><div><button type="submit" class="btn btn-primary" ng-click="createOrUpdate()" ng-disabled="!couponChangeable">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="hideEditView()">{{\'cancel\' | translate}}</button></div></div></div></div>');
$templateCache.put('app/pages/marketing/promotions/details/editDetails.html','<style>\n  .margin-bottom-well {\n    margin-bottom: 10px;\n  }\n\n  .modal-dialog {\n    position: relative;\n    display: table;\n    overflow-y: auto;\n    overflow-x: auto;\n    width: auto;\n    min-width: 300px;\n  }\n</style><div class="modal-content"><div class="modal-header bg-info"><span>{{\'config_detail_of_each_language\' | translate}}</span></div><div class="modal-body"><table class="table modal-dialog" st-table="languagesUsed"><thead><tr class="black-muted-bg"><th>{{\'language\' | translate }}</th><th>{{\'activity_title\' | translate }}</th><th>{{\'activity_target\' | translate }}</th><th>{{\'activity_image_url\' | translate }}</th><th>{{\'description\' | translate }}</th><th>{{\'actions\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="language in languagesUsed" class="no-top-border"><td><a>{{language.label | translate }}</a></td><td>{{details[language.value].title | limitTo:50}}{{configMap[configName].length > 50 ? \'...\' : \'\'}}</td><td><a href="{{details[language.value].target}}" target="_blank">{{\'click_to_see\' | translate}}</a></td><td><a href="{{details[language.value].imageUrl}}" target="_blank">{{\'click_to_see\' | translate}}</a></td><td>{{details[language.value].description | limitTo:20}}{{configMap[configName].length > 20 ? \'...\' : \'\'}}</td><td><div class="buttons"><button class="btn btn-danger btn-xs" ng-click="deleteDetail(language.value)">{{\'delete\' | translate}}</button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="!getDataError"><td colspan="3" class="text-center"><div st-pagination="" st-items-by-page="10" st-displayed-pages="5" st-template="app/theme/components/pagination/pagination.custom.html"></div></td></tr><tr ng-show="getDataError"><td colspan="3" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="promotionsEmpty"><td colspan="3" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table><form><button class="btn btn-info margin-bottom-well" ng-if="editable" ng-click="openOrCloseEditor()">{{openOrCloseEditorView | translate}}</button><div id="addDetail" ng-show="addLanguageDetail"><div class="form-group margin-thirdPx has-error margin-bottom-well"><label for="language_select">{{\'language_select\' | translate }}</label><select class="form-control" id="language_select" ng-model="languageSelected" ng-change="languageChanged(languageSelected)" ng-options="item as item.label for item in languagesLeft track by item.value"></select></div><div class="form-group margin-thirdPx margin-bottom-well"><label for="title">{{\'activity_title\' | translate }}{{\'not_null\' | translate}}</label> <input type="text" class="form-control" id="title" ng-model="newDetail.title"></div><div class="form-group margin-thirdPx margin-bottom-well"><label for="description">{{\'activity_description\' | translate }}</label> <textarea type="text" rows="2" class="form-control" id="description" ng-model="newDetail.description"></textarea></div><div class="form-group margin-thirdPx margin-bottom-well" ng-show="needRule"><label for="rule">{{\'activity_rule\' | translate }}</label> <textarea type="text" rows="3" class="form-control" id="rule" ng-model="newDetail.rule"></textarea></div><div id="imageUpload"><div style="margin-bottom: 20px"><label for="adImage"><span>{{\'please_to_choose_a_file\' | translate}}</span></label> <input type="file" accept=".jpeg,.png,.jpg" id="adImage" nv-file-select="" uploader="uploader"> <img src="" id="loc_img" hidden=""></div><div ng-if="uploader.queue.length > 0"><label>{{\'upload_queue\' | translate}}</label><table class="table text-center"><thead><tr><th>{{\'name\' | translate}}</th><th class="text-center" ng-show="uploader.isHTML5">{{\'size\' | translate}}</th><th class="text-center" ng-show="uploader.isHTML5">{{\'progress\' | translate}}</th><th class="text-center">{{\'status\' | translate}}</th><th class="text-center">{{\'actions\' | translate}}</th></tr></thead><tbody><tr ng-repeat="item in uploader.queue"><td><strong>{{ item.file.name }}</strong></td><td ng-show="uploader.isHTML5" nowrap="">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show="uploader.isHTML5"><div class="progress" style="margin-top: 5px"><div class="progress-bar" role="progressbar" ng-style="{ \'width\': item.progress + \'%\' }"></div></div></td><td><span ng-show="item.isSuccess"><i class="glyphicon glyphicon-ok"></i></span> <span ng-show="item.isCancel"><i class="glyphicon glyphicon-ban-circle"></i></span> <span ng-show="item.isError"><i class="glyphicon glyphicon-remove"></i></span></td><td><button type="button" class="btn btn-success btn-xs" ng-click="item.upload()" ng-disabled="item.isReady || item.isUploading || item.isSuccess || notReady"><span class="glyphicon glyphicon-upload"></span> {{\'upload\' | translate}}</button> <button type="button" class="btn btn-warning btn-xs" ng-click="item.cancel()" ng-disabled="!item.isUploading"><span class="glyphicon glyphicon-ban-circle"></span> {{\'cancel\' | translate}}</button> <button type="button" class="btn btn-danger btn-xs" ng-click="item.remove()"><span class="glyphicon glyphicon-trash"></span> {{\'remove\' | translate}}</button></td></tr></tbody></table></div></div><div class="form-group"><select class="form-control" style="margin-bottom: 15px" ng-model="linkTypeSelected" ng-change="linkTypeChanged(linkTypeSelected)" ng-options="item as item.label for item in linkTypes track by item.value"></select></div><div class="input-group" ng-show="newDetail.isLocationBasedLink"><div class="control-label" ng-show="countryCodesCanBeAdded.length != 0" style="margin-bottom: 5px"><select class="btn-group bootstrap-select form-control" ng-model="countryCodeSelected" ng-change="countryCodeChanged(countryCodeSelected)" ng-options="item as item.label for item in countryCodesCanBeAdded track by item.value"></select></div><div class="input-group" ng-show="newDetail.isLocationBasedLink"><input class="form-control" ng-model="newUrl" placeholder="please input target page link"> <span class="input-group-btn"><button class="btn btn-info" type="button" ng-click="addNewLocationUrl()" ng-disabled="isAddingLocationUrl">{{\'create\' | translate}}</button></span></div><div class="input-group row" ng-show="newDetail.isLocationBasedLink"><div ng-repeat="locationUrl in locationUrlsForShow"><div style="margin-left: 15px"><label class="col-sm-2">{{locationUrl.countryCode | translate}}</label> <a class="col-sm-4" href="{{locationUrl.url}}" target="_blank">{{locationUrl.urlForShow}}</a> <a class="col-sm-4" href="{{locationUrl.imageUrl}}" target="_blank">{{locationUrl.imageUrlForShow}}</a> <button class="col-sm-2 btn btn-raised btn-danger btn-xs" style="margin-bottom: 5px" ng-click="deleteLocationUrl(locationUrl)">{{\'remove\' | translate}}</button></div></div></div></div><div class="form-group" ng-show="!newDetail.isLocationBasedLink"><input class="form-control" ng-model="newDetail.target" placeholder="please input target page link"></div><div class="buttons"><button type="submit" class="btn btn-primary" ng-click="submit()" ng-disabled="holdSubmit">{{\'submit\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">{{\'cancel\' | translate}}</button></div></div></form></div></div>');
$templateCache.put('app/pages/statistics/charts/device/deviceStatisticsChart.html','<style>\n  .no-bucket-data {\n    font-size: 20px;\n    text-align: center;\n  }\n</style><div ng-controller="DeviceStatisticsChartCtrl"><div class="row"><div class="dropdown form-group col-md-2"><div class="dropdown-toggle"><select class="form-control" ng-change="changeLogType(logTypeSelected)" ng-model="logTypeSelected" ng-options="item as item.label for item in logTypeItems track by item.value"></select></div></div><div class="form-group col-md-2"><button type="button" class="btn btn-info" ng-click="callServer(tableState)" ng-disabled="holdSubmit">{{\'search\' | translate}}</button></div></div><div class="row"><div id="zoomAxisChart" class="admin-chart" ng-show="data.length > 0"></div><div class="no-bucket-data" ng-show="data.length == 0"><span>{{noDataMsg}}</span></div></div></div>');
$templateCache.put('app/pages/statistics/charts/order/orderLineChart.html','<style>\n  .no-bucket-data {\n    font-size: 20px;\n    text-align: center;\n  }\n\n</style><div ng-controller="OrderLineChartCtrl"><div class="row"><div class="dropdown form-group col-md-2"><div class="form-group"><label style="float: left">{{\'type\' | translate }}:</label><div class="dropdown-toggle"><select class="form-control" ng-change="changeLogType(logTypeSelected)" ng-model="logTypeSelected" ng-options="item as item.label for item in logTypeItems track by item.value"></select></div></div></div><div class="form-group col-md-2"><label>{{\'end_time\' | translate}}</label> <a class="dropdown-toggle" id="dropdownEnd" role="button" data-toggle="dropdown"><div class="input-group date"><input class="form-control" data-ng-model="dateRangeEnd"> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div></a><ul class="dropdown-menu" role="menu" aria-labelledby="dLabel"><datetimepicker data-ng-model="dateRangeEnd" data-datetimepicker-config="{ dropdownSelector: \'#dropdownEnd\', minView: \'day\'}" data-on-set-time="endDateOnSetTime()"></datetimepicker></ul></div><div class="form-group col-md-2" style="margin-top: 20px"><button type="button" class="btn btn-info" ng-click="callServer(tableState)" ng-disabled="holdSubmit">{{\'search\' | translate}}</button></div><div class="row"><div class="col-md-12"><div id="orderChart" class="admin-chart" ng-show="logTypeSelected.value == \'OrdersIncomeCount\' && data.length > 0"></div><div id="totalIncomePieChart" class="admin-chart" ng-show="logTypeSelected.value == \'OrdersTotalIncome\' && data.length > 0"></div><div id="orderPieChart" class="admin-chart" ng-show="logTypeSelected.value == \'OrdersAverageCount\' && data.length > 0"></div><div id="cashChart" class="admin-chart" ng-show="logTypeSelected.value == \'DailyCashIncome\' && data.length > 0"></div><div class="no-bucket-data" ng-show="data.length == 0"><span>{{noDataMsg}}</span></div></div></div></div></div>');
$templateCache.put('app/pages/statistics/logs/cloudsotrageservice/loglist.html','');
$templateCache.put('app/pages/statistics/logs/devicecall/loglist.html','');
$templateCache.put('app/pages/statistics/logs/loginandout/loglist.html','<div ng-controller="LoginOrLogoutCtrl"><div class="form-group col-md-2"><label>{{\'device_sn\' | translate}}</label> <input ng-model="serialNumber" ng-blur="serialNumberInputBlurred()" placeholder="{{\'search_placeholder\' | translate}}" class="form-control search-input"></div><div class="dropdown form-group col-md-4" style="margin-top: 20px"><button type="button" class="btn btn-info" ng-disabled="holdSubmit" ng-click="callServer(tableState)">{{\'search\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="resetSearch()">{{\'reset_search\' | translate}}</button></div><table class="table table-hover" st-pipe="callServer" st-table="logs"><thead><tr><th><span class="label label-info">{{\'count\' | translate}} : {{logs.length}}</span></th></tr><tr class="black-muted-bg"><th>{{\'device_sn\' | translate}}</th><th>{{\'online_time\' | translate}}(utc+8)</th><th>{{\'duration\' | translate}}</th><th>{{\'logout_time\' | translate}}(utc+8)</th><th>{{\'offline_period\' | translate}}</th><th>{{\'region\' | translate}}</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="log in logs" class="no-top-border"><td>{{log.serialNumber}}</td><td>{{log.onlineTime}}</td><td>{{log.duration}}</td><td>{{log.logoutTime}}</td><td>{{log.offlineTime}}</td><td>{{log.region}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12" class="text-center">{{\'loading\' | translate}}</td></tr></tbody><tfoot><tr ng-show="getDataError"><td colspan="12" class="text-center red-color">{{\'unable_get_data\' | translate}}</td></tr><tr ng-show="logsEmpty"><td colspan="12" class="text-center green-color">{{\'no_data\' | translate}}</td></tr></tfoot></table></div>');
$templateCache.put('app/pages/statistics/logs/smarthome/loglist.html','');}]);